import * as React from "react";
import { forwardRef } from "react";
const SvgPulseLogicFig = (props: React.SVGProps<SVGSVGElement>, ref: React.ForwardedRef<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1em"
    fill="none"
    viewBox="0 0 29647 5924"
    ref={ref}
    {...props}
  >
    <path fill="#CBDEDC" d="M1 0h29646v5923H1z" />
    <path fill="#CDA024" fillOpacity={0.6} d="M0 3736h29647v2188H0z" />
    <path stroke="#424546" strokeWidth={100} d="M14688 3627H1" />
    <path stroke="#5BB3E5" strokeWidth={70} d="M14688 3627H1" />
    <path
      fill="#5BB3E5"
      d="M12255 3656h16v22h-16zM12288 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M12943 3656h16v22h-16zM12976 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M13278 3656h16v22h-16zM13311 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M13613 3656h16v22h-16zM13646 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M13948 3656h16v22h-16zM13981 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M14283 3656h16v22h-16zM14316 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M14618 3656h16v22h-16zM14651 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M11920 3656h16v22h-16zM11953 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M11491 3656h16v22h-16zM11524 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M11033 3656h16v22h-16zM11066 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M7916 3656h16v22h-16zM7949 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M5588 3656h16v22h-16zM5621 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M3243 3656h16v22h-16zM3276 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M10698 3656h16v22h-16zM10731 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M7581 3656h16v22h-16zM7614 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M5253 3656h16v22h-16zM5286 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M2908 3656h16v22h-16zM2941 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M10363 3656h16v22h-16zM10396 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M7246 3656h16v22h-16zM7279 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M4918 3656h16v22h-16zM4951 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M2573 3656h16v22h-16zM2606 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M10028 3656h16v22h-16zM10061 3739.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M6911 3656h16v22h-16zM6944 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M4583 3656h16v22h-16zM4616 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M2238 3656h16v22h-16zM2271 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M9693 3656h16v22h-16zM9726 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M6576 3656h16v22h-16zM6609 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M4248 3656h16v22h-16zM4281 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M1903 3656h16v22h-16zM1936 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M9358 3656h16v22h-16zM9391 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M6241 3656h16v22h-16zM6274 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M3913 3656h16v22h-16zM3946 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M1568 3656h16v22h-16zM1601 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M9023 3656h16v22h-16zM9056 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M5906 3656h16v22h-16zM5939 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M3578 3656h16v22h-16zM3611 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M1233 3656h16v22h-16zM1266 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M8558 3656h16v22h-16zM8591 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M8223 3656h16v22h-16zM8256 3739.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M11414.7 1584.7s-69-276.51-68.2-356.58c.6-54.17 51.4-164.89 51.4-164.89s-15.3 144.8-7.6 213.38c9.8 86.97 60.8 280.08 60.8 280.08zM12045 2913.22s278.8 63.16 358.9 61.83c54.2-.9 163.4-49.72 163.4-49.72s-144.4 15.5-213.3 8.72c-87.3-8.6-282.1-55.49-282.1-55.49z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.589}
      d="M11303 2988.87s-507.3-187.16-656.7-221.8c-101.1-23.43-325 27.01-325 27.01s289.3 21.26 414.3 67.49c158.6 58.65 550.9 224.54 550.9 224.54z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M11652.2 2991.67s479.3-176.76 619-214.52c94.5-25.55 296.4-10.71 296.4-10.71s-255 49.59-373.1 93.23c-149.8 55.35-525.7 238.84-525.7 238.84z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.376}
      d="M11134.8 2102.93s-128.1 168.86-176.7 202.76c-32.9 22.94-127.7 33.88-127.7 33.88s95.6-51.28 132.6-86.37c46.9-44.5 134.7-164.55 134.7-164.55z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M11405.2 2066.55s-508.2-48.71-653.6-50.26c-98.3-1.06-294.9 60.5-294.9 60.5s261.6-14.95 386.9-2.88c158.9 15.32 566.3 94.75 566.3 94.75z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M12979.5 1672.04s208.8-102.24 271-118.59c42.2-11.06 132.6-1.91 132.6-1.91s-113.8 20.71-166.4 40.06c-66.7 24.55-212.2 97.83-212.2 97.83z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.672}
      d="M11877.6 1608.96s-183.5-32.55-232.2-54.27c-33-14.68-89.8-74.15-89.8-74.15s85.2 47.48 128.7 61.12c55.2 17.29 183.9 38.28 183.9 38.28zM10873.2 2076.33s-134.5 132.43-179.2 160.2c-30.2 18.79-105.7 31.86-105.7 31.86s84.6-43.16 120.6-71.21c45.6-35.58 138.7-129.56 138.7-129.56zM12329.3 1890.98s144.1 122.83 190.7 147.17c31.5 16.47 107.4 23.24 107.4 23.24s-87.4-36.52-125.3-61.9c-48.1-32.19-148.1-119.56-148.1-119.56zM11881.5 2502.55s144.1-122.83 190.7-147.17c31.5-16.47 107.4-23.25 107.4-23.25s-87.4 36.53-125.3 61.91c-48.1 32.19-148.1 119.56-148.1 119.56zM11854.2 1534.92s95.5-163.56 110.1-213.83c9.8-34.01-1.4-110.45-1.4-110.45s-17.6 92.83-35.4 134.71c-22.5 53.11-91.1 166.94-91.1 166.94z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M12364.2 1310.35s112.5-202.66 131.7-263.94c13-41.45 7.7-132.37 7.7-132.37s-25.9 112.53-47.8 163.97c-27.7 65.23-108.1 206.4-108.1 206.4z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M12718.4 1315.2s279.3-38.99 354.9-67.64c51.2-19.38 144-97.49 144-97.49s-132.9 65.33-200 81.69c-85.2 20.75-282.8 38.13-282.8 38.13z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M11437.8 2501.28s315.4-13.33 420.5-8.19c71 3.47 209.7 38.98 209.7 38.98s-188.1-17.2-279.1-16.81c-115.5.5-413.6 19.81-413.6 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.982}
      d="M11953 1882.35s-151-383.31-173-500.22c-14.9-79.04-32-335.4-32-335.4s63.1 269.39 88.9 369.35c32.7 126.76 183.7 434.18 183.7 434.18zM11320.5 1943.86s162.8-385.83 188.4-503.9c17.3-79.81 42-339.2 42-339.2s-71.2 271.85-100 372.69c-36.6 127.87-197.2 436.83-197.2 436.83z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M11997.1 1889.4s315.4-13.33 420.5-8.19c71 3.47 209.7 38.98 209.7 38.98s-188.1-17.2-279.1-16.81c-115.5.5-413.6 19.81-413.6 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M12413.6 1528.34s-104.1-256.27-125.5-344.9c-14.4-59.96-2.9-186.946-2.9-186.946s27.2 161.506 52.5 236.676c32 95.32 126.2 302.63 126.2 302.63z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M11028.2 1367.21s162.9-162.89 199.4-216.05c24.7-35.96 49.4-123.81 49.4-123.81s-58.8 100.13-94.3 143.24c-45.1 54.67-160.4 167.58-160.4 167.58z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M11018.1 1622.33s-31.3-273.43-29-365.13c1.5-62.03 42.7-185.13 42.7-185.13s-14.7 164.79-10.3 243.95c5.7 100.39 44.1 358.38 44.1 358.38z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M11258 3737h148s-177.7-699.7 18.7-1151.04c207.5-513.15 1003.8-1026.48 1095.3-1086.46s172.6 121.18 297.7 153.79c247.1 64.41 565.3 104.97 565.3 104.97s-324.1-48.84-550.3-139.45c-107-42.88-200.8-116.98-222.2-160.81-22.4-46.03 95.9-101.41 144.9-182.9 96.3-160.1 209.3-299.565 204.8-304.06s-231.4 266.72-371.9 403.35c-269.9 262.41-1007.2 636.95-1217.6 1153.09-175.4 385.36-100.4 473.28-112.7 1209.52"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M11721.5 3737h-120s64.7-830.16-53.8-1185.53c-167.9-503.75-483.4-846.7-694.1-1009.14-49.6-38.22-51.5 21.64-133.8 54.26-162.6 64.4-272.7-57.26-272.7-57.26s287.8 79.47 331.5-56.98c14.8-46.02-77.7-158.93-138.4-222.25-84.3-88.12-83.7-157.05-83.7-157.05s174.5 152.7 267 289.34c177.5 262.4 669 605.46 807.4 1121.59 149.3 556.8 60.4 489.28 90.6 1223.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12561.3 2049 132.4-68.53s-53.4-9.23-81.7 3.29c-28.4 12.52-50.7 65.24-50.7 65.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12560.9 2051.19 132.7-70.87s-22.3 49.39-48.9 65.77c-26.6 16.37-83.8 5.1-83.8 5.1"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12037.2 2546.66 132.4-68.52s-53.4-9.23-81.7 3.29c-28.4 12.52-50.7 65.23-50.7 65.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12036.8 2548.85 132.7-70.87s-22.3 49.39-48.9 65.77c-26.6 16.37-83.8 5.1-83.8 5.1"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12087.4 2349.77 82 92.67s-1.6-44.49-17.3-64.73c-15.8-20.24-64.7-27.94-64.7-27.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12083.5 2350.99 88.3 90.25s-44.7-6.47-64.1-24.04-24.2-66.21-24.2-66.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12108.5 2364.12 122.9-27.42s-41.9-20.11-67.7-16.06c-25.9 4.06-55.2 43.48-55.2 43.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12108 2359 122.9-15.98s-31.9 32.15-57.2 37.07c-25.2 4.91-65.7-21.09-65.7-21.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12014 2521.78 47.3 120.9s13.5-44.08 5.3-69.67-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12015.1 2521.38 43.5 121.22s-39.1-26.56-49.6-51.2c-10.6-24.63 6.1-70.02 6.1-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12548 2051.74 45.9-141.95s-44.4 31.06-55.8 59.91c-11.3 28.85 9.9 82.04 9.9 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12548.1 2052.42 46.8-141.67s17.5 51.62 9.6 81.61-56.4 60.06-56.4 60.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13013.1 1698.44-155.6 70.37s61.4 13.26 94.6.62c33.3-12.64 61-70.99 61-70.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13013.6 1694.94-155.9 74.99s28-55.85 59.3-73.38c31.4-17.53 96.6-1.61 96.6-1.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11734.8 2498.48 96-120.74s-53.1 13.79-74.4 37.59c-21.4 23.8-21.6 83.15-21.6 83.15"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11739.2 2501.14 88-124.24s1.1 55.03-15.6 81.89c-16.7 26.87-72.4 42.35-72.4 42.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12470.1 2750.31 82 92.67s-1.7-44.49-17.4-64.73-64.6-27.94-64.6-27.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12466.2 2751.52 88.2 90.26s-44.6-6.47-64-24.04-24.2-66.22-24.2-66.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11980.4 2447.88 123-27.42s-41.9-20.11-67.8-16.06c-25.9 4.06-55.2 43.48-55.2 43.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11980 2442.77 122.9-15.99s-31.9 32.15-57.2 37.07c-25.3 4.91-65.7-21.08-65.7-21.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12233.9 2914.74-83.7 103.1s45.8-11.37 64.4-31.67 19.3-71.43 19.3-71.43"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12230.1 2912.36-76.7 106.27s-.6-47.35 14-70.35c14.5-23 62.7-35.92 62.7-35.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11845.8 3001.72-83.7 103.09s45.8-11.36 64.4-31.67c18.6-20.3 19.3-71.42 19.3-71.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11842 2999.33-76.7 106.27s-.7-47.35 13.9-70.35c14.6-22.99 62.8-35.92 62.8-35.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11947 2463.47 45.9-141.95s-44.4 31.06-55.8 59.91c-11.3 28.85 9.9 82.04 9.9 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11947.1 2464.16 46.8-141.68s17.5 51.63 9.6 81.62-56.4 60.06-56.4 60.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11739.7 2514.18 126.8 122.58s-7.4-62.48-32-89.46c-24.6-26.99-94.8-33.12-94.8-33.12"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11735.3 2517.2 133.4 116.79s-63.5-3.27-92.7-25.71c-29.1-22.44-40.7-91.08-40.7-91.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12074 2350.27 99.4-118.36s-53.5 12.26-75.6 35.52c-22 23.26-23.8 82.84-23.8 82.84"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12078.4 2353.2 91.2-122.38s0 55.1-17.3 81.62c-17.4 26.51-73.9 40.76-73.9 40.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12385.9 1237.07 147.6 17.9s-39.4-38.16-69.9-43.78c-30.4-5.63-77.7 25.88-77.7 25.88"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12385.2 1235.43 147.4 22.46s-47.5 25.78-78.4 23c-30.8-2.78-69-45.46-69-45.46"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12478 1037.78 120.9-23.45s-40.5-20.827-65.9-17.57c-25.4 3.26-55 41.02-55 41.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12477.5 1032.75 120.9-12.24s-32.2 30.58-57.1 34.69-63.8-22.45-63.8-22.45"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12216.4 1263.57 121-23.45s-40.5-20.82-65.9-17.56c-25.4 3.25-55.1 41.01-55.1 41.01"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12216 1258.55 120.9-12.24s-32.2 30.58-57.1 34.69-63.8-22.45-63.8-22.45"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12493.6 969.427 57.7-112.158s-40.8 19.984-54.1 42.512c-13.4 22.529-3.6 69.646-3.6 69.646"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12493.1 969.901 59.4-111.739s7.3 45.121-3.6 69.03c-10.9 23.91-55.8 42.709-55.8 42.709"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12384.5 1400.47-139.7-53.3s28.5 45.95 56.8 58.77c28.3 12.83 82.9-5.47 82.9-5.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12385.2 1400.6-139.4-54.6s52.8-14.9 82.4-5.36c29.7 9.53 57 59.96 57 59.96"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12421.8 1187.05 57.8-112.16s-40.8 19.98-54.2 42.51c-13.3 22.53-3.6 69.65-3.6 69.65"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12421.4 1187.53 59.4-111.74s7.2 45.12-3.7 69.03c-10.8 23.91-55.7 42.71-55.7 42.71"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12430 1187.25-90.2-118.49s-1.8 54.2 15.2 79.92c17.1 25.72 75 38.57 75 38.57"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12435 1187.62-98.2-119.01s53.6 12.94 75.4 36.37 22.8 82.64 22.8 82.64"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12331.1 1250.34-120.2-93.68s12.5 52.73 36.1 73.64c23.6 20.92 84.1 20.04 84.1 20.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12333.1 1247.52-122.5-88.47s54.9-3.2 81.4 13.47 41.1 75 41.1 75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12475.6 1040.78-52.4-142.002s-17 51.036-8 81.054 60.4 60.948 60.4 60.948"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12473.2 1041.26-45.8-142.338s44.5 32.427 55.8 61.428-10 80.91-10 80.91"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.571}
      d="M10784.1 2825.6s-105.1-219.93-159.8-281.69c-37-41.78-154.1-95.28-154.1-95.28s110.4 102.78 150.3 161.05c50.4 73.9 140 250.82 140 250.82s22.2-3.87 27.2-11.13c5.1-7.26-3.6-23.77-3.6-23.77"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10569 2519.58 111.9-76.6s-14.3 46.14-36.4 63.42c-22.2 17.27-75.5 13.18-75.5 13.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10568.7 2517.29 111.1-72.64s-48.5-4.28-72.5 9.31-38.6 63.33-38.6 63.33"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10654.9 2598.33 133.1 18.49s-43 24.99-70.9 22.92c-27.8-2.07-62.2-41.41-62.2-41.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10654.4 2603.46 133 6.99s-36.9-31.66-64.4-34.83c-27.4-3.17-68.6 27.84-68.6 27.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10493.1 2469.89-108.5 57.85s18-40.21 39.7-53.57c21.8-13.35 68.8-4.28 68.8-4.28"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10491 2471.31-103.1 55.92s43.2 5.71 65.3-4.61c22.2-10.33 37.8-51.31 37.8-51.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10492.6 2464.33-108.4-62.23s45-4.9 68.3 6.67c23.2 11.57 40.1 55.56 40.1 55.56"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10492.6 2466.87-108-65.5s16.4 42.26 38 57.2c21.5 14.93 70 8.3 70 8.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m10603.9 2570.1-89.1 107.52s.3-50.5 17.3-73.92 71.8-33.6 71.8-33.6"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m10608.6 2570.78-96.6 106.09s50.4-9.39 71.7-30.14c21.3-20.76 24.9-75.95 24.9-75.95"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10571.7 2540-124.3 4.04s35.7-29.13 61.5-31.59c25.7-2.47 62.8 27.55 62.8 27.55"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10572.2 2537.45-124 10.25s38 24.34 63.9 23.8c25.8-.54 60.1-34.05 60.1-34.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10581.6 2512.25-19.5-149.1s-28.8 46.38-26.8 77.48 46.3 71.62 46.3 71.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10576.2 2512.85-7.3-149.06s34.7 42.75 38.1 73.63-30.8 75.43-30.8 75.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10495 2471.86-42.1-142.9s43.7 32.13 54.2 61.22c10.6 29.09-12.1 81.68-12.1 81.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10494.8 2472.55-42.9-142.62s-18.7 51.13-11.6 81.27c7.1 30.15 54.5 61.35 54.5 61.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10615.6 2576.3 10.4 123.42s-30.9-33.03-34.7-58.47c-3.8-25.43 24.3-64.95 24.3-64.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10614 2575.75 14.7 123.24s22.5-39.58 21-65.36-35.7-57.88-35.7-57.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10587.1 2740.79 124.4-13.32s-39.4-24.47-65.4-23.35c-26 1.11-59 36.67-59 36.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10586.6 2736.35 124.3-3.28s-35.2 28.59-60.9 30.88c-25.7 2.28-63.4-27.6-63.4-27.6"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10759.5 2811.47 101.9-112.45s-2.6 54.45-22.2 79.03c-19.6 24.59-79.7 33.42-79.7 33.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10754.9 2809.74 109.3-109.05s-54.7 7.11-78.7 28.3c-24.1 21.19-30.6 80.75-30.6 80.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m10712.7 2699.28 120.7-29.6s-28.7 35.24-53.4 42.92c-24.6 7.69-67.3-13.32-67.3-13.32"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m10712.1 2699.44 120.5-30.91s-41.8-17.34-67.2-12.46-53.3 43.37-53.3 43.37"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10656 2602.32 83.4-121.38s4.1 53.83-11.6 80.09c-15.6 26.25-71.8 41.29-71.8 41.29"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10651.3 2603.75 90.7-123.88s-52.5 16.11-72.8 40.64c-20.4 24.54-17.9 83.24-17.9 83.24"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12535.4 2038.31 81.9 92.67s-1.6-44.49-17.3-64.73c-15.8-20.24-64.6-27.94-64.6-27.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12531.5 2039.52 88.2 90.26s-44.7-6.47-64.1-24.04c-19.3-17.57-24.1-66.22-24.1-66.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12424.3 1892.34 49.2-115.22s-39.2 22.71-50.9 45.98c-11.6 23.27 1.7 69.24 1.7 69.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12423.4 1892.93 51.8-115.02s10.8 44.56 1.5 69.06c-9.2 24.51-53.3 45.96-53.3 45.96"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12366.5 1910.19 47.3 120.9s13.5-44.07 5.3-69.67c-8.2-25.59-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12367.7 1909.79 43.4 121.22s-39.1-26.56-49.6-51.19c-10.6-24.64 6.2-70.03 6.2-70.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12619.7 1930.08 45.9-141.96s-44.5 31.07-55.8 59.92 9.9 82.04 9.9 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12619.8 1930.76 46.8-141.67s17.4 51.62 9.5 81.61-56.3 60.06-56.3 60.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12396.8 2963.28 145.5-98.16s-63.1-2.62-94.5 15.93-51 82.23-51 82.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12398.5 2967.99 141.9-105.09s-17.4 60.71-45.5 84.26c-28 23.55-96.4 20.83-96.4 20.83"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12904.1 1644.75 132.5-68.53s-53.4-9.23-81.8 3.29c-28.3 12.52-50.7 65.24-50.7 65.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12903.8 1646.94 132.7-70.87s-22.3 49.39-48.9 65.77c-26.6 16.37-83.8 5.1-83.8 5.1"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12208.8 1891.73 81.9 92.67s-1.6-44.48-17.3-64.73c-15.8-20.24-64.6-27.94-64.6-27.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12204.8 1892.95 88.3 90.26s-44.7-6.47-64.1-24.04c-19.4-17.58-24.2-66.22-24.2-66.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m13241.3 1568.36 58.5-111.85s-40.9 19.72-54.4 42.18c-13.5 22.45-4.1 69.67-4.1 69.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m13241.6 1568.66 58.8-111.05s6.9 44.94-3.9 68.7c-10.8 23.77-54.9 42.35-54.9 42.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12556.7 1789.83 47.3 120.9s13.5-44.08 5.3-69.67-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12557.8 1789.43 43.5 121.22s-39.1-26.56-49.7-51.19c-10.5-24.64 6.2-70.03 6.2-70.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12149.7 2034.89 45.9-141.95s-44.4 31.06-55.7 59.91c-11.4 28.85 9.8 82.04 9.8 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12149.9 2035.58 46.7-141.68s17.5 51.62 9.6 81.61-56.3 60.07-56.3 60.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13013.6 1694.15 62.4 162.99s18.7-59.09 7.9-93.57c-10.8-34.49-70.3-69.42-70.3-69.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13015.6 1693.61 56.3 163.4s-52.1-36.35-65.8-69.6c-13.7-33.24 9.5-93.8 9.5-93.8"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13179.9 1725.22 48.1 143.96s19-50.68 10.9-81.05c-8-30.37-59-62.91-59-62.91"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13183.8 1724.71 38.6 144.24s-42.9-34.65-52.7-64.15c-9.8-29.49 14.1-80.09 14.1-80.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12230.8 2828.38 108.9 57.12s-18.3-40.08-40.1-53.29-68.8-3.83-68.8-3.83"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12232.8 2829.12 103.6 56.5s-43.1 6.2-65.3-4.21c-22.3-10.4-38.3-52.29-38.3-52.29"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12910.3 1645.79-40.6-119.9s-15.6 42.32-8.8 67.62 49.4 52.28 49.4 52.28"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12907.1 1646.2-32.9-120.13s35.9 28.68 44.3 53.24c8.4 24.55-11.4 66.89-11.4 66.89"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11664.4 2517.59 47.3 120.9s13.5-44.08 5.3-69.67c-8.3-25.6-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11665.5 2517.19 43.5 121.21s-39.1-26.55-49.7-51.19c-10.5-24.64 6.2-70.02 6.2-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12304.1 1905.63 45.9-141.95s-44.4 31.06-55.7 59.91c-11.4 28.85 9.8 82.04 9.8 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12304.3 1906.32 46.7-141.68s17.5 51.62 9.6 81.61-56.3 60.07-56.3 60.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13148.7 1713.98 145-99.33s-63.2-2.27-94.5 16.52-50.5 82.81-50.5 82.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13150.5 1718.76 141.1-106.42s-16.8 60.9-44.7 84.71c-27.8 23.82-96.4 21.71-96.4 21.71"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12225.2 2911.84 119.9 128.39s-4.1-62.84-27.2-90.95c-23-28.11-92.7-37.44-92.7-37.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12220 2914.14 128.1 123.89s-63.4-7.07-91.4-31.09c-28.1-24.01-36.7-92.8-36.7-92.8"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12046.2 2914.91-21.7 170s44.5-43.99 51.3-78.94c6.7-34.94-29.6-91.06-29.6-91.06"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12047.7 2914.15-26.2 169.72s-29.1-55.74-25.8-91.31c3.2-35.58 52-78.41 52-78.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12198.3 1905.27 75.9-131.65s-50 21.65-67.4 47.99c-17.3 26.34-8.5 83.66-8.5 83.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12201.4 1905.74 70.8-130.88s6.5 53.8-6.6 81.86-64.2 49.02-64.2 49.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12869.2 1266.33 111.3 133.6s-.5-62.85-21.7-91.96c-21.3-29.1-89.6-41.64-89.6-41.64"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12863.5 1267.24 120.5 131.69s-62.7-11.49-89.3-37.25c-26.6-25.75-31.2-94.44-31.2-94.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11864.5 2943.61 86.5-126.46s-51.7 17.73-71.2 42.85-15.3 83.61-15.3 83.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11868.4 2945.06 79.7-127.6s3.8 54.51-11.1 81.99c-15 27.48-68.6 45.61-68.6 45.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12511.5 2931.63 108.7 63.76s-16.5-41.86-38.2-56.43c-21.7-14.58-70.5-7.33-70.5-7.33"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12513.1 2933.37 104.3 61.11s-44.5 4.78-66.9-6.58c-22.5-11.36-37.4-54.53-37.4-54.53"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11830.2 3000.58 157.9 71.05s-29.5-54.91-61.3-71.63c-31.8-16.73-96.6.58-96.6.58"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11829.4 2998.99 157.7 75.24s-62.6 13.52-96.3-.03-61.4-75.21-61.4-75.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13277.5 1742.65 64.9 134.46s10.8-52.6-.9-81.27c-11.8-28.67-64-53.19-64-53.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13274.9 1742.24 68 134.83s-48.8-24.78-64.6-51.91c-15.8-27.12-3.4-82.92-3.4-82.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m13186.5 1448.61 59.2 120.27s9.3-47.45-1.5-73.12c-10.7-25.67-57.7-47.15-57.7-47.15"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m13183.9 1448.25 62.5 120.6s-44.1-21.78-58.6-46.02c-14.4-24.24-3.9-74.58-3.9-74.58"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11875.1 2940.06-35.7-121.59s-17.7 41.82-11.9 67.41 47.6 54.18 47.6 54.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11870.8 2940.5-25.8-121.75s34.3 30.74 41.2 55.72c6.9 24.99-15.4 66.03-15.4 66.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12364.1 2848.35 47.3 120.91s13.5-44.08 5.3-69.67c-8.2-25.6-52.6-51.24-52.6-51.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12365.2 2847.95 43.5 121.22s-39.1-26.56-49.6-51.19c-10.6-24.64 6.1-70.03 6.1-70.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12409.1 2646.26 47.3 120.91s13.5-44.08 5.3-69.67c-8.3-25.6-52.6-51.24-52.6-51.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12410.2 2645.87 43.5 121.21s-39.1-26.55-49.7-51.19c-10.5-24.64 6.2-70.02 6.2-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13276.3 1743.21 159.9-61.73s-61.1-16.88-95.1-6.1c-34.1 10.77-64.8 67.83-64.8 67.83"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13275.7 1744.62 160.3-62.31s-32.2 53.5-64.5 68.48c-32.4 14.98-95.8-6.17-95.8-6.17"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M12446.4 1980.07c-26.1 2.37-46.1 21.24-44.7 42.15s23.7 35.94 49.7 33.58c26.1-2.37 46.1-21.24 44.7-42.15s-23.6-35.95-49.7-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12411.8 2035.76s-7.9-22.13 2.4-31.02c13.4-11.57 29.9-1.74 29.9-1.74-8.6 1.27-18.3 1.39-23.5 6.99-5.7 6.14-6.5 18.03-8.8 25.77"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M12443.9 2030.34s10.1 2.95 10.8 3.97c4.6 6.66 6.3 8.08 6.3 8.08s-9.6 3.66-14.2 3.2-9.7-3.54-9.7-3.54.4 5.34-.8 7.22c-1.4 2.24-7.6 6.22-7.6 6.22s-6-4.13-7.2-6.96c-1.3-2.91 4.6-9.26 4.6-9.26s-5.7.94-9.1-.73c-3.6-1.74-8.5-7.3-8.5-7.3s4.4-3.88 7.8-4.42c3.2-.51 12.8 1.15 12.8 1.15s-6.6-4.46-8.9-7.84c-2.4-3.52 4-9.69 4-9.69s7.4 3.86 10.9 7.01c2.7 2.41.8 8.32.8 8.32s2.5-6.12 5.5-8.33c3-2.2 11.1-1.93 11.1-1.93s2.8 7.26 1.2 10.22c-1.6 2.82-9.8 4.61-9.8 4.61"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M12435.2 2041.48c1.4-.13 3.9.23 4.8-.46 1-.69 2.2-2.84 2.5-4.07.8-3.26.7-5.61-2.5-7.75-1.2-.77-3.4.02-4.6.13-.7.06-1.5.03-2.2.19-2.5.63-4.4 2.41-6 4.06-.7.67-1.3 2.15-.7 2.98.6.75 1.5 1.43 1.9 2.24.7 1.08 1.8 3.26 3.4 3.73 1 .31 1.4-.45 2.2-.71.7-.28.3-.06 1.2-.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M12535.5 1892.32c-22.3 2.03-39.5 18.18-38.3 36.08s20.3 30.76 42.6 28.74c22.3-2.03 39.4-18.18 38.2-36.08-1.1-17.89-20.2-30.76-42.5-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12505.9 1939.98s-6.8-18.93 2-26.55c11.5-9.9 25.6-1.48 25.6-1.48-7.3 1.09-15.6 1.19-20.1 5.98-4.9 5.25-5.6 15.43-7.5 22.05"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12533.4 1935.35s8.5 2.53 9.1 3.4c4 5.7 5.5 6.91 5.5 6.91s-8.2 3.14-12.2 2.74c-3.9-.39-8.3-3.03-8.3-3.03s.4 4.57-.6 6.18c-1.2 1.92-6.6 5.32-6.6 5.32s-5.1-3.53-6.2-5.95c-1.1-2.49 4-7.93 4-7.93s-4.8.81-7.8-.62c-3-1.49-7.3-6.25-7.3-6.25s3.8-3.32 6.7-3.78c2.7-.44 11 .99 11 .99s-5.7-3.83-7.7-6.72c-2-3.01 3.5-8.29 3.5-8.29s6.3 3.3 9.3 6c2.3 2.06.7 7.12.7 7.12s2.1-5.24 4.7-7.13c2.5-1.88 9.5-1.65 9.5-1.65s2.4 6.21 1 8.75c-1.3 2.4-8.3 3.94-8.3 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M12525.9 1944.88c1.2-.11 3.3.19 4.1-.39.8-.59 1.9-2.43 2.1-3.49.7-2.79.7-4.8-2.1-6.63-1-.66-2.9.02-4 .11-.5.05-1.2.02-1.8.17-2.2.53-3.8 2.05-5.2 3.47-.5.57-1 1.84-.5 2.55.4.64 1.2 1.22 1.6 1.92.6.92 1.5 2.79 2.8 3.18 1 .27 1.3-.38 1.9-.6.7-.24.3-.05 1.1-.29"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M11842.9 2507.34c-22.3 2.03-39.4 18.18-38.3 36.08 1.2 17.89 20.3 30.76 42.6 28.74 22.3-2.03 39.5-18.18 38.3-36.08s-20.3-30.76-42.6-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11813.3 2555s-6.8-18.94 2.1-26.56c11.4-9.9 25.5-1.48 25.5-1.48-7.3 1.09-15.6 1.19-20.1 5.98-4.8 5.25-5.6 15.43-7.5 22.06"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11840.8 2550.36s8.6 2.53 9.2 3.41c3.9 5.69 5.4 6.91 5.4 6.91s-8.2 3.13-12.2 2.74c-3.9-.39-8.3-3.03-8.3-3.03s.4 4.57-.6 6.18c-1.2 1.92-6.6 5.32-6.6 5.32s-5.1-3.54-6.1-5.95c-1.2-2.49 3.9-7.93 3.9-7.93s-4.8.8-7.8-.62c-3-1.49-7.3-6.25-7.3-6.25s3.8-3.32 6.7-3.78c2.8-.44 11 .98 11 .98s-5.7-3.82-7.6-6.71c-2.1-3.02 3.4-8.3 3.4-8.3s6.3 3.31 9.3 6c2.3 2.07.7 7.13.7 7.13s2.1-5.24 4.7-7.13c2.5-1.89 9.5-1.65 9.5-1.65s2.4 6.21 1 8.74c-1.3 2.41-8.3 3.94-8.3 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M11833.3 2559.9c1.2-.11 3.3.19 4.1-.4.9-.59 1.9-2.43 2.1-3.48.7-2.79.7-4.8-2.1-6.64-1-.65-2.9.02-3.9.12-.6.05-1.3.02-1.9.16-2.1.54-3.8 2.06-5.2 3.47-.5.57-1 1.84-.5 2.56.4.63 1.2 1.22 1.6 1.91.6.92 1.5 2.79 2.9 3.19.9.27 1.2-.38 1.8-.61.7-.24.3-.05 1.1-.28"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M11979 2521.18c-26.1 2.37-46.1 21.24-44.7 42.15s23.6 35.95 49.7 33.58 46.1-21.24 44.7-42.15-23.7-35.94-49.7-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11944.4 2576.86s-7.9-22.13 2.4-31.03c13.4-11.56 29.9-1.73 29.9-1.73-8.6 1.27-18.3 1.39-23.5 6.99-5.7 6.14-6.5 18.03-8.8 25.77"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M11976.5 2571.45s10 2.95 10.7 3.97c4.6 6.66 6.4 8.08 6.4 8.08s-9.6 3.66-14.2 3.2c-4.7-.46-9.8-3.54-9.8-3.54s.5 5.34-.7 7.22c-1.4 2.24-7.7 6.22-7.7 6.22s-5.9-4.13-7.2-6.96c-1.3-2.91 4.6-9.26 4.6-9.26s-5.6.94-9-.73c-3.6-1.74-8.6-7.3-8.6-7.3s4.5-3.88 7.8-4.42c3.3-.51 12.9 1.15 12.9 1.15s-6.7-4.46-8.9-7.84c-2.4-3.52 3.9-9.69 3.9-9.69s7.4 3.86 10.9 7.01c2.7 2.41.9 8.32.9 8.32s2.4-6.12 5.4-8.33c3-2.2 11.1-1.93 11.1-1.93s2.9 7.26 1.3 10.22c-1.6 2.82-9.8 4.61-9.8 4.61"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M11967.8 2582.58c1.4-.13 3.8.22 4.8-.46 1-.69 2.1-2.84 2.4-4.07.8-3.26.8-5.61-2.4-7.76-1.2-.76-3.4.03-4.7.14-.6.06-1.5.02-2.1.19-2.5.63-4.5 2.41-6.1 4.06-.6.66-1.2 2.15-.6 2.98.5.75 1.4 1.43 1.9 2.24.7 1.07 1.7 3.26 3.3 3.72 1.1.32 1.5-.44 2.2-.71.8-.28.3-.05 1.3-.33"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12563.9 2053.16c24.7-2.99 43.2-21.46 41.3-41.24s-23.4-33.39-48.1-30.4-43.2 21.45-41.3 41.23c1.8 19.79 23.4 33.4 48.1 30.41"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12563.8 2004.43s-9.6-2.38-10.3-3.31c-4.7-6.11-6.4-7.38-6.4-7.38s8.9-3.87 13.3-3.63 9.4 2.95 9.4 2.95-.7-5.04.3-6.87c1.3-2.17 7-6.2 7-6.2s5.8 3.66 7.1 6.29c1.4 2.69-3.9 8.96-3.9 8.96s5.3-1.13 8.6.31c3.4 1.49 8.4 6.55 8.4 6.55s-4.1 3.86-7.2 4.51c-3 .62-12.2-.56-12.2-.56s6.5 3.95 8.8 7.06c2.4 3.23-3.4 9.33-3.4 9.33s-7.1-3.34-10.6-6.18c-2.6-2.17-1.1-7.84-1.1-7.84s-2.1 5.9-4.9 8.11c-2.7 2.21-10.4 2.29-10.4 2.29s-3-6.75-1.6-9.62c1.4-2.73 9.1-4.77 9.1-4.77"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12553.9 2043.06s-22.4 2.44-27.9-8.75c-7.1-14.52 6.4-27.34 6.4-27.34-1.1 8.02-3.6 16.81.2 22.69 4.1 6.44 14.8 9.73 21.3 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12572.6 1994.64c-1.3.16-3.6-.11-4.5.57s-2 2.75-2.2 3.93c-.7 3.11-.6 5.34 2.5 7.28 1.2.7 3.3-.12 4.4-.26.7-.07 1.5-.06 2.1-.24 2.3-.67 4.1-2.41 5.6-4.02.6-.65 1.1-2.07.5-2.85-.5-.69-1.4-1.31-1.8-2.07-.7-1-1.8-3.03-3.3-3.43-1-.27-1.4.47-2.1.74-.7.28-.3.06-1.2.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12369 1898.77c24.7-2.99 43.2-21.45 41.3-41.23s-23.4-33.4-48.1-30.41c-24.7 3-43.2 21.46-41.3 41.24 1.8 19.78 23.4 33.4 48.1 30.4"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12368.9 1850.05s-9.6-2.38-10.4-3.31c-4.6-6.11-6.3-7.38-6.3-7.38s8.9-3.87 13.3-3.63c4.4.25 9.3 2.95 9.3 2.95s-.6-5.03.4-6.86c1.3-2.18 7-6.21 7-6.21s5.8 3.67 7.1 6.29c1.4 2.69-3.9 8.96-3.9 8.96s5.3-1.13 8.6.31c3.4 1.49 8.4 6.55 8.4 6.55s-4.1 3.86-7.2 4.51c-3 .62-12.2-.56-12.2-.56s6.4 3.95 8.8 7.06c2.4 3.23-3.4 9.34-3.4 9.34s-7.2-3.35-10.6-6.19c-2.7-2.17-1.2-7.84-1.2-7.84s-2 5.9-4.8 8.11c-2.7 2.21-10.4 2.29-10.4 2.29s-3-6.75-1.6-9.62c1.4-2.73 9.1-4.77 9.1-4.77"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12359 1888.69s-22.4 2.43-27.9-8.76c-7.1-14.52 6.4-27.34 6.4-27.34-1.2 8.02-3.6 16.81.1 22.7 4.2 6.43 14.9 9.73 21.4 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12377.7 1840.26c-1.3.16-3.6-.1-4.5.57-.9.69-2 2.76-2.2 3.94-.7 3.11-.6 5.33 2.5 7.28 1.2.69 3.3-.12 4.4-.26.7-.08 1.4-.07 2.1-.25 2.3-.66 4.1-2.4 5.6-4.01.6-.66 1.1-2.08.5-2.85-.5-.69-1.4-1.31-1.9-2.07-.6-1-1.7-3.04-3.2-3.44-1-.26-1.4.47-2.1.74-.7.29-.3.06-1.2.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12123 2349.76c24.7-2.8 43.1-21.27 41.2-41.24s-23.4-33.89-48.1-31.09c-24.6 2.8-43.1 21.26-41.2 41.23 2 19.98 23.5 33.9 48.1 31.1"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12122.7 2300.48s-9.3-2.62-9.9-3.56c-4.2-6.2-5.8-7.51-5.8-7.51s9.1-3.6 13.4-3.24 9 3.18 9 3.18-.2-5.02.9-6.81c1.4-2.14 7.3-5.98 7.3-5.98s5.5 3.79 6.6 6.43c1.1 2.72-4.5 8.8-4.5 8.8s5.3-.98 8.4.54c3.3 1.58 7.9 6.73 7.9 6.73s-4.3 3.73-7.5 4.29c-3 .53-11.9-.88-11.9-.88s6.1 4.1 8.1 7.24c2.2 3.28-3.9 9.19-3.9 9.19s-6.9-3.52-10.1-6.43c-2.4-2.22-.6-7.82-.6-7.82s-2.4 5.81-5.3 7.93c-2.8 2.12-10.4 2-10.4 2s-2.5-6.79-.9-9.6c1.5-2.68 9.2-4.5 9.2-4.5"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12112.1 2339.74s-21.8 1.84-26.8-9.51c-6.5-14.73 6.8-27.21 6.8-27.21-1.2 8-3.9 16.74-.4 22.73 3.9 6.56 14.2 10.14 20.4 13.99"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12131.7 2290.84c-1.3.15-3.6-.13-4.5.54-.9.68-2 2.76-2.2 3.95-.7 3.13-.6 5.38 2.5 7.37 1.2.7 3.3-.1 4.4-.23.7-.07 1.5-.05 2.1-.23 2.3-.65 4.1-2.39 5.6-4 .6-.66 1.1-2.09.5-2.87-.5-.7-1.4-1.34-1.9-2.1-.6-1.02-1.7-3.08-3.2-3.5-1-.28-1.4.46-2.1.73-.7.28-.3.06-1.2.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12146.8 2408.11c24.5 0 44.4-16.37 44.4-36.57 0-20.19-19.9-36.56-44.4-36.56s-44.3 16.37-44.3 36.56c0 20.2 19.8 36.57 44.3 36.57"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12151.5 2358.77s-9-3.76-9.6-4.78c-3.5-6.66-5-8.17-5-8.17s9.4-2.44 13.6-1.55c4.3.89 8.7 4.28 8.7 4.28s.2-5.03 1.5-6.66c1.6-1.95 7.9-5.03 7.9-5.03s5 4.45 5.9 7.21c.9 2.84-5.4 8.17-5.4 8.17s5.4-.32 8.4 1.59c3.1 1.98 7.1 7.66 7.1 7.66s-4.6 3.17-7.8 3.33c-3 .16-11.8-2.36-11.8-2.36s5.7 4.83 7.4 8.21c1.8 3.51-4.8 8.63-4.8 8.63s-6.5-4.34-9.4-7.63c-2.2-2.52.2-7.84.2-7.84s-3 5.46-6 7.21c-3.1 1.76-10.6.69-10.6.69s-1.9-7.05 0-9.65c1.8-2.46 9.7-3.31 9.7-3.31"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12136.9 2396.76s-22.1-.94-26-12.74c-5.2-15.33 9.5-25.93 9.5-25.93-2.1 7.71-5.6 15.99-2.6 22.33 3.2 6.94 13.2 11.77 19.1 16.34"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12161.3 2350.25c-1.3 0-3.5-.55-4.5.02-.9.58-2.1 2.54-2.5 3.7-1 3.06-1.1 5.31 1.8 7.66 1.1.83 3.2.27 4.4.27.6 0 1.3.11 2 0 2.4-.38 4.3-1.92 5.9-3.37.6-.58 1.3-1.95.8-2.8-.5-.77-1.3-1.5-1.7-2.32-.5-1.09-1.4-3.28-2.9-3.87-.9-.39-1.4.31-2.1.5-.7.2-.3.02-1.2.21"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M12424.7 1962.83c21.8-2.63 38.1-18.7 36.5-35.89-1.7-17.2-20.6-29-42.4-26.37-21.7 2.63-38 18.7-36.4 35.89s20.6 29 42.3 26.37"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M12424.7 1920.48s-8.5-2.05-9.1-2.86c-4.1-5.3-5.6-6.41-5.6-6.41s7.9-3.37 11.7-3.17c3.9.2 8.3 2.55 8.3 2.55s-.6-4.38.3-5.97c1.1-1.9 6.2-5.4 6.2-5.4s5.1 3.17 6.2 5.45c1.2 2.34-3.5 7.79-3.5 7.79s4.7-.99 7.6.26c3.1 1.29 7.4 5.68 7.4 5.68s-3.6 3.36-6.3 3.93c-2.7.54-10.8-.46-10.8-.46s5.7 3.42 7.7 6.12c2.2 2.8-2.9 8.12-2.9 8.12s-6.3-2.9-9.4-5.36c-2.3-1.88-1-6.82-1-6.82s-1.8 5.14-4.2 7.06c-2.4 1.93-9.2 2.01-9.2 2.01s-2.6-5.86-1.4-8.36c1.2-2.37 8-4.16 8-4.16"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12415.9 1954.03s-19.7 2.14-24.5-7.55c-6.2-12.58 5.6-23.71 5.6-23.71-1 6.95-3.2 14.58.2 19.67 3.6 5.57 13 8.42 18.7 11.59"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M12432.5 1911.97c-1.2.14-3.2-.09-4 .5s-1.7 2.39-1.9 3.42c-.6 2.7-.6 4.64 2.2 6.32 1 .6 2.9-.11 3.9-.23.5-.07 1.2-.06 1.8-.21 2.1-.58 3.6-2.1 4.9-3.5.6-.57 1-1.81.5-2.48-.5-.6-1.2-1.14-1.6-1.79-.6-.87-1.6-2.64-2.9-2.99-.9-.23-1.2.41-1.8.65-.7.25-.3.05-1.1.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12747.7 1593.85 132.6-120.18s-63.5 5.17-92.4 28.37-40.2 91.81-40.2 91.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12752.3 1598.55 123.7-127.33s-7.5 63.22-31.5 91.15-92.2 36.18-92.2 36.18"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11741.5 2512.23-5.5-149.19s-32.7 43.57-33.5 74.53c-.9 30.95 39 74.66 39 74.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11737.5 2512.86 3.9-149.06s31.3 45.03 32.4 76.04c1 31.01-36.3 73.02-36.3 73.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12519.4 2610.85-58.4 162.48s52.4-34.33 66.6-67.28c14.1-32.95-8.2-95.2-8.2-95.2"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12519.5 2610.05-59.9 162.17s-18.4-60.33-8-94.73c10.3-34.41 67.9-67.44 67.9-67.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12253 2660.37-17.5 170.54s43.6-45.02 49.5-80.13c5.8-35.11-32-90.41-32-90.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12254.9 2659.61-22.7 170.28s-30.3-55.2-27.7-90.85c2.5-35.64 50.4-79.43 50.4-79.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m12098.5 2732.27-15.6 152.61s39-40.29 44.2-71.7c5.2-31.42-28.6-80.91-28.6-80.91"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m12100.2 2731.6-20.4 152.37s-27.1-49.39-24.8-81.29 45.2-71.08 45.2-71.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12747.5 1437.8 10.1 149.27s31.4-44.51 31.4-75.54c-.1-31.02-41.5-73.73-41.5-73.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12752.1 1437.19-.4 149.16s-32.4-44.33-34.2-75.32c-1.8-31 34.6-73.84 34.6-73.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12656.1 1672.85 122.9-27.41s-41.9-20.12-67.8-16.06c-25.8 4.06-55.1 43.47-55.1 43.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12655.6 1667.75 122.9-15.99s-31.9 32.16-57.2 37.07-65.7-21.08-65.7-21.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12730.2 1797.95 58.1-162.56s-52.3 34.41-66.5 67.37c-14.1 32.97 8.4 95.19 8.4 95.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12730.1 1798.74 59.5-162.24s18.5 60.29 8.2 94.71c-10.2 34.41-67.7 67.53-67.7 67.53"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12966.2 1267.86 82.5-128.53s-51.1 19.25-69.8 44.86c-18.7 25.6-12.7 83.67-12.7 83.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12969.8 1268.82 76.3-128.7s4.8 54.23-9.4 81.9c-14.3 27.68-66.9 46.8-66.9 46.8"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m13069.4 1699.71 82 92.67s-1.7-44.48-17.4-64.72c-15.7-20.25-64.6-27.95-64.6-27.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m13065.5 1700.93 88.2 90.26s-44.6-6.47-64-24.04-24.2-66.22-24.2-66.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m13117.9 1512.62-15.5 122.8s32.1-31.81 37-57.05c4.8-25.25-21.5-65.75-21.5-65.75"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m13119 1512.06-18.8 122.61s-21.1-40.24-18.7-65.93c2.3-25.7 37.5-56.68 37.5-56.68"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12926.7 1146.3 47.3 120.9s13.5-44.08 5.3-69.67c-8.2-25.6-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12927.9 1145.9 43.4 121.21s-39.1-26.55-49.6-51.19c-10.6-24.63 6.2-70.02 6.2-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13098.7 1219.17 163.9 52.96s-35.8-51.32-69.1-64.4c-33.3-13.07-94.8 11.44-94.8 11.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13097.9 1219.32 163.6 53.93s-59.6 20.19-94.2 11.09c-34.7-9.1-69.4-65.02-69.4-65.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13326.1 1043.61-134.9 117.21s63.5-3.87 92.9-26.43c29.4-22.55 42-90.78 42-90.78"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13321.8 1038.78-126.5 124.6s8.8-63 33.4-90.4 93.1-34.2 93.1-34.2"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11828.3 1269.05 82 149.98s9.6-61.68-5.5-93.84c-15-32.15-76.5-56.14-76.5-56.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11824.3 1267.84 87.7 151.86s-58-25.24-78.1-55.64-9.6-96.22-9.6-96.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11819.6 1460.18-75.4-126.06s-6.7 53.48 7.2 80.6c14 27.12 68.2 45.46 68.2 45.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11823.6 1461.88-81.3-128.99s51.1 19.83 69.5 45.56c18.5 25.73 11.8 83.43 11.8 83.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11755.5 1142.87-114.5-50.03s21.8 39.41 44.8 51.24c23.1 11.82 69.7-1.21 69.7-1.21"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11756.1 1143.72-114.4-52.51s45-10.29 69.4-.89c24.4 9.41 45 53.4 45 53.4"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11910 1397.52 159.9-61.8s-61.1-16.85-95.1-6.05c-34.1 10.8-64.8 67.85-64.8 67.85"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11909.5 1398.98 160.2-62.47s-32.1 53.53-64.5 68.54-95.7-6.07-95.7-6.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11771.5 1748.03 141.7-48.65s-52.5-17.3-82.5-9.04c-30.1 8.26-59.2 57.69-59.2 57.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11771 1746.18 141.9-43.18s-31.1 44.17-60 54.96c-28.8 10.8-81.9-11.78-81.9-11.78"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11838.5 1463.18-118.1 40.92s43.9 14.24 68.9 7.27c25.1-6.96 49.2-48.19 49.2-48.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11838.9 1464.49-118.2 36.81s25.8-37 49.8-46.17c24-9.16 68.4 9.36 68.4 9.36"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11912.4 1701.83-156.9-73.61s28.6 55.38 60.1 72.63c31.6 17.24 96.8.98 96.8.98"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11913.3 1703.83-156.8-78.6s63.1-12.48 96.6 1.77 60.2 76.83 60.2 76.83"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11938.5 1745.33 101.7-116.69s-53.8 11.22-76.3 34.11c-22.5 22.88-25.4 82.58-25.4 82.58"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11943 1748.44 93.2-121.04s-.7 55.12-18.5 81.38c-17.8 26.27-74.7 39.66-74.7 39.66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m11641 1216.06 117.4-65.33s-48.3-6.07-73.4 6.02c-25.2 12.1-44 59.31-44 59.31"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11640.9 1218.57 117.3-68.42s-18.5 45.17-41.9 60.83-75.4 7.59-75.4 7.59"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.505}
      d="m11967.1 1267.76-53.6-114.11s-9.6 44.13 0 68.43c9.7 24.31 53.6 45.68 53.6 45.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11968.9 1268.11-55.5-114.44s40.8 21.57 53.8 44.63c12.9 23.05 1.7 69.81 1.7 69.81"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m11483.5 1523.28 102.7-35.33s-38.1-12.51-59.9-6.5c-21.8 6-42.8 41.83-42.8 41.83"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m11483.1 1521.99 102.8-31.47s-22.5 32.05-43.4 39.91-59.4-8.44-59.4-8.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11708.1 1669.88-35.6-121.62s-17.7 41.8-12 67.4c5.8 25.6 47.6 54.22 47.6 54.22"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11703.8 1670.32-25.7-121.78s34.2 30.78 41.1 55.77-15.4 66.01-15.4 66.01"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11715.5 1398.12-27.3 169.2s45.8-42.64 53.7-77.36c7.9-34.71-26.4-91.84-26.4-91.84"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11716.5 1397.35-30.7 168.9s-27.7-56.42-23.4-91.88c4.2-35.46 54.1-77.02 54.1-77.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12283.3 1059.57-115.9-99.366s9.8 53.426 32.5 75.466c22.6 22.03 83.4 23.9 83.4 23.9"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12286.1 1056.7-119.7-93.965s55-.736 81 17.122c26 17.859 38.7 76.843 38.7 76.843"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11894.9 1627.89 92.4-86.64s-44.8 4.42-65 21.19c-20.3 16.76-27.4 65.45-27.4 65.45"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11898.2 1631.12 85.9-91.53s-4.5 44.82-21.1 64.86c-16.7 20.04-64.8 26.67-64.8 26.67"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11661.9 1262.85 123.8 9.8s-34.3-30.58-59.9-34.22c-25.6-3.65-63.9 24.42-63.9 24.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11661.4 1260.95 123.5 14.7s-38.9 22.86-64.7 21.39-58.8-36.09-58.8-36.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12167.5 1094.98 118.6-46.92s-45.6-12.1-70.9-3.86c-25.2 8.24-47.7 50.78-47.7 50.78"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12167.1 1096.49 118.8-48.24s-23.4 40.19-47.3 51.72c-24 11.52-71.5-3.48-71.5-3.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11023.8 1084.25 109.6-61.17s-45.1-5.62-68.6 5.71-41 55.46-41 55.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11023.6 1086.62 109.6-64.09s-17.2 42.24-39.1 56.91c-21.8 14.66-70.5 7.18-70.5 7.18"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11208.9 1166.73 120.9-23.45s-40.5-20.82-65.8-17.57c-25.4 3.26-55.1 41.02-55.1 41.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11208.4 1161.71 120.9-12.24s-32.2 30.58-57.1 34.69c-24.9 4.1-63.8-22.45-63.8-22.45"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10893.4 1431.33 120.9-23.45s-40.5-20.82-65.9-17.57c-25.3 3.26-55 41.02-55 41.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10892.9 1426.31 120.9-12.24s-32.2 30.57-57.1 34.68-63.8-22.44-63.8-22.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11171.4 1511.43-139.6-53.3s28.5 45.95 56.7 58.78c28.3 12.82 82.9-5.48 82.9-5.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11172.1 1511.56-139.4-54.59s52.8-14.91 82.5-5.37c29.6 9.53 56.9 59.96 56.9 59.96"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11134.5 1234.12 36.8 121.25s17.2-41.94 11.2-67.48-48-53.77-48-53.77"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11138.5 1233.69 27.4 121.43s-34.6-30.31-41.9-55.21c-7.2-24.89 14.5-66.22 14.5-66.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11134 1238.42 144.7 34.85s-34.6-42.07-64.1-51.16c-29.6-9.08-80.6 16.31-80.6 16.31"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11133.3 1238.21 144.4 36.49s-49.9 20.96-80.3 15.23c-30.4-5.74-64.1-51.72-64.1-51.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11013.5 1420.3-120.2-93.68s12.5 52.73 36.1 73.65c23.6 20.91 84.1 20.03 84.1 20.03"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11015.5 1417.48-122.5-88.47s54.9-3.2 81.4 13.47 41.1 75 41.1 75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11206.5 1169.73-52.3-142s-17.1 51.04-8.1 81.05c9 30.02 60.4 60.95 60.4 60.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11204.1 1170.21-45.8-142.33s44.5 32.42 55.8 61.42-10 80.91-10 80.91"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11014.2 1188.52-115.9-99.36s9.8 53.42 32.5 75.46c22.6 22.03 83.4 23.9 83.4 23.9"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11017 1185.65-119.7-93.96s55-.73 81 17.12c26 17.86 38.7 76.84 38.7 76.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10898.4 1223.93 118.6-46.92s-45.6-12.09-70.8-3.86c-25.3 8.24-47.8 50.78-47.8 50.78"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10898.1 1225.44 118.7-48.24s-23.3 40.19-47.3 51.72-71.4-3.48-71.4-3.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11780.3 1238.03 106.9-142.06s-60.8 17.67-84.6 45.76c-23.9 28.09-22.3 96.3-22.3 96.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11785.2 1240.78 98-145.49s2.6 63.42-15.9 94.82-82.1 50.67-82.1 50.67"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m11751.5 1083.97 32.2-127.838s-37.6 29.856-45.9 55.948c-8.4 26.09 13.7 71.89 13.7 71.89"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m11751.5 1084.57 33.3-127.589s18.1 44.699 12.8 71.609c-5.3 26.9-46.1 55.98-46.1 55.98"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10709.7 1585.66 82 149.98s9.5-61.67-5.5-93.83c-15.1-32.16-76.5-56.15-76.5-56.15"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10705.6 1584.45 87.7 151.87s-57.9-25.25-78-55.65-9.7-96.22-9.7-96.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10599 1582.7-75.4-126.07s-6.7 53.48 7.3 80.6c13.9 27.13 68.1 45.47 68.1 45.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10603 1584.39-81.3-128.99s51.1 19.83 69.6 45.56c18.4 25.72 11.7 83.43 11.7 83.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10844.6 1703.97 159.9-61.8s-61.1-16.85-95.1-6.05c-34.1 10.8-64.8 67.85-64.8 67.85"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10844.1 1705.43 160.2-62.47s-32.1 53.53-64.5 68.55c-32.4 15.01-95.7-6.08-95.7-6.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10658.3 1474.06-62.3 110.26s41.5-18.42 55.8-40.49c14.3-22.08 6.5-69.77 6.5-69.77"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10655.8 1473.73-58.3 109.5s-5.6-44.81 5.1-68.28c10.8-23.46 53.2-41.22 53.2-41.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10608.4 1340.82 123.7 9.8s-34.2-30.57-59.8-34.22c-25.6-3.64-63.9 24.42-63.9 24.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10607.8 1338.92 123.6 14.7s-38.9 22.87-64.7 21.4c-25.8-1.48-58.9-36.1-58.9-36.1"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10784.5 1365.93 106.8-142.06s-60.7 17.67-84.6 45.76c-23.9 28.1-22.2 96.3-22.2 96.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10789.4 1368.69 97.9-145.49s2.7 63.41-15.8 94.81c-18.5 31.41-82.1 50.68-82.1 50.68"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m10797.9 1366.31-46.6-125.82s-15 45.26-7 71.86 53.6 53.96 53.6 53.96"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m10795.8 1366.73-40.8-126.11s39.5 28.66 49.5 54.35c10.1 25.69-8.7 71.76-8.7 71.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10959.8 2056.84 151.8-81.72s-61.8-9.01-94.4 6.03c-32.5 15.05-57.4 75.69-57.4 75.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10959.5 2059.75 151.9-85.11s-24.6 57.6-55 77.16-96.9 7.95-96.9 7.95"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10984.1 2076.84-129.7 75.24s53.9 5.6 81.8-8.41c27.8-14.01 47.9-66.83 47.9-66.83"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10984 2073.71-129.1 79.33s19.4-50.8 45.1-68.86c25.8-18.07 84-10.47 84-10.47"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10608.6 2260.69-103.3 75.04s45.8.64 68.1-13.62c22.4-14.25 35.2-61.42 35.2-61.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10606.7 2257.1-99.4 80.46s10.6-44.47 30.2-62.38 69.2-18.08 69.2-18.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10964.9 2061.92-67.5-159.92s-16.1 59.55-4.2 93.48 71.7 66.44 71.7 66.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10965.1 2062.43-65.7-160.37s53.9 33.14 69.6 65.62-3.9 94.75-3.9 94.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m10481.4 2065.38-135.2 102.14s60.7-.05 90-19.51 45.2-82.63 45.2-82.63"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m10478.5 2060.58-129.4 109.45s12.9-59.22 38.3-83.51 91.1-25.94 91.1-25.94"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10962.6 2073.79 44.5 118.01s13.8-42.64 6.1-67.6-50.6-50.41-50.6-50.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10964.3 2073.4 39.6 118.3s-37.3-26.57-47.1-50.65c-9.7-24.08 7.5-67.65 7.5-67.65"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10662.1 2037.42-87.4 152.2s57.7-25.13 77.7-55.59 9.7-96.61 9.7-96.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10658.5 2036.9-81.5 151.27s-7.6-62.12 7.5-94.55c15.1-32.42 74-56.72 74-56.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10487.4 2072.28-71.2-129.65s-8.2 53.41 4.9 81.21c13.1 27.81 66.3 48.44 66.3 48.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10491 2073.38-76.2-131.38s50.2 21.76 67.6 48.05c17.5 26.3 8.6 83.33 8.6 83.33"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m10673.7 2376.31-65-115.46s-7 47.98 5 72.77 60 42.69 60 42.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10677 2377.51-69.7-117.44s45.3 19.06 61.2 42.54c16 23.48 8.5 74.9 8.5 74.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10474.2 2068.57-15.5 170.77s43.2-45.5 48.6-80.67c5.5-35.18-33.1-90.1-33.1-90.1"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10476.3 2067.81-21.2 170.52s-30.8-54.94-28.5-90.62c2.2-35.68 49.7-79.9 49.7-79.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11204.9 2117.81-127.1 126.28s63.1-8.15 91-32.68c27.8-24.53 36.1-93.6 36.1-93.6"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11199.9 2113.51-117.5 132.7s4.7-63.53 27.4-92.51c22.6-28.97 90.1-40.19 90.1-40.19"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11213.1 2273.69-18.6-149.13s-29.1 46.22-27.2 77.32c1.8 31.1 45.8 71.81 45.8 71.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11207.8 2274.29-6.6-149.09s34.5 42.89 37.8 73.79c3.3 30.89-31.2 75.3-31.2 75.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11246.8 2031.28-121.7 32.65s42.7 18.19 68.3 13.02c25.7-5.16 53.4-45.67 53.4-45.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11247.3 2035.9-121.8 22.14s30.1-33.72 55.1-39.89c25-6.18 66.7 17.75 66.7 17.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11168.5 1899.32-47.6 165.27s50.3-37.38 62.2-71.03c12-33.66-14.6-94.24-14.6-94.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11168.4 1898.54-48.6 164.94s-21.9-58.93-13.9-93.78 62.5-71.16 62.5-71.16"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10442.9 2787.95-78.9 130.28s50.5-20.58 68.5-46.6 10.4-83.68 10.4-83.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10439.6 2787.3-73.3 129.85s-5.7-54 7.9-81.88c13.6-27.87 65.4-47.97 65.4-47.97"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10751.2 2033.75 95.2-83.25s-45 2.88-65.7 18.91c-20.8 16.03-29.5 64.34-29.5 64.34"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10754.3 2037.15 89.1-88.45s-6 44.59-23.4 64.03c-17.3 19.45-65.7 24.42-65.7 24.42"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10680.3 2221.75 7.7-123.7s-30.3 33.66-33.5 59.18 25.8 64.52 25.8 64.52"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10678.4 2222.29 12.6-123.52s23.1 39.24 22.1 65.05c-1.1 25.81-34.7 58.47-34.7 58.47"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10291.5 1593.32 165.4-53.16s-60.2-21.62-95.3-12.74c-35 8.87-70.1 65.9-70.1 65.9"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10290.9 1589.45 165.6-43.48s-37.9 49.64-71.7 60.81-93.9-17.33-93.9-17.33"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10746 2185.33 5.5 149.19s32.7-43.57 33.5-74.53c.9-30.95-39-74.66-39-74.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10750.1 2184.71-4 149.05s-31.3-45.02-32.3-76.03c-1.1-31.02 36.3-73.02 36.3-73.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10605.5 1609.87-78.5 101.77s44.1-12.2 61.6-32.3 16.9-69.47 16.9-69.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10601.9 1607.77-71.9 104.44s-1.5-45.85 12.1-68.41 59.8-36.03 59.8-36.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10775 2033.76-42.9-169.89s-26.9 57.04-20.3 92.72 63.2 77.17 63.2 77.17"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10768.3 2034.39-27.9-170.04s45.5 44.7 53.5 79.69c7.9 34.99-25.6 90.35-25.6 90.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10662.6 1238.47 62.7-136.87s-47.7 26.06-62.5 53.65c-14.7 27.59-.2 83.22-.2 83.22"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10660.7 1239.17 67.3-136.65s11.5 54.01-.7 83.18-66.6 53.47-66.6 53.47"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10861.5 2230.03 121 28.05s-29.2-34.87-53.9-42.24-67.1 14.19-67.1 14.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10861 2229.78 120.7 29.56s-41.6 17.79-67 13.19-53.7-42.75-53.7-42.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10679 1254.46-172.2-2.97s50.1 39.66 85.8 42.53 86.4-39.56 86.4-39.56"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10679.7 1258.29-171.9-12.17s52.3-34.36 88.1-34.04c35.7.32 83.8 46.21 83.8 46.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10604.4 1177.37 30.3-145.39s-41.2 35.27-49.3 65.02c-8.2 29.74 19 80.37 19 80.37"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10604.2 1178.05 32-145.12s22.2 49.66 17.4 80.19c-4.9 30.54-49.4 64.93-49.4 64.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m10649.3 1737.41-46-128.12s-15.8 45.76-8 72.83c7.9 27.07 54 55.29 54 55.29"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10646.7 1737.85-39.2-128.41s39.5 29.74 49.3 55.93c9.7 26.19-10.1 72.48-10.1 72.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10612 1156.69-164.9-49.17s37.1 50.53 70.7 62.83c33.5 12.3 94.2-13.66 94.2-13.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10612.8 1156.57-164.6-50.26s59-21.42 93.8-13.09 70.8 63.35 70.8 63.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10995.8 2260.61 55.4 166.29s22-58.52 12.7-93.6-68.1-72.69-68.1-72.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11000.3 2260.04 44.5 166.6s-49.5-40.05-60.9-74.12c-11.3-34.07 16.4-92.48 16.4-92.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11113.5 2355.63-120.5-95.95s55 1.21 81.2 19.55c26.1 18.35 39.3 76.4 39.3 76.4"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11110.4 2359.97-114.4-102.6s10.1 54.04 32.5 76.73c22.4 22.68 81.9 25.87 81.9 25.87"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10873 2336.98-124.6 6.66s38.1 26.32 64 26.58c26 .26 60.6-33.24 60.6-33.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10873.5 2340.74-124.4-1.99s36.3-26.99 62.1-28.17c25.8-1.19 62.3 30.16 62.3 30.16"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10548.3 1918.38 117.3 130.11s-2.9-62.89-25.5-91.33c-22.5-28.44-91.8-38.78-91.8-38.78"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10542.8 1920.33 126 126.27s-63.2-8.39-90.8-32.94c-27.7-24.54-35.2-93.33-35.2-93.33"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10445.5 1542.78-66.8-99.78s-3.8 43.9 8.8 65.46c12.5 21.57 58 34.32 58 34.32"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10449.3 1544.07-72.6-102.07s42.6 13.77 59 34.02c16.3 20.24 13.6 68.05 13.6 68.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10840.8 2446.24 20.6-124.09s22.8 39.51 20.2 65.45c-2.6 25.93-40.8 58.64-40.8 58.64"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10845.6 2446.73 9.9-124.09s-30.1 34.79-33.7 60.46c-3.7 25.66 23.8 63.63 23.8 63.63"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10269.8 2866.01 97.9-90.51s-47.2 4.32-68.6 21.81-29.3 68.7-29.3 68.7"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10273.3 2869.45 91.1-95.73s-5.1 47.14-22.7 68.12c-17.7 20.98-68.4 27.61-68.4 27.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10516 2939.86-88.7-151.58s57.9 24.65 78.2 54.96 10.5 96.62 10.5 96.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10512.3 2940.46-82.6-150.8s-7.3 62.2 8.1 94.55c15.3 32.34 74.5 56.25 74.5 56.25"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10363.7 2783.77-153.3-82.07s25.3 56.9 56 75.84 97.3 6.23 97.3 6.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10360.8 2781.72-145.7-79.25s61-7.99 92.3 6.64c31.3 14.64 53.4 72.61 53.4 72.61"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M12072.8 2363.35c-26.1 2.06-46.1 20.94-44.7 42.14 1.4 21.21 23.7 36.73 49.7 34.66 26.1-2.07 46.1-20.94 44.8-42.15-1.4-21.21-23.7-36.72-49.8-34.65"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12039.3 2419.56s-8.6-21.62 1.2-30.59c12.7-11.67 29.3-2.33 29.3-2.33-8.4 1.43-17.9 1.75-22.9 7.37-5.3 6.16-5.7 17.88-7.6 25.55"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M12070.4 2414.32s9.8 3.17 10.5 4.2c4.2 6.73 5.8 8.18 5.8 8.18s-9.7 3.43-14.3 2.88c-4.5-.56-9.4-3.75-9.4-3.75s.1 5.33-1.2 7.18c-1.5 2.19-7.9 6.01-7.9 6.01s-5.7-4.24-6.7-7.08c-1.2-2.93 5-9.12 5-9.12s-5.6.81-8.9-.93c-3.5-1.81-8.1-7.46-8.1-7.46s4.6-3.76 8-4.22c3.2-.44 12.7 1.43 12.7 1.43s-6.4-4.59-8.4-8.01c-2.2-3.56 4.5-9.56 4.5-9.56s7.1 4.01 10.4 7.23c2.5 2.46.3 8.3.3 8.3s2.8-6.04 5.9-8.17 11.1-1.68 11.1-1.68 2.5 7.29.7 10.21c-1.7 2.76-10 4.36-10 4.36"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M12061.6 2425.37c1.4-.11 3.9.27 4.8-.41 1-.68 2.2-2.84 2.5-4.09.8-3.3.8-5.68-2.5-7.89-1.2-.79-3.4-.02-4.6.08-.7.05-1.5 0-2.2.17-2.5.6-4.4 2.38-6 4.03-.7.67-1.3 2.16-.7 3.02.6.76 1.5 1.46 2 2.29.6 1.1 1.7 3.32 3.3 3.82 1 .33 1.4-.44 2.2-.7.7-.27.3-.05 1.2-.32"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M10860.9 2299.79c-22.3 2.03-39.4 18.18-38.2 36.08 1.2 17.89 20.2 30.76 42.5 28.74 22.3-2.03 39.5-18.18 38.3-36.08s-20.3-30.76-42.6-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10831.3 2347.45s-6.7-18.94 2.1-26.55c11.4-9.9 25.6-1.49 25.6-1.49-7.4 1.09-15.7 1.19-20.1 5.99-4.9 5.25-5.6 15.42-7.6 22.05"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M10858.8 2342.81s8.6 2.53 9.2 3.4c3.9 5.7 5.4 6.92 5.4 6.92s-8.2 3.13-12.1 2.74c-4-.39-8.4-3.04-8.4-3.04s.4 4.58-.6 6.19c-1.2 1.92-6.5 5.32-6.5 5.32s-5.1-3.54-6.2-5.95c-1.1-2.49 3.9-7.93 3.9-7.93s-4.8.8-7.7-.63c-3.1-1.48-7.4-6.24-7.4-6.24s3.8-3.33 6.7-3.78c2.8-.45 11 .98 11 .98s-5.7-3.82-7.6-6.72c-2-3.01 3.4-8.29 3.4-8.29s6.3 3.31 9.3 6c2.3 2.07.7 7.13.7 7.13s2.2-5.25 4.7-7.13c2.6-1.89 9.5-1.65 9.5-1.65s2.5 6.21 1.1 8.74c-1.4 2.41-8.4 3.94-8.4 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M10851.4 2352.34c1.2-.1 3.2.2 4-.39.9-.59 1.9-2.43 2.2-3.48.6-2.79.6-4.8-2.2-6.64-1-.66-2.9.02-3.9.12-.6.05-1.3.02-1.9.16-2.1.54-3.8 2.06-5.1 3.47-.6.57-1.1 1.84-.6 2.56.5.63 1.2 1.22 1.6 1.91.6.92 1.5 2.79 2.9 3.19.9.27 1.2-.38 1.9-.61.6-.24.2-.05 1.1-.29"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M10955.5 2288.74c-26 2.37-46 21.24-44.7 42.15 1.4 20.91 23.7 35.95 49.8 33.58s46.1-21.24 44.7-42.15-23.7-35.95-49.8-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10921 2344.43s-7.9-22.13 2.4-31.03c13.3-11.56 29.9-1.73 29.9-1.73-8.6 1.27-18.3 1.39-23.5 6.99-5.7 6.14-6.6 18.03-8.8 25.77"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M10953.1 2339.01s10 2.95 10.7 3.97c4.6 6.66 6.4 8.08 6.4 8.08s-9.6 3.66-14.3 3.2c-4.6-.46-9.7-3.55-9.7-3.55s.4 5.35-.7 7.23c-1.4 2.24-7.7 6.22-7.7 6.22s-5.9-4.13-7.2-6.96c-1.3-2.91 4.6-9.27 4.6-9.27s-5.6.95-9.1-.72c-3.5-1.74-8.5-7.3-8.5-7.3s4.4-3.88 7.8-4.42c3.2-.51 12.8 1.15 12.8 1.15s-6.6-4.46-8.9-7.84c-2.3-3.52 4-9.7 4-9.7s7.4 3.87 10.9 7.02c2.7 2.41.8 8.32.8 8.32s2.5-6.12 5.5-8.33c3-2.2 11.1-1.93 11.1-1.93s2.9 7.26 1.2 10.22c-1.5 2.81-9.7 4.61-9.7 4.61"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M10944.4 2350.14c1.4-.13 3.8.23 4.8-.46.9-.69 2.1-2.83 2.4-4.07.8-3.26.8-5.61-2.5-7.75-1.1-.77-3.4.02-4.6.13-.7.06-1.5.03-2.1.19-2.6.63-4.5 2.41-6.1 4.06-.6.67-1.2 2.15-.6 2.98.5.75 1.4 1.43 1.9 2.24.6 1.08 1.7 3.26 3.3 3.73 1.1.31 1.5-.45 2.2-.71.8-.28.3-.06 1.3-.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M10986.7 2164.2c-22.3 2.03-39.4 18.18-38.2 36.08 1.2 17.89 20.2 30.76 42.6 28.74 22.3-2.03 39.4-18.18 38.2-36.08s-20.2-30.76-42.6-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10957.2 2211.85s-6.8-18.93 2-26.55c11.5-9.9 25.6-1.48 25.6-1.48-7.3 1.08-15.7 1.19-20.1 5.98-4.9 5.25-5.6 15.43-7.5 22.05"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M10984.6 2207.22s8.6 2.53 9.2 3.41c4 5.69 5.5 6.91 5.5 6.91s-8.3 3.13-12.2 2.74c-4-.39-8.3-3.04-8.3-3.04s.3 4.58-.7 6.19c-1.2 1.92-6.5 5.32-6.5 5.32s-5.1-3.54-6.2-5.95c-1.1-2.49 4-7.93 4-7.93s-4.9.8-7.8-.62c-3.1-1.49-7.3-6.25-7.3-6.25s3.8-3.32 6.7-3.78c2.7-.45 10.9.98 10.9.98s-5.6-3.82-7.6-6.72c-2-3.01 3.4-8.29 3.4-8.29s6.4 3.31 9.4 6c2.3 2.07.7 7.13.7 7.13s2.1-5.25 4.6-7.13c2.6-1.89 9.5-1.65 9.5-1.65s2.5 6.21 1.1 8.74c-1.4 2.41-8.4 3.94-8.4 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M10977.2 2216.75c1.2-.11 3.3.19 4.1-.39.8-.59 1.8-2.43 2.1-3.49.7-2.79.6-4.8-2.1-6.63-1-.66-3 .02-4 .11-.6.05-1.3.02-1.8.17-2.2.53-3.8 2.06-5.2 3.47-.6.57-1.1 1.84-.6 2.55.5.64 1.3 1.22 1.7 1.92.5.92 1.5 2.79 2.8 3.19.9.26 1.3-.39 1.9-.61.7-.24.3-.05 1.1-.29"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12084.3 2881.16-47.6-116.26s-12.2 42.89-3.9 67.53c8.4 24.64 51.5 48.73 51.5 48.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12083.9 2881.54-45.2-116.58s38.5 24.72 49.4 48.36c10.8 23.65-4.2 68.22-4.2 68.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10455.5 2664.89 42.3 116.24s14.2-41.65 6.9-66.21c-7.2-24.57-49.2-50.03-49.2-50.03"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10457.7 2664.49 36.5 116.52s-36.1-26.77-45.1-50.52c-9.1-23.75 8.6-66 8.6-66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11008.8 2957.07-112.8 61.44s46.1 6.39 70.3-4.95c24.2-11.33 42.5-56.49 42.5-56.49"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11009 2954.82-112.8 64.12s18.1-43.02 40.6-57.73c22.6-14.72 72.2-6.39 72.2-6.39"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10690.4 2848.75-112.9 61.45s46.2 6.38 70.4-4.95c24.1-11.34 42.5-56.5 42.5-56.5"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10690.6 2846.5-112.9 64.12s18.2-43.02 40.7-57.73c22.6-14.72 72.2-6.39 72.2-6.39"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11054.5 2951.05 158.1-64.92s-61.3-15.35-95-3.88c-33.6 11.48-63.1 68.8-63.1 68.8"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11054 2953.77 158.4-68.03s-30.3 54.58-62.3 70.71c-31.9 16.13-96.1-2.68-96.1-2.68"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11028.9 2834.96 41 116.83s14.7-41.55 7.8-66.23c-7-24.67-48.8-50.6-48.8-50.6"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11031.5 2834.56 34.4 117.08s-35.7-27.42-44.3-51.32 9.9-65.76 9.9-65.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10980.3 2953.28 63.1 162.6s18.4-59.14 7.4-93.55c-10.9-34.42-70.5-69.05-70.5-69.05"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10982.1 2952.74 57.4 163.03s-52.3-35.95-66.3-69.1c-13.9-33.15 8.9-93.93 8.9-93.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10850 2880.94-107.1 141.87s60.8-17.54 84.7-45.59 22.4-96.28 22.4-96.28"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10845.1 2878.15-98.2 145.34s-2.6-63.42 16-94.8c18.6-31.37 82.2-50.54 82.2-50.54"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10884.3 2857.15 127.4-81.45s-54.4-3.36-81.9 11.97c-27.4 15.32-45.5 69.48-45.5 69.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10885.2 2860.96 125.3-86.89s-16.7 51.97-41.5 71.55c-24.8 19.57-83.8 15.34-83.8 15.34"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11139.5 3052.5 73 99.78s2.2-45.09-11.5-66.72c-13.8-21.63-61.5-33.06-61.5-33.06"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11135.4 3051.8 79.4 100.96s-44.3-11.87-62-31.79c-17.7-19.93-17.4-69.17-17.4-69.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10676.2 2826.83 29.8 171.71s31.2-54.92 27.3-90.82c-3.8-35.9-57.1-80.89-57.1-80.89"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10682.9 2826.16 14.8 171.72s-41.9-47.94-47.2-83.44c-5.2-35.5 32.4-88.28 32.4-88.28"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10673.6 2828.06 24.3-121.43s-34.1 29.63-40.7 54.49c-6.7 24.86 16.4 66.94 16.4 66.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10673.3 2828.62 26-121.21s18.7 41.33 14.8 66.82c-3.8 25.49-40.8 54.39-40.8 54.39"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11136 3052.34-5.3 127.77s30.6-35.3 33.4-61.69c2.8-26.4-28.1-66.08-28.1-66.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11138.3 3051.78-11 127.61s-24.5-40.12-23.9-66.76c.7-26.64 34.9-60.85 34.9-60.85"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10893 2864.29 1.7-124.16s-28.8 35-30.8 60.69 29.1 63.47 29.1 63.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10890.4 2864.82 8-124.01s24.6 38.43 24.5 64.3c-.1 25.86-32.5 59.71-32.5 59.71"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12228.2 2822.8-47.5-116.26s-12.3 42.89-3.9 67.53c8.3 24.65 51.4 48.73 51.4 48.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12227.9 2823.18-45.3-116.58s38.6 24.72 49.4 48.36c10.9 23.65-4.1 68.22-4.1 68.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11557.3 1131.96-87-92.02s44.4 7.23 63.5 25.18c19.2 17.96 23.5 66.84 23.5 66.84"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11553.7 1134.81-80.1-96.17s2.1 45.01 17.5 65.95c15.3 20.94 62.6 30.22 62.6 30.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11401 1400.32-111.3 67.11s16.5-43.38 38.7-58.69c22.1-15.3 72.6-8.42 72.6-8.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11399.7 1402.18-107.4 64.19s46 4.7 69.2-7.26c23.1-11.95 38.2-56.93 38.2-56.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11227.6 1662.77-111.3 67.1s16.5-43.37 38.6-58.68c22.2-15.3 72.7-8.42 72.7-8.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11226.3 1664.63-107.4 64.19s46 4.7 69.1-7.26c23.2-11.95 38.3-56.93 38.3-56.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11372.7 1230.49 113.8-132.21s-1.5 62.89-23.2 91.73c-21.8 28.85-90.6 40.48-90.6 40.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11367 1229.12 122.9-129.44s-62.9 10.19-89.9 35.44c-27.1 25.25-33 94-33 94"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11486.1 1411.44-42.4-114.63s37.3 23.98 47.6 47.21c10.2 23.23-5.2 67.42-5.2 67.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11486.3 1412-43.6-114.41s-12.6 42.82-5.1 67.1c7.6 24.28 48.7 47.31 48.7 47.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11278 1039.19-62.3-107.443s40.9 17.613 55.1 39.106c14.3 21.494 7.2 68.337 7.2 68.337"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11275.4 1039.59-58-106.841s-5.3 43.965 5.5 66.874c10.7 22.907 52.5 39.967 52.5 39.967"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11406.2 1407.01-118.9-133.6s62.3 12.26 88.5 38.42c26.3 26.16 30.4 95.18 30.4 95.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11401 1410.7-109.1-138.84s1.3 63.66 22.2 93.82c20.9 30.15 86.9 45.02 86.9 45.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11418.6 1585.17-172.3.68s50.6-39.07 86.3-41.47c35.8-2.4 86 40.79 86 40.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11419.3 1581.08-172 10.4s51.9 34.93 87.7 34.98 84.3-45.38 84.3-45.38"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11333.6 1809.67 134.9-66.19s-23.8 48.4-50.9 63.82c-27.1 15.43-84 2.37-84 2.37"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11334.1 1811.77 132.4-71.18s-54-9.83-82.4 3.16c-28.3 12.99-50 68.02-50 68.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11385.9 1084.21 48.3-115.777s11.9 42.967 3.4 67.517c-8.6 24.56-51.7 48.26-51.7 48.26"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11385.9 1084.59 46.7-116.109s-38.8 24.219-50 47.749c-11.1 23.52 3.3 68.36 3.3 68.36"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11331.1 1791.24-48.7-165.01s50.5 37.08 62.7 70.67-14 94.34-14 94.34"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11330.9 1792.04-49.6-164.69s-21.5 59.07-13.3 93.87c8.2 34.81 62.9 70.82 62.9 70.82"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11333.3 1812.87 117.6 41.55s-43.9 13.88-68.9 6.77c-24.9-7.11-48.7-48.32-48.7-48.32"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11332.9 1813.76 117.8 38.25s-25.3-37.3-49.2-46.76c-24-9.45-68.6 8.51-68.6 8.51"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11483 1273.66-115-54.86s45.8-9.08 70.4.84c24.6 9.93 44.6 54.02 44.6 54.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11483.4 1276.17-115.3-58.1s20.2 41.99 43.3 55.5 72 2.6 72 2.6"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12795.9 1174.11-126.1-31.28s43.7-19.67 70.2-14.85c26.6 4.82 55.9 46.13 55.9 46.13"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12796.4 1169.03-126.2-19.84s32 34.02 57.9 39.77c25.9 5.76 68.3-19.93 68.3-19.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11144.2 1558.25-26.2 171.99s-32.3-54.26-29.2-90.18c3.2-35.92 55.4-81.81 55.4-81.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11137.7 1557.57-11.6 171.97s41-48.66 45.6-84.25-34-87.72-34-87.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12821.4 1382.27 46.5-113.93s12 41.99 3.9 66.13c-8.2 24.15-50.4 47.8-50.4 47.8"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12821.8 1382.63 44.1-114.24s-37.7 24.28-48.3 47.46c-10.5 23.17 4.2 66.78 4.2 66.78"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12952.1 976.494 22.6-121.306s21.6 39.106 18.5 64.489c-3 25.383-41.1 56.817-41.1 56.817"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12956.9 976.96 11.9-121.33s-30.1 33.58-34.1 58.646 22.2 62.684 22.2 62.684"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12785.8 1173.96 17.8-172.35s34.6 52.67 33.3 88.56c-1.4 35.89-51.1 83.79-51.1 83.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12791.6 1174.66 4.6-172.27s-39 50.18-42.1 85.92c-3.1 35.73 37.5 86.35 37.5 86.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12699 1303.16-142.1-105.49s63.4-.39 94.2 19.68c30.8 20.08 47.9 85.81 47.9 85.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12696.2 1308.16-136.4-113.09s14 61.78 40.8 86.92c26.9 25.13 95.6 26.17 95.6 26.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12957.8 1146.87-53.7-117.8s41 22.48 53.6 46.23.1 71.57.1 71.57"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12959.4 1147.47-57.7-117.61s-9.9 46.42.5 71.53c10.4 25.1 57.2 46.08 57.2 46.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11649.6 1253.67-115-54.86s45.8-9.09 70.4.84c24.6 9.92 44.6 54.02 44.6 54.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11650 1256.17-115.3-58.1s20.2 41.99 43.3 55.5 72 2.6 72 2.6"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11173 1136.17-168.2 35.23s41.5-47.46 75.9-56.93c34.5-9.48 92.3 21.7 92.3 21.7"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11173.8 1135.58-167.8 37.84s56.9 25.69 92.2 19.97c35.3-5.71 75.6-57.81 75.6-57.81"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11671.8 1331.68-172.4-3.33s51.5-38.02 87.4-39.59c35.8-1.57 85 42.92 85 42.92"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11672.6 1327.14-172.2 7.31s51.3 35.92 87.1 36.62c35.8.69 85.1-43.93 85.1-43.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m11554.8 1627.5-154.2-2.99s46-34.01 78.1-35.42 76.1 38.41 76.1 38.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m11555.5 1623.43-154.1 6.54s45.9 32.15 77.9 32.77c32.1.62 76.2-39.31 76.2-39.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11419.6 1630.67 110.3 57.56s-44.6 7.43-68.2-3.11-42.1-54.45-42.1-54.45"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11419.3 1628.78 110.5 59.63s-18.4-41.29-40.6-55.05c-22.1-13.76-69.9-4.58-69.9-4.58"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11491.9 1416.51 110.3 57.56s-44.6 7.43-68.2-3.11-42.1-54.45-42.1-54.45"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11491.6 1414.63 110.5 59.62s-18.5-41.29-40.6-55.05c-22.1-13.75-69.9-4.57-69.9-4.57"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M11748.4 1232.25c-26.1 2.37-46.1 21.24-44.7 42.15s23.6 35.95 49.7 33.58 46.1-21.24 44.7-42.15-23.6-35.94-49.7-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11713.8 1287.94s-7.9-22.13 2.4-31.02c13.4-11.57 29.9-1.74 29.9-1.74-8.6 1.27-18.3 1.39-23.5 6.99-5.7 6.14-6.5 18.03-8.8 25.77"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M11745.9 1282.52s10 2.96 10.7 3.98c4.6 6.65 6.4 8.07 6.4 8.07s-9.6 3.66-14.2 3.21c-4.6-.46-9.7-3.55-9.7-3.55s.4 5.34-.8 7.23c-1.4 2.24-7.6 6.21-7.6 6.21s-6-4.13-7.3-6.95c-1.3-2.91 4.7-9.27 4.7-9.27s-5.7.95-9.1-.72c-3.6-1.74-8.6-7.31-8.6-7.31s4.5-3.88 7.9-4.41c3.2-.52 12.8 1.15 12.8 1.15s-6.6-4.47-8.9-7.85c-2.4-3.52 4-9.69 4-9.69s7.3 3.86 10.9 7.01c2.6 2.41.8 8.33.8 8.33s2.5-6.13 5.4-8.33c3-2.21 11.1-1.93 11.1-1.93s2.9 7.25 1.3 10.22c-1.6 2.81-9.8 4.6-9.8 4.6"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M11737.2 1293.65c1.4-.12 3.8.23 4.8-.46s2.1-2.83 2.4-4.07c.9-3.26.8-5.61-2.4-7.75-1.2-.77-3.4.02-4.7.13-.6.06-1.4.03-2.1.2-2.5.62-4.5 2.4-6 4.05-.7.67-1.3 2.15-.7 2.98.5.75 1.4 1.43 1.9 2.25.7 1.07 1.7 3.25 3.3 3.72 1.1.31 1.5-.45 2.2-.71.8-.28.4-.06 1.3-.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11801.2 1162.48c24.7-2.99 43.2-21.45 41.3-41.23-1.8-19.79-23.4-33.4-48.1-30.41-24.6 2.99-43.2 21.45-41.3 41.24 1.9 19.78 23.4 33.39 48.1 30.4"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11801.1 1113.76s-9.6-2.38-10.3-3.32c-4.6-6.1-6.4-7.38-6.4-7.38s9-3.86 13.3-3.62c4.4.24 9.4 2.95 9.4 2.95s-.6-5.04.4-6.87c1.2-2.18 6.9-6.2 6.9-6.2s5.9 3.66 7.2 6.28c1.3 2.7-4 8.97-4 8.97s5.3-1.13 8.6.3c3.5 1.5 8.4 6.56 8.4 6.56s-4 3.86-7.2 4.5c-3 .63-12.2-.55-12.2-.55s6.5 3.95 8.8 7.05c2.4 3.24-3.4 9.34-3.4 9.34s-7.1-3.35-10.6-6.18c-2.6-2.17-1.1-7.85-1.1-7.85s-2.1 5.91-4.8 8.12-10.4 2.29-10.4 2.29-3.1-6.75-1.6-9.63c1.3-2.72 9-4.76 9-4.76"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11791.3 1152.39s-22.5 2.43-27.9-8.75c-7.1-14.53 6.3-27.34 6.3-27.34-1.1 8.01-3.6 16.8.2 22.69 4.1 6.43 14.8 9.73 21.4 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11810 1103.97c-1.3.16-3.6-.11-4.5.57-1 .68-2 2.75-2.3 3.93-.6 3.11-.6 5.34 2.6 7.28 1.1.69 3.2-.12 4.4-.26.6-.08 1.4-.07 2-.24 2.4-.67 4.2-2.41 5.6-4.02.6-.65 1.2-2.08.6-2.85-.5-.69-1.4-1.31-1.9-2.07-.6-1-1.7-3.04-3.3-3.43-1-.27-1.3.46-2 .73-.7.29-.3.07-1.2.36"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11751.6 1583.7c24.7-2.99 43.2-21.45 41.3-41.24-1.8-19.78-23.4-33.39-48.1-30.4s-43.2 21.45-41.3 41.24c1.9 19.78 23.4 33.39 48.1 30.4"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11751.5 1534.97s-9.6-2.37-10.3-3.31c-4.7-6.11-6.4-7.38-6.4-7.38s8.9-3.86 13.3-3.62 9.4 2.95 9.4 2.95-.7-5.04.4-6.87c1.2-2.18 6.9-6.2 6.9-6.2s5.8 3.66 7.2 6.28c1.3 2.7-4 8.96-4 8.96s5.3-1.13 8.6.31c3.5 1.5 8.4 6.55 8.4 6.55s-4 3.86-7.2 4.51c-3 .62-12.2-.56-12.2-.56s6.5 3.95 8.8 7.06c2.4 3.23-3.4 9.34-3.4 9.34s-7.1-3.35-10.6-6.19c-2.6-2.17-1.1-7.84-1.1-7.84s-2.1 5.9-4.8 8.11c-2.8 2.21-10.4 2.29-10.4 2.29s-3.1-6.75-1.6-9.62c1.3-2.73 9-4.77 9-4.77"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11741.6 1573.6s-22.4 2.44-27.9-8.75c-7-14.52 6.4-27.34 6.4-27.34-1.1 8.02-3.6 16.81.2 22.69 4.1 6.44 14.8 9.74 21.3 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11760.4 1525.18c-1.4.16-3.7-.1-4.6.57-.9.69-1.9 2.75-2.2 3.94-.7 3.11-.6 5.33 2.6 7.28 1.1.69 3.2-.12 4.4-.26.6-.08 1.4-.07 2-.25 2.4-.66 4.2-2.41 5.6-4.02.6-.65 1.1-2.07.6-2.84-.6-.7-1.4-1.32-1.9-2.07-.7-1-1.7-3.04-3.3-3.44-1-.27-1.3.47-2 .74-.8.29-.3.06-1.2.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M10980.8 1280.1c-26.1 2.37-46.1 21.24-44.7 42.15 1.4 20.92 23.6 35.95 49.7 33.58 26.1-2.36 46.1-21.24 44.7-42.15s-23.6-35.94-49.7-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10946.2 1335.8s-7.9-22.13 2.4-31.03c13.4-11.57 29.9-1.73 29.9-1.73-8.6 1.27-18.3 1.39-23.5 6.99-5.7 6.13-6.5 18.03-8.8 25.77"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M10978.3 1330.37s10 2.96 10.7 3.98c4.6 6.65 6.4 8.07 6.4 8.07s-9.6 3.66-14.2 3.21c-4.6-.46-9.8-3.55-9.8-3.55s.5 5.34-.7 7.23c-1.4 2.24-7.6 6.21-7.6 6.21s-6-4.13-7.3-6.95c-1.3-2.91 4.7-9.27 4.7-9.27s-5.7.95-9.1-.72c-3.6-1.74-8.6-7.3-8.6-7.3s4.5-3.88 7.9-4.42c3.2-.52 12.8 1.15 12.8 1.15s-6.6-4.47-8.9-7.85c-2.4-3.52 4-9.69 4-9.69s7.3 3.87 10.9 7.02c2.6 2.41.8 8.32.8 8.32s2.5-6.13 5.4-8.33c3-2.2 11.1-1.93 11.1-1.93s2.9 7.25 1.3 10.22c-1.6 2.81-9.8 4.6-9.8 4.6"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M10969.6 1341.5c1.4-.12 3.8.23 4.8-.45 1-.7 2.1-2.84 2.4-4.08.9-3.26.8-5.6-2.4-7.75-1.2-.77-3.4.02-4.7.13-.6.06-1.4.03-2.1.2-2.5.62-4.5 2.4-6 4.05-.7.67-1.3 2.15-.7 2.99.5.74 1.4 1.42 1.9 2.24.7 1.07 1.7 3.25 3.3 3.72 1.1.31 1.5-.45 2.2-.71.8-.28.4-.06 1.3-.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11211.3 1233.48c24.7-2.99 43.2-21.46 41.4-41.24-1.9-19.78-23.4-33.39-48.1-30.4s-43.2 21.45-41.3 41.23c1.8 19.79 23.4 33.4 48 30.41"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11211.3 1184.76s-9.6-2.38-10.4-3.32c-4.6-6.11-6.3-7.38-6.3-7.38s8.9-3.86 13.3-3.62 9.3 2.95 9.3 2.95-.6-5.04.4-6.87c1.2-2.18 7-6.2 7-6.2s5.8 3.66 7.1 6.28c1.4 2.7-4 8.96-4 8.96s5.3-1.13 8.7.31c3.4 1.5 8.4 6.55 8.4 6.55s-4.1 3.86-7.2 4.51c-3.1.62-12.2-.55-12.2-.55s6.4 3.95 8.7 7.05c2.4 3.23-3.3 9.34-3.3 9.34s-7.2-3.35-10.6-6.19c-2.7-2.17-1.2-7.84-1.2-7.84s-2 5.9-4.8 8.11c-2.7 2.21-10.4 2.29-10.4 2.29s-3-6.75-1.6-9.62c1.4-2.73 9.1-4.76 9.1-4.76"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11201.4 1223.38s-22.5 2.44-27.9-8.75c-7.1-14.52 6.3-27.34 6.3-27.34-1.1 8.02-3.5 16.81.2 22.7 4.2 6.43 14.9 9.73 21.4 13.39"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11220.1 1174.96c-1.3.16-3.6-.1-4.5.57-.9.69-2 2.76-2.2 3.94-.7 3.11-.6 5.33 2.5 7.28 1.2.69 3.3-.12 4.4-.26.7-.08 1.4-.07 2-.25 2.4-.66 4.2-2.41 5.7-4.02.6-.65 1.1-2.07.5-2.84-.5-.69-1.4-1.32-1.9-2.07-.6-1-1.7-3.04-3.2-3.44-1-.27-1.4.47-2.1.74-.7.29-.3.06-1.2.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11066 1581.73c24.7-2.99 43.2-21.45 41.4-41.23-1.9-19.79-23.4-33.4-48.1-30.41s-43.2 21.45-41.4 41.24c1.9 19.78 23.4 33.39 48.1 30.4"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11065.9 1533.01s-9.6-2.38-10.3-3.32c-4.6-6.11-6.3-7.38-6.3-7.38s8.9-3.86 13.3-3.62 9.3 2.95 9.3 2.95-.6-5.04.4-6.87c1.2-2.18 7-6.2 7-6.2s5.8 3.66 7.1 6.28c1.3 2.7-4 8.96-4 8.96s5.3-1.13 8.7.31c3.4 1.5 8.3 6.55 8.3 6.55s-4 3.86-7.2 4.51c-3 .62-12.1-.55-12.1-.55s6.4 3.95 8.7 7.05c2.4 3.23-3.3 9.34-3.3 9.34s-7.2-3.35-10.6-6.19c-2.7-2.17-1.2-7.84-1.2-7.84s-2.1 5.9-4.8 8.11-10.4 2.29-10.4 2.29-3-6.75-1.6-9.62c1.4-2.73 9-4.76 9-4.76"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11056.1 1571.63s-22.5 2.44-27.9-8.75c-7.1-14.52 6.3-27.34 6.3-27.34-1.1 8.02-3.6 16.81.2 22.7 4.1 6.43 14.9 9.73 21.4 13.39"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11074.8 1523.22c-1.3.16-3.6-.11-4.5.57s-2 2.75-2.2 3.93c-.7 3.11-.6 5.34 2.5 7.28 1.1.69 3.2-.12 4.4-.26.6-.08 1.4-.07 2-.24 2.4-.67 4.2-2.41 5.7-4.02.6-.65 1.1-2.08.5-2.85-.5-.69-1.4-1.31-1.9-2.07-.6-1-1.7-3.04-3.2-3.43-1-.27-1.4.46-2.1.73-.7.29-.3.07-1.2.36"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M10994.2 1223.99c21.8-2.63 38.1-18.7 36.5-35.89-1.7-17.19-20.6-28.99-42.4-26.36-21.7 2.63-38 18.7-36.4 35.89s20.5 28.99 42.3 26.36"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M10994.2 1181.64s-8.5-2.05-9.1-2.86c-4.1-5.3-5.6-6.41-5.6-6.41s7.9-3.37 11.7-3.17c3.9.2 8.3 2.55 8.3 2.55s-.6-4.38.3-5.97c1.1-1.9 6.1-5.4 6.1-5.4s5.2 3.17 6.3 5.45c1.2 2.34-3.5 7.79-3.5 7.79s4.7-.99 7.6.26c3 1.29 7.4 5.68 7.4 5.68s-3.6 3.36-6.4 3.93c-2.6.54-10.7-.46-10.7-.46s5.7 3.42 7.7 6.12c2.1 2.8-2.9 8.12-2.9 8.12s-6.3-2.9-9.4-5.36c-2.3-1.88-1-6.82-1-6.82s-1.8 5.14-4.2 7.06c-2.4 1.93-9.2 2.01-9.2 2.01s-2.7-5.86-1.4-8.36c1.2-2.37 8-4.16 8-4.16"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10985.4 1215.19s-19.7 2.14-24.5-7.55c-6.2-12.58 5.6-23.71 5.6-23.71-1 6.95-3.2 14.58.1 19.67 3.7 5.57 13.1 8.42 18.8 11.59"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M11002 1173.12c-1.2.14-3.2-.08-4 .5-.8.6-1.7 2.4-1.9 3.43-.6 2.7-.6 4.63 2.2 6.32 1 .6 2.8-.11 3.9-.23.5-.07 1.2-.06 1.7-.22 2.1-.58 3.7-2.1 5-3.5.5-.56 1-1.8.5-2.47-.5-.6-1.2-1.14-1.7-1.8-.5-.87-1.5-2.64-2.8-2.98-.9-.23-1.2.41-1.8.64-.7.25-.3.06-1.1.31"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M11874 1444.12c15.4-15.14 17.9-37.54 5.6-50.04-12.4-12.51-34.8-10.37-50.2 4.77-15.3 15.14-17.8 37.55-5.5 50.05s34.7 10.36 50.1-4.78"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M11846.8 1410.72s-7.9 3.25-8.9 2.95c-6.2-1.94-8.1-1.96-8.1-1.96s4.4-7.31 7.6-9.39 8-2.71 8-2.71-2.9-3.24-3.1-5.07c-.2-2.17 1.9-7.96 1.9-7.96s5.9-.39 8.1.79c2.3 1.21 1.6 8.38 1.6 8.38s3.2-3.52 6.2-4.21c3.2-.71 9.2.33 9.2.33s-1 4.8-2.9 6.88c-1.8 1.99-8.8 5.86-8.8 5.86s6.4-.51 9.6.5c3.3 1.06 2.2 8.33 2.2 8.33s-6.7 1.31-10.5 1.07c-2.9-.18-4.6-4.96-4.6-4.96s1.4 5.24.6 8.21c-.9 2.96-6.2 6.96-6.2 6.96s-5.5-3.22-5.9-5.99c-.4-2.62 4-8.01 4-8.01"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11860.9 1443.23s-14.5 13.11-24.1 8.23c-12.6-6.32-9.9-21.94-9.9-21.94 3.4 6.05 6.3 13.33 12 15.43 6.3 2.3 15.5-.9 22-1.72"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M11847.8 1399.33c-.8.81-2.5 1.86-2.8 2.79-.2.95.2 2.92.7 3.86 1.2 2.49 2.5 3.95 5.8 3.62 1.1-.13 2.1-1.8 2.9-2.51.4-.39.9-.8 1.2-1.24 1.3-1.72 1.6-3.86 1.7-5.74 0-.76-.4-2.01-1.2-2.22-.8-.2-1.7-.16-2.5-.42-1-.34-2.9-1.15-4.1-.62-.9.36-.7 1.05-1.1 1.6-.3.59-.1.21-.6.88"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M11257 3735.57s-259.8 359.51-425.1 505.53c-168.7 149-633.3 138.36-633.3 138.36s488.5 19.5 657.2-114.41c155.6-123.51 403.1-439.01 403.1-439.01s-124.6 420.65-232.6 609.29c-108.4 189.36-854.3 513.51-854.3 513.51s765.9-291.34 879.4-478.92 238.1-633.24 238.1-633.24-101.1 495.87-146 715.83c-41.1 201.28-352 792.77-352 792.77s385.4-680.39 428.1-870.04c49.7-220.83 99.2-643.88 99.2-643.88s62.1 560.07 71.8 790.22c8.4 196.75-5.3 332.58-5.3 332.58s40.7-145.8 37.3-348.55c-4-231.93-69.2-784.89-69.2-784.89s116.2 548.97 157 779.57c35.4 200.32 484.2 752.97 484.2 752.97s-406.1-560.55-436.4-763.61c-35-235.47-170.2-798.2-170.2-798.2s324.5 441.67 394.2 662.51c62 196.94 513.1 454.97 513.1 454.97s-432.9-284-489.6-478.92c-67-230.15-398.7-694.44-398.7-694.44z"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M10890.1 4210.18c-68.7-20.59-50.2-50.81-120.1-62.47-52.5-8.75-166-17.13-216.2-17.13-30.9 0-138-12.35-152.5-16.5-10.9-3.14-270.8 61.99-263.1 54.28 30-29.96 244.4-84.98 285.1-83.15 78.2 3.57 158.6 6.63 234.2 23.44 48.3 10.73 101.9 1.04 149.9 11.71 21.2 4.71 73.9 23.6 89 38.63 1.6 1.65 16 17.56 17.5 17.56M10856.6 4605.08c-26.7-5.32-51.1-17.74-77.3-24.58-33.1-8.62-68.2-7.11-100.7-15.22-55.3-13.84-108.2-17.56-166.3-17.56-41 0-81.9 5.85-121.7 5.85-12.7 0-30.5 4.68-42.2 9.37-5.4 2.18-17.6 0-17.6 0s4.7-1.57 7.1-2.34c9.8-3.28 21.3-12.96 30.4-15.22 31.3-7.83 59.1-16.47 93.7-21.08 55.4-7.39 213.1-9.26 270.4 3.52 30.4 6.75 156.6 33.2 165.1 50.34 8.3 16.6-19.2 17.56-33.9 17.56-2.3 0-7 11.62-7 9.36M11618.2 4073.19c76.5 0 149.8 17.54 225 23.79 107.8 8.99 216.7 7.31 325.6 7.31 63 0 129.3.51 192.1-5.48 20.5-1.94 41.8-1.38 62.2-3.64 5.9-.67 10.5-1.84 16.5-1.84h11c-47.9 0-91.4 19.11-137.2 29.27-89.3 19.85-245.4 22.3-334.2 6.15-60.6-11.02-136.9 6.7-197-8.31-22.2-5.56-138.4 5.22-141.6 2-8.1-8.17-9.4-49.25-22.4-49.25M11815.7 4477.51c79.7 0 196.4 32.03 281.8 42.09 103.3 12.16 183.2-31.1 272.6-31.1 12.1 0 65.4-7.75 113.4-14.64 43.5-6.25-122.1 46.88-153 55.72-105.5 30.12-225.6 19.29-335.5 19.29-31.6 0-151.8 7.63-151.8-23.79M11585.3 4686.07c84.7 36.3 156.5 90.41 241.4 124.39 24.3 9.71 52.5 10.38 76.9 20.14 30.8 12.35 73.9 15.03 102.4 29.27 9.5 4.71 25.3 14.63 36.6 14.63 4.7 0 142.5 48.05 137.9 48.05-12.4 0-259.6-43.02-291.6-59.04-49.2-24.58-110.6-36.79-168.3-51.21-25.8-6.44-108.9-54.89-118.9-54.89M11157.1 4629.35c12.8 57.57 43.3 115.36 54.9 173.79 11.7 58.11.6 148.12 23.5 201.58 53.8 125.5 69.8 106.1 69.8 252.15 0 44.51 58.6 176.83 58.6 221.37v45.71c0 7.95-60.3-153.55-71.4-164.65-6.5-6.52-14.2-79.1-18.3-93.31-10.8-38.04-3.1-102.59-14.3-130.56-15.5-38.68-51.7-103.28-60.7-143.83-18.7-84.16-27.8-166.77-43.9-246.99-2.2-10.94-10.8-69.53-20.1-69.53"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M10385.4 4087.59c-14.3-14.29-32.6-22.04-51.9-30.31-18.1-7.77-37.2-16.1-54.4-32.03-16.2-15.09-31.2-46.03-48.8-68.36-13.1-16.49-27.8-28.25-44.6-28.25-3 0-5.5 2.47-5.5 5.53s2.5 5.53 5.5 5.53c13.8 0 25.2 10.57 35.9 24.08 18 22.75 33.5 54.2 50 69.58 18.2 16.9 38.3 25.86 57.5 34.11 18 7.69 35.1 14.66 48.4 27.94 2.2 2.18 5.7 2.18 7.9 0 2.1-2.16 2.1-5.67 0-7.82M10546.2 4102.46c-10.3-41.11-29.2-61.39-51.8-80.17-14.4-11.97-30.5-23.31-46.6-39.48-6.6-6.58-8.6-19-10.4-31.8-2.2-14.77-3.8-30.07-8.7-39.96-3-6.02-8.2-12.88-12.6-19.96-3.7-5.96-7-12-7-17.8 0-3.06-2.5-5.53-5.5-5.53-3.1 0-5.6 2.47-5.6 5.53 0 6.23 2.5 12.8 6.1 19.27 4.7 8.3 11.1 16.44 14.7 23.46 5.4 10.96 6.1 29.24 9 45.1 2.2 12.21 5.7 23.07 12.1 29.51 16.5 16.47 32.7 28.01 47.4 40.17 21 17.43 38.6 36.22 48.1 74.34.8 2.98 3.8 4.79 6.7 4.05 3-.75 4.8-3.75 4.1-6.73M10479.6 4112.14c-45.2 22.64-92.3 67.69-138.7 100.15-29.7 20.8-59 36.48-87.5 36.48-3.1 0-5.5 2.5-5.5 5.56s2.4 5.53 5.5 5.53c30.5 0 62.1-16.23 93.9-38.5 45.9-32.14 92.4-76.89 137.3-99.3 2.7-1.35 3.8-4.71 2.4-7.42-1.3-2.74-4.7-3.86-7.4-2.5M10681.8 4130.07c-35.4 10.11-61.9 29-88.5 49.25-25.7 19.61-51.5 40.5-86 55.26-15.7 6.76-63.4 30.12-126.4 37.01-3.1.32-5.3 3.06-4.9 6.12.3 3.04 3 5.24 6.1 4.9 64.6-7.05 113.5-30.92 129.6-37.84 35.4-15.16 61.9-36.5 88.3-56.61 25.5-19.45 50.9-37.73 84.8-47.42 3-.85 4.7-3.91 3.9-6.86-.9-2.93-4-4.66-6.9-3.81M10749.7 4132.96c-10.1-35.44-27.6-63.43-42.7-92.37-14.5-27.86-26.6-56.65-26.6-94.54 0-9.95-2.1-28.87-8.4-42.41-4.9-10.69-12.6-18.01-22.8-18.01-3 0-5.5 2.47-5.5 5.53s2.5 5.56 5.5 5.56c6.1 0 9.8 5.25 12.8 11.58 5.5 12.05 7.3 28.89 7.3 37.75 0 39.91 12.6 70.3 27.9 99.65 14.7 28.3 31.9 55.63 41.8 90.32.9 2.93 3.9 4.63 6.9 3.81 2.9-.85 4.6-3.91 3.8-6.87"
      clipRule="evenodd"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M10255.2 4000.58c0-11.28-3.9-32.43 1-42.2 3.8-7.64 9.6-16.26 9.6-25.44 0-3.48-3.5-23.01-5.8-23.01M10293.1 4043.26c-21.2 0-43.8-5.7-65.2-2.4-6.1.93-12.5 2.4-18.7 2.4-7.4 0-15.5 4.07-22.1 6.7-1.2.48-15.4 1.36-16.8 0M10323.8 4058.08c6.1-24.43 12.3-38.29 26.4-59.42 10.7-16.12 34.1-25.67 23.9-46.03M10424.5 3911.85c2.7-14.66 7.7-33.1 17.3-45.07 10-12.51 20.9-24.96 25.4-40.77 2-7.02-5.6-16.04-8.2-22.05-.8-1.84-1.4-7.19-3.3-7.19M10445.6 3993.4c-13.3 4.42-24 21.95-35 30.2-2.6 1.97-4.9 6.75-7.7 8.17M10504.6 4037.51c-2.2-14.21-7.2-27.03-9.6-41.24-2.1-12.37 2.5-25.86 4.8-37.41 2.6-13.12 16.1-22.96 20.6-36.45 1.5-4.55 2.2-15.19-2.9-17.75M10688.7 4009.2c4.7-10.88 6.3-27.51 14.9-35.95 10.6-10.4 28.2-17.13 34.5-31.66 3.8-8.7 7.2-29.8 4.4-39.8-1.7-5.8-3.9-12.48-3.9-18.71M10669.1 3932.95c-27 0-59.5 13.7-84-.96-15.3-9.21-19.9-31.45-31.6-44.6-2.6-2.98-6.7-14.39-11.5-14.39M10228.3 4148.3c-8.8 8.8-14.6 16.57-21.1 27.32-5.2 8.7-7.8 19.21-13.9 27.33-12.6 16.81-28.9 31.34-47.4 41.26-13.9 7.43-29.5 16.71-45.1 19.19M10180.4 4153.09c-7.4-7.34-12.4-17.11-20.2-23.97-17.7-15.81-38-26.08-59.9-34.06-7.9-2.87-15.3-8.62-22.5-12.96-1.4-.82-5.8-3.59-5.8-5.26M10306 4246.14c-1.4 6.94-5.6 11.89-8.1 18.7-2 5.38-2.4 11.92-6.7 16.31-5 4.95-11.6 10.67-15.9 16.28-8.1 10.73-14.4 19.56-24.9 27.84-8.8 6.89-21.7 13.46-31.6 18.7M10351.6 4212.56c-7.5-5.14-17.5-15.25-26.4-18.23-17.7-5.91-37-5.53-55.1-10.08-4.1-.99-24.5-8.6-24.5-11.98M10561.6 4209.68c-4.4-3.8-10.6-10.21-16.3-13.43-16.5-9.45-39.8-8.97-57.5-14.88-9.9-3.3-13.5-9.15-20.6-16.31-1.8-1.78-9.4-7.18-8.2-7.18M10507.2 4239.96c-9.2 12.82-14.5 27.64-26.4 36.93-9.1 7.1-23.2 8.25-33.1 15.35-8.4 5.96-19.5 9.44-28.8 13.41"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.095}
      d="M11998.5 4113.84c-.8-1.57.3-3.67 2.2-2.68M11887.3 4122.49c-44 0-41.4 92.01-16.5 115.34 12.7 11.9 30.1 16.82 41 30.89 9.3 11.98 15.2 26.8 21.2 40.58 9.6 21.95 11.7 44.88 7.5 68.35-.6 3.33-11.4 35.44-6.3 37.14M12215.6 4123.98c-.7-.72 5.4-6.89 5.5-7 11-12.02 19.8-22.24 21-39.08 1.9-25.97-4.2-52.61 8.4-77 12.5-24.16 36.7-36.16 57.3-52.53 28.5-22.72 48.3-68.56 56.8-102.8M12390.2 4101.9c0-1.04-.4-1.09.4-1.49 19.2-9.61 41.5-9.74 57.9-26.1 13.8-13.81 13.5-38.24 23.7-54.47 16.8-26.63 44.3-45.31 62.1-71.91M12294.1 4121.75c-5.4 1.35 16 19.05 15.3 30.43-1.2 21.21-22.5 44.36-19.2 64.77 3 19.1 41.9 37.11 26.4 60.29M12071 4530.14c6.2-6.2 17.1-8.31 22.8-16.87 17.4-26.02-9.5-59.1 9.4-88.63 10.5-16.36 50.5-36.85 50.5-57.15M12281.5 4530.72c-.3-.35-.6-.61-.9 0-10.8 21.63-13.5 43.98-16.4 67.9-6 49.51 62.8 78.27 24.1 138.59M12348.8 4508.93c60.7-22.99 18.9-49.84 38.1-88.18 14.2-28.52 46.8-46.67 64.6-73.25M12008.4 4545.94c-13.7 10.21 4.6 38.74 11.6 47.44 29.9 37.27 81 48.63 81 104.3M12112.6 4786.14c0-7.9 28-40.12 35-42.81 14.2-5.5 29.4-1.94 43.1-10.75 17-10.96 10.3-47.54 23.1-52.65M11678.2 4222.32c-6.1 12.21-6.1 30.86-16.6 43.72-13.8 16.86-38.5 21.84-47.5 42.81-15.7 37.17-7 84.84-30.7 118.02M11779.2 4432.54c-52.6 26.31-47.6 80.86-71.3 125.18-12.7 23.76-36.1 29.48-53.2 48.19M11759.6 4795.41c6.5 0 16.7-10.62 21.5-14.32 39.5-30.33 18.8-58.59 25.5-99.67 2.1-12.95 10.2-23.78 16-35.22 2.2-4.39 12.9-40.87 16.4-40.87M11929 4845.53c2.1-19.47-11.6-36.4-7.6-56.09.1-.63 45.8-66.59 53.4-77.87M11855.3 4844.95c-8.9-8.81-17.5 52.57-17.8 56.83-4.3 57.87 62.7 99.56 30.7 155.49M12073.4 4901.35c1.1-3.27 14.8 34.59 16 44.91 4 34.7-5 77.56-36.3 98.47M11633.3 4844.2c-8-23.79-52.7 25.27-56.3 30.44-22.2 32.03 5.1 56.59-8.5 86.52-12.4 27.22-52.5 41.03-73.3 61.78M11423.9 4738.11c-8.1-6.06 31.4-9.84 32.4-9.55 21.8 6.55 33.6 36.45 53.1 47.89M11392.3 4379.43c-13-19.55-62.6 35.42-67 41.48-20.8 28.63-.4 70.32-28.8 106.67-11 14.1-46.5 28.87-49.7 46.4M11225.6 4964.3c57.3-28.63 79.3 39.01 114.6 68.33 26.1 21.63 63.6 31.82 96.9 33.28M11070.9 4801.68c-10.6-5.34-33.1 27.62-45.5 31.19-83.7 23.92-117.5 24.79-189.8 80.4M10678.4 4732.29c-14.8 14.79-14.9 59.76-24.9 79.82-15.7 31.4-41.2 57.55-58.5 88.17-21.8 38.37-32 87.14-44 129.37M10469.5 4823.31c-6.4-25.46-45.2-39.43-66.7-41.63-63.9-6.52-116.2 18.22-178.6-10.89M10578.9 4544.45c-7.1 2.34-45.6 45.63-72.1 58.19-58.9 27.91-129.6 33.58-185.2 67.74M10694.5 4539.23c-11.9-23.81-8.2-51.03-31.5-70.72-19.1-16.2-108.2-38.47-108.2-63.43M10844.6 4561.61c-4.8-5.99-1.8-76.79-8.1-94.62-10.4-29.58-55.2-65.96-50.6-98.31M11065.2 4390.18c0-35.28-38.9-54.78-55.9-80.27-18.6-27.99-14.9-59.44-14.9-91.02M11010.5 4503.26c-16.6 24.95-33.8 116.14-32.8 145.94 1 32 11.7 61.86 4.1 94.42-7.8 33.95-33.1 33.69-48.4 57.74M11770.1 5054.58c-7.3-3.65-41.8 54.28-46.1 63.11-20.2 41.37-9.9 88.09-28.2 130.11-16.3 37.06-56.4 57.12-73.1 93.25M11870 5179.31c36.7-36.61 78.2 24.88 115.8 33.58 39 8.96 68.6-13.97 103.3-26.13M10995 4981.91c-18.6 9.29 27.8 94.19 30.4 103.4 14.5 51.64-6.8 109.3.9 162.94M11181 4848.67c-52.2 16.07-47.4 105.12-65.5 143.83-9.7 20.81-33.9 35.02-41 56.25M11285.3 5219.89c-18.5-10.57-42.5 19.55-51.6 32.38-20.9 29.45-23.6 68.14-46 96.39-22 27.83-62 31.56-81.9 64.74"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11321.7 5354.33c4-15.86 39.3-20.83 50.5-17.77 34.4 9.47 43.2 50.07 86.9 53.42 31.2 2.4 59-22.37 90.2-22.37M11915.9 4265.66c19.7-19.68 48.9-11.17 76.6-24.82 14.7-7.21 32-29.37 42.8-32.99M11859.1 4219.02c2.9-2.85-8.4 4.02-9.4 4.84-6 5.11-12 10.27-16.6 16.79-12.3 17.75-7.8 41.48-21.5 58.11-4.2 5.03-9.3 8.86-14.2 13.14-.9.78-8.1 7.4-6.7 7.11M11945.4 4371.59c-3.5-2.32 15.9-6.52 17.5-6.44 11.9.77 21.8 9.9 33.3 12.48 32.1 7.1 55.7-19.48 84.2-26.58M12292 4216.15c1.7-.85-16.5-1.06-18.5-.88-11.6 1.01-24 7.85-33.2 14.61-12.8 9.42-19.8 29.27-34.2 35.68-18.4 8.22-38.8 5.29-57.7 14.71M12312.8 4251.91c22.9-34.43 74.1-11.55 103.5-35.07M12483.1 4007.15c-1.3 2.69.7-5.99.5-8.99-.5-6.36-2.2-12.72-4.5-18.68-10.5-26.77-14.3-27.22-5.3-54.33M12460.2 4063.69c-.6-1.22 8.4-.27 9.4 0 6.5 1.62 9.9 6.09 12.5 12.05 10 22.86 25.2 18.36 46.8 17.78M12406.3 4404.39c-5-2.02-2-20.91-5.1-29.45-4-11.1-14.8-18.02-19.7-28.55-7.9-17.01-4.1-43.29 1.7-60.67M12388.1 4462.58c6.8-6.76 19.1-6.47 28.2-10.46 23.1-10.16 57.8-28.07 83.2-28.07M12277.3 4635.02c-1.8-.59.1-2.85.9-3.94 5.7-7.85 17.6-17.45 27.7-17.69 8.3-.22 15.5 4.52 23.9 4.25 15.7-.53 36.1-13.67 48.7-23.14M12296.3 4694.11c3.1-6.15-30.8 9.58-35 13.25-10.9 9.47-16.9 22.69-27.3 32.51-9 8.46-21.8 13.36-28.8 23.82M12066.4 4635.31c14.3-7.13 17.1-26 30.4-33.21 14.3-7.66 41.3-1.59 63.8-12.82M12095.7 4463.37c-1.5-.58 2.2-3.77 2.8-4.33 9-7.56 19.7-12.59 32-10.38 13.6 2.47 23.3 15.67 37.1 17.37 14.1 1.76 25.4-7.92 38.8-10.16M12143.6 4390.55c-2.9 5.7-21.6-14.92-23.1-17.4-7.9-12.26.2-24.87-3-36.45-2.1-7.5-11.4-15.4-16.4-20.94-2.3-2.55-10.6-13.65-14.5-13.65M11697.6 4569.7c0 .02-5.7-7.13-7.1-8.49-3.8-3.83-12.4-6.09-17.6-6.73-7.2-.88-13.8 4.04-21.1 3.56-9.4-.64-45.2-14.95-49.8-24.1M11727.4 4518.32c23.5 0 19.1 39.32 33 53.45 2.6 2.63 20.4 18.01 24.2 10.48M11607.2 4369.99c0 4.68 10.1-4.37 13.9-1.57 24.1 17.96 19.8 65.26 68.1 45.95M11627.4 4293.04c0-11.06-26.5-7.92-33.3-10.19-18.8-6.25-34.6-49.54-25.1-66.19M11806.9 4739.56c0-20.25 37.1-17.99 45.4-20.25 17.9-4.84 36.1-18.39 52.7-26.69M11809.2 4677.03c-.1.02-3.7-2.34-6.4-3.86-5.5-3.17-11.8-4.82-17.6-7.32-13.9-5.96-23.3 3.65-33-13.83-.9-1.68-5.2-8.86-3-11.07M11947.4 4758.34c-6.1-3.06 11.9-3.38 12.6-3.17 3.7 1.2 8.7 11.28 10.5 14.42 14 24.56 36.6 7.69 56.3 8.99M11858.2 4963.99c0-11.18 26.7-12.46 31.1-12.27 21.2.91 65.8-1.65 77.8-25.6M11878.9 5023.05c-14.4-7.19-35.6 6.06-50.8 6.84-8.2.4-29.8-16.66-35.6-22.43M12092.5 4983.54c19.7-23.68 59.8-8.09 84.3-17.7 4.6-1.78 8.5-4.12 12.5-6.81 1.1-.69 18.7-15.16 15.5-16.79M12067.6 5028.29c-21.5-21.44-49.2 5.75-72.5 12.67-7.9 2.31-20.6-1.12-26.9 2.84M12342.2 3910.07c-1.9-3.92 10.8-6.5 13.8-6.68 10.4-.64 19.6 4.09 30-.16 16.7-6.79 26.9-39.59 45.5-39.59M12312.7 3941.3c-1.9-5.59-10.1-6.33-14.7-8.2-6.9-2.84-13.3-9.15-17.6-15.08-15-20.57-10.4-38.93-12.9-61.57M11931.4 4415.7c-12.2 6.11-12.3 19.26-22.5 26.66-8.7 6.27-25.9 2.44-30 15.45M12314.9 4278.75c3.5 0-5.5 4.15-7.9 6.6-5.9 5.83-11.9 11.44-17.8 17.3-9.2 9.2-6.7 20.86-14.5 28.65-8.3 8.36-22 6.39-31 14.56M12155.7 4371.51c-3-1.02-1.1-9.48-.1-11.58 5.4-10.61 17.8-11.49 25.6-18.92 3.9-3.64 5.3-24.77 8.3-25.27M12453.3 4351.52c3.4-6.65 7-9.65 7.4-18.01.3-5.99-2.6-13.52-.5-19.29 2.4-6.84 11.9-9.5 15.2-16.31 2.2-4.58.4-13.28 4.4-16.47M12535.8 3946.67c-.5 2.77.8-14.18-1.8-20.75-5-12.27-20.1-16.74-23.7-30.39-4.9-18.17 22.2-59.22 10.8-70.56M12535.2 3950.53c8.1-14.23 28.1-29.74 31.7-38.79 8.2-20.51-3.8-37.04 11.5-55.37"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12454.1 4352.24c0-15.06-17.3-26.34-14.4-43.55 1.3-7.88 19-41.27 8.8-46.38M12381.3 4104.67c-1.2-1.2 10.2-.46 11.4-.11 6.1 1.73 8.5 10.32 9 15.7 2.5 23.46-7.5 33.47 19.6 38.76 5.9 1.17 14-1.01 18.2 4.26M12292.9 4737.64c-17.3 17.29 2.3 37.43 5.2 57.92 2 13.78-5.3 25.41-5.3 38.29"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12292.4 4735.83c0 .05-14.3 10.88-18.3 14.87-8.6 8.65-7.4 21.58-14.7 29.99-8.1 9.23-22.8 11.89-31.6 22.48M12101.9 4701.4c-5.3 21.05 22.3-3.19 31-9.84 4.6-3.57 23.8 2.04 23.8-3.94M12098.3 4701.48c-5.3 10.53-11 34.27-6.9 46.48M12213.5 4686.61c8.6-17.16-5-64.87 16.1-73.33"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12212 4687.62c-1.7 3.27 14.4-10.62 17.7-11.66 18-5.77 19.6-.21 35.1-12.13M11936.8 4416.63c0-1.36 12 6.47 17.4 14.9 12.2 19.18 11.2 31.13 37 27.35M11584.6 4427.67c-5.1 2.55 13.3 35.33 13.9 43.23.7 7.56-1.9 14.56-4.6 21.48-1.4 3.59-6.5 13.67-3.8 10.93M11580.5 4429.4c-1.3-1.33-9.7 10.33-10.9 11.44-14.9 14-15.6 29.78-18.4 49.33M11657.4 4605.3c-4 0 16.1 37.17 13.7 48.69-.5 2.66-3.7 16.41-7.8 16.41M11654.8 4602.95c-13.1 0-31.9 36.08-33.8 45.58M11836.8 4613.28c6.3-18.89-37.4-33.02-16.7-53.77M11840.1 4607.03c-2.2 2.23 6.1 2.36 9.2 2.6 9.5.75 16.4-5.05 24.9-5.05M12088.9 5187.16c0-8.89 10.4-16.15 13.1-25.09 2.2-7.29-1.2-15.01-.4-22.43 1.9-17.83 20.9-27.33 34.8-34.78M12091.9 5183.22c-.9-.45 11.5 2.48 13.6 3.09 8.2 2.39 15.8 6.49 23 11.09 26.2 16.9 43.9 4.5 71.9 2.03M12035.2 5206.16c-5.2 3.73-2 15.17-1.1 19.93 3.3 16.92 12.7 30.94 19.5 46.48 2.3 5.46 2 14.21-2.8 18.25M11979.6 5208.44c-.7 1.1 1.2-6.97 1.4-8.7.5-5.88-.9-11.7.7-17.56 4.4-16.65 21.9-29.21 23.2-46.24M12053.9 5043c-6.4 2.13-10.8 23.39-10.6 29.11.3 8.97 8.4 14.13 11.5 22.09 4.2 10.72.1 21.79-4.4 31.63-1.4 3.09-3.4 10.11-6.5 11.84M12048.6 5046.33c-12.5 0-30.9 15.62-38.3 24.56-2.8 3.33-3 8.22-6.2 11.23-4 3.75-11.3 4.92-16.1 7.69M11870.6 5054.61c-1.9.26 5.7 4.09 5.8 4.2 5.4 3.51 7.7 8.19 10.6 13.73 5.4 10.27 10.2 35.23 22.3 40.09M11867.5 5060.33c-8.3 1.65-7.8 10.21-6.5 17.16 2.8 15.59 14.2 27.03 18.2 41.8.9 3.35 0 20.96-7.3 17.83M11621.1 5333.92c-7.8 7.72 10.5 31.8 12.8 40.87 3.5 13.52-8 27.51-9.9 41.08M11618.2 5336.5c-23.4 10.94-28.4 48.82-56.6 52.36M11643.2 5306.73c-.9 2.82.1-6.01-.6-8.88-1.3-5.48-6.1-8.57-10.8-11.23-11.1-6.33-38-7.69-36.5-23.92M11680 5269.29c-3.6 0 7.1 1.47 10.3 3.14 7.2 3.89 14 9.21 19.6 15.3 19.9 21.53 35.8 37.44 65.8 44.28M11706.8 5200.91c.2 3.73-.7-5.56-2.6-8.08-3.8-4.93-10.8-7.05-16.8-6.95-9.4.13-17.8 6.73-27.3 6.47-18.4-.51-35.9-24.35-44.7-38.66M11724.3 5120.08c-.3.08-6.4-15.03-9.6-16.84-6.4-3.62-14.3-4.33-20.4-8.56-13.4-9.24-18.3-27.14-21.5-42.1-1.1-4.92-4.4-13.06-2.9-18.14M11716.6 5154.38c0 .45 13.4-1.73 14.9-1.62 6.7.53 12.3 5.85 16.7 10.29 14.4 14.43 16 38.32 33.8 50.58 8.2 5.62 18.6 4.47 27.2 8.81M11957.2 5203.82c-5.4-1.81-6.7 24.34-5.9 28.31 2.6 11.52 15.3 16.92 21.9 25.56 9.1 11.98 14.7 29.57 16.7 44.41M11557 4983.83c-.2-.43 6.4 5.8 7.7 8.3 3.8 7.32 6.7 15.94 7.1 24.19.8 14.23 1 25.72 8.8 38.28 7 11.39 18.7 19.51 23.8 32.2M11568.2 4913.22c-3 1.49-7.6-1.68-11-1.31-6.6.75-13.5 3.89-20.2 1.73-22.1-7.1-40.7-39.27-42.2-60.85M11592.2 4868.65c-8.6 5.16.4 25.62 4 31.18 7.9 12.29 22.4 18.6 32 29.43 13.6 15.22 13.6 30.81 16.1 49.7M11494 5025.26c-10.4 13.81 3.8 34.8 10.1 46.61 7 13.12 6.1 25.12-2.5 37.49-2.6 3.78-6.4 8.38-10.2 11.04M11489.9 5027.09c-9.8 0-26.3.45-33.4-7.39-7-7.72-6.6-24.4-6.6-34.27M11436.3 5068.6c-3.6 0-8.2 11.31-9.7 13.68-3.8 6.04-11 14.82-10.3 22.4 1.1 12.61 8.1 19.74 4.5 33.66-.8 2.87-1.7 7.87-4.8 9.07M11442.1 5069.64c-4.5-.43 5.2-7.61 9.1-6.95 4.9.8 7.9 6.34 13.2 5.4 6.6-1.14 8.2-9.81 13.3-11.52M11387.2 5346.93c0-7.29-3.6-17.72.7-24.24 7.4-11.38 25.4-11.62 33.3-23.86 7.3-11.28 2.3-28.5 11.5-38.77M11468.1 5389.48c1.4-.98 1.6-6.78 1.8-8.41.6-9.39-3.6-17.77-.9-27.43 3.7-13.35 18.9-17.66 25.5-28.92 6.4-10.83 3.9-25.43 6.1-37.41M11429.8 5379.1c-2.4-2.36-6.4 4.77-7.3 6.07-4.7 6.76-8.6 16.12-7.5 24.53 2.2 16.02 22.5 23.89 23.3 42.23.4 7.53-3.9 15.53-7.7 21.76-.4.75-5.1 8.62-6.1 6.49M11553.7 5366.6c0-12.29-5.2-29.8-4-42.68 1-11.09 10.2-18.2 10.2-30.62M11332.6 5030.07c-7.1-1.81-12.8 20.46-12.8 24.91 0 7.13 5.7 13.57 8.5 19.79 7 15.35 10.2 44.38-6.6 55.13M11292.8 4980.32c0-4.79 2.1-8.84 1.1-13.84-1.6-7.34-8.4-17.08-5.2-24.66 4.7-11.28 18.3-14.58 22-26.82 3.6-11.79-.6-24.67 2.8-36.61M11145.8 5381.81c-5.1 3.09 11.8 25.25 13.1 31.21 3.8 18.73-6.9 38.05-.2 56.3M11189.6 5344.59c0-22.93-29-21.71-43.3-28.3-10.4-4.85-13.8-21.48-15.3-31.59M11225.4 5260.54c0-18.68-20.5-26.79-32.7-37.3-16-13.73-20-37.91-11.2-57.34M11216.9 5295.45c-.8.37-2.9 1.09-2.5 2.34 1.3 3.54 6.9 5.8 9.5 8.51 5.6 5.77 9.8 13.14 12.6 20.7 7.7 21.31-.6 44.54 5.1 65.75M11076.9 5053.19c-.8-1.17 4.8 18.79 6.6 22.57 7.2 14.68 19.5 23.09 19.7 41 .1 4.95-.2 14.34-6.3 15.78M11071.3 5051.95c-14.3 14.34-8.6 35.89-4.6 53.1.9 4.23 4.7 19.66-1.1 22.01M11101.5 5010.65c-4.7-9.47-7.4-17.64-19.5-20.67-7.1-1.78-14.4.85-20.9-3.62-10-6.76-11.3-22.7-10.8-33.55M11133.2 4929.07c-7.3-9.79-25.8-18.44-28.2-29.9-1.7-7.8 1.8-16.39 2.8-24.06 1.7-12.47.7-25.43-4.9-36.61M11125.1 4970.55c0 2.51 5.1 3.81 6.6 4.45 5.2 2.34 9.4 6.09 12.7 10.67 7.5 10.19 9.3 40.68 22.9 44.96 4.9 1.52 9.5-1.62 14.3-.88M11027.8 5252.35c0 2.29 8.9 8.46 10.5 9.92 10.3 9.5 27.8 16.6 34.1 29.3 1.2 2.28 6 19.82 1.1 20.51M11025.2 5248.09c-8.6 12.99-9.9 38.26-4.3 52.15 2.9 7.45 10.1 14.45 10.6 22.75 1 15.62-12.1 26.42-16.7 40.23M11026.4 5172.6c-.5.27-6.2-3.64-7.4-3.88-5.7-1.09-11.8-.83-17 1.91-11.4 6.04-18.8 17.22-29.1 24.61-12.1 8.7-25.8 12.03-39.5 17.22M11022.7 5085.55c-3.4-6.76.4-26.5 4.5-32.44 4.6-6.62 12.2-8.14 15.5-16.44 3.4-8.49.9-21.15 6-28.81M11037.3 5141c-.8 0 1.9-.19 2.7 0 2.8.61 5.7 1.11 8.4 2.44 6.1 3.12 9.6 8.12 12.2 14.27 4.4 10.03 8.5 27.48 18.2 33.76 14.3 9.37 33.6-1.06 42.3 14.13M11453.6 4722.47c0-16.25-10.2-27.85-11.3-43.9-1-16.02 9.1-26.82 11.9-41.66 2.5-13.65-2.6-31.88 1.6-44.6M11485.6 4755.89c-8.1.48-13.2 14.26-14.5 20.73-2.7 12.9 3.7 26.74-.3 39.08-6.3 19.59-24.6 33.39-26 55.18M11513 4779.33c0-5.21 8.3-4.12 11-2.47 11.7 7.07 36.9 31.1 49.1 9.63"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11516.3 4778.59c-5.2 1.94-3.2 15.91-3.1 19.84.2 6.2-.2 13.87 3 19.43 6.2 10.93 23.6 20.56 15.9 36.02M11248.1 4578.88c3.7 0 12.9 9.63 15.6 12.21 11.9 11.76 16.9 33.68 14.5 50.12-1.6 11.1-5.3 22.62-2.5 33.85 3.5 14.47 14.5 26.07 17.8 40.95M11244 4580.79c-12 5.4-9.8 31.21-9.9 41.43-.3 19 8.4 33.36 12.8 51.06 3.7 14.37-2.6 37.3-11.5 48.77M11300.7 4527.9c0 2.98 6.7 6.84 8.7 8.75 3.9 3.83 6.2 9.79 7.5 15.03 3.9 16.15 1 33.16 3.7 49.47 2.9 16.71 11.5 31.69 14.3 48.53M11311.8 4456.91c-3.4-8.46-10.7-1.35-16.2 2.53-10.6 7.4-24.7 20.62-32.7 31.02M10834.4 4916.65c-2.6 0-1.3 10.43-1.3 11.76 0 14.18 11.6 21.47 13.6 34.53 3 19.77-19.9 41.14-23.8 60.56M10829 4919.29c-27.2 10.9-33.5 41.66-49.8 63.4-6.7 8.97-19.4 10.96-25.3 19.66M10922.8 4869.61c-9.8 2.79-11.2 22.24-9.6 30.2 2.1 10.4 9.3 19.1 12.4 29.16 3.5 11.12 2.4 23.17.6 34.53-.9 5.73-1.9 16.02-7.3 19.61M10880.1 4883.71c-2.2-1.44-.7-10.86-1.5-13.3-2.1-7.16-9.2-12.94-15.6-16.05-18-8.7-60.4-5.4-63.1-31.37M10992.6 4844.94c-1.9-2.79-2.4-6.62-3.6-9.74-10.1-27.67 15-31.05 27.2-51.99 8.1-13.94 7.4-32.54 9.2-48.02M10932.8 4799.87c-5.6 1.38-9.2 9.28-15.7 8.3-23.4-3.49-36.1-36.29-61-34.51M10932.7 4808.25c-11.3 4.1 1.3 28.95 7.5 31.69M10983.4 4716.75c-5.5-7.05-5.8-21.23-15.5-24.61-7-2.45-15.8 4.5-22.2 6.17-12.4 3.25-27-3.93-37.4-9.92-3.6-2.08-9.1-4.23-10.5-8.51M10976.7 4648.43c3.1-6.36 17.4-7.59 22.8-5.25 15.8 6.82 21.3 29.11 39.2 34.65 9.7 3 23.8-2.42 33.8-3.75M10649.1 4821.67c-.4-.08 8-2.13 9.2-2.29 7.5-1.04 14-1.36 19.8 4.39 4.7 4.73 7.2 12.66 13.4 15.88 4.3 2.26 8.7-.53 12.5-2.45 9.6-4.84 17-10.32 28.2-11.22M10589.4 4906.89c-5.4 1.78-11 1.09-16.3 3.51-13.6 6.15-29.6 20.33-40.4 30.57-7.7 7.24-13.4 18.12-21.7 24.24-7.2 5.27-19.2-3.3-28.2 3.38M10553.2 5023.72c-3.7 20.57 18.9 23.55 27.3 37.62 16.2 26.95 15.8 60.85 29.3 89.27M10547.9 5036.11c-2.6-7.77-21.6 17.46-24.3 19.98-15.3 14.43-36.5 32.38-57.7 36.62M10566.2 4966.3c-2.8-4.31 11.5-2.29 12.2-2.16 9 2.03 17 7.13 22.6 14.45 10.3 13.28 14.3 26.53 30.2 34.7 10.3 5.32 22.1 4.89 32.3 10.43M10607 4886.14c-3.1-3.16 3-1.2 6.6-1.78 7.6-1.28 16.1-1.12 21.5 5.11 5.5 6.25 5.9 15.27 10.6 22.08 9.1 13.12 27.6 23.79 42.6 28.79M10635.7 4843.54c-5-8.2-26 .74-31.5 2.55-26.2 8.6-50.3 19.42-77.2 6.52M10226.8 4768.08c2.4 1.19-4.4-10.22-4.7-10.54-4.7-6.76-10.6-13.97-12.2-22.27-3.4-17.45 13.3-35.23-1.8-50.98-3.4-3.59-6.6-6.46-10.8-9.07M10228.8 4770.12c-15.1 2.51-43.1-1.06-52.2 12.27-7.1 10.43-8 24.61-11.3 36.56-.7 2.82-2.1 11.6-6.2 11.6"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.554}
      d="M10286.7 4784.25c-3.8 0-7.5 23.44-8.2 26.34-4.4 19.18-11.4 63.85-40.9 61.7"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M10303.4 4788c0-13.22 10.2-22.21 2.7-36.87-8.1-15.83-44.7-29.59-32.7-52.79M10393.2 4778.43c-.6.1.4-6.12.3-7.03-.3-4.44-1.9-8.94-3.9-12.88-12.2-23.54-25.7-40.78-6.6-66.41M10379 4779.01c-4.6-.93-3.8 5.8-4.4 9.18-1.9 10.7-4.4 21.31-9.1 31.16-8.5 17.77-29.8 24.61-39.3 42.09M10322.7 4671.66c0-17.4-22.3-20.86-33.5-30.36-12.3-10.38-18.7-27.8-22.5-42.89M10321.4 4673.31c2.1-1.04-2.9 3.61-4 5.66-2.4 4.63-3.9 9.85-4.6 14.98-1.8 12.48 6.3 26.4 14.5 35.23M10379.6 4641.24c-.3 1.89-.3-3.59-.4-4.26-.3-3.03-1-6.01-2.3-8.8-3.8-8.49-7.7-21.77-14.3-28.18-8.4-8.12-27.8-3.99-38.7-6.17-1.9-.4-10.6-.7-10.6-3.89M10446.7 4622.38c-11.8 7.37-5.8 30.62-1.6 40.81 4.7 11.23 15.5 16.82 22.3 26.4 9.1 12.9 6.3 36.45-2 49.33M10499.5 4600.06c-.3.45-1.6 2.71-2.1 2.71-.2 0-1.4-4.02-1.5-4.18-1.2-2.2-3.3-3.96-5.3-5.5-8-6.34-16.3-9.37-26.3-11.9-20.4-5.19-35.9 10.99-53.9 15.86M10659 4464.79c-3.1 1.3.3-19.08 2.9-22.14 4.9-5.8 16.8-3.88 23.3-8.14 17.7-11.47 11.1-38.85 30-48.03M10682.4 4485.86c0 .93 9-1.07 9.8-1.18 5.2-.58 10.8-.77 16 .08 11.2 1.81 21.5 10.91 33 10.91 12.2 0 25.1-11.76 34.3-18.57M10580.5 4435.07c-2 0-4.5 6.33-5.9 8.06-5.7 7.26-11.6 15.59-18.9 21.34-11.7 9.23-36.2 9.04-50.4 12.95M10552.1 4407.69c-3.6 0-7.4-3.09-11-3.65-8.2-1.27-18.9.78-26.5 3.6-14.5 5.26-25.9 18.46-40.2 22.85M10566.3 4425.01c-2.3 0 1.7-4.68 2-4.92 4.6-4.36 10.7-7.29 16.1-10.48 14.6-8.65 32.1-13.71 44.3-25.92M10820 4432.97c7.3 5.48 27.5 6.09 35.2 1.12 8-5.22 13.4-14.61 20-21.34 13.4-13.73 32.2-24.43 51.4-26.9M10846.5 4507.39c9.9-4.93 23.4 6.38 32.6 7.9 12.4 1.99 36.3-9.9 47.7-14.98M10799.3 4411.07c3.1 6.07-7 14.71-10.8 17.32-11.7 8.12-40.5 21.45-55 16.05M11004.4 4295.52c4.9-12.27 28.8-10.75 37.1-20.94 9.5-11.73 7.5-29.51 13.2-43.05 6.8-15.88 20.7-26.58 31-39.96M10995 4246.88c-12.8 0-24.4 8.54-37.1 10.3-12.6 1.73-24.4-3.01-36.8-2.77-6.4.13-14.8 2.61-18.7 8.06M11024.4 4329.25c-7.8 5.83-7 19.93-12.5 27.7-13.1 18.39-39.8 20.09-41.1 46.54M11047.7 4349.37c5.2-10.46 2.6-22.88 9.1-32.94 6.4-9.98 20-14.74 24.1-26.13M10993.4 4221.92c5.6-11.23 12.5-21.93 21.6-30.52 6.3-5.88 14.1-8.59 19-16.04 6.4-9.55 7.5-21.58 10.6-32.38M10992.3 4220.06c0-21.53-5.1-37.3 9.7-56.41M10786.5 4368.84c-1.8 0 .2-5.11.5-5.75 2.1-4.78 6.7-10.03 11.2-12.55 6.1-3.46 12.1-2.08 18.6-3.41 9.4-1.92 29.6-14.53 31.4-25.46M10781.4 4371.42c0-16.2-13.9-30.94 1.6-43.82M10835.7 3980.28c-1.7 1.7 1 5.14-.2 7.26-4.5 8.25-12.6 17.06-12.4 26.96.5 27.7 15.7 42.22 2.7 70.11M10251 4257.6c-16.7 0-33.9 26.15-38 40.57-2.6 9.47-2 18.84-9.2 26.53-3.5 3.75-9.5 4.1-14.2 5.16M10251.9 4255.92c-25.7 0-29.1-15.61-40.3-35.57M10382.8 4279.55c-6.8-2.71-10.9 7.24-13.8 11.84-4.2 6.68-8 13.73-7.8 21.85.2 8.88 6.4 24.63-3 30.89M10375.6 4280c-2.5 2.53-7.8-1.41-10.8-1.73-13.1-1.35-23.6-2.92-32-14.13M10198.5 3935.1c-28.4 0-22-25.84-28.7-45.93"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M10195.5 3939.94c0-8.06-8.1-4.13-13.1-1.92-12.2 5.54-26.7 8.52-38.3 14.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M11600.5 3734.94s-353.6 359.19-491.5 569.38-516.2 468.28-516.2 468.28 439.5-243 577.4-436.35c128.5-180.13 436.3-500.21 436.3-500.21s-165.8 435.74-248.7 653.62c-105.4 276.71-513.6 854.98-513.6 854.98s527.5-595.99 639.9-872.7c82.5-202.87 165-635.9 165-635.9s34.6 508.83 34.6 763.62c0 262.95-8 1000.25-8 1000.25s57.7-750.15 74.5-1000.25c15.4-228.32-53.7-747.16-53.7-747.16s114.5 375.06 175.5 559.5c69.2 209.32 258.7 698.51 258.7 698.51s-145.5-526.82-206.7-737.01c-57.3-196.86-196.5-549.5-196.5-549.5s502.5 382.75 632 549.5c104.2 134.12 364.5 545.44 364.5 545.44s-171.3-437.79-274-574.71c-130.9-174.27-722.5-557.23-722.5-557.23s367.2 186.39 517.1 255.11c139.8 64.1 410.2 174.41 410.2 174.41l-426.3-245.39-506-236.19z"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11309.9 4746.71c43.4 37.23 93.6 118.06 101 175.16 9.8 75.85 24 67.6 35.3 146.52 6.8 47.68 30.7 99.56 30.7 148.81 0 68.06 27.6 140.67 27.6 209.98 0 9.02 27.8 347.51-6.2 153.82-9.6-54.44-32.9-248.94-52.3-307.31-28-83.92-22.1-201.18-61.1-279.24-8.6-17.24-40.8-116.06-56-146.44-11.7-23.34-33-39.3-49.1-55.4"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11309.9 4746.71c43.4 37.23 93.6 118.06 101 175.16 9.8 75.85 24 67.6 35.3 146.52 6.8 47.68 30.7 99.56 30.7 148.81 0 68.06 27.6 140.67 27.6 209.98 0 9.02 27.8 347.51-6.2 153.82-9.6-54.44-32.9-248.94-52.3-307.31-28-83.92-22.1-201.18-61.1-279.24-8.6-17.24-40.8-116.06-56-146.44-11.7-23.34-33-39.3-49.1-55.4"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11982.6 4554.24c-1.2-1.25 70.9 8.06 87.9 13.97 9.7 3.4 19.3 7.5 27.7 13.46 55 38.71 102.5 89.9 163.8 118.99 37.6 17.85 77.5 27.99 118.6 27.45 16.1-.21 32.6-3.16 48.1-3.16 2.1 0 80.1-16.02 76.7-12.48-29.2 30.36-125.5 54.33-155.4 55.58-90.7 3.78-194.7-43.5-261.2-102.67-2.3-1.97-4.3-4.21-6.5-6.15-1.7-1.49-3.4-2.79-5.2-4.18-1.7-1.33-3.4-2.71-5.1-3.99-32.3-23.17-82.7-47.94-81.7-48.93"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11982.6 4554.24c-1.2-1.25 70.9 8.06 87.9 13.97 9.7 3.4 19.3 7.5 27.7 13.46 55 38.71 102.5 89.9 163.8 118.99 37.6 17.85 77.5 27.99 118.6 27.45 16.1-.21 32.6-3.16 48.1-3.16 2.1 0 80.1-16.02 76.7-12.48-29.2 30.36-125.5 54.33-155.4 55.58-90.7 3.78-194.7-43.5-261.2-102.67-2.3-1.97-4.3-4.21-6.5-6.15-1.7-1.49-3.4-2.79-5.2-4.18-1.7-1.33-3.4-2.71-5.1-3.99-32.3-23.17-82.7-47.94-81.7-48.93"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11019.3 4427.93c-9.7-6.46-14.3-18.59-24.6-24.47-56.9-32.52-125.8-35.26-186.2-60.4-49.9-20.78-98.1-53.35-143.9-81.52-39.7-24.45-80.2-52.9-114.2-84.88-27.2-25.62-124.1-99.59-118.2-92.64 27.5 32.38 150.2 152.69 167 168.2 86.2 79.59 164.9 107.36 267.4 152.91 34.6 15.38 69.3 63.83 95.6 75.54 26.7 11.87 34.5-34.16 49.3-51.4 2.1-2.4 9.2-1.84 8.2-4.85"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11019.3 4427.93c-9.7-6.46-14.3-18.59-24.6-24.47-56.9-32.52-125.8-35.26-186.2-60.4-49.9-20.78-98.1-53.35-143.9-81.52-39.7-24.45-80.2-52.9-114.2-84.88-27.2-25.62-124.1-99.59-118.2-92.64 27.5 32.38 150.2 152.69 167 168.2 86.2 79.59 164.9 107.36 267.4 152.91 34.6 15.38 69.3 63.83 95.6 75.54 26.7 11.87 34.5-34.16 49.3-51.4 2.1-2.4 9.2-1.84 8.2-4.85"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12454.7 4367.54c20.7 0 60 11.25 82.8 13.81 61.8 6.86 129.9-7.66 187.7-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.3 89.21-43.8 7.29-72.4 13.2-111-9.34-20.3-11.87-5.8-37.28-17.1-51.4-2.9-3.6-7 .53-4.5 2.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M12454.7 4367.54c20.7 0 60 11.25 82.8 13.81 61.8 6.86 129.9-7.66 187.7-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.3 89.21-43.8 7.29-72.4 13.2-111-9.34-20.3-11.87-5.8-37.28-17.1-51.4-2.9-3.6-7 .53-4.5 2.98"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11738 4689.85c-6.7-6.67 25.8 52.74 29.4 61.89 14.1 35.12 35.3 71.01 52.1 105.34 34.5 70.03 78.4 138.65 124.8 201.49 18.8 25.44 44.7 44.65 62.8 70.72 21.4 31.05 45.4 59.36 69.8 87.88 8.6 9.9 20.4 26.08 24.5 38.26.9 2.64 64 127.56 64 127.56s-93.7-141.71-105.3-150.84c-37.4-29.69-79.4-87.75-103.9-116.46-83.2-97.19-90-135.93-168.6-236.32-24.2-30.86-49.8-68.19-49.8-108.15 0-13.81-17-41.06-16.6-38.64"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11738 4689.85c-6.7-6.67 25.8 52.74 29.4 61.89 14.1 35.12 35.3 71.01 52.1 105.34 34.5 70.03 78.4 138.65 124.8 201.49 18.8 25.44 44.7 44.65 62.8 70.72 21.4 31.05 45.4 59.36 69.8 87.88 8.6 9.9 20.4 26.08 24.5 38.26.9 2.64 64 127.56 64 127.56s-93.7-141.71-105.3-150.84c-37.4-29.69-79.4-87.75-103.9-116.46-83.2-97.19-90-135.93-168.6-236.32-24.2-30.86-49.8-68.19-49.8-108.15 0-13.81-17-41.06-16.6-38.64"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11239.6 4743.76c4.9-4.84-12.5 5.48-18.6 8.65-11.6 6.06-24.8 7.98-36.8 13.3-36.7 16.34-77.1 30.41-116.3 39.11-54 12-110.3 14.82-164.9 23.63-45.5 7.34-90 20.3-135.4 27.62-16.7 2.68-142 39.61-149.7 41.42-137.1 32.41 157.2-15.83 172.1-18.78 52.3-10.32 107.9-30.78 160.8-34.62 71.8-5.18 153.9 10.25 224-9.31 37.2-10.4 52.2-55.21 66-86.2.6-1.23 3.5-7.83 4.7-7.83"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11239.6 4743.76c4.9-4.84-12.5 5.48-18.6 8.65-11.6 6.06-24.8 7.98-36.8 13.3-36.7 16.34-77.1 30.41-116.3 39.11-54 12-110.3 14.82-164.9 23.63-45.5 7.34-90 20.3-135.4 27.62-16.7 2.68-142 39.61-149.7 41.42-137.1 32.41 157.2-15.83 172.1-18.78 52.3-10.32 107.9-30.78 160.8-34.62 71.8-5.18 153.9 10.25 224-9.31 37.2-10.4 52.2-55.21 66-86.2.6-1.23 3.5-7.83 4.7-7.83"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.909}
      d="M12339.5 4051.54c3.3-13.23 29.4-13.6 38-12.78 37.2 3.57 65.6 34.7 117.5 31.56 70.5-4.28 75.3-41.9 126.2-60.85 41.7-15.48 85.4-3.48 127.6 1.86M12648 4389.92c-5.2-7.77 8.1-26.88 11.5-33.42 22.1-41.19 74.3-36.93 96.8-72 40.1-62.34 1.2-160.28 77.5-202.48M12795.5 4365.17c95.8 22.3 69.6 61.04 128.7 100.63 39.5 26.5 81.7 20.03 125.9 26.37M12660.9 4757.47c-9.3-16.95 53 18.38 66.7 34.61 51.4 60.72 48.5 72.93 129.6 78.41 13.9.93 51 7.85 57.9-9.04M12459.5 4515.98c-54.4 9.61-91.8 52.76-140.6 68.3-26.8 8.51-84.6-6.33-110.5-13.97M12263.5 4752.94c-23.2 5.8-26.5 50.66-18.2 67.23 15.2 30.41 52.6 44.38 69.3 74.66 23.1 41.51 8.8 88.79 11.8 133.54 1.3 20.54 7.4 39.96 7.4 60.82M12078.9 4571.38c17.1-11.44 1.7-91.77 11.3-120.88 17.4-53.05 69.6-81.1 112.4-113.16M12016.6 4811.5c-38.7 0-65.2 48.82-59.8 83.86 2.9 18.02 15.9 31.75 16.4 50.88.5 16.63-11.9 54.19-34.5 51.37M12070.5 5227.37c-8.8-23.95 44-38.05 57.4-33.13 18.5 6.79 28.4 24.93 44.6 35.39 55 35.7 107.7 44.91 164.7 4.39M11910 4300.6c-7.4-12.88 39.7-33.34 47.5-35.41 26-6.9 48.5 12.95 74.7 10.8 33.1-2.77 55.4-30.97 85-42.2M11697.9 5019.44c-12.5-3.12-21.8 2.82-32.2 9.2-51.2 31.53-26 74.07-57.5 107.41-20 21.21-53.7 5.51-72.4 33.55M11692.7 5265.57c-1.1-.45-.3-.45.3-.53 9.4-1.04 19.6 2.05 28.8 4.12 21.9 5.01 49.5 11.68 64.1 30.36 48.4 61.94 11.8 125.48 120.1 143.65 15 2.5 28.9 1.57 43.7-1.73M11697.3 4749.08c-14-13.99-45.1 17.06-56.5 25.84-16.7 12.93-32.8 29.59-54.6 32.99-44.5 6.97-75.1-27.96-89.8 35.81M11681 5469.99c.4-.45-20 11.79-24.8 17.69-13 15.91-14.4 34.99-16.9 54.71-2.8 22.16 2.7 42.97-6.5 64.17-28.2 64.63-53.2 54.6-59.1 124.87M11487.1 5485.96c-62.2-31.13-75.6 125.82-97.1 152.03-24.6 29.85-66.5 51.3-85.2 84.66M11454.4 5319.95c-43-48.37-112.9-39.27-156.8 5.86-21.2 21.76-25.3 59.41-51.1 77.08-19.9 13.59-81.4 4.52-108.1 9.84M11433.5 5086.08c12.4-43.47 60.1-21.58 84.2-30.09 23.2-8.17 40-39.78 58.4-54.86 15.4-12.67 38.8-21.58 49.5-38.98M11357.5 4905.68c-11.7-8.78-36.4 14.9-42.5 21.85-29.7 33.98-33.9 82.05-56.2 120.31-32.1 55.48-115.2 60.16-162.8 98.53M11482.3 5364.55c-1.6-1.68-.6-2.19 1.3-3.46 11.1-7.83 33.7-13.68 45.5-5.19 48.1 34.59 54.8 36.85 104.9 4.79M10914.9 5259.39c-9 2.98-18.6 46.3-16.5 57.9 2.8 16.23 13 32.41 18.6 47.79 16.4 44.99 13.8 92.53-7.9 135.77M10943.5 5195.09c-18.6-18.55-62.4 2.85-77.4 14.23-26.5 20.36-46 48.16-72.2 68.7-29.5 23.1-109.8 34.83-144.6 37.15M11055.2 5062.11c-20.7 3.86-18.5 53.48-15.9 67.34 4.2 21.69 22.7 41.06 31.8 61.12 18.5 40.42 24.5 88.76 17.8 132.45M11071.3 4994.88c-21-3.49-78.4 41.61-106.2 48.05-34.2 7.93-74.3 14.16-109.2 10.8-16.3-1.57-36.7-14.74-52.2-12.53M10659.2 4896.24c-9.3 0-30.9 57.07-31.7 65.61-5.2 55.53 28.2 149.06-37 180.13M10716.5 4873.87c0 7.96-1.6-5.88-2.4-7.85-4-10.08-14.2-21.58-23.1-27.54-8-5.35-19.2-4.65-26.7-10.53-16.9-13.36-3.1-59.44-.9-79.08M10938.7 4832.73c0-59.41-44-30.09-69.9-74.39-17.1-29.35 2.9-63.64-6-94.8M11102.8 4808.92c-6.5-8.78-2-40.84-7.2-53.64-8.9-22.35-32.5-33.15-42.4-54.47-18.9-40.28 8-70.16 21.3-105.54M11013.8 4824.48c-22.2 3.52-68.5 60.83-75.1 83.34-4.4 14.87-.9 36.45-9.9 49.11-15.7 22.35-63.8 40.58-85.8 55.26M10696.7 4703.61c-13.4-1.22-21.8-25.22-36.4-30.07-40.8-13.62-105.9 28.69-97.3-53M10791.9 4638c-2.3 13.78-11.6 68.43-12.7 82-1.4 19 11.1 36.5 14.7 55.23 2.8 15.28-19.2 45.26-27.1 57.5M10874.3 4576.49c-2.8 5.45-2.9-11.9-5.5-17.43-6.3-13.7-14.6-22.99-29.1-27.96-55.8-19.06-85 14.97-121.3-57.64M10911.3 4396.92c-21.7-11.47-19.2-60-14-79.35 8.2-30.91 40.6-52.81 57-79.2 17.4-28.07 16.5-75.35 9.8-106.64M10718.3 4301.61c-7.7-6.12 4.5-23.42 8.3-28.5 17.6-23.17 47.3-34.48 63.8-58.85 26.8-39.49 9.6-107.89-1.3-151.61M10577.7 4211.34c2 6.97-20.3 33.81-24.1 39-36.3 48.98-102.8 46.75-160.5 50.61M10772.7 4358.71c-19.3 3.62-33.7 52.28-46.7 66.43-29.7 32.23-72.5 44.94-111.3 59.9M10530 4179.67c-3-1.01 8-17.24 9.3-19.05 14.8-20.17 39.4-29.16 53.8-49.25 24.3-33.87-13.1-79.44 25.5-108.23"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10478.2 3895.51c-14 0-60.9 68.99-77.6 84.26M10808.3 4149.63c-.3 1.41 17.1-31.26 33.6-32.73 57-5.1 74.6 3.94 105.8-58.45M10784.9 4211.55c-1.2 2.39-16.9-19.75-25.7-21.85-12.3-2.93-41.3 10.91-49.4.8M10603.6 4033.44c0-10.03 3.1-26.34-3.2-35.02-9.4-12.85-47.4-22.72-35.3-44.59M10617 4010.4c-1-5.08 24-11.84 29.3-18.76 10.7-14.02 2.5-36.93 21.4-43.39"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10623.9 4003.88c-12.3-15.49 3.5-44.54-7.4-61.78M10968.6 4131.72c-26.9-26.87 60.8-38.66 65.7-60.87"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10968.6 4139.25c-11.7-23.28-11.2-72.34 8.9-88.38M10951.9 4249.89c35-34.94 49.4 54.33 111.5 50.31M10899.1 4305.12c-31.2-41.53-55.8-29.08-38.7-80.14M10790.2 4068.19c-2.7 0-.9-20.3 2.3-22.38 9.2-6.12 27.8-1.38 39.5-8.38M10618.9 4485.04c-1.7-1.73-3.3 6.62-3.2 6.86 1.8 9.29 5.8 24.19 2.3 33.42-7.7 20.14-46.2 33.9-46.2 55.23M10614.7 4484.79c-29.1-29.08-85 29.49-120.4 26.27M10721.8 4478.17c-4.5-4.47 18.3-20.7 20.7-22.48 15.5-11.49 29.2-28.42 24.7-48.98M10762.5 4522.1c-26.5-5.29-56.2 24.64-62.1 49.01-1.9 7.5 2.4 17.64.1 24.08-1.4 3.72-8.9 21.6-12.3 19.55M10824.9 4527.45c-6 3.99-3.4-14.03-5.5-20.92-5.4-17.27-9.1-33.95 5-48.05M10869.7 4670.8c4.9-24.53 27.5-19.93 38.7-30.62 17.7-16.85 19.9-42.52 37.2-59.76M11074.8 4595.27c-10.2-30.41-25.8-58.7 6.3-81.15M11073.9 4601.97c9.8-6.51 23.5-2.26 32.1-11.3 33.8-35.68 15.7-68.38 76.6-87.33M11085.5 4738.17c-4.2-8.4 15.5-27.14 21.1-29.69 15.9-7.26 38.4-.32 55.8-6.25 24.7-8.46 37.6-35.02 54-53M11046.7 4682.91c-38.7-38.66-66.7 14.26-110.5 14.26M10909.5 4783.16c0-35.49 72.2-16.25 76.1-16.79 10.1-1.35 18.6-8.94 25.7-15.69M10785.9 4743.23c-5.3-21.52 28.1-52.52 42.4-62.05M10657.4 4823.1c-17.5-26.21-49.9 12.53-68.2 10.24M10699.2 4839.46c-.9 0-1-.98-1.1-1.86-2.2-24.43 16-46.35 31.1-62.69M10633.8 5000.14c-1.7-1.73 1.8 2.26 2.4 2.79 7.3 6.57 18.2 9.26 27.5 11.31 25.5 5.61 52.1 10.27 77.9 13.46M10623.3 5085.07c-11.5-11.49-83 10.72-108.5-27.56M10591.7 5142.04c4.9 1.62 8 45.33 7.6 50.34M10590.8 5136.45c-33.4 12.96-68.9 22.46-94.8 48.32M10805.9 5042.74c-7.8-31.34-57.6-23.2-34.3-76.41M10797.5 5040.48c-29.6 5.16-54.1 39.64-66.3 64.01M10848.1 5007.33c-16.4 16.44-35.3-55.5-48.2-58.7M10938.4 4933.7c-.8-.24 12.3-9.92 13-10.37 7.5-4.98 19.5-12 28.8-11.71 12.8.4 12.6 16.92 21.1 23.55 13.2 10.27 33-1.44 44.8-8.39M10933.4 5052.72c-5-10.78-16.5 15.03-19 18.65-10.9 15.78-23.7 74.55-36.7 77.34M10973.8 5040.88c-17.5-34.97-23.2-41.27-4.3-71.5M10918.4 5500.59c-22.2 0-66.5 86.26-87.5 100.25"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10913.6 5499.39c8.9 8.91 4.3 41.99 7.7 54.6 3.2 11.49 14.2 18.38 20.4 28.07 13.6 21.23 19.3 45.79 19.3 70.56M10927.7 5420.74c-.6 1.89 2-8.57 4.1-11.73 5.2-7.48 14-15.19 22.4-18.36 25.1-9.45 48.4 12.27 68.4-15.46M10908.9 5354.97c-12.3 6.18-21.8 18.55-34.2 25.41-21.7 12.08-46.5 20.65-67.1 34.35M10650.6 5317.03c0-27.65-85.1-31.93-105.6-50.85"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10653.9 5316.63c-42.6-2.85-65.9 118.45-79.3 126.59M10743.1 5300.8c-2.2-53.3-106-60.72-55.7-131.12M10838.3 5240.48c-56.6 42.44-8.6 110.34-24.3 158.95M11091.6 5250.46c-3.7-7.34 24.4-16.84 25.7-17.16 17-4.26 30.8 7.66 43.1 17.42 37.4 29.64 70 12.38 110.5-4.12M11091.3 5323.55c-12.1 0-14.2 23.79-14.5 31.69-1.4 41.29 16.1 54.04-15.8 89.98"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M11091.3 5323.55c-3.1 0 6.2 4.34 9.3 4.52 6 .38 13.4 1.84 19.3 3.06 23.3 4.85 36.4 18.6 61.7 16.79M11141.2 5415.13c4-7.85-26.5 25.33-31 33.82-16.7 31.95 0 55.21-34.1 80M11138 5413.29c-12.7-1.97-33.7-9.15-28.2-23.04M11224.2 5413c-3.6-13.33-34.2 29.48-36.9 35.02-20.7 42.33 4.9 91.2-26.6 130.85M11328.7 5301.33c-14.7 2.45-19.2-24.72-18.7-34.48 1.6-31.61 40.7-50.4 28-85.46M11256.8 5051.6c-10.3-7.37-15.3 39.72-15.2 41.13 1.3 29.16 18.2 54.79 14.1 85.2M11294.2 4976.92c-19-18.97-70.9 6.83-61-39.41M11098.2 5145.71c-5.9 0 4.4 17.24 5.9 20.75 6 13.97 5.4 24.06-5.1 34.49M11552.3 5373.73c12.4 6.19 29.2-13.36 30.3-24.75 4.6-45.5-27.7-59.12 22.8-95.17M11405.9 5597.38c-29.9 19.88 16.2 60.75 23 76.42 10.3 23.94 2.4 50.87-1.9 74.92M11348 5675.93c-.6 1.65-25.7-5.72-38.9-.94-35.1 12.62-61.5 48.72-101 48.72M11430.9 5517.8c-5.7-3.8-2-5.24-9.6-8.27-44.5-17.8-65.6 42.14-104.2-15.73M11608.5 5648.1c-3.9 0 6.8-3.78 10.3-5.32 9.4-4.02 15.5-2.05 22.2 5.32 22.8 25.25 43.6 43.58 80.2 40.6M11573.7 5731.43c-7.8-1.65-6.7-7.72-16.6-5.86-28 5.25-39.3 52.18-79.9 56.44M11641.4 5522.7c-21.2-21.16-57.9-26.4-76.5-49.65M11785.9 5300.26c-1.9-1.91-.1-10.93-1.2-14.12-17.2-48.75 20.3-102.2 58.6-132.85M11834.6 5403.16c-13 7.82 45.1 16.54 63.1 8.11 36.8-17.19 44.8-51.88 72.8-76.81M11895.5 5444.58c5.4-23.97-47.5 42.2-50 56.97-6.5 39.03 41.3 56.96 8.2 94.64M11940.5 5444.58c-16.4-20.43 91.9-71.41 104.9-79.5M11941.1 5444.58c-6 12.08 32.9 15.57 40.6 21.82 20.9 16.89 38.5 55.53 68.3 32.33M11502.8 4849.39c0-7.34-7.5 13.01-4.6 23.41 5.7 20.49 16.8 38.03 13.8 60.46-.9 6.49-9.6 30.51-20.3 23.41M11500.5 4845.93c-35 5.54-53.5 16.13-82.9 40.47M11567.5 4809.98c-6.3 0-14.8-9.39-19.2-13.06-56.9-47.39-28.6-65.75-58-115.4M11638.3 4960.39c-8.8 8.81-20.2-9.42-21.6-15.43-4.8-20.75-12.3-54.28 6.7-69.9"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M11630 4960.53c10.9 12.69 37.4.82 50.6-1.33M11548.8 5030.31c-10.1-15.24-17.5-40.81-11.6-58.59 5.5-16.28 27.1-36.74 18-54.97M11551.9 5154.75c-3.1 3.09 1.6 27.17 1.3 31.96-1.4 21.82-13.5 40.25-21.4 60.02M11958 4890.66c-10.3-10.33-6-27.27-21.4-38.21-18.7-13.33-58.5-14.95-70.1-36.21M11966.7 4966.14c49.6 33.07 24.2 50.53 28.7 99.03M12177 5234.89c11.2 19.67 35.3-18.28 37-29.42 2.8-18.52-16.3-58.41-5.8-72M12283.4 5258.34c-7.7 13.62 15.8 41.56 16.6 57.49 1.4 27.97-17.8 51.46-24.9 77.35M12340.3 5235.82c8.5-30.54 42.8-47.49 71.7-52.57M12343.1 5235.03c35.8 15.75 71.1 66.33 115.6 45.79M12338.9 5091c-36 15.38-36 61.07-37.7 94.51"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M12336.9 5093.8c27.3 12.32 51.7 36.8 56.8 67.74M12330.1 4943.76c.6-11.12 22.8.53 33.1 4.79 31.1 12.88 46.1 48.88 76.4 31.96M12294.4 4878.13c-11.9-19.91-73.6 30.28-100.2 25.57M12093.4 4496.08c3.1-6.28 14.2-14.1 19.5-18.22 42.7-33.85 51.8 56.4 101.4 16.76M12138.5 4389.73c-14.3-39.32-88.1-42.25-58-99.72M12209.4 4576.62c0-19.56-45 6.25-55.8-7.18M12325.3 4575.02c-5.6-47.63-36.7-93.1-26.1-142.03M12287.9 4589.13c-17.4 5.8-9 64.81-6.8 78.81M12392.7 4542.8c54.8 38.21 46.7 54.17 43.5 112.09M12709.8 4779.36c64.3-42.86 17.6-77.99 70.9-120.61M12787.7 4861.09c32.4-50.31 32.6-132.15 98.2-147.48M12857.6 4872.93c-9.9 4.29-3.8 29.8-3.8 37.94 0 34.62 3.7 65.27-23.2 92.14M12917.3 4864.56c28.2-42.79 7.8-65.08 67.2-81.08"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M12915.8 4862.02s10.6.96 12.4 1.2c9.3 1.33 19 4.87 26.2 11.04 16.6 14.18 21.6 39.41 41.1 50.21M11981.5 4268.99c-4.4 1.09 7.4-5.29 10.2-8.78 6.4-7.85 8.9-15.8 7.7-25.83-2.9-25.79-19.2-68.75-.9-91.32M12086.2 4256.75c-1.2 2.53 5.6 1.2 8.4 1.46 10.5.91 22.9.96 32.9 4.79 18.5 7.08 19.3 30.15 31.9 43.27M13055 4486.23c-7.1 0 13-22.51 14.6-23.41 2.7-1.47 4.2-1.92 7.9-2.16 36.9-2.23 46.9-23.04 75.9-41.66M13053.4 4490.89c12.3 12.34 87 48.58 113 48.58M12938.6 4476.79c-2.8-11.28-20.6 26.45-22.3 31.02-13.2 35.76 12 75.89-23.6 103.82M12987.4 4484.1c-4.4-56.51 1.3-58.74 48.6-91.44M12877.7 4404.24c8.4-37.12 38.1-44.78 66.7-64.98M12787.7 4164.48c-2.8-5.48 9.3 8.03 14 12 7.1 6.04 13.7 12.32 20.3 18.89 20.8 20.46 46.4 16.68 73.4 14.9M12765 4269.12c-58.9-9.81-51.5-27.06-50-86.79M12840.8 4079.82c14.1-42.39 4.2-50.29 42.9-73.46M12838.8 4085c-4.5-4.52 12.7 2.13 18.8 4.02 9.9 3.01 19.3 7.37 29.2 10.51 31.7 10 57.1-9.07 83.8-23.04M12761.7 4015.53c-1.1-2.76-7.4-4.01-7.7-5.05-6.3-25.36 57.1-52.58 74.7-56.59"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M12756.7 4011.27c-5.9 26.61 42.5 16.23 69.9 7.19M12605.5 4020.99c-3.5-17.03 30.4-97.57 14.3-113.69M12537.3 4056.8c-28 35.97 57.4 52.55 36.6 101.82M12324.4 4966.14c-1.8 2.42-19.5-5.06-23.4-5.19-14.4-.56-30.3 7.58-43.3 12.9-21 8.6-39.5 47.2-62.5 35.68"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M8740.67 1584.7s-68.93-276.5-68.12-356.58c.54-54.17 51.37-164.88 51.37-164.88s-15.31 144.79-7.62 213.37c9.75 86.97 60.84 280.08 60.84 280.08zM9370.96 2913.21s278.81 63.16 358.91 61.83c54.19-.89 163.41-49.71 163.41-49.71s-144.42 15.5-213.28 8.72c-87.33-8.6-282.14-55.49-282.14-55.49z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.589}
      d="M8629.02 2988.87s-507.34-187.17-656.74-221.8c-101.06-23.44-324.96 27.01-324.96 27.01s289.26 21.25 414.3 67.49c158.55 58.64 550.91 224.53 550.91 224.53z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M8978.22 2991.67s479.31-176.76 618.98-214.52c94.48-25.55 296.44-10.71 296.44-10.71s-255.03 49.59-373.16 93.23c-149.81 55.35-525.69 238.84-525.69 238.84z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.376}
      d="M8460.78 2102.93s-128.11 168.86-176.72 202.76c-32.88 22.94-127.63 33.88-127.63 33.88s95.57-51.28 132.56-86.37c46.9-44.5 134.74-164.55 134.74-164.55z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M8731.24 2066.55s-508.22-48.7-653.62-50.26c-98.35-1.06-294.96 60.5-294.96 60.5s261.68-14.94 386.96-2.87c158.86 15.31 566.23 94.74 566.23 94.74z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M10305.5 1672.04s208.8-102.24 271-118.59c42.2-11.06 132.6-1.91 132.6-1.91s-113.8 20.71-166.4 40.06c-66.7 24.55-212.2 97.83-212.2 97.83z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.672}
      d="M9203.57 1608.96s-183.47-32.55-232.19-54.27c-32.96-14.68-89.76-74.15-89.76-74.15s85.16 47.48 128.67 61.12c55.17 17.29 183.93 38.28 183.93 38.28zM8199.24 2076.33s-134.54 132.43-179.23 160.2c-30.23 18.79-105.71 31.86-105.71 31.86s84.62-43.16 120.58-71.21c45.6-35.58 138.75-129.56 138.75-129.56zM9655.28 1890.98s144.16 122.83 190.72 147.17c31.5 16.47 107.4 23.25 107.4 23.25s-87.41-36.53-125.34-61.91c-48.11-32.18-148.1-119.56-148.1-119.56zM9207.49 2502.55s144.16-122.83 190.72-147.17c31.5-16.47 107.4-23.25 107.4-23.25s-87.41 36.53-125.34 61.91c-48.11 32.19-148.1 119.56-148.1 119.56zM9180.17 1534.92s95.55-163.57 110.11-213.84c9.85-34-1.42-110.45-1.42-110.45s-17.57 92.84-35.33 134.72c-22.53 53.11-91.12 166.93-91.12 166.93z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M9690.18 1310.35s112.49-202.66 131.73-263.94c13.02-41.45 7.69-132.37 7.69-132.37s-25.89 112.53-47.75 163.97c-27.73 65.23-108.18 206.4-108.18 206.4z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M10044.4 1315.2s279.3-38.99 354.9-67.64c51.2-19.38 144-97.49 144-97.49s-132.9 65.33-200 81.69c-85.2 20.75-282.8 38.13-282.8 38.13z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M8763.81 2501.28s315.43-13.33 420.45-8.19c71.05 3.47 209.75 38.98 209.75 38.98s-188.1-17.2-279.14-16.81c-115.46.5-413.62 19.81-413.62 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.982}
      d="M9279 1882.35s-150.98-383.31-173.01-500.22c-14.89-79.04-31.95-335.4-31.95-335.4s63.04 269.39 88.82 369.35c32.7 126.76 183.75 434.18 183.75 434.18zM8646.54 1943.86s162.79-385.83 188.36-503.9c17.28-79.81 42.04-339.2 42.04-339.2s-71.23 271.85-100.06 372.69c-36.56 127.87-197.15 436.83-197.15 436.83z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M9323.12 1889.4s315.43-13.33 420.45-8.19c71.05 3.47 209.75 38.98 209.75 38.98s-188.1-17.2-279.14-16.81c-115.46.5-413.62 19.81-413.62 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M9739.57 1528.34s-104.05-256.27-125.43-344.9c-14.47-59.96-2.92-186.946-2.92-186.946s27.21 161.506 52.46 236.676c32.02 95.32 126.2 302.63 126.2 302.63z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M8354.19 1367.21s162.93-162.89 199.4-216.05c24.68-35.96 49.45-123.81 49.45-123.81s-58.79 100.13-94.35 143.24c-45.1 54.67-160.41 167.58-160.41 167.58z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M8344.12 1622.33s-31.29-273.43-29.02-365.13c1.54-62.04 42.67-185.14 42.67-185.14s-14.71 164.79-10.26 243.96c5.65 100.39 44.14 358.37 44.14 358.37z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M8584 3737h148s-177.71-699.7 18.72-1151.04C8958.25 2072.81 9754.53 1559.48 9846 1499.5s172.6 121.18 297.7 153.79c247.1 64.41 565.3 104.97 565.3 104.97s-324.1-48.84-550.3-139.45c-107-42.88-200.85-116.98-222.2-160.81-22.43-46.03 95.9-101.41 144.9-182.9 96.3-160.1 209.3-299.565 204.8-304.06s-231.4 266.72-371.89 403.35c-269.91 262.41-1007.22 636.95-1217.57 1153.09C8521.31 2912.84 8596.33 3000.76 8584 3737"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M9047.5 3737h-120s64.66-830.16-53.8-1185.53c-167.91-503.75-483.37-846.7-694.13-1009.14-49.6-38.22-51.51 21.64-133.82 54.26-162.52 64.4-272.67-57.26-272.67-57.26s287.78 79.47 331.52-56.98c14.76-46.02-77.75-158.93-138.35-222.25-84.34-88.12-83.71-157.05-83.71-157.05s174.47 152.7 266.92 289.34c177.56 262.4 669.04 605.46 807.42 1121.59 149.29 556.8 60.38 489.28 90.62 1223.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9887.26 2049 132.44-68.53s-53.4-9.23-81.74 3.29-50.7 65.24-50.7 65.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9886.87 2051.19 132.73-70.88s-22.33 49.4-48.91 65.77c-26.59 16.37-83.82 5.11-83.82 5.11"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9363.16 2546.66 132.47-68.52s-53.43-9.23-81.77 3.29c-28.35 12.52-50.7 65.23-50.7 65.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9362.77 2548.86 132.73-70.88s-22.33 49.4-48.92 65.77c-26.58 16.37-83.81 5.11-83.81 5.11"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9413.45 2349.77 81.97 92.67s-1.65-44.49-17.37-64.73c-15.71-20.24-64.6-27.94-64.6-27.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9409.54 2350.99 88.21 90.25s-44.62-6.47-64.02-24.04c-19.39-17.57-24.19-66.21-24.19-66.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9434.47 2364.12 122.95-27.42s-41.9-20.11-67.76-16.06c-25.86 4.06-55.19 43.48-55.19 43.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9434.02 2359 122.91-15.98s-31.91 32.15-57.19 37.07c-25.27 4.91-65.72-21.09-65.72-21.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9339.98 2521.77 47.33 120.9s13.51-44.07 5.28-69.66c-8.23-25.6-52.61-51.24-52.61-51.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9341.14 2521.38 43.45 121.22s-39.09-26.56-49.63-51.2c-10.55-24.63 6.18-70.02 6.18-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9874.01 2051.74 45.9-141.95s-44.45 31.06-55.77 59.91c-11.33 28.85 9.87 82.04 9.87 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9874.13 2052.43 46.77-141.68s17.48 51.63 9.58 81.62c-7.89 29.99-56.35 60.06-56.35 60.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10339.1 1698.44-155.6 70.37s61.4 13.25 94.6.62c33.3-12.64 61-70.99 61-70.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10339.6 1694.94-155.9 74.99s28-55.85 59.3-73.38c31.4-17.53 96.6-1.61 96.6-1.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9060.76 2498.47 96.06-120.73s-53.07 13.78-74.46 37.58c-21.38 23.8-21.6 83.15-21.6 83.15"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9065.15 2501.14 88-124.24s1.18 55.03-15.51 81.89c-16.7 26.87-72.49 42.35-72.49 42.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9796.13 2750.3 81.98 92.67s-1.66-44.48-17.37-64.73c-15.72-20.24-64.61-27.94-64.61-27.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9792.23 2751.52 88.21 90.25s-44.62-6.47-64.02-24.04-24.19-66.21-24.19-66.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9306.41 2447.87 122.95-27.42s-41.9-20.11-67.76-16.05-55.19 43.47-55.19 43.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9305.95 2442.76 122.92-15.99s-31.91 32.16-57.19 37.07c-25.27 4.92-65.73-21.08-65.73-21.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9559.94 2914.74-83.73 103.1s45.8-11.37 64.41-31.67c18.62-20.3 19.32-71.43 19.32-71.43"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9556.13 2912.36-76.69 106.27s-.66-47.35 13.91-70.35 62.78-35.92 62.78-35.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9171.79 3001.71-83.72 103.1s45.79-11.37 64.41-31.67c18.61-20.3 19.31-71.43 19.31-71.43"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9167.98 2999.33-76.7 106.27s-.66-47.35 13.92-70.35c14.57-22.99 62.78-35.92 62.78-35.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9273.02 2463.47 45.9-141.95s-44.44 31.06-55.77 59.91 9.87 82.04 9.87 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9273.15 2464.16 46.76-141.68s17.48 51.62 9.58 81.61c-7.89 29.99-56.34 60.07-56.34 60.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9065.74 2514.18 126.72 122.59s-7.38-62.48-31.94-89.47c-24.57-26.98-94.78-33.12-94.78-33.12"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9061.34 2517.2 133.41 116.79s-63.59-3.27-92.7-25.71-40.71-91.08-40.71-91.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9399.96 2350.28 99.46-118.37s-53.51 12.26-75.57 35.52c-22.06 23.27-23.89 82.85-23.89 82.85"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9404.44 2353.2 91.13-122.38s.06 55.1-17.3 81.62c-17.35 26.51-73.83 40.76-73.83 40.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9711.86 1237.07 147.67 17.9s-39.48-38.16-69.91-43.78c-30.42-5.63-77.76 25.88-77.76 25.88"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9711.2 1235.43 147.37 22.46s-47.49 25.78-78.32 23c-30.84-2.78-69.05-45.46-69.05-45.46"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9803.95 1037.78 120.94-23.45s-40.48-20.827-65.87-17.57c-25.39 3.26-55.07 41.02-55.07 41.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9803.49 1032.76 120.89-12.25s-32.19 30.58-57.08 34.69c-24.9 4.11-63.81-22.44-63.81-22.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9542.44 1263.57 120.94-23.45s-40.48-20.82-65.87-17.57c-25.4 3.26-55.07 41.02-55.07 41.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9541.98 1258.55 120.88-12.24s-32.18 30.58-57.08 34.69c-24.9 4.1-63.8-22.45-63.8-22.45"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9819.58 969.427 57.73-112.158s-40.76 19.984-54.13 42.512c-13.37 22.529-3.6 69.646-3.6 69.646"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9819.13 969.905 59.41-111.739s7.25 45.121-3.64 69.03c-10.9 23.91-55.77 42.709-55.77 42.709"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9710.49 1400.47-139.66-53.3s28.5 45.95 56.76 58.77c28.27 12.83 82.9-5.47 82.9-5.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9711.19 1400.6-139.44-54.6s52.85-14.9 82.48-5.36c29.64 9.53 56.96 59.96 56.96 59.96"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9747.84 1187.05 57.73-112.16s-40.77 19.98-54.14 42.51c-13.36 22.53-3.59 69.65-3.59 69.65"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9747.38 1187.53 59.42-111.74s7.25 45.12-3.65 69.03-55.77 42.71-55.77 42.71"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9755.97 1187.25-90.18-118.49s-1.82 54.2 15.26 79.92c17.07 25.72 74.92 38.57 74.92 38.57"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9760.96 1187.63-98.14-119.02s53.55 12.95 75.35 36.37c21.81 23.43 22.79 82.65 22.79 82.65"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9657.08 1250.34-120.15-93.69s12.47 52.74 36.08 73.65c23.62 20.91 84.07 20.04 84.07 20.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9659.09 1247.51-122.46-88.47s54.85-3.2 81.37 13.47c26.51 16.67 41.09 75 41.09 75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9801.63 1040.78-52.39-142.002s-17.01 51.036-8.02 81.054 60.41 60.948 60.41 60.948"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9799.18 1041.26-45.75-142.338s44.45 32.427 55.74 61.428c11.3 29.001-9.99 80.91-9.99 80.91"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.571}
      d="M8110.14 2825.6s-105.16-219.93-159.83-281.69c-36.97-41.78-154.11-95.28-154.11-95.28s110.44 102.78 150.26 161.05c50.49 73.9 139.99 250.82 139.99 250.82s22.23-3.87 27.3-11.13c5.06-7.26-3.61-23.77-3.61-23.77"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7894.98 2519.58 111.94-76.6s-14.28 46.14-36.44 63.41c-22.16 17.28-75.5 13.19-75.5 13.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7894.67 2517.29 111.09-72.64s-48.5-4.28-72.48 9.31-38.61 63.33-38.61 63.33"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7980.93 2598.33 133.07 18.49s-43.04 24.99-70.89 22.92-62.18-41.41-62.18-41.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7980.41 2603.46 132.95 6.99s-36.84-31.66-64.31-34.83c-27.48-3.17-68.64 27.84-68.64 27.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7819.15 2469.89-108.55 57.85s18-40.21 39.73-53.57c21.72-13.36 68.82-4.28 68.82-4.28"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7817.04 2471.31-103.09 55.92s43.13 5.7 65.28-4.62 37.81-51.3 37.81-51.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7818.62 2464.33-108.4-62.23s44.97-4.9 68.23 6.67 40.17 55.56 40.17 55.56"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7818.6 2466.87-107.99-65.5s16.43 42.27 37.96 57.2c21.53 14.94 70.03 8.3 70.03 8.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m7929.95 2570.11-89.13 107.51s.29-50.5 17.28-73.92c17-23.41 71.85-33.59 71.85-33.59"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m7934.57 2570.78-96.54 106.09s50.34-9.39 71.65-30.14c21.32-20.76 24.89-75.95 24.89-75.95"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7897.68 2540-124.24 4.04s35.7-29.13 61.45-31.59c25.74-2.47 62.79 27.55 62.79 27.55"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7898.21 2537.45-124.01 10.24s38.02 24.34 63.86 23.81c25.83-.54 60.15-34.05 60.15-34.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7907.56 2512.25-19.41-149.1s-28.88 46.38-26.85 77.48c2.02 31.1 46.26 71.62 46.26 71.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7902.16 2512.85-7.24-149.06s34.72 42.75 38.11 73.63c3.4 30.88-30.87 75.43-30.87 75.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7820.97 2471.86-42.08-142.9s43.67 32.13 54.22 61.22-12.14 81.68-12.14 81.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7820.81 2472.55-42.91-142.62s-18.68 51.13-11.59 81.27c7.08 30.15 54.5 61.35 54.5 61.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7941.61 2576.29 10.41 123.43s-30.95-33.04-34.73-58.47c-3.79-25.44 24.32-64.96 24.32-64.96"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7940.01 2575.75 14.7 123.24s22.44-39.58 20.94-65.36c-1.49-25.78-35.64-57.88-35.64-57.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7913.12 2740.79 124.43-13.32s-39.44-24.47-65.43-23.35c-26 1.11-59 36.67-59 36.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7912.62 2736.34 124.29-3.27s-35.16 28.59-60.88 30.87c-25.73 2.29-63.41-27.6-63.41-27.6"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8085.54 2811.47 101.9-112.45s-2.69 54.45-22.26 79.03c-19.57 24.59-79.64 33.42-79.64 33.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8080.86 2809.74 109.34-109.05s-54.73 7.11-78.74 28.3-30.6 80.75-30.6 80.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8038.69 2699.28 120.68-29.6s-28.7 35.23-53.36 42.92c-24.66 7.68-67.32-13.32-67.32-13.32"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8038.13 2699.44 120.42-30.91s-41.76-17.34-67.13-12.46-53.29 43.37-53.29 43.37"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7981.98 2602.32 83.45-121.38s4.06 53.83-11.6 80.09c-15.66 26.25-71.85 41.29-71.85 41.29"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7977.29 2603.75 90.74-123.88s-52.53 16.11-72.87 40.64c-20.34 24.54-17.87 83.24-17.87 83.24"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9861.36 2038.3 81.97 92.67s-1.65-44.48-17.37-64.73c-15.71-20.24-64.6-27.94-64.6-27.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9857.45 2039.52 88.22 90.25s-44.62-6.47-64.02-24.04-24.2-66.21-24.2-66.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9750.28 1892.34 49.2-115.22s-39.2 22.7-50.86 45.97c-11.65 23.27 1.66 69.25 1.66 69.25"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9749.36 1892.92 51.83-115.02s10.76 44.57 1.51 69.07c-9.24 24.5-53.34 45.95-53.34 45.95"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9692.5 1910.19 47.33 120.9s13.51-44.07 5.28-69.67c-8.23-25.59-52.61-51.23-52.61-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9693.66 1909.79 43.45 121.22s-39.08-26.56-49.63-51.19c-10.55-24.64 6.18-70.03 6.18-70.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9945.67 1930.07 45.89-141.95s-44.44 31.06-55.77 59.91c-11.32 28.85 9.88 82.04 9.88 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9945.79 1930.76 46.77-141.67s17.44 51.62 9.54 81.61c-7.86 29.99-56.31 60.06-56.31 60.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9722.77 2963.28 145.57-98.16s-63.13-2.62-94.53 15.93-51.04 82.23-51.04 82.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9724.47 2967.99 141.88-105.09s-17.37 60.71-45.41 84.26-96.47 20.83-96.47 20.83"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10230.1 1644.75 132.5-68.52s-53.4-9.23-81.8 3.29c-28.3 12.52-50.7 65.23-50.7 65.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10229.8 1646.95 132.7-70.88s-22.3 49.4-48.9 65.77-83.8 5.11-83.8 5.11"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9534.75 1891.73 81.98 92.68s-1.66-44.49-17.37-64.73c-15.72-20.24-64.61-27.95-64.61-27.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9530.84 1892.95 88.22 90.26s-44.62-6.47-64.02-24.04c-19.4-17.58-24.2-66.22-24.2-66.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10567.3 1568.36 58.5-111.84s-40.9 19.72-54.4 42.17-4.1 69.67-4.1 69.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10567.6 1568.65 58.8-111.05s6.9 44.94-3.9 68.71-54.9 42.34-54.9 42.34"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9882.67 1789.82 47.33 120.9s13.51-44.07 5.28-69.66c-8.23-25.6-52.61-51.24-52.61-51.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9883.83 1789.43 43.45 121.22s-39.08-26.56-49.63-51.2c-10.55-24.63 6.18-70.02 6.18-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9475.74 2034.88 45.9-141.95s-44.45 31.07-55.77 59.91c-11.33 28.85 9.87 82.04 9.87 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9475.86 2035.57 46.77-141.67s17.48 51.62 9.58 81.61c-7.89 29.99-56.35 60.06-56.35 60.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10339.6 1694.14 62.4 163s18.7-59.09 7.9-93.58c-10.8-34.48-70.3-69.42-70.3-69.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10341.6 1693.61 56.3 163.4s-52.1-36.36-65.8-69.6 9.5-93.8 9.5-93.8"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10505.9 1725.21 48.1 143.96s19-50.67 10.9-81.05c-8-30.37-59-62.91-59-62.91"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10509.8 1724.71 38.6 144.24s-42.9-34.66-52.7-64.15 14.1-80.09 14.1-80.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9556.8 2828.38 108.88 57.11s-18.29-40.08-40.1-53.29c-21.8-13.21-68.78-3.82-68.78-3.82"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9558.83 2829.12 103.58 56.49s-43.11 6.2-65.35-4.2-38.23-52.29-38.23-52.29"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10236.3 1645.79-40.6-119.9s-15.6 42.32-8.8 67.62 49.4 52.28 49.4 52.28"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10233.1 1646.2-32.9-120.13s35.9 28.68 44.3 53.24c8.4 24.55-11.4 66.89-11.4 66.89"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8990.37 2517.59 47.32 120.9s13.52-44.08 5.28-69.67c-8.23-25.6-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8991.53 2517.19 43.45 121.21s-39.09-26.55-49.64-51.19 6.19-70.02 6.19-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9630.14 1905.63 45.9-141.95s-44.44 31.06-55.77 59.91 9.87 82.04 9.87 82.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9630.27 1906.32 46.76-141.68s17.48 51.62 9.59 81.61c-7.9 29.99-56.35 60.07-56.35 60.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10474.7 1713.98 145-99.33s-63.2-2.27-94.5 16.52-50.5 82.81-50.5 82.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10476.5 1718.76 141.1-106.42s-16.8 60.9-44.7 84.71c-27.8 23.82-96.4 21.71-96.4 21.71"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9551.23 2911.84 119.83 128.39s-4.05-62.84-27.11-90.95-92.72-37.44-92.72-37.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9546.02 2914.14 128.07 123.89s-63.35-7.07-91.42-31.09c-28.08-24.01-36.65-92.8-36.65-92.8"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9372.24 2914.91-21.78 170s44.58-43.99 51.32-78.94c6.74-34.94-29.54-91.06-29.54-91.06"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9373.69 2914.15-26.15 169.72s-29.17-55.74-25.88-91.31c3.29-35.58 52.03-78.41 52.03-78.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9524.31 1905.27 75.94-131.65s-50.03 21.65-67.4 47.99c-17.38 26.34-8.54 83.66-8.54 83.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9527.42 1905.74 70.82-130.88s6.49 53.8-6.62 81.86c-13.12 28.06-64.2 49.02-64.2 49.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10195.2 1266.33 111.3 133.59s-.5-62.85-21.7-91.95c-21.3-29.11-89.6-41.64-89.6-41.64"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10189.5 1267.24 120.5 131.68s-62.7-11.49-89.3-37.24c-26.6-25.76-31.2-94.44-31.2-94.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9190.51 2943.61 86.53-126.46s-51.72 17.73-71.21 42.85-15.32 83.61-15.32 83.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9194.41 2945.07 79.64-127.61s3.89 54.52-11.06 81.99c-14.94 27.48-68.58 45.62-68.58 45.62"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9837.55 2931.63 108.63 63.76s-16.53-41.86-38.19-56.43c-21.66-14.58-70.44-7.33-70.44-7.33"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9839.05 2933.37 104.34 61.11s-44.48 4.78-66.94-6.58-37.4-54.53-37.4-54.53"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9156.17 3000.58 157.93 71.05s-29.51-54.91-61.31-71.64c-31.81-16.72-96.62.59-96.62.59"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9155.37 2998.99 157.73 75.25s-62.65 13.51-96.34-.04-61.39-75.21-61.39-75.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10603.5 1742.65 64.9 134.46s10.8-52.6-.9-81.27c-11.8-28.67-64-53.19-64-53.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10600.9 1742.24 68 134.83s-48.8-24.78-64.6-51.91c-15.8-27.12-3.4-82.92-3.4-82.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m10512.5 1448.61 59.2 120.27s9.3-47.45-1.5-73.12c-10.7-25.67-57.7-47.15-57.7-47.15"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10509.9 1448.25 62.5 120.6s-44.1-21.78-58.6-46.02c-14.4-24.24-3.9-74.58-3.9-74.58"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9201.09 2940.06-35.65-121.59s-17.7 41.82-11.93 67.41c5.76 25.59 47.58 54.18 47.58 54.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9196.84 2940.5-25.86-121.76s34.27 30.75 41.19 55.73-15.33 66.03-15.33 66.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9690.08 2848.35 47.32 120.9s13.52-44.07 5.28-69.67c-8.23-25.59-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9691.24 2847.95 43.45 121.22s-39.09-26.56-49.64-51.19c-10.55-24.64 6.19-70.03 6.19-70.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9735.05 2646.26 47.33 120.9s13.51-44.07 5.28-69.67c-8.23-25.59-52.61-51.23-52.61-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9736.21 2645.87 43.45 121.21s-39.08-26.55-49.63-51.19 6.18-70.02 6.18-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10602.3 1743.2 159.9-61.73s-61.1-16.88-95.1-6.1c-34.1 10.78-64.8 67.83-64.8 67.83"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10601.7 1744.62 160.3-62.31s-32.2 53.5-64.5 68.48c-32.4 14.98-95.8-6.17-95.8-6.17"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9772.41 1980.07c-26.08 2.37-46.09 21.24-44.7 42.15s23.65 35.95 49.73 33.58 46.09-21.24 44.7-42.15-23.66-35.94-49.73-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9737.85 2035.76s-7.91-22.13 2.39-31.03c13.37-11.57 29.89-1.73 29.89-1.73-8.59 1.27-18.3 1.39-23.5 6.99-5.69 6.14-6.54 18.03-8.78 25.77"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9769.94 2030.34s10.01 2.95 10.72 3.97c4.6 6.66 6.36 8.08 6.36 8.08s-9.6 3.66-14.22 3.2c-4.61-.46-9.72-3.54-9.72-3.54s.43 5.34-.75 7.22c-1.39 2.24-7.64 6.22-7.64 6.22s-5.95-4.13-7.22-6.96c-1.3-2.91 4.62-9.26 4.62-9.26s-5.65.94-9.09-.73c-3.56-1.74-8.54-7.3-8.54-7.3s4.45-3.88 7.82-4.42c3.21-.51 12.82 1.15 12.82 1.15s-6.62-4.46-8.91-7.84c-2.37-3.52 3.99-9.69 3.99-9.69s7.39 3.86 10.91 7.01c2.68 2.41.82 8.32.82 8.32s2.48-6.12 5.46-8.33c2.99-2.2 11.09-1.93 11.09-1.93s2.89 7.26 1.24 10.22c-1.57 2.82-9.76 4.61-9.76 4.61"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9761.24 2041.48c1.4-.13 3.81.22 4.77-.46.98-.69 2.16-2.84 2.46-4.08.81-3.25.77-5.6-2.46-7.75-1.18-.76-3.42.02-4.64.14-.68.06-1.49.02-2.14.19-2.53.62-4.46 2.4-6.05 4.05-.65.67-1.25 2.15-.65 2.99.53.74 1.43 1.43 1.92 2.24.64 1.07 1.72 3.26 3.32 3.72 1.06.32 1.46-.45 2.19-.71.78-.28.32-.06 1.28-.33"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M9861.48 1892.33c-22.32 2.02-39.45 18.17-38.26 36.07s20.25 30.77 42.57 28.74c22.31-2.03 39.44-18.18 38.25-36.07-1.19-17.9-20.25-30.77-42.56-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9831.9 1939.98s-6.77-18.93 2.04-26.55c11.45-9.9 25.59-1.48 25.59-1.48-7.35 1.09-15.67 1.19-20.12 5.98-4.86 5.25-5.59 15.43-7.51 22.05"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9859.36 1935.34s8.57 2.53 9.18 3.41c3.94 5.69 5.44 6.91 5.44 6.91s-8.21 3.13-12.16 2.74c-3.96-.39-8.33-3.03-8.33-3.03s.37 4.57-.64 6.18c-1.19 1.92-6.54 5.32-6.54 5.32s-5.09-3.54-6.17-5.95c-1.12-2.49 3.94-7.93 3.94-7.93s-4.83.81-7.77-.62c-3.05-1.49-7.31-6.25-7.31-6.25s3.8-3.32 6.69-3.78c2.75-.44 10.97.98 10.97.98s-5.66-3.82-7.62-6.71c-2.03-3.02 3.42-8.3 3.42-8.3s6.32 3.31 9.33 6.01c2.29 2.06.7 7.12.7 7.12s2.12-5.24 4.68-7.13 9.49-1.65 9.49-1.65 2.47 6.21 1.06 8.74c-1.34 2.41-8.36 3.94-8.36 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M9851.92 1944.88c1.2-.11 3.26.19 4.09-.39.83-.59 1.84-2.43 2.1-3.49.69-2.79.66-4.8-2.11-6.63-1.01-.66-2.92.02-3.97.11-.58.05-1.28.02-1.83.17-2.16.53-3.82 2.05-5.18 3.47-.55.57-1.06 1.84-.56 2.55.46.64 1.23 1.22 1.65 1.92.55.92 1.47 2.79 2.84 3.18.91.27 1.25-.38 1.87-.6.67-.24.28-.05 1.1-.29"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M9168.9 2507.34c-22.32 2.03-39.45 18.18-38.26 36.07 1.19 17.9 20.25 30.77 42.57 28.74 22.32-2.02 39.44-18.17 38.25-36.07s-20.24-30.77-42.56-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9139.32 2555s-6.77-18.94 2.04-26.56c11.45-9.9 25.59-1.48 25.59-1.48-7.35 1.09-15.66 1.19-20.12 5.98-4.86 5.25-5.59 15.43-7.51 22.06"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9166.78 2550.36s8.57 2.53 9.18 3.41c3.94 5.69 5.44 6.91 5.44 6.91s-8.21 3.13-12.16 2.74-8.33-3.03-8.33-3.03.37 4.57-.63 6.18c-1.2 1.92-6.55 5.32-6.55 5.32s-5.09-3.54-6.17-5.95c-1.11-2.49 3.95-7.93 3.95-7.93s-4.83.8-7.78-.62c-3.05-1.49-7.31-6.25-7.31-6.25s3.81-3.32 6.69-3.78c2.75-.44 10.98.98 10.98.98s-5.67-3.82-7.63-6.71c-2.03-3.02 3.42-8.3 3.42-8.3s6.32 3.31 9.33 6c2.3 2.07.7 7.13.7 7.13s2.12-5.24 4.68-7.13 9.49-1.65 9.49-1.65 2.47 6.21 1.06 8.74c-1.34 2.41-8.36 3.94-8.36 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M9159.34 2559.89c1.2-.11 3.27.19 4.09-.39.84-.59 1.84-2.43 2.1-3.49.69-2.79.66-4.79-2.11-6.63-1.01-.66-2.92.02-3.97.11-.58.05-1.28.02-1.83.17-2.16.53-3.82 2.06-5.18 3.47-.55.57-1.06 1.84-.56 2.55.46.64 1.23 1.22 1.65 1.92.55.92 1.47 2.79 2.84 3.19.91.27 1.25-.39 1.87-.61.67-.24.28-.05 1.1-.29"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9304.97 2521.18c-26.08 2.36-46.09 21.24-44.7 42.15s23.66 35.94 49.73 33.58c26.08-2.37 46.09-21.24 44.7-42.15s-23.66-35.95-49.73-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9270.41 2576.86s-7.91-22.12 2.39-31.02c13.37-11.57 29.89-1.74 29.89-1.74-8.59 1.27-18.3 1.39-23.5 7-5.69 6.13-6.54 18.02-8.78 25.76"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9302.5 2571.45s10.01 2.95 10.72 3.97c4.6 6.66 6.36 8.08 6.36 8.08s-9.6 3.66-14.21 3.2c-4.62-.46-9.73-3.54-9.73-3.54s.43 5.34-.75 7.22c-1.39 2.24-7.64 6.22-7.64 6.22s-5.95-4.13-7.22-6.96c-1.3-2.91 4.62-9.26 4.62-9.26s-5.65.94-9.09-.73c-3.56-1.74-8.54-7.3-8.54-7.3s4.45-3.88 7.82-4.42c3.21-.51 12.82 1.15 12.82 1.15s-6.62-4.46-8.9-7.84c-2.38-3.52 3.98-9.69 3.98-9.69s7.39 3.86 10.91 7.01c2.68 2.41.82 8.32.82 8.32s2.48-6.12 5.46-8.33c2.99-2.2 11.1-1.93 11.1-1.93s2.88 7.26 1.23 10.22c-1.57 2.82-9.76 4.61-9.76 4.61"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9293.8 2582.58c1.4-.12 3.82.23 4.78-.46.98-.69 2.15-2.83 2.45-4.07.81-3.26.77-5.61-2.46-7.75-1.18-.77-3.42.02-4.64.13-.67.06-1.49.03-2.14.19-2.53.63-4.46 2.41-6.05 4.06-.65.67-1.24 2.15-.65 2.98.54.75 1.43 1.43 1.92 2.24.64 1.08 1.73 3.26 3.32 3.73 1.06.31 1.46-.45 2.19-.71.78-.28.33-.06 1.28-.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9889.87 2053.16c24.69-2.99 43.2-21.46 41.33-41.24s-23.4-33.39-48.09-30.4c-24.7 2.99-43.2 21.45-41.34 41.23 1.87 19.79 23.4 33.4 48.1 30.41"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9889.77 2004.43s-9.6-2.38-10.32-3.31c-4.63-6.11-6.35-7.38-6.35-7.38s8.91-3.87 13.3-3.63 9.35 2.95 9.35 2.95-.63-5.04.39-6.87c1.23-2.17 6.97-6.2 6.97-6.2s5.8 3.66 7.12 6.29c1.36 2.69-3.96 8.96-3.96 8.96s5.29-1.13 8.62.31c3.44 1.49 8.39 6.55 8.39 6.55s-4.03 3.86-7.2 4.51c-3.02.62-12.18-.56-12.18-.56s6.45 3.95 8.76 7.06c2.4 3.23-3.35 9.33-3.35 9.33s-7.16-3.34-10.61-6.18c-2.65-2.17-1.14-7.84-1.14-7.84s-2.08 5.9-4.81 8.11-10.41 2.29-10.41 2.29-3.04-6.75-1.6-9.62c1.36-2.73 9.03-4.77 9.03-4.77"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9879.91 2043.06s-22.44 2.44-27.89-8.75c-7.08-14.52 6.35-27.34 6.35-27.34-1.12 8.02-3.59 16.81.18 22.69 4.13 6.44 14.84 9.73 21.36 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9898.64 1994.64c-1.32.16-3.63-.11-4.52.57-.91.68-1.97 2.75-2.22 3.93-.69 3.11-.59 5.34 2.53 7.28 1.14.7 3.25-.12 4.41-.26.63-.07 1.41-.06 2.02-.24 2.38-.67 4.17-2.41 5.64-4.02.6-.65 1.12-2.07.54-2.85-.53-.69-1.4-1.31-1.88-2.07-.64-1-1.73-3.03-3.25-3.43-1.02-.27-1.38.47-2.06.74-.74.28-.31.06-1.21.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9694.96 1898.78c24.69-2.99 43.2-21.46 41.33-41.24s-23.4-33.39-48.09-30.4c-24.7 2.99-43.2 21.45-41.34 41.23 1.87 19.79 23.4 33.4 48.1 30.41"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9694.86 1850.05s-9.6-2.38-10.32-3.31c-4.63-6.11-6.35-7.38-6.35-7.38s8.91-3.87 13.3-3.63c4.39.25 9.35 2.95 9.35 2.95s-.63-5.03.39-6.86c1.23-2.18 6.96-6.21 6.96-6.21s5.81 3.67 7.13 6.29c1.36 2.69-3.96 8.96-3.96 8.96s5.29-1.13 8.62.31c3.44 1.49 8.39 6.55 8.39 6.55s-4.04 3.86-7.2 4.51c-3.02.62-12.18-.56-12.18-.56s6.45 3.95 8.76 7.06c2.4 3.23-3.35 9.34-3.35 9.34s-7.16-3.35-10.61-6.19c-2.65-2.17-1.14-7.84-1.14-7.84s-2.08 5.9-4.81 8.11-10.41 2.29-10.41 2.29-3.04-6.75-1.6-9.62c1.36-2.73 9.03-4.77 9.03-4.77"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9685 1888.68s-22.44 2.44-27.89-8.75c-7.08-14.52 6.35-27.34 6.35-27.34-1.12 8.02-3.59 16.81.18 22.69 4.13 6.44 14.84 9.73 21.36 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9703.73 1840.27c-1.32.16-3.63-.11-4.52.57-.91.68-1.97 2.75-2.22 3.93-.69 3.11-.59 5.34 2.53 7.28 1.14.69 3.25-.12 4.41-.26.63-.08 1.41-.07 2.02-.24 2.38-.67 4.17-2.41 5.64-4.02.6-.65 1.12-2.07.54-2.85-.53-.69-1.4-1.31-1.88-2.07-.64-1-1.73-3.04-3.25-3.43-1.02-.27-1.38.46-2.06.73-.73.29-.31.07-1.21.36"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9449.03 2349.76c24.66-2.8 43.09-21.27 41.18-41.24-1.9-19.97-23.44-33.89-48.09-31.09s-43.09 21.26-41.18 41.23c1.91 19.98 23.44 33.9 48.09 31.1"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9448.74 2300.48s-9.3-2.62-9.95-3.56c-4.15-6.2-5.76-7.51-5.76-7.51s9.07-3.6 13.38-3.24 9.02 3.18 9.02 3.18-.27-5.02.87-6.81c1.36-2.14 7.3-5.98 7.3-5.98s5.47 3.79 6.59 6.43c1.15 2.72-4.53 8.8-4.53 8.8s5.3-.98 8.48.54c3.3 1.58 7.83 6.73 7.83 6.73s-4.25 3.73-7.42 4.29c-3.02.53-11.98-.88-11.98-.88s6.09 4.1 8.16 7.24c2.14 3.28-3.96 9.19-3.96 9.19s-6.83-3.52-10.04-6.43c-2.46-2.22-.58-7.82-.58-7.82s-2.46 5.81-5.31 7.93-10.42 2-10.42 2-2.53-6.79-.92-9.6c1.53-2.68 9.24-4.5 9.24-4.5"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9438.08 2339.74s-21.81 1.84-26.8-9.51c-6.49-14.73 6.86-27.21 6.86-27.21-1.29 8-3.91 16.74-.41 22.73 3.84 6.56 14.13 10.14 20.35 13.99"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9457.72 2290.84c-1.32.15-3.62-.13-4.51.54-.91.68-1.96 2.76-2.21 3.95-.68 3.13-.58 5.38 2.55 7.37 1.14.7 3.24-.1 4.39-.23.64-.07 1.42-.05 2.03-.23 2.37-.65 4.15-2.39 5.61-4 .6-.66 1.12-2.09.54-2.87-.53-.7-1.4-1.34-1.89-2.1-.64-1.02-1.72-3.08-3.25-3.5-1.01-.28-1.37.46-2.05.73-.74.28-.31.06-1.21.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9472.83 2408.11c24.48 0 44.32-16.37 44.32-36.57 0-20.19-19.84-36.56-44.32-36.56-24.49 0-44.33 16.37-44.33 36.56 0 20.2 19.84 36.57 44.33 36.57"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9477.45 2358.77s-9-3.76-9.54-4.78c-3.53-6.66-5-8.17-5-8.17s9.36-2.44 13.61-1.55c4.26.89 8.67 4.28 8.67 4.28s.21-5.03 1.52-6.66c1.56-1.95 7.84-5.03 7.84-5.03s5.08 4.45 5.93 7.21c.88 2.84-5.36 8.17-5.36 8.17s5.37-.32 8.39 1.59c3.12 1.98 7.12 7.66 7.12 7.66s-4.59 3.17-7.79 3.33c-3.06.16-11.83-2.36-11.83-2.36s5.66 4.83 7.41 8.21c1.81 3.51-4.83 8.63-4.83 8.63s-6.45-4.34-9.36-7.63c-2.23-2.52.18-7.84.18-7.84s-3.01 5.46-6.05 7.21c-3.04 1.76-10.56.69-10.56.69s-1.86-7.05.02-9.65c1.78-2.46 9.63-3.31 9.63-3.31"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9462.92 2396.76s-22.14-.94-26.07-12.74c-5.11-15.33 9.54-25.93 9.54-25.93-2.07 7.71-5.55 15.99-2.61 22.33 3.23 6.94 13.24 11.77 19.14 16.34"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9487.33 2350.25c-1.31 0-3.55-.55-4.49.02-.95.58-2.19 2.54-2.54 3.7-.96 3.06-1.07 5.31 1.81 7.66 1.05.83 3.19.27 4.34.27.63 0 1.4.11 2.01 0 2.4-.38 4.31-1.92 5.9-3.37.65-.58 1.29-1.95.79-2.8-.45-.77-1.25-1.5-1.65-2.32-.54-1.09-1.41-3.28-2.87-3.87-.97-.39-1.39.31-2.09.5-.74.2-.31.02-1.21.21"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M9750.71 1962.83c21.75-2.63 38.07-18.7 36.45-35.89s-20.57-28.99-42.32-26.36-38.07 18.7-36.45 35.89 20.57 28.99 42.32 26.36"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M9750.69 1920.48s-8.45-2.05-9.09-2.86c-4.07-5.3-5.59-6.41-5.59-6.41s7.86-3.37 11.72-3.17c3.87.2 8.24 2.55 8.24 2.55s-.56-4.38.35-5.97c1.08-1.9 6.14-5.4 6.14-5.4s5.11 3.17 6.27 5.45c1.19 2.34-3.5 7.79-3.5 7.79s4.66-.99 7.59.26c3.04 1.29 7.39 5.68 7.39 5.68s-3.56 3.36-6.35 3.93c-2.66.54-10.73-.46-10.73-.46s5.68 3.42 7.71 6.12c2.11 2.8-2.96 8.12-2.96 8.12s-6.3-2.9-9.34-5.36c-2.33-1.88-1-6.82-1-6.82s-1.83 5.14-4.24 7.06c-2.41 1.93-9.17 2.01-9.17 2.01s-2.67-5.86-1.4-8.36c1.2-2.37 7.96-4.16 7.96-4.16"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9741.94 1954.03s-19.77 2.14-24.54-7.55c-6.22-12.58 5.63-23.71 5.63-23.71-.99 6.95-3.18 14.58.13 19.68 3.62 5.57 13.05 8.41 18.78 11.58"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M9758.51 1911.96c-1.16.14-3.19-.08-3.98.5-.8.6-1.74 2.4-1.96 3.43-.61 2.7-.53 4.63 2.22 6.32 1.01.6 2.86-.11 3.88-.23.56-.07 1.25-.06 1.79-.22 2.1-.58 3.67-2.1 4.96-3.5.53-.56 1-1.8.48-2.47-.46-.6-1.22-1.14-1.65-1.8-.56-.87-1.51-2.64-2.86-2.98-.89-.23-1.21.41-1.81.64-.65.25-.27.06-1.07.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10073.7 1593.85 132.6-120.18s-63.5 5.17-92.4 28.37-40.2 91.81-40.2 91.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10078.3 1598.55 123.7-127.33s-7.5 63.22-31.5 91.15-92.2 36.18-92.2 36.18"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9067.46 2512.23-5.43-149.19s-32.68 43.57-33.54 74.53c-.87 30.95 38.97 74.66 38.97 74.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9063.46 2512.86 3.91-149.06s31.31 45.03 32.39 76.04c1.07 31.01-36.3 73.02-36.3 73.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9845.4 2610.85-58.43 162.48s52.41-34.33 66.59-67.28-8.16-95.2-8.16-95.2"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9845.5 2610.05-59.86 162.17s-18.39-60.33-8.06-94.73c10.34-34.41 67.92-67.44 67.92-67.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9579.02 2660.37-17.48 170.54s43.58-45.02 49.44-80.13c5.87-35.11-31.96-90.41-31.96-90.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9580.91 2659.61-22.74 170.28s-30.29-55.2-27.72-90.85c2.58-35.64 50.46-79.43 50.46-79.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m9424.49 2732.27-15.63 152.61s39-40.29 44.24-71.7c5.25-31.42-28.61-80.91-28.61-80.91"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m9426.18 2731.6-20.35 152.37s-27.1-49.39-24.79-81.29c2.3-31.9 45.14-71.08 45.14-71.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10073.5 1437.8 10.1 149.27s31.4-44.51 31.4-75.54c-.1-31.02-41.5-73.73-41.5-73.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10078.1 1437.19-.4 149.16s-32.4-44.33-34.2-75.32c-1.8-31 34.6-73.84 34.6-73.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9982.05 1672.85 122.95-27.41s-41.9-20.12-67.8-16.06c-25.8 4.06-55.15 43.47-55.15 43.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9981.59 1667.74 122.91-15.99s-31.9 32.16-57.2 37.08c-25.3 4.91-65.71-21.09-65.71-21.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10056.2 1797.95 58.1-162.56s-52.3 34.41-66.5 67.37c-14.1 32.97 8.4 95.19 8.4 95.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10056.1 1798.74 59.5-162.24s18.5 60.29 8.2 94.71c-10.2 34.41-67.7 67.53-67.7 67.53"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10292.2 1267.86 82.5-128.53s-51.1 19.25-69.8 44.85c-18.7 25.61-12.7 83.68-12.7 83.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10295.8 1268.81 76.3-128.7s4.8 54.24-9.4 81.91c-14.3 27.67-66.9 46.79-66.9 46.79"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10395.4 1699.71 82 92.67s-1.7-44.48-17.4-64.72c-15.7-20.25-64.6-27.95-64.6-27.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10391.5 1700.93 88.2 90.25s-44.6-6.47-64-24.04-24.2-66.21-24.2-66.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10443.9 1512.62-15.5 122.8s32.1-31.81 37-57.05c4.8-25.25-21.5-65.75-21.5-65.75"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10445 1512.06-18.8 122.61s-21.1-40.24-18.7-65.93c2.3-25.7 37.5-56.68 37.5-56.68"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10252.7 1146.3 47.3 120.9s13.5-44.08 5.3-69.67c-8.2-25.6-52.6-51.23-52.6-51.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10253.9 1145.9 43.4 121.21s-39.1-26.55-49.6-51.19c-10.6-24.63 6.2-70.02 6.2-70.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10424.7 1219.17 163.9 52.96s-35.8-51.32-69.1-64.4c-33.3-13.07-94.8 11.44-94.8 11.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10423.9 1219.32 163.6 53.94s-59.6 20.19-94.2 11.09c-34.7-9.11-69.4-65.03-69.4-65.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10652.1 1043.61-134.9 117.2s63.5-3.87 92.9-26.42 42-90.78 42-90.78"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10647.8 1038.77-126.5 124.61s8.8-63.01 33.4-90.41 93.1-34.2 93.1-34.2"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9154.34 1269.05 81.95 149.98s9.58-61.68-5.48-93.84c-15.06-32.15-76.47-56.14-76.47-56.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9150.26 1267.84 87.69 151.86s-57.97-25.24-78.04-55.64c-20.08-30.4-9.65-96.22-9.65-96.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9145.58 1460.18-75.39-126.06s-6.72 53.48 7.25 80.6c13.98 27.12 68.14 45.46 68.14 45.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9149.58 1461.88-81.29-128.99s51.08 19.84 69.54 45.56c18.45 25.73 11.75 83.43 11.75 83.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9081.51 1142.86-114.55-50.02s21.79 39.41 44.88 51.23 69.67-1.21 69.67-1.21"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9082.1 1143.72-114.4-52.51s45.02-10.3 69.43-.89 44.97 53.4 44.97 53.4"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9236 1397.52 159.93-61.8s-61.14-16.85-95.16-6.05-64.77 67.85-64.77 67.85"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9235.49 1398.97 160.17-62.46s-32.06 53.53-64.44 68.54-95.73-6.08-95.73-6.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9097.48 1748.02 141.77-48.64s-52.52-17.31-82.58-9.05-59.19 57.69-59.19 57.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9097 1746.18 141.92-43.18s-31.16 44.17-60 54.96c-28.85 10.79-81.92-11.78-81.92-11.78"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9164.48 1463.18-118.03 40.92s43.85 14.24 68.88 7.27c25.04-6.96 49.15-48.19 49.15-48.19"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9164.88 1464.49-118.16 36.81s25.74-37 49.75-46.17c24-9.16 68.41 9.36 68.41 9.36"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9238.45 1701.83-156.93-73.61s28.57 55.38 60.12 72.63c31.56 17.24 96.81.98 96.81.98"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9239.26 1703.83-156.76-78.6s63.07-12.48 96.6 1.76c33.53 14.25 60.16 76.84 60.16 76.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9264.49 1745.33 101.68-116.69s-53.77 11.22-76.27 34.11c-22.5 22.88-25.41 82.58-25.41 82.58"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9269.01 1748.44 93.24-121.04s-.72 55.12-18.53 81.38c-17.8 26.27-74.71 39.66-74.71 39.66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m8967.05 1216.05 117.38-65.32s-48.29-6.07-73.46 6.02-43.92 59.3-43.92 59.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8966.9 1218.57 117.26-68.42s-18.45 45.17-41.86 60.83-75.4 7.59-75.4 7.59"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.505}
      d="m9293.08 1267.76-53.56-114.11s-9.66 44.13-.01 68.43c9.64 24.31 53.57 45.68 53.57 45.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9294.91 1268.11-55.53-114.44s40.84 21.57 53.79 44.62c12.96 23.06 1.74 69.82 1.74 69.82"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m8809.47 1523.28 102.71-35.33s-38.08-12.51-59.86-6.5c-21.78 6-42.85 41.83-42.85 41.83"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m8809.12 1521.99 102.82-31.47s-22.53 32.05-43.43 39.91c-20.89 7.85-59.39-8.44-59.39-8.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9034.06 1669.88-35.54-121.62s-17.73 41.8-11.99 67.4c5.74 25.59 47.53 54.22 47.53 54.22"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9029.79 1670.31-25.71-121.78s34.24 30.79 41.13 55.78-15.42 66-15.42 66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9041.54 1398.12-27.33 169.2s45.84-42.64 53.71-77.36c7.87-34.71-26.38-91.84-26.38-91.84"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9042.46 1397.35-30.63 168.9s-27.7-56.42-23.47-91.88 54.1-77.02 54.1-77.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9609.31 1059.57-115.9-99.366s9.82 53.426 32.47 75.466c22.65 22.03 83.43 23.9 83.43 23.9"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9612.13 1056.7-119.77-93.965s55.03-.736 81.04 17.122c26.02 17.859 38.73 76.843 38.73 76.843"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9220.87 1627.89 92.39-86.64s-44.8 4.42-65.01 21.18c-20.2 16.77-27.38 65.46-27.38 65.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9224.25 1631.11 85.86-91.52s-4.53 44.81-21.16 64.85c-16.62 20.05-64.7 26.67-64.7 26.67"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8987.9 1262.85 123.77 9.8s-34.28-30.58-59.85-34.22-63.92 24.42-63.92 24.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8987.36 1260.95 123.52 14.7s-38.86 22.86-64.66 21.39c-25.79-1.47-58.86-36.09-58.86-36.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9493.51 1094.98 118.55-46.93s-45.58-12.09-70.81-3.86c-25.24 8.24-47.74 50.79-47.74 50.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9493.14 1096.48 118.73-48.24s-23.33 40.2-47.31 51.72c-23.98 11.53-71.42-3.48-71.42-3.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8349.77 1084.25 109.67-61.17s-45.14-5.62-68.66 5.71-41.01 55.46-41.01 55.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8349.64 1086.61 109.54-64.09s-17.19 42.25-39.06 56.91c-21.87 14.67-70.48 7.18-70.48 7.18"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8534.88 1166.73 120.94-23.45s-40.48-20.82-65.87-17.57c-25.39 3.26-55.07 41.02-55.07 41.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8534.42 1161.71 120.88-12.25s-32.18 30.58-57.08 34.69-63.8-22.44-63.8-22.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8219.38 1431.33 120.93-23.45s-40.47-20.82-65.86-17.57c-25.4 3.26-55.07 41.02-55.07 41.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8218.92 1426.31 120.88-12.24s-32.18 30.57-57.08 34.68-63.8-22.44-63.8-22.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8497.44 1511.43-139.67-53.3s28.5 45.95 56.77 58.78c28.26 12.82 82.9-5.48 82.9-5.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8498.13 1511.56-139.44-54.59s52.85-14.91 82.48-5.37c29.64 9.53 56.96 59.96 56.96 59.96"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8460.47 1234.12 36.8 121.25s17.24-41.94 11.23-67.48-48.03-53.77-48.03-53.77"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8464.52 1233.69 27.39 121.43s-34.64-30.31-41.87-55.21c-7.23-24.89 14.48-66.22 14.48-66.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8460 1238.42 144.71 34.85s-34.57-42.07-64.15-51.16c-29.58-9.08-80.56 16.31-80.56 16.31"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8459.32 1238.21 144.41 36.49s-49.95 20.96-80.36 15.23c-30.41-5.74-64.05-51.72-64.05-51.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8339.45 1420.3-120.15-93.69s12.47 52.74 36.08 73.65c23.62 20.91 84.07 20.04 84.07 20.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8341.46 1417.48-122.45-88.47s54.84-3.2 81.36 13.47 41.09 75 41.09 75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8532.54 1169.72-52.39-141.99s-17.01 51.03-8.02 81.05 60.41 60.94 60.41 60.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8530.09 1170.21-45.75-142.33s44.44 32.42 55.74 61.42-9.99 80.91-9.99 80.91"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8340.21 1188.52-115.9-99.36s9.81 53.42 32.47 75.46c22.65 22.03 83.43 23.9 83.43 23.9"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8343.02 1185.65-119.77-93.96s55.03-.74 81.04 17.12c26.02 17.86 38.73 76.84 38.73 76.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8224.44 1223.93 118.54-46.92s-45.58-12.1-70.81-3.86c-25.23 8.23-47.73 50.78-47.73 50.78"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8224.06 1225.44 118.74-48.24s-23.34 40.19-47.32 51.72c-23.97 11.52-71.42-3.48-71.42-3.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9106.34 1238.03 106.84-142.06s-60.74 17.67-84.62 45.76c-23.89 28.09-22.22 96.3-22.22 96.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9111.24 1240.78 97.96-145.49s2.64 63.42-15.87 94.82-82.09 50.67-82.09 50.67"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m9077.5 1083.97 32.23-127.838s-37.65 29.856-45.98 55.948c-8.32 26.09 13.75 71.89 13.75 71.89"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m9077.53 1084.57 33.23-127.589s18.1 44.699 12.82 71.609c-5.28 26.9-46.05 55.98-46.05 55.98"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8035.72 1585.66 81.95 149.98s9.58-61.67-5.48-93.83-76.47-56.15-76.47-56.15"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8031.64 1584.45 87.69 151.87s-57.97-25.25-78.04-55.65c-20.08-30.4-9.65-96.22-9.65-96.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7925 1582.69-75.39-126.06s-6.72 53.47 7.26 80.6c13.97 27.12 68.13 45.46 68.13 45.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7929 1584.38-81.28-128.99s51.08 19.84 69.53 45.56c18.46 25.73 11.75 83.43 11.75 83.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8170.6 1703.97 159.93-61.8s-61.14-16.85-95.16-6.05-64.77 67.85-64.77 67.85"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8170.09 1705.43 160.16-62.47s-32.06 53.53-64.43 68.54c-32.38 15.01-95.73-6.07-95.73-6.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7984.3 1474.07-62.34 110.26s41.57-18.42 55.86-40.5c14.29-22.07 6.48-69.76 6.48-69.76"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7981.79 1473.73-58.25 109.5s-5.67-44.81 5.1-68.28c10.77-23.46 53.15-41.22 53.15-41.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7934.38 1340.82 123.77 9.8s-34.28-30.58-59.86-34.22c-25.57-3.65-63.91 24.42-63.91 24.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7933.84 1338.92 123.52 14.7s-38.87 22.87-64.66 21.4c-25.79-1.48-58.86-36.1-58.86-36.1"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8110.48 1365.93 106.84-142.06s-60.74 17.67-84.63 45.76c-23.88 28.1-22.21 96.3-22.21 96.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8115.37 1368.69 97.96-145.49s2.65 63.41-15.86 94.81c-18.51 31.41-82.1 50.68-82.1 50.68"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m8123.94 1366.3-46.6-125.81s-15.01 45.26-7 71.86c8 26.6 53.6 53.95 53.6 53.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m8121.83 1366.73-40.84-126.12s39.47 28.66 49.54 54.36c10.07 25.69-8.7 71.76-8.7 71.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8285.84 2056.84 151.81-81.72s-61.89-9.02-94.41 6.03c-32.52 15.04-57.4 75.69-57.4 75.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8285.48 2059.75 151.97-85.1s-24.69 57.59-55.08 77.15-96.89 7.95-96.89 7.95"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8310.1 2076.84-129.71 75.24s53.95 5.6 81.8-8.41c27.84-14.01 47.91-66.83 47.91-66.83"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8309.99 2073.71-129.08 79.33s19.42-50.8 45.14-68.86c25.72-18.07 83.94-10.47 83.94-10.47"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7934.56 2260.68-103.27 75.05s45.8.64 68.14-13.62c22.33-14.26 35.13-61.43 35.13-61.43"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7932.71 2257.1-99.45 80.46s10.67-44.47 30.23-62.38c19.57-17.91 69.22-18.08 69.22-18.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="M8290.92 2061.92 8223.39 1902s-16.12 59.55-4.19 93.48 71.72 66.44 71.72 66.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8291.14 2062.43-65.79-160.37s53.98 33.14 69.65 65.62-3.86 94.75-3.86 94.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m7807.42 2065.38-135.22 102.14s60.71-.05 89.99-19.51c29.29-19.46 45.23-82.63 45.23-82.63"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m7804.55 2060.58-129.4 109.45s12.83-59.22 38.23-83.51 91.17-25.94 91.17-25.94"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8288.58 2073.79 44.54 118.01s13.78-42.64 6.1-67.6-50.64-50.41-50.64-50.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8290.29 2073.4 39.65 118.3s-37.38-26.57-47.11-50.65 7.46-67.65 7.46-67.65"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7988.05 2037.42-87.36 152.2s57.72-25.13 77.72-55.59 9.64-96.61 9.64-96.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7984.5 2036.91-81.53 151.26s-7.57-62.12 7.52-94.54c15.09-32.43 74.01-56.72 74.01-56.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7813.41 2072.28-71.19-129.65s-8.2 53.41 4.89 81.21c13.08 27.81 66.3 48.44 66.3 48.44"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M7816.97 2073.37 7740.76 1942s50.25 21.76 67.68 48.05c17.44 26.29 8.53 83.32 8.53 83.32"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m7999.71 2376.31-65.03-115.47s-6.98 47.99 5.01 72.78c11.98 24.78 60.02 42.69 60.02 42.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8003.03 2377.51-69.77-117.44s45.36 19.06 61.28 42.54c15.93 23.48 8.49 74.9 8.49 74.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7800.22 2068.57-15.47 170.77s43.11-45.5 48.56-80.67c5.45-35.18-33.09-90.1-33.09-90.1"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7802.32 2067.81-21.18 170.52s-30.79-54.94-28.55-90.62c2.25-35.68 49.73-79.9 49.73-79.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8530.9 2117.81-127.09 126.28s63.08-8.15 90.96-32.68c27.87-24.53 36.13-93.6 36.13-93.6"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8525.87 2113.51-117.46 132.7s4.7-63.53 27.35-92.51c22.66-28.97 90.11-40.19 90.11-40.19"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8539.14 2273.69-18.64-149.13s-29.1 46.22-27.24 77.32 45.88 71.81 45.88 71.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8533.8 2274.29-6.59-149.09s34.52 42.89 37.78 73.79c3.27 30.89-31.19 75.3-31.19 75.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8572.81 2031.27-121.75 32.65s42.71 18.19 68.39 13.03 53.36-45.68 53.36-45.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8573.25 2035.89-121.77 22.14s30.17-33.71 55.12-39.89c24.95-6.17 66.65 17.75 66.65 17.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8494.54 1899.32-47.6 165.27s50.22-37.38 62.21-71.03c11.98-33.66-14.61-94.24-14.61-94.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8494.36 1898.54-48.58 164.94s-21.89-58.93-13.9-93.78c7.98-34.85 62.48-71.16 62.48-71.16"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7768.95 2787.95-78.94 130.29s50.53-20.59 68.5-46.61c17.98-26.01 10.44-83.68 10.44-83.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7765.6 2787.3-73.29 129.85s-5.76-54 7.87-81.88c13.63-27.87 65.42-47.97 65.42-47.97"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8077.19 2033.75 95.17-83.24s-44.94 2.88-65.68 18.91c-20.74 16.02-29.49 64.33-29.49 64.33"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8080.26 2037.15 89.16-88.45s-6.06 44.59-23.4 64.03c-17.33 19.45-65.76 24.42-65.76 24.42"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8006.31 2221.75 7.72-123.7s-30.31 33.66-33.54 59.18c-3.24 25.52 25.82 64.52 25.82 64.52"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8004.4 2222.29 12.63-123.52s23.12 39.24 22.05 65.05c-1.06 25.81-34.68 58.47-34.68 58.47"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7617.45 1593.32 165.49-53.16s-60.28-21.62-95.31-12.74c-35.03 8.87-70.18 65.9-70.18 65.9"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7616.89 1589.45 165.61-43.48s-37.94 49.64-71.7 60.81c-33.75 11.17-93.91-17.33-93.91-17.33"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8072.04 2185.32 5.44 149.19s32.67-43.57 33.54-74.52c.86-30.96-38.98-74.67-38.98-74.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8076.05 2184.71-3.91 149.05s-31.31-45.02-32.39-76.03c-1.07-31.02 36.3-73.02 36.3-73.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7931.53 1609.87-78.51 101.77s44.06-12.2 61.58-32.3c17.51-20.1 16.93-69.47 16.93-69.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7927.93 1607.76-71.94 104.45s-1.5-45.85 12.12-68.41c13.62-22.57 59.82-36.04 59.82-36.04"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8100.96 2033.76-42.9-169.89s-26.9 57.04-20.29 92.72 63.19 77.17 63.19 77.17"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8094.33 2034.39-27.95-170.04s45.5 44.7 53.47 79.69-25.52 90.35-25.52 90.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7988.56 1238.47 62.7-136.87s-47.7 26.06-62.42 53.65c-14.71 27.59-.28 83.22-.28 83.22"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7986.66 1239.17 67.36-136.65s11.44 54.01-.73 83.18-66.63 53.47-66.63 53.47"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8187.55 2230.02 120.93 28.06s-29.15-34.87-53.88-42.24c-24.74-7.37-67.05 14.18-67.05 14.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8186.98 2229.78 120.68 29.56s-41.51 17.79-66.92 13.19c-25.4-4.6-53.76-42.75-53.76-42.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8004.97 1254.46-172.17-2.98s50.06 39.67 85.76 42.54c35.71 2.87 86.41-39.56 86.41-39.56"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8005.69 1258.28-171.85-12.16s52.25-34.36 88.02-34.04c35.78.32 83.83 46.2 83.83 46.2"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7930.45 1177.37 30.24-145.4s-41.15 35.27-49.3 65.02c-8.16 29.75 19.06 80.38 19.06 80.38"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7930.16 1178.05 32.05-145.13s22.17 49.67 17.35 80.2-49.4 64.93-49.4 64.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m7975.27 1737.41-45.95-128.12s-15.81 45.77-7.98 72.83c7.84 27.07 53.93 55.29 53.93 55.29"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7972.65 1737.85-39.17-128.41s39.51 29.74 49.27 55.93-10.1 72.48-10.1 72.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7938.04 1156.69-164.97-49.17s37.1 50.53 70.68 62.83c33.59 12.3 94.29-13.66 94.29-13.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7938.83 1156.57-164.63-50.26s59.04-21.42 93.83-13.09c34.8 8.33 70.8 63.35 70.8 63.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8321.77 2260.61 55.42 166.29s21.99-58.52 12.71-93.6c-9.29-35.08-68.13-72.69-68.13-72.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8326.31 2260.03 44.44 166.61s-49.48-40.06-60.82-74.12c-11.34-34.07 16.38-92.49 16.38-92.49"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8439.5 2355.63-120.55-95.95s55.06 1.21 81.23 19.55c26.16 18.35 39.32 76.4 39.32 76.4"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M8436.43 2359.97 8322 2257.37s10.09 54.04 32.48 76.73c22.39 22.68 81.95 25.87 81.95 25.87"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8198.96 2336.98-124.58 6.66s38.11 26.32 64.05 26.58c25.95.26 60.53-33.24 60.53-33.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8199.47 2340.74-124.4-2s36.34-26.98 62.16-28.17c25.81-1.18 62.24 30.17 62.24 30.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7874.27 1918.39 117.34 130.1s-2.95-62.88-25.48-91.33c-22.53-28.44-91.86-38.77-91.86-38.77"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7868.85 1920.33 125.97 126.27s-63.19-8.4-90.86-32.94-35.11-93.33-35.11-93.33"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7771.54 1542.78-66.86-99.78s-3.74 43.9 8.78 65.46c12.51 21.57 58.08 34.32 58.08 34.32"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="M7775.28 1544.07 7702.65 1442s42.69 13.77 59.01 34.02c16.32 20.24 13.62 68.05 13.62 68.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8166.77 2446.24 20.68-124.09s22.77 39.51 20.15 65.45c-2.61 25.93-40.83 58.64-40.83 58.64"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8171.57 2446.73 9.92-124.09s-30.08 34.79-33.72 60.46c-3.64 25.66 23.8 63.63 23.8 63.63"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m7595.79 2866.01 97.91-90.51s-47.21 4.32-68.61 21.81c-21.39 17.49-29.3 68.7-29.3 68.7"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m7599.3 2869.45 91.12-95.73s-5.1 47.14-22.75 68.12c-17.66 20.98-68.37 27.61-68.37 27.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7842 2939.86-88.73-151.58s57.95 24.65 78.22 54.96 10.51 96.62 10.51 96.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7838.33 2940.46-82.64-150.8s-7.25 62.2 8.07 94.55c15.33 32.34 74.57 56.25 74.57 56.25"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7689.73 2783.77-153.34-82.07s25.34 56.89 56.03 75.83c30.68 18.95 97.31 6.24 97.31 6.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7686.76 2781.72-145.66-79.25s61.01-7.99 92.3 6.64c31.3 14.63 53.36 72.61 53.36 72.61"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9398.83 2363.35c-26.09 2.06-46.11 20.94-44.73 42.14 1.39 21.21 23.65 36.73 49.74 34.66 26.08-2.07 46.11-20.94 44.72-42.15-1.38-21.21-23.65-36.72-49.73-34.65"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9365.26 2419.56s-8.6-21.62 1.2-30.59c12.73-11.67 29.35-2.33 29.35-2.33-8.4 1.43-17.96 1.75-22.87 7.37-5.36 6.16-5.76 17.88-7.68 25.55"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9396.44 2414.33s9.77 3.16 10.42 4.19c4.19 6.73 5.85 8.19 5.85 8.19s-9.72 3.43-14.27 2.87c-4.56-.56-9.45-3.75-9.45-3.75s.13 5.33-1.14 7.18c-1.51 2.2-7.93 6.02-7.93 6.02s-5.67-4.25-6.77-7.09c-1.13-2.92 5.09-9.12 5.09-9.12s-5.65.81-8.97-.92c-3.43-1.82-8.06-7.46-8.06-7.46s4.63-3.77 8-4.23c3.21-.44 12.65 1.43 12.65 1.43s-6.31-4.59-8.39-8.01c-2.16-3.55 4.49-9.56 4.49-9.56s7.12 4.02 10.43 7.23c2.52 2.46.35 8.31.35 8.31s2.8-6.05 5.88-8.18c3.09-2.12 11.11-1.67 11.11-1.67s2.45 7.29.65 10.2c-1.71 2.77-9.94 4.37-9.94 4.37"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9387.65 2425.37c1.39-.11 3.81.27 4.77-.41.98-.68 2.16-2.84 2.46-4.09.81-3.3.77-5.68-2.46-7.89-1.18-.79-3.42-.02-4.64.08-.67.05-1.49 0-2.14.17-2.53.6-4.46 2.38-6.05 4.03-.65.67-1.25 2.16-.66 3.02.54.76 1.44 1.46 1.92 2.29.65 1.1 1.73 3.32 3.32 3.82 1.07.33 1.47-.44 2.2-.7.78-.27.32-.05 1.28-.32"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M8186.92 2299.79c-22.32 2.02-39.45 18.18-38.26 36.07 1.19 17.9 20.25 30.77 42.57 28.74 22.31-2.02 39.44-18.18 38.25-36.07-1.19-17.9-20.25-30.77-42.56-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8157.34 2347.44s-6.77-18.93 2.05-26.55c11.44-9.9 25.58-1.48 25.58-1.48-7.35 1.09-15.66 1.19-20.12 5.98-4.86 5.25-5.59 15.43-7.51 22.05"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8184.8 2342.81s8.58 2.53 9.18 3.4c3.94 5.7 5.44 6.91 5.44 6.91s-8.21 3.14-12.16 2.74c-3.95-.39-8.33-3.03-8.33-3.03s.37 4.57-.63 6.18c-1.2 1.92-6.54 5.32-6.54 5.32s-5.1-3.53-6.18-5.95c-1.11-2.49 3.95-7.93 3.95-7.93s-4.83.81-7.78-.62c-3.05-1.49-7.31-6.25-7.31-6.25s3.81-3.32 6.69-3.78c2.75-.44 10.98.99 10.98.99s-5.67-3.82-7.62-6.72c-2.04-3.01 3.41-8.29 3.41-8.29s6.32 3.3 9.33 6c2.3 2.06.71 7.12.71 7.12s2.11-5.24 4.67-7.13c2.56-1.88 9.49-1.65 9.49-1.65s2.47 6.21 1.06 8.75c-1.34 2.41-8.36 3.94-8.36 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M8177.36 2352.34c1.2-.11 3.27.19 4.09-.39.84-.59 1.84-2.43 2.1-3.49.69-2.79.66-4.8-2.1-6.63-1.01-.66-2.93.02-3.98.11-.57.05-1.27.02-1.83.17-2.16.53-3.81 2.06-5.18 3.47-.55.57-1.06 1.84-.55 2.55.45.64 1.22 1.22 1.64 1.92.55.92 1.48 2.79 2.84 3.19.91.26 1.25-.39 1.88-.61.66-.24.27-.05 1.09-.29"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M8281.54 2288.74c-26.08 2.37-46.09 21.24-44.7 42.15s23.66 35.95 49.74 33.58c26.07-2.37 46.09-21.24 44.7-42.15-1.4-20.91-23.66-35.95-49.74-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8246.98 2344.42s-7.91-22.12 2.39-31.02c13.37-11.57 29.89-1.73 29.89-1.73-8.58 1.27-18.3 1.39-23.5 6.99-5.68 6.13-6.54 18.02-8.78 25.76"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M8279.07 2339.01s10.02 2.95 10.73 3.97c4.6 6.66 6.35 8.08 6.35 8.08s-9.59 3.66-14.21 3.2-9.73-3.55-9.73-3.55.43 5.35-.74 7.23c-1.4 2.24-7.65 6.22-7.65 6.22s-5.95-4.13-7.21-6.96c-1.3-2.91 4.61-9.27 4.61-9.27s-5.64.95-9.08-.72c-3.57-1.74-8.54-7.3-8.54-7.3s4.44-3.88 7.81-4.42c3.22-.51 12.83 1.15 12.83 1.15s-6.62-4.46-8.91-7.84c-2.38-3.52 3.99-9.7 3.99-9.7s7.39 3.87 10.9 7.02c2.68 2.41.82 8.32.82 8.32s2.48-6.12 5.47-8.33c2.99-2.2 11.09-1.93 11.09-1.93s2.88 7.26 1.23 10.22c-1.56 2.81-9.76 4.61-9.76 4.61"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M8270.37 2350.14c1.4-.13 3.82.22 4.78-.46.98-.69 2.16-2.84 2.46-4.08.8-3.25.77-5.6-2.46-7.75-1.18-.76-3.42.02-4.65.14-.67.06-1.49.02-2.14.19-2.52.62-4.45 2.4-6.04 4.05-.65.67-1.25 2.15-.66 2.99.54.74 1.44 1.43 1.92 2.24.65 1.07 1.73 3.26 3.32 3.72 1.06.32 1.47-.45 2.19-.71.78-.28.33-.06 1.28-.33"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M8312.75 2164.2c-22.32 2.02-39.45 18.18-38.26 36.07 1.19 17.9 20.25 30.77 42.57 28.74 22.32-2.02 39.44-18.17 38.25-36.07s-20.24-30.77-42.56-28.74"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8283.17 2211.85s-6.77-18.93 2.05-26.55c11.44-9.9 25.58-1.48 25.58-1.48-7.35 1.08-15.66 1.19-20.12 5.98-4.86 5.25-5.59 15.43-7.51 22.05"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8310.63 2207.22s8.57 2.53 9.18 3.41c3.94 5.69 5.44 6.91 5.44 6.91s-8.21 3.13-12.16 2.74-8.33-3.04-8.33-3.04.37 4.58-.63 6.19c-1.2 1.92-6.55 5.32-6.55 5.32s-5.09-3.54-6.17-5.95c-1.12-2.49 3.95-7.93 3.95-7.93s-4.83.8-7.78-.62c-3.05-1.49-7.31-6.25-7.31-6.25s3.81-3.32 6.69-3.78c2.75-.45 10.98.98 10.98.98s-5.67-3.82-7.63-6.72c-2.03-3.01 3.42-8.29 3.42-8.29s6.32 3.31 9.33 6c2.3 2.07.7 7.13.7 7.13s2.12-5.25 4.68-7.13c2.56-1.89 9.49-1.65 9.49-1.65s2.47 6.21 1.06 8.74c-1.34 2.41-8.36 3.94-8.36 3.94"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M8303.19 2216.75c1.2-.11 3.27.19 4.09-.4.84-.59 1.84-2.42 2.1-3.48.69-2.79.66-4.8-2.1-6.64-1.01-.65-2.93.02-3.98.12-.57.05-1.27.02-1.83.16-2.16.54-3.81 2.06-5.18 3.47-.55.58-1.06 1.84-.55 2.56.45.64 1.22 1.22 1.64 1.92.55.91 1.48 2.78 2.84 3.18.91.27 1.25-.38 1.88-.61.66-.24.27-.05 1.09-.28"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9410.29 2881.16-47.56-116.26s-12.26 42.89-3.91 67.53 51.47 48.73 51.47 48.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9409.91 2881.54-45.24-116.58s38.53 24.72 49.39 48.36c10.86 23.65-4.15 68.22-4.15 68.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7781.54 2664.89 42.29 116.24s14.14-41.65 6.9-66.21c-7.24-24.57-49.19-50.03-49.19-50.03"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7783.73 2664.5 36.5 116.51s-36.12-26.77-45.17-50.52 8.67-65.99 8.67-65.99"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8334.79 2957.06-112.82 61.45s46.14 6.38 70.32-4.95c24.17-11.34 42.5-56.5 42.5-56.5"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8335.02 2954.81-112.87 64.12s18.14-43.02 40.7-57.73c22.55-14.72 72.17-6.39 72.17-6.39"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8016.36 2848.74-112.81 61.45s46.14 6.39 70.31-4.95c24.18-11.33 42.5-56.5 42.5-56.5"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8016.6 2846.5-112.87 64.12s18.14-43.02 40.69-57.73c22.56-14.72 72.18-6.39 72.18-6.39"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8380.51 2951.05 158.09-64.92s-61.28-15.35-94.96-3.88c-33.68 11.48-63.13 68.8-63.13 68.8"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8380.02 2953.77 158.35-68.03s-30.3 54.58-62.23 70.71-96.12-2.68-96.12-2.68"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8354.85 2834.96 41.07 116.83s14.71-41.55 7.74-66.23c-6.96-24.67-48.81-50.6-48.81-50.6"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8357.49 2834.56 34.41 117.08s-35.66-27.42-44.29-51.32 9.88-65.76 9.88-65.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8306.3 2953.27 63.07 162.61s18.38-59.14 7.43-93.56c-10.94-34.41-70.5-69.05-70.5-69.05"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8308.06 2952.73 57.47 163.03s-52.31-35.95-66.29-69.1c-13.99-33.14 8.82-93.93 8.82-93.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8176.02 2880.94-107.15 141.88s60.78-17.55 84.73-45.6c23.94-28.05 22.42-96.28 22.42-96.28"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8171.11 2878.15-98.23 145.34s-2.55-63.42 16.01-94.8c18.57-31.37 82.22-50.54 82.22-50.54"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8210.27 2857.15 127.45-81.45s-54.43-3.36-81.87 11.97c-27.45 15.32-45.58 69.48-45.58 69.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8211.22 2860.96 125.25-86.89s-16.64 51.97-41.47 71.55c-24.83 19.57-83.78 15.34-83.78 15.34"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8465.5 3052.49 72.96 99.79s2.28-45.1-11.49-66.73c-13.76-21.63-61.47-33.06-61.47-33.06"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8461.4 3051.79 79.44 100.96s-44.34-11.86-62.05-31.79c-17.71-19.92-17.39-69.17-17.39-69.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8002.23 2826.83 29.81 171.71s31.17-54.91 27.3-90.82c-3.87-35.9-57.11-80.89-57.11-80.89"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8008.93 2826.16 14.8 171.72s-41.95-47.93-47.21-83.43 32.41-88.29 32.41-88.29"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7999.56 2828.06 24.38-121.43s-34.14 29.63-40.77 54.49c-6.62 24.86 16.39 66.94 16.39 66.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7999.27 2828.62 26.01-121.21s18.73 41.33 14.86 66.82-40.87 54.39-40.87 54.39"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8462 3052.33-5.34 127.78s30.63-35.3 33.43-61.7c2.79-26.39-28.09-66.08-28.09-66.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8464.28 3051.78-11.02 127.6s-24.49-40.11-23.81-66.76c.68-26.64 34.83-60.84 34.83-60.84"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8219.02 2864.29 1.7-124.16s-28.85 35-30.84 60.69c-2 25.69 29.14 63.47 29.14 63.47"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8216.41 2864.82 8.02-124.02s24.61 38.44 24.51 64.3-32.53 59.72-32.53 59.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9554.24 2822.8-47.56-116.26s-12.26 42.89-3.91 67.53c8.35 24.65 51.47 48.73 51.47 48.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9553.86 2823.18-45.24-116.58s38.54 24.72 49.39 48.36c10.86 23.65-4.15 68.22-4.15 68.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8883.33 1131.97-87.03-92.03s44.36 7.23 63.51 25.19c19.16 17.95 23.52 66.84 23.52 66.84"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8879.67 1134.81-80.09-96.17s2.1 45.01 17.48 65.95 62.61 30.22 62.61 30.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8727.03 1400.32-111.34 67.11s16.5-43.38 38.67-58.69c22.17-15.3 72.67-8.42 72.67-8.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8725.73 1402.18-107.4 64.19s46 4.7 69.14-7.26c23.13-11.96 38.26-56.93 38.26-56.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8553.6 1662.76-111.33 67.11s16.49-43.38 38.66-58.68c22.17-15.31 72.67-8.43 72.67-8.43"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8552.31 1664.63-107.4 64.19s45.99 4.7 69.13-7.26c23.13-11.95 38.27-56.93 38.27-56.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8698.68 1230.49 113.87-132.21s-1.51 62.89-23.29 91.73c-21.78 28.85-90.58 40.48-90.58 40.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8693.04 1229.12 122.9-129.44s-62.91 10.19-89.98 35.44-32.92 94-32.92 94"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8812.11 1411.43-42.36-114.62s37.28 23.97 47.51 47.21c10.24 23.23-5.15 67.41-5.15 67.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8812.26 1412-43.52-114.41s-12.65 42.82-5.1 67.1c7.56 24.28 48.62 47.31 48.62 47.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8603.96 1039.19-62.25-107.443s40.9 17.613 55.14 39.106c14.23 21.494 7.11 68.337 7.11 68.337"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8601.4 1039.59-58.03-106.841s-5.25 43.965 5.5 66.874c10.75 22.907 52.53 39.967 52.53 39.967"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8732.2 1407.01-118.92-133.6s62.28 12.25 88.55 38.42c26.28 26.16 30.37 95.18 30.37 95.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8726.98 1410.7-109.12-138.84s1.37 63.66 22.24 93.82c20.87 30.15 86.88 45.02 86.88 45.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8744.55 1585.17-172.27.68s50.59-39.07 86.35-41.47c35.75-2.4 85.92 40.79 85.92 40.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8745.28 1581.08-171.98 10.4s51.9 34.93 87.68 34.98 84.3-45.38 84.3-45.38"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8659.61 1809.67 134.88-66.19s-23.81 48.4-50.89 63.82c-27.09 15.43-83.99 2.37-83.99 2.37"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8660.09 1811.77 132.39-71.19s-54.01-9.83-82.37 3.16-50.02 68.03-50.02 68.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8711.87 1084.21 48.34-115.777s11.86 42.967 3.34 67.517c-8.52 24.56-51.68 48.26-51.68 48.26"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8711.9 1084.59 46.7-116.109s-38.82 24.219-49.98 47.749c-11.15 23.52 3.28 68.36 3.28 68.36"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8657.13 1791.24-48.68-165.01s50.44 37.08 62.65 70.67c12.2 33.59-13.97 94.34-13.97 94.34"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8656.95 1792.04-49.65-164.69s-21.55 59.07-13.34 93.87c8.2 34.81 62.99 70.82 62.99 70.82"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8659.29 1812.87 117.62 41.55s-43.92 13.88-68.88 6.77-48.74-48.32-48.74-48.32"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8658.9 1813.76 117.75 38.25s-25.29-37.3-49.2-46.76c-23.9-9.45-68.55 8.51-68.55 8.51"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8809.03 1273.66-115.05-54.86s45.83-9.08 70.41.84c24.59 9.92 44.64 54.02 44.64 54.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8809.37 1276.17-115.28-58.11s20.16 41.99 43.29 55.5c23.14 13.51 71.99 2.61 71.99 2.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10121.9 1174.1-126.12-31.28s43.72-19.66 70.22-14.85c26.6 4.82 55.9 46.13 55.9 46.13"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10122.4 1169.03-126.16-19.85s31.96 34.02 57.86 39.78 68.3-19.93 68.3-19.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8470.17 1558.25-26.19 171.99s-32.25-54.26-29.14-90.18c3.12-35.92 55.33-81.81 55.33-81.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8463.66 1557.57-11.59 171.97s41.04-48.66 45.63-84.25-34.04-87.72-34.04-87.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10147.4 1382.26 46.5-113.92s12 41.98 3.9 66.13c-8.2 24.14-50.4 47.79-50.4 47.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10147.8 1382.63 44.1-114.24s-37.7 24.28-48.3 47.45c-10.5 23.18 4.2 66.79 4.2 66.79"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10278.1 976.498 22.6-121.307s21.6 39.107 18.5 64.49c-3 25.383-41.1 56.817-41.1 56.817"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10282.9 976.96 11.9-121.33s-30.1 33.58-34.1 58.646 22.2 62.684 22.2 62.684"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10111.8 1173.95 17.8-172.34s34.6 52.66 33.3 88.56c-1.4 35.89-51.1 83.78-51.1 83.78"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10117.6 1174.65 4.6-172.26s-39 50.18-42.1 85.91c-3.1 35.74 37.5 86.35 37.5 86.35"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10025 1303.16-142.14-105.49s63.47-.39 94.25 19.68c30.79 20.08 47.89 85.81 47.89 85.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10022.2 1308.16-136.42-113.09s14.05 61.78 40.86 86.92c26.82 25.13 95.56 26.17 95.56 26.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10283.8 1146.86-53.7-117.79s41 22.48 53.6 46.23c12.6 23.74.1 71.56.1 71.56"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10285.4 1147.46-57.7-117.6s-9.9 46.42.5 71.52c10.4 25.11 57.2 46.08 57.2 46.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8975.65 1253.67-115.06-54.86s45.84-9.09 70.42.84c24.58 9.92 44.64 54.02 44.64 54.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8975.99 1256.17-115.28-58.1s20.16 41.99 43.29 55.5c23.14 13.51 71.99 2.6 71.99 2.6"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8498.99 1136.17-168.18 35.23s41.46-47.46 75.91-56.93c34.45-9.48 92.27 21.7 92.27 21.7"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8499.77 1135.58-167.81 37.84s56.94 25.69 92.22 19.97c35.28-5.71 75.59-57.81 75.59-57.81"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8997.85 1331.68-172.41-3.33s51.49-38.02 87.32-39.59c35.84-1.57 85.09 42.92 85.09 42.92"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8998.56 1327.14-172.13 7.31s51.28 35.92 87.05 36.62c35.77.69 85.08-43.93 85.08-43.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8880.84 1627.51-154.28-2.99s46.07-34.02 78.14-35.42c32.07-1.41 76.14 38.41 76.14 38.41"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8881.48 1623.44-154.03 6.54s45.88 32.15 77.89 32.77 76.14-39.31 76.14-39.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8745.63 1630.67 110.3 57.56s-44.59 7.43-68.2-3.11-42.1-54.45-42.1-54.45"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8745.31 1628.78 110.52 59.63s-18.46-41.29-40.59-55.05-69.93-4.58-69.93-4.58"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8817.89 1416.51 110.3 57.56s-44.59 7.43-68.2-3.11c-23.6-10.54-42.1-54.45-42.1-54.45"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8817.57 1414.63 110.52 59.62s-18.46-41.29-40.59-55.05c-22.13-13.75-69.93-4.57-69.93-4.57"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9074.38 1232.25c-26.08 2.37-46.09 21.24-44.7 42.15s23.66 35.95 49.74 33.58c26.07-2.37 46.09-21.24 44.7-42.15-1.4-20.91-23.66-35.94-49.74-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9039.82 1287.94s-7.91-22.13 2.39-31.03c13.37-11.57 29.9-1.73 29.9-1.73-8.59 1.27-18.3 1.39-23.51 6.99-5.68 6.14-6.53 18.03-8.78 25.77"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9071.91 1282.52s10.02 2.95 10.73 3.97c4.6 6.66 6.35 8.08 6.35 8.08s-9.59 3.66-14.21 3.2-9.73-3.54-9.73-3.54.43 5.34-.74 7.22c-1.4 2.24-7.65 6.22-7.65 6.22s-5.95-4.13-7.21-6.96c-1.3-2.91 4.61-9.26 4.61-9.26s-5.64.94-9.08-.73c-3.57-1.74-8.54-7.3-8.54-7.3s4.44-3.88 7.81-4.42c3.22-.51 12.83 1.15 12.83 1.15s-6.62-4.46-8.91-7.84c-2.38-3.52 3.99-9.69 3.99-9.69s7.39 3.86 10.9 7.01c2.68 2.41.82 8.32.82 8.32s2.48-6.12 5.47-8.33c2.99-2.2 11.09-1.93 11.09-1.93s2.88 7.26 1.23 10.22c-1.56 2.82-9.76 4.61-9.76 4.61"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9063.21 1293.65c1.4-.12 3.82.23 4.78-.46.98-.69 2.15-2.83 2.45-4.07.81-3.26.78-5.61-2.45-7.75-1.18-.77-3.42.02-4.65.13-.67.06-1.49.03-2.14.2-2.52.62-4.45 2.4-6.04 4.05-.65.67-1.25 2.15-.66 2.98.54.75 1.43 1.43 1.92 2.25.65 1.07 1.73 3.25 3.32 3.72 1.06.31 1.46-.45 2.19-.71.78-.28.33-.06 1.28-.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9127.21 1162.48c24.69-2.99 43.2-21.45 41.33-41.23-1.87-19.79-23.4-33.4-48.1-30.41-24.69 2.99-43.2 21.45-41.33 41.24 1.87 19.78 23.4 33.39 48.1 30.4"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9127.11 1113.76s-9.6-2.38-10.32-3.32c-4.63-6.11-6.35-7.38-6.35-7.38s8.91-3.86 13.3-3.62 9.35 2.95 9.35 2.95-.64-5.04.39-6.87c1.23-2.18 6.96-6.2 6.96-6.2s5.81 3.66 7.13 6.28c1.35 2.7-3.96 8.96-3.96 8.96s5.29-1.13 8.62.31c3.44 1.5 8.39 6.55 8.39 6.55s-4.04 3.86-7.2 4.51c-3.02.62-12.18-.55-12.18-.55s6.45 3.95 8.76 7.05c2.4 3.23-3.35 9.34-3.35 9.34s-7.16-3.35-10.62-6.19c-2.64-2.17-1.13-7.84-1.13-7.84s-2.08 5.9-4.81 8.11-10.41 2.29-10.41 2.29-3.04-6.75-1.6-9.62c1.36-2.73 9.03-4.76 9.03-4.76"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9117.25 1152.39s-22.44 2.43-27.89-8.75c-7.08-14.53 6.35-27.34 6.35-27.34-1.12 8.01-3.59 16.8.18 22.69 4.13 6.43 14.84 9.73 21.36 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9135.98 1103.97c-1.32.16-3.63-.11-4.52.57-.91.68-1.97 2.75-2.22 3.93-.69 3.11-.59 5.34 2.53 7.28 1.14.69 3.25-.12 4.41-.26.63-.08 1.41-.07 2.02-.24 2.38-.67 4.17-2.41 5.64-4.02.6-.65 1.12-2.08.54-2.85-.53-.69-1.4-1.31-1.88-2.07-.64-1-1.73-3.04-3.25-3.43-1.02-.27-1.38.46-2.06.73-.74.29-.31.07-1.21.36"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9077.59 1583.7c24.69-3 43.2-21.46 41.33-41.24s-23.4-33.39-48.09-30.4c-24.7 2.99-43.2 21.45-41.34 41.23 1.87 19.78 23.4 33.4 48.1 30.41"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9077.49 1534.97s-9.6-2.38-10.31-3.31c-4.64-6.11-6.36-7.39-6.36-7.39s8.91-3.86 13.3-3.62 9.35 2.95 9.35 2.95-.63-5.04.4-6.87c1.22-2.18 6.96-6.2 6.96-6.2s5.81 3.66 7.12 6.28c1.36 2.7-3.96 8.97-3.96 8.97s5.3-1.13 8.62.3c3.45 1.5 8.39 6.56 8.39 6.56s-4.03 3.86-7.2 4.51c-3.01.62-12.17-.56-12.17-.56s6.45 3.95 8.76 7.06c2.4 3.23-3.36 9.33-3.36 9.33s-7.15-3.35-10.61-6.18c-2.64-2.17-1.14-7.85-1.14-7.85s-2.08 5.91-4.81 8.12-10.4 2.29-10.4 2.29-3.04-6.75-1.61-9.63c1.36-2.72 9.03-4.76 9.03-4.76"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9067.63 1573.6s-22.44 2.44-27.89-8.75c-7.08-14.52 6.35-27.34 6.35-27.34-1.11 8.02-3.58 16.81.19 22.69 4.13 6.44 14.83 9.74 21.35 13.4"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9086.37 1525.18c-1.32.16-3.63-.1-4.52.57-.91.69-1.98 2.75-2.23 3.94-.68 3.11-.59 5.33 2.54 7.28 1.14.69 3.24-.12 4.4-.26.64-.08 1.42-.07 2.03-.25 2.38-.66 4.17-2.41 5.63-4.02.6-.65 1.13-2.07.54-2.84-.52-.7-1.39-1.32-1.88-2.07-.63-1-1.72-3.04-3.24-3.44-1.02-.27-1.38.47-2.07.74-.73.29-.3.06-1.2.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M8306.78 1280.1c-26.08 2.37-46.09 21.24-44.7 42.15 1.39 20.92 23.66 35.95 49.74 33.58 26.07-2.36 46.08-21.24 44.69-42.15s-23.65-35.94-49.73-33.58"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8272.22 1335.79s-7.91-22.12 2.39-31.02c13.37-11.57 29.89-1.74 29.89-1.74-8.59 1.27-18.3 1.39-23.5 7-5.69 6.13-6.54 18.02-8.78 25.76"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M8304.31 1330.37s10.01 2.96 10.72 3.98c4.6 6.65 6.36 8.07 6.36 8.07s-9.6 3.66-14.21 3.21c-4.62-.46-9.73-3.55-9.73-3.55s.43 5.34-.74 7.23c-1.4 2.24-7.65 6.21-7.65 6.21s-5.95-4.13-7.21-6.95c-1.31-2.91 4.61-9.27 4.61-9.27s-5.65.95-9.09-.72c-3.56-1.74-8.54-7.3-8.54-7.3s4.45-3.88 7.82-4.42c3.21-.52 12.82 1.15 12.82 1.15s-6.62-4.47-8.9-7.85c-2.38-3.52 3.98-9.69 3.98-9.69s7.4 3.87 10.91 7.02c2.68 2.41.82 8.32.82 8.32s2.48-6.13 5.47-8.33c2.98-2.2 11.09-1.93 11.09-1.93s2.88 7.25 1.23 10.22c-1.57 2.81-9.76 4.6-9.76 4.6"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M8295.61 1341.5c1.4-.12 3.82.23 4.78-.45.98-.7 2.15-2.84 2.45-4.08.81-3.26.78-5.6-2.45-7.75-1.18-.77-3.42.02-4.65.13-.67.06-1.49.03-2.14.2-2.52.62-4.45 2.4-6.05 4.05-.64.67-1.24 2.15-.65 2.99.54.74 1.43 1.42 1.92 2.24.65 1.07 1.73 3.25 3.32 3.72 1.06.31 1.46-.45 2.19-.71.78-.28.33-.06 1.28-.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M8537.35 1233.48c24.69-2.99 43.2-21.45 41.33-41.23-1.87-19.79-23.4-33.4-48.09-30.41-24.7 2.99-43.2 21.45-41.34 41.24 1.87 19.78 23.4 33.39 48.1 30.4"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8537.25 1184.76s-9.6-2.38-10.32-3.32c-4.63-6.11-6.35-7.38-6.35-7.38s8.91-3.86 13.3-3.62 9.35 2.95 9.35 2.95-.63-5.04.39-6.87c1.23-2.18 6.97-6.2 6.97-6.2s5.8 3.66 7.12 6.28c1.36 2.7-3.96 8.96-3.96 8.96s5.29-1.13 8.62.31c3.44 1.5 8.39 6.55 8.39 6.55s-4.04 3.86-7.2 4.51c-3.02.62-12.18-.55-12.18-.55s6.45 3.95 8.76 7.05c2.4 3.23-3.35 9.34-3.35 9.34s-7.16-3.35-10.61-6.19c-2.65-2.17-1.14-7.84-1.14-7.84s-2.08 5.9-4.81 8.11-10.41 2.29-10.41 2.29-3.04-6.75-1.6-9.62c1.36-2.73 9.03-4.76 9.03-4.76"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8527.39 1223.38s-22.44 2.44-27.89-8.75c-7.08-14.52 6.35-27.34 6.35-27.34-1.12 8.02-3.58 16.81.18 22.7 4.13 6.43 14.84 9.73 21.36 13.39"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M8546.13 1174.97c-1.33.16-3.63-.11-4.53.57-.91.68-1.97 2.75-2.22 3.93-.68 3.11-.59 5.34 2.54 7.28 1.14.69 3.24-.12 4.4-.26.64-.08 1.41-.07 2.03-.24 2.38-.67 4.16-2.41 5.63-4.02.6-.65 1.13-2.08.54-2.85-.53-.69-1.39-1.31-1.88-2.07-.64-1-1.72-3.04-3.25-3.43-1.01-.27-1.37.46-2.06.73-.73.29-.31.07-1.2.36"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M8392.03 1581.73c24.7-2.99 43.2-21.45 41.33-41.23-1.86-19.79-23.4-33.4-48.09-30.41s-43.2 21.45-41.33 41.24c1.86 19.78 23.4 33.39 48.09 30.4"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8391.93 1533.01s-9.6-2.38-10.31-3.32c-4.64-6.11-6.36-7.38-6.36-7.38s8.92-3.86 13.3-3.62c4.39.24 9.36 2.95 9.36 2.95s-.64-5.04.39-6.87c1.22-2.18 6.96-6.2 6.96-6.2s5.81 3.66 7.12 6.28c1.36 2.7-3.96 8.96-3.96 8.96s5.3-1.13 8.62.31c3.45 1.5 8.4 6.55 8.4 6.55s-4.04 3.86-7.21 4.51c-3.01.62-12.17-.55-12.17-.55s6.45 3.95 8.76 7.05c2.4 3.23-3.36 9.34-3.36 9.34s-7.15-3.35-10.61-6.19c-2.64-2.17-1.14-7.84-1.14-7.84s-2.08 5.9-4.81 8.11-10.4 2.29-10.4 2.29-3.04-6.75-1.61-9.62c1.36-2.73 9.03-4.76 9.03-4.76"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8382.08 1571.63s-22.45 2.44-27.9-8.75c-7.08-14.52 6.35-27.34 6.35-27.34-1.11 8.02-3.58 16.81.19 22.7 4.13 6.43 14.84 9.73 21.36 13.39"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M8400.81 1523.22c-1.33.16-3.63-.11-4.53.57-.91.68-1.97 2.75-2.22 3.93-.68 3.11-.59 5.34 2.54 7.28 1.14.69 3.24-.12 4.4-.26.64-.08 1.41-.07 2.03-.24 2.38-.67 4.16-2.41 5.63-4.02.6-.65 1.13-2.08.54-2.85-.53-.69-1.39-1.31-1.88-2.07-.64-1-1.72-3.04-3.25-3.43-1.01-.27-1.37.46-2.06.73-.73.29-.31.07-1.2.36"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M8320.2 1223.99c21.75-2.63 38.07-18.7 36.45-35.89s-20.57-28.99-42.32-26.36-38.07 18.7-36.45 35.89 20.57 28.99 42.32 26.36"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M8320.18 1181.64s-8.46-2.05-9.09-2.87c-4.08-5.3-5.59-6.4-5.59-6.4s7.86-3.37 11.72-3.17c3.87.2 8.24 2.55 8.24 2.55s-.56-4.38.35-5.97c1.08-1.9 6.14-5.41 6.14-5.41s5.11 3.18 6.26 5.45c1.2 2.34-3.49 7.8-3.49 7.8s4.66-.99 7.59.25c3.03 1.3 7.39 5.69 7.39 5.69s-3.56 3.36-6.35 3.93c-2.66.54-10.73-.47-10.73-.47s5.68 3.43 7.71 6.12c2.11 2.81-2.96 8.12-2.96 8.12s-6.3-2.89-9.35-5.35c-2.32-1.88-.99-6.82-.99-6.82s-1.84 5.13-4.24 7.06c-2.41 1.92-9.17 2.01-9.17 2.01s-2.67-5.86-1.41-8.36c1.21-2.38 7.97-4.16 7.97-4.16"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8311.43 1215.19s-19.77 2.14-24.54-7.55c-6.22-12.58 5.63-23.71 5.63-23.71-1 6.95-3.18 14.58.12 19.67 3.63 5.57 13.05 8.42 18.79 11.59"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M8328 1173.12c-1.16.14-3.19-.09-3.98.5-.8.6-1.74 2.39-1.96 3.42-.61 2.71-.53 4.64 2.22 6.33 1 .6 2.86-.11 3.88-.24.56-.06 1.25-.06 1.78-.21 2.1-.58 3.68-2.1 4.97-3.5.53-.57 1-1.8.48-2.48-.46-.6-1.23-1.13-1.65-1.79-.56-.87-1.52-2.64-2.86-2.98-.89-.24-1.21.4-1.82.64-.64.25-.27.05-1.06.31"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M9200 1444.12c15.37-15.14 17.86-37.55 5.55-50.05-12.3-12.5-34.74-10.36-50.11 4.78s-17.85 37.55-5.55 50.05c12.31 12.5 34.74 10.36 50.11-4.78"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M9172.82 1410.72s-7.93 3.24-8.89 2.95c-6.27-1.95-8.1-1.96-8.1-1.96s4.38-7.32 7.58-9.4c3.21-2.08 8.04-2.71 8.04-2.71s-2.93-3.24-3.1-5.07c-.21-2.17 1.86-7.96 1.86-7.96s5.88-.39 8.1.79c2.28 1.21 1.61 8.38 1.61 8.38s3.17-3.52 6.22-4.21c3.16-.71 9.13.33 9.13.33s-.95 4.8-2.86 6.89c-1.82 1.98-8.85 5.86-8.85 5.86s6.48-.52 9.64.49c3.27 1.06 2.22 8.33 2.22 8.33s-6.68 1.31-10.51 1.08c-2.93-.18-4.65-4.97-4.65-4.97s1.43 5.24.59 8.21c-.83 2.97-6.2 6.96-6.2 6.96s-5.45-3.21-5.85-5.98c-.38-2.63 4.02-8.01 4.02-8.01"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9186.91 1443.23s-14.48 13.11-24.15 8.23c-12.55-6.33-9.82-21.95-9.82-21.95 3.41 6.06 6.27 13.33 11.98 15.44 6.26 2.3 15.5-.91 21.99-1.72"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M9173.81 1399.33c-.82.81-2.56 1.85-2.8 2.79-.25.95.17 2.92.66 3.86 1.26 2.48 2.56 3.95 5.8 3.62 1.17-.13 2.17-1.81 2.89-2.52.4-.39.94-.79 1.27-1.24 1.27-1.72 1.53-3.85 1.65-5.73.05-.76-.38-2.01-1.22-2.23-.75-.19-1.69-.15-2.45-.41-.99-.34-2.88-1.16-4.15-.62-.85.36-.69 1.05-1.01 1.6-.35.58-.18.2-.64.88"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M8583 3735.57s-259.79 359.51-425.12 505.53c-168.72 149-633.24 138.36-633.24 138.36s488.47 19.5 657.19-114.41c155.59-123.51 403.04-439.01 403.04-439.01s-124.54 420.65-232.55 609.29c-108.42 189.36-854.29 513.51-854.29 513.51s765.87-291.34 879.39-478.92 238.1-633.24 238.1-633.24-101.16 495.87-146.05 715.83c-41.05 201.28-352 792.77-352 792.77s385.42-680.39 428.12-870.04c49.76-220.83 99.19-643.88 99.19-643.88s62.08 560.07 71.84 790.22c8.33 196.75-5.32 332.58-5.32 332.58s40.74-145.8 37.25-348.55c-3.99-231.93-69.18-784.89-69.18-784.89s116.19 548.97 156.98 779.57c35.44 200.32 484.25 752.97 484.25 752.97s-406.13-560.55-436.35-763.61c-35.05-235.47-170.29-798.2-170.29-798.2s324.58 441.67 394.21 662.51c62.07 196.94 513.08 454.97 513.08 454.97s-432.86-284-489.56-478.92c-66.97-230.15-398.69-694.44-398.69-694.44z"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M8216.08 4210.18c-68.67-20.59-50.17-50.81-120.07-62.47-52.53-8.75-166.02-17.13-216.17-17.13-30.92 0-138.01-12.35-152.54-16.5-10.94-3.14-270.82 61.99-263.09 54.28 29.96-29.96 244.43-84.98 285.13-83.15 78.12 3.57 158.56 6.63 234.17 23.44 48.33 10.73 101.94 1.04 149.87 11.71 21.22 4.71 73.96 23.6 88.99 38.63 1.66 1.65 16.05 17.56 17.56 17.56M8182.56 4605.08c-26.67-5.32-51.05-17.74-77.28-24.58-33.06-8.62-68.18-7.11-100.69-15.22-55.3-13.84-108.2-17.56-166.26-17.56-41.07 0-81.96 5.85-121.77 5.85-12.69 0-30.47 4.68-42.15 9.37-5.44 2.18-17.56 0-17.56 0s4.68-1.57 7.02-2.34c9.84-3.28 21.36-12.96 30.44-15.22 31.24-7.83 59.13-16.47 93.67-21.08 55.39-7.39 213.09-9.26 270.47 3.52 30.39 6.75 156.52 33.2 165.09 50.34 8.3 16.6-19.24 17.56-33.96 17.56-2.3 0-7.02 11.62-7.02 9.36M8944.17 4073.19c76.54 0 149.79 17.54 225.03 23.79 107.82 8.99 216.69 7.31 325.64 7.31 62.98 0 129.29.51 192.1-5.48 20.49-1.94 41.75-1.38 62.19-3.64 5.88-.67 10.5-1.84 16.46-1.84h10.99c-47.89 0-91.42 19.11-137.21 29.27-89.29 19.85-245.37 22.3-334.13 6.15-60.66-11.02-136.97 6.7-197.07-8.31-22.16-5.56-138.33 5.22-141.55 2-8.17-8.17-9.44-49.25-22.45-49.25M9141.75 4477.51c79.6 0 196.3 32.03 281.73 42.09 103.32 12.16 183.22-31.1 272.59-31.1 12.16 0 65.43-7.75 113.43-14.64 43.52-6.25-122.1 46.88-152.99 55.72-105.47 30.12-225.6 19.29-335.46 19.29-31.64 0-151.85 7.63-151.85-23.79M8911.25 4686.07c84.72 36.3 156.5 90.41 241.48 124.39 24.3 9.71 52.45 10.38 76.84 20.14 30.87 12.35 73.97 15.03 102.44 29.27 9.45 4.71 25.25 14.63 36.61 14.63 4.63 0 142.48 48.05 137.85 48.05-12.37 0-259.55-43.02-291.53-59.04-49.19-24.58-110.66-36.79-168.31-51.21-25.84-6.44-108.9-54.89-118.91-54.89M8483.15 4629.35c12.8 57.57 43.21 115.36 54.89 173.79 11.63 58.11.53 148.12 23.44 201.58 53.8 125.5 69.87 106.1 69.87 252.15 0 44.51 58.53 176.83 58.53 221.37v45.71c0 7.95-60.26-153.55-71.36-164.65-6.51-6.52-14.23-79.1-18.27-93.31-10.89-38.04-3.14-102.59-14.32-130.56-15.48-38.68-51.7-103.28-60.69-143.83-18.7-84.16-27.88-166.77-43.93-246.99-2.18-10.94-10.83-69.53-20.11-69.53"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M7711.39 4087.59c-14.3-14.29-32.56-22.04-51.9-30.31-18.12-7.77-37.22-16.1-54.36-32.03-16.2-15.09-31.21-46.03-48.87-68.36-13.08-16.49-27.74-28.25-44.55-28.25-3.05 0-5.54 2.47-5.54 5.53s2.49 5.53 5.54 5.53c13.76 0 25.16 10.57 35.86 24.08 18.01 22.75 33.49 54.2 50.01 69.58 18.17 16.9 38.33 25.86 57.54 34.11 17.99 7.69 35.13 14.66 48.43 27.94a5.517 5.517 0 0 0 7.84 0c2.16-2.16 2.16-5.67 0-7.82M7872.17 4102.46c-10.27-41.11-29.15-61.39-51.79-80.17-14.42-11.97-30.44-23.31-46.63-39.48-6.55-6.58-8.52-19-10.37-31.8-2.13-14.77-3.77-30.07-8.71-39.96-3.02-6.02-8.14-12.88-12.52-19.96-3.71-5.96-7.02-12-7.02-17.8 0-3.06-2.49-5.53-5.54-5.53-3.06 0-5.55 2.47-5.55 5.53 0 6.23 2.48 12.8 6.09 19.27 4.62 8.3 11.12 16.44 14.62 23.46 5.49 10.96 6.18 29.24 9.02 45.1 2.18 12.21 5.69 23.07 12.14 29.51 16.47 16.47 32.73 28.01 47.39 40.17 21 17.43 38.58 36.22 48.12 74.34a5.544 5.544 0 0 0 6.72 4.05 5.55 5.55 0 0 0 4.03-6.73M7805.61 4112.14c-45.25 22.64-92.33 67.69-138.7 100.15-29.72 20.8-59.05 36.48-87.51 36.48-3.06 0-5.54 2.5-5.54 5.56s2.48 5.53 5.54 5.53c30.45 0 62.07-16.23 93.87-38.5 45.93-32.14 92.48-76.89 137.29-99.3 2.74-1.35 3.85-4.71 2.48-7.42-1.37-2.74-4.7-3.86-7.43-2.5M8007.8 4130.07c-35.37 10.11-61.94 29-88.53 49.25-25.71 19.61-51.46 40.5-85.93 55.26-15.74 6.76-63.4 30.12-126.48 37.01-3.04.32-5.24 3.06-4.9 6.12a5.53 5.53 0 0 0 6.11 4.9c64.64-7.05 113.51-30.92 129.64-37.84 35.39-15.16 61.88-36.5 88.28-56.61 25.51-19.45 50.92-37.73 84.86-47.42a5.55 5.55 0 0 0 3.8-6.86c-.83-2.93-3.91-4.66-6.85-3.81M8075.69 4132.96c-10.12-35.44-27.64-63.43-42.68-92.37-14.49-27.86-26.62-56.65-26.62-94.54 0-9.95-2.09-28.87-8.36-42.41-4.96-10.69-12.61-18.01-22.8-18.01-3.06 0-5.54 2.47-5.54 5.53s2.48 5.56 5.54 5.56c6.04 0 9.8 5.25 12.74 11.58 5.57 12.05 7.33 28.89 7.33 37.75 0 39.91 12.61 70.3 27.87 99.65 14.72 28.3 31.96 55.63 41.87 90.32.84 2.93 3.91 4.63 6.85 3.81a5.55 5.55 0 0 0 3.8-6.87"
      clipRule="evenodd"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M7581.2 4000.58c0-11.28-3.93-32.43.96-42.2 3.82-7.64 9.59-16.26 9.59-25.44 0-3.48-3.43-23.01-5.75-23.01M7619.09 4043.26c-21.21 0-43.74-5.7-65.23-2.4-6.08.93-12.5 2.4-18.7 2.4-7.32 0-15.47 4.07-22.06 6.7-1.16.48-15.45 1.36-16.79 0M7649.78 4058.08c6.1-24.43 12.3-38.29 26.37-59.42 10.75-16.12 34.16-25.67 23.98-46.03M7750.49 3911.85c2.67-14.66 7.7-33.1 17.26-45.07 10.01-12.51 20.91-24.96 25.42-40.77 2.01-7.02-5.57-16.04-8.15-22.05-.79-1.84-1.46-7.19-3.36-7.19M7771.59 3993.4c-13.25 4.42-24.02 21.95-35.01 30.2-2.61 1.97-4.86 6.75-7.67 8.17M7830.58 4037.51c-2.18-14.21-7.22-27.03-9.59-41.24-2.06-12.37 2.49-25.86 4.79-37.41 2.63-13.12 16.13-22.96 20.63-36.45 1.52-4.55 2.2-15.19-2.88-17.75M8014.74 4009.2c4.67-10.88 6.23-27.51 14.87-35.95 10.62-10.4 28.22-17.13 34.53-31.66 3.77-8.7 7.17-29.8 4.31-39.8-1.66-5.8-3.84-12.48-3.84-18.71M7995.08 3932.95c-27.01 0-59.51 13.7-83.93-.96-15.36-9.21-19.98-31.45-31.65-44.6-2.64-2.98-6.73-14.39-11.51-14.39M7554.34 4148.3c-8.81 8.8-14.65 16.57-21.1 27.32-5.21 8.7-7.8 19.21-13.91 27.33-12.6 16.81-28.97 31.34-47.47 41.26-13.9 7.43-29.49 16.71-45.09 19.19M7506.39 4153.09c-7.34-7.34-12.4-17.11-20.15-23.97-17.76-15.81-38.01-26.08-59.95-34.06-7.91-2.87-15.32-8.62-22.54-12.96-1.38-.82-5.75-3.59-5.75-5.26M7632.03 4246.14c-1.39 6.94-5.68 11.89-8.15 18.7-1.96 5.38-2.35 11.92-6.71 16.31-4.96 4.95-11.56 10.67-15.83 16.28-8.14 10.73-14.4 19.56-24.94 27.84-8.78 6.89-21.71 13.46-31.65 18.7M7677.59 4212.56c-7.49-5.14-17.47-15.25-26.37-18.23-17.73-5.91-37-5.53-55.15-10.08-4.03-.99-24.46-8.6-24.46-11.98M7887.65 4209.68c-4.41-3.8-10.7-10.21-16.31-13.43-16.54-9.45-39.86-8.97-57.55-14.88-9.9-3.3-13.47-9.15-20.62-16.31-1.81-1.78-9.38-7.18-8.15-7.18M7833.16 4239.96c-9.16 12.82-14.47 27.64-26.38 36.93-9.1 7.1-23.15 8.25-33.09 15.35-8.34 5.96-19.49 9.44-28.77 13.41"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.095}
      d="M9324.51 4113.84c-.8-1.57.26-3.67 2.23-2.68M9213.34 4122.49c-44.06 0-41.48 92.01-16.57 115.34 12.72 11.9 30.17 16.82 41.05 30.89 9.24 11.98 15.17 26.8 21.18 40.58 9.55 21.95 11.68 44.88 7.45 68.35-.58 3.33-11.36 35.44-6.25 37.14M9541.59 4123.98c-.72-.72 5.4-6.89 5.51-7 10.99-12.02 19.85-22.24 21.04-39.08 1.87-25.97-4.23-52.61 8.36-77 12.45-24.16 36.74-36.16 57.28-52.53 28.55-22.72 48.29-68.56 56.86-102.8M9716.16 4101.9c0-1.04-.35-1.09.45-1.49 19.24-9.61 41.51-9.74 57.87-26.1 13.81-13.81 13.49-38.24 23.73-54.47 16.82-26.63 44.33-45.31 62.08-71.91M9620.06 4121.75c-5.35 1.35 16.04 19.05 15.37 30.43-1.25 21.21-22.51 44.36-19.23 64.77 3.03 19.1 41.85 37.11 26.39 60.29M9397.01 4530.14c6.2-6.2 17.11-8.31 22.83-16.87 17.35-26.02-9.52-59.1 9.39-88.63 10.51-16.36 50.45-36.85 50.45-57.15M9607.52 4530.72c-.34-.35-.58-.61-.87 0-10.83 21.63-13.52 43.98-16.42 67.9-6.04 49.51 62.79 78.27 24.02 138.59M9674.81 4508.93c60.64-22.99 18.89-49.84 38.05-88.18 14.26-28.52 46.88-46.67 64.6-73.25M9334.35 4545.94c-13.65 10.21 4.63 38.74 11.63 47.44 29.93 37.27 81.02 48.63 81.02 104.3M9438.65 4786.14c0-7.9 27.94-40.12 34.91-42.81 14.21-5.5 29.48-1.94 43.1-10.75 17-10.96 10.35-47.54 23.12-52.65M9004.16 4222.32c-6.09 12.21-6.04 30.86-16.55 43.72-13.81 16.86-38.55 21.84-47.46 42.81-15.78 37.17-7.03 84.84-30.73 118.02M9105.16 4432.54c-52.6 26.31-47.6 80.86-71.3 125.18-12.7 23.76-36.11 29.48-53.11 48.19M9085.63 4795.41c6.49 0 16.63-10.62 21.47-14.32 39.52-30.33 18.84-58.59 25.52-99.67 2.1-12.95 10.14-23.78 15.96-35.22 2.27-4.39 12.96-40.87 16.42-40.87M9254.98 4845.53c2.16-19.47-11.54-36.4-7.61-56.09.11-.63 45.87-66.59 53.4-77.87M9181.26 4844.95c-8.81-8.81-17.43 52.57-17.75 56.83-4.34 57.87 62.68 99.56 30.73 155.49M9399.41 4901.35c1.06-3.27 14.76 34.59 15.96 44.91 3.99 34.7-4.92 77.56-36.27 98.47M8959.25 4844.2c-7.93-23.79-52.68 25.27-56.25 30.44-22.16 32.03 5.11 56.59-8.48 86.52-12.38 27.22-52.53 41.03-73.28 61.78M8749.93 4738.11c-8.08-6.06 31.37-9.84 32.36-9.55 21.79 6.55 33.58 36.45 53.13 47.89M8718.3 4379.43c-13.04-19.55-62.61 35.42-67 41.48-20.8 28.63-.42 70.32-28.78 106.67-11.02 14.1-46.51 28.87-49.71 46.4M8551.64 4964.3c57.25-28.63 79.26 39.01 114.59 68.33 26.02 21.63 63.54 31.82 96.82 33.28M8396.92 4801.68c-10.67-5.34-33.1 27.62-45.51 31.19-83.75 23.92-117.48 24.79-189.78 80.4M8004.37 4732.29c-14.79 14.79-14.88 59.76-24.92 79.82-15.7 31.4-41.12 57.55-58.48 88.17-21.74 38.37-31.95 87.14-44.02 129.37M7795.49 4823.31c-6.36-25.46-45.14-39.43-66.69-41.63-63.91-6.52-116.24 18.22-178.59-10.89M7904.86 4544.45c-7.02 2.34-45.57 45.63-72.07 58.19-58.94 27.91-129.63 33.58-185.15 67.74M8020.48 4539.23c-11.9-23.81-8.19-51.03-31.48-70.72-19.14-16.2-108.17-38.47-108.17-63.43M8170.58 4561.61c-4.79-5.99-1.77-76.79-8.05-94.62-10.45-29.58-55.2-65.96-50.58-98.31M8391.25 4390.18c0-35.28-38.96-54.78-55.95-80.27-18.65-27.99-14.92-59.44-14.92-91.02M8336.49 4503.26c-16.64 24.95-33.75 116.14-32.82 145.94 1 32 11.75 61.86 4.18 94.42-7.9 33.95-33.18 33.69-48.49 57.74M9096.06 5054.58c-7.26-3.65-41.8 54.28-46.08 63.11-20.2 41.37-9.85 88.09-28.2 130.11-16.23 37.06-56.33 57.12-73.12 93.25M9196.02 5179.31c36.64-36.61 78.15 24.88 115.8 33.58 38.95 8.96 68.56-13.97 103.26-26.13M8320.98 4981.91c-18.58 9.29 27.85 94.19 30.43 103.4 14.47 51.64-6.76 109.3.9 162.94M8507.04 4848.67c-52.19 16.07-47.39 105.12-65.51 143.83-9.74 20.81-33.95 35.02-41.03 56.25M8611.31 5219.89c-18.46-10.57-42.54 19.55-51.61 32.38-20.86 29.45-23.58 68.14-45.95 96.39-22.09 27.83-62.01 31.56-81.92 64.74"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8647.74 5354.33c3.94-15.86 39.24-20.83 50.42-17.77 34.43 9.47 43.26 50.07 86.98 53.42 31.21 2.4 58.96-22.37 90.11-22.37M9241.92 4265.66c19.69-19.68 48.85-11.17 76.58-24.82 14.66-7.21 31.98-29.37 42.78-32.99M9185.12 4219.02c2.84-2.85-8.44 4.02-9.4 4.84-6.01 5.11-12.05 10.27-16.6 16.79-12.34 17.75-7.85 41.48-21.55 58.11-4.15 5.03-9.23 8.86-14.13 13.14-.9.78-8.14 7.4-6.7 7.11M9271.37 4371.59c-3.45-2.32 15.94-6.52 17.49-6.44 11.97.77 21.87 9.9 33.39 12.48 32.06 7.1 55.6-19.48 84.1-26.58M9618.01 4216.15c1.73-.85-16.5-1.06-18.5-.88-11.6 1.01-23.99 7.85-33.17 14.61-12.83 9.42-19.88 29.27-34.19 35.68-18.42 8.22-38.88 5.29-57.71 14.71M9638.76 4251.91c22.96-34.43 74.15-11.55 103.55-35.07M9809.09 4007.15c-1.33 2.69.75-5.99.51-8.99-.48-6.36-2.23-12.72-4.55-18.68-10.48-26.77-14.29-27.22-5.24-54.33M9786.19 4063.69c-.61-1.22 8.41-.27 9.39 0 6.55 1.62 9.93 6.09 12.53 12.05 10.01 22.86 25.15 18.36 46.75 17.78M9732.34 4404.39c-5.08-2.02-2.05-20.91-5.14-29.45-4.04-11.1-14.76-18.02-19.66-28.55-7.9-17.01-4.12-43.29 1.68-60.67M9714.14 4462.58c6.78-6.76 19.07-6.47 28.17-10.46 23.07-10.16 57.79-28.07 83.2-28.07M9603.29 4635.02c-1.81-.59.08-2.85.88-3.94 5.69-7.85 17.64-17.45 27.78-17.69 8.22-.22 15.4 4.52 23.89 4.25 15.62-.53 36.03-13.67 48.64-23.14M9622.34 4694.11c3.09-6.15-30.89 9.58-35.07 13.25-10.82 9.47-16.84 22.69-27.27 32.51-8.99 8.46-21.79 13.36-28.76 23.82M9392.41 4635.31c14.26-7.13 17.05-26 30.44-33.21 14.23-7.66 41.24-1.59 63.72-12.82M9421.67 4463.37c-1.49-.58 2.19-3.77 2.85-4.33 8.94-7.56 19.72-12.59 31.93-10.38 13.68 2.47 23.36 15.67 37.14 17.37 14.1 1.76 25.41-7.92 38.85-10.16M9469.59 4390.55c-2.84 5.7-21.55-14.92-23.12-17.4-7.9-12.26.19-24.87-2.98-36.45-2.05-7.5-11.41-15.4-16.39-20.94-2.28-2.55-10.64-13.65-14.52-13.65M9023.64 4569.7c0 .02-5.75-7.13-7.1-8.49-3.84-3.83-12.4-6.09-17.59-6.73-7.29-.88-13.89 4.04-21.15 3.56-9.42-.64-45.21-14.95-49.81-24.1M9053.38 4518.32c23.47 0 19.08 39.32 33.02 53.45 2.58 2.63 20.44 18.01 24.22 10.48M8933.15 4369.99c0 4.68 10.16-4.37 13.92-1.57 24.16 17.96 19.79 65.26 68.08 45.95M8953.4 4293.04c0-11.06-26.5-7.92-33.29-10.19-18.78-6.25-34.64-49.54-25.11-66.19M9132.94 4739.56c0-20.25 37.01-17.99 45.34-20.25 17.88-4.84 36.08-18.39 52.68-26.69M9135.2 4677.03c-.05.02-3.75-2.34-6.41-3.86-5.53-3.17-11.76-4.82-17.59-7.32-13.89-5.96-23.33 3.65-33.02-13.83-.9-1.68-5.16-8.86-2.95-11.07M9273.45 4758.34c-6.12-3.06 11.87-3.38 12.56-3.17 3.64 1.2 8.65 11.28 10.45 14.42 14.03 24.56 36.61 7.69 56.33 8.99M9184.21 4963.99c0-11.18 26.69-12.46 31.13-12.27 21.21.91 65.8-1.65 77.77-25.6M9204.88 5023.05c-14.39-7.19-35.54 6.06-50.79 6.84-8.17.4-29.8-16.66-35.57-22.43M9418.51 4983.54c19.72-23.68 59.84-8.09 84.29-17.7 4.58-1.78 8.46-4.12 12.53-6.81 1.07-.69 18.71-15.16 15.43-16.79M9393.6 5028.29c-21.47-21.44-49.19 5.75-72.52 12.67-7.85 2.31-20.6-1.12-26.88 2.84M9668.21 3910.07c-1.94-3.92 10.75-6.5 13.79-6.68 10.37-.64 19.63 4.09 30.04-.16 16.68-6.79 26.87-39.59 45.41-39.59M9638.65 3941.3c-1.86-5.59-10.05-6.33-14.63-8.2-6.94-2.84-13.28-9.15-17.61-15.08-15.01-20.57-10.43-38.93-12.93-61.57M9257.41 4415.7c-12.24 6.11-12.35 19.26-22.51 26.66-8.68 6.27-25.89 2.44-29.96 15.45M9640.94 4278.75c3.46 0-5.51 4.15-7.95 6.6-5.86 5.83-11.92 11.44-17.78 17.3-9.2 9.2-6.68 20.86-14.47 28.65-8.38 8.36-22 6.39-31.08 14.56M9481.73 4371.51c-3.04-1.02-1.12-9.48-.08-11.58 5.32-10.61 17.72-11.49 25.57-18.92 3.88-3.64 5.27-24.77 8.27-25.27M9779.35 4351.52c3.32-6.65 7-9.65 7.34-18.01.27-5.99-2.61-13.52-.53-19.29 2.45-6.84 11.92-9.5 15.25-16.31 2.2-4.58.34-13.28 4.44-16.47M9861.81 3946.67c-.48 2.77.82-14.18-1.84-20.75-4.98-12.27-20.04-16.74-23.68-30.39-4.9-18.17 22.16-59.22 10.83-70.56M9861.19 3950.53c8.12-14.23 28.07-29.74 31.69-38.79 8.2-20.51-3.75-37.04 11.55-55.37"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9780.07 4352.24c0-15.06-17.24-26.34-14.37-43.55 1.3-7.88 19.02-41.27 8.81-46.38M9707.27 4104.67c-1.2-1.2 10.22-.46 11.44-.11 6.07 1.73 8.46 10.32 9.02 15.7 2.48 23.46-7.55 33.47 19.53 38.76 5.93 1.17 14-1.01 18.23 4.26M9618.88 4737.64c-17.29 17.29 2.34 37.43 5.25 57.92 1.96 13.78-5.35 25.41-5.35 38.29"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9618.35 4735.83c.03.05-14.23 10.88-18.22 14.87-8.62 8.65-7.42 21.58-14.77 29.99-8.09 9.23-22.8 11.89-31.61 22.48M9427.9 4701.4c-5.27 21.05 22.32-3.19 30.97-9.84 4.66-3.57 23.82 2.04 23.82-3.94M9424.26 4701.48c-5.27 10.53-10.97 34.27-6.9 46.48M9539.49 4686.61c8.57-17.16-5.03-64.87 16.1-73.33"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9537.97 4687.62c-1.65 3.27 14.48-10.62 17.72-11.66 18.04-5.77 19.64-.21 35.13-12.13M9262.75 4416.63c0-1.36 12 6.47 17.41 14.9 12.29 19.18 11.22 31.13 37.06 27.35M8910.56 4427.67c-5.08 2.55 13.3 35.33 13.97 43.23.64 7.56-1.94 14.56-4.66 21.48-1.41 3.59-6.46 13.67-3.75 10.93M8906.52 4429.4c-1.36-1.33-9.77 10.33-10.94 11.44-14.87 14-15.54 29.78-18.33 49.33M8983.35 4605.3c-3.96 0 16.16 37.17 13.79 48.69-.54 2.66-3.75 16.41-7.8 16.41M8980.83 4602.95c-13.15 0-31.93 36.08-33.82 45.58M9162.79 4613.28c6.31-18.89-37.43-33.02-16.71-53.77M9166.14 4607.03c-2.26 2.23 6.02 2.36 9.21 2.6 9.44.75 16.39-5.05 24.82-5.05M9414.94 5187.16c0-8.89 10.41-16.15 13.07-25.09 2.21-7.29-1.2-15.01-.43-22.43 1.89-17.83 20.97-27.33 34.78-34.78M9417.9 5183.22c-.91-.45 11.47 2.48 13.57 3.09 8.25 2.39 15.83 6.49 23.01 11.09 26.26 16.9 43.88 4.5 71.95 2.03M9361.17 5206.16c-5.19 3.73-2.02 15.17-1.09 19.93 3.33 16.92 12.72 30.94 19.48 46.48 2.37 5.46 2.07 14.21-2.77 18.25M9305.56 5208.44c-.63 1.1 1.28-6.97 1.41-8.7.54-5.88-.85-11.7.7-17.56 4.39-16.65 21.92-29.21 23.25-46.24M9379.88 5043c-6.36 2.13-10.75 23.39-10.57 29.11.32 8.97 8.39 14.13 11.47 22.09 4.21 10.72.16 21.79-4.36 31.63-1.44 3.09-3.43 10.11-6.55 11.84M9374.56 5046.33c-12.46 0-30.84 15.62-38.29 24.56-2.77 3.33-2.96 8.22-6.15 11.23-4.04 3.75-11.31 4.92-16.1 7.69M9196.56 5054.61c-1.87.26 5.72 4.09 5.85 4.2 5.43 3.51 7.69 8.19 10.61 13.73 5.41 10.27 10.2 35.23 22.33 40.09M9193.47 5060.33c-8.22 1.65-7.79 10.21-6.52 17.16 2.82 15.59 14.21 27.03 18.23 41.8.93 3.35.02 20.96-7.32 17.83M8947.09 5333.92c-7.74 7.72 10.48 31.8 12.83 40.87 3.48 13.52-8.07 27.51-9.93 41.08M8944.19 5336.5c-23.41 10.94-28.39 48.82-56.59 52.36M8969.23 5306.73c-.93 2.82.08-6.01-.61-8.88-1.33-5.48-6.15-8.57-10.81-11.23-11.09-6.33-37.96-7.69-36.5-23.92M9005.97 5269.29c-3.59 0 7.13 1.47 10.3 3.14 7.26 3.89 14.08 9.21 19.66 15.3 19.82 21.53 35.74 37.44 65.8 44.28M9032.79 5200.91c.24 3.73-.72-5.56-2.63-8.08-3.81-4.93-10.75-7.05-16.79-6.95-9.42.13-17.77 6.73-27.25 6.47-18.38-.51-35.97-24.35-44.75-38.66M9050.3 5120.08c-.27.08-6.39-15.03-9.61-16.84-6.43-3.62-14.26-4.33-20.4-8.56-13.44-9.24-18.33-27.14-21.53-42.1-1.04-4.92-4.33-13.06-2.9-18.14M9042.61 5154.38c0 .45 13.41-1.73 14.9-1.62 6.73.53 12.27 5.85 16.71 10.29 14.42 14.43 16.02 38.32 33.79 50.58 8.19 5.62 18.54 4.47 27.19 8.81M9283.19 5203.82c-5.43-1.81-6.73 24.34-5.86 28.31 2.56 11.52 15.3 16.92 21.88 25.56 9.1 11.98 14.68 29.57 16.65 44.41M8883.02 4983.83c-.18-.43 6.41 5.8 7.72 8.3 3.78 7.32 6.68 15.94 7.1 24.19.72 14.23.99 25.72 8.76 38.28 7.02 11.39 18.7 19.51 23.78 32.2M8894.2 4913.22c-2.98 1.49-7.59-1.68-10.99-1.31-6.6.75-13.54 3.89-20.22 1.73-22.09-7.1-40.68-39.27-42.23-60.85M8918.17 4868.65c-8.62 5.16.4 25.62 4.02 31.18 7.93 12.29 22.45 18.6 32.06 29.43 13.52 15.22 13.54 30.81 16.02 49.7M8819.96 5025.26c-10.35 13.81 3.81 34.8 10.11 46.61 7.03 13.12 6.1 25.12-2.47 37.49-2.61 3.78-6.39 8.38-10.16 11.04M8815.95 5027.09c-9.88 0-26.4.45-33.48-7.39-6.99-7.72-6.59-24.4-6.59-34.27M8762.26 5068.6c-3.57 0-8.12 11.31-9.64 13.68-3.83 6.04-11.04 14.82-10.35 22.4 1.15 12.61 8.09 19.74 4.5 33.66-.75 2.87-1.62 7.87-4.82 9.07M8768.05 5069.64c-4.47-.43 5.22-7.61 9.18-6.95 4.87.8 7.88 6.34 13.2 5.4 6.6-1.14 8.17-9.81 13.25-11.52M8713.22 5346.93c0-7.29-3.65-17.72.64-24.24 7.45-11.38 25.41-11.62 33.34-23.86 7.34-11.28 2.26-28.5 11.54-38.77M8794.05 5389.48c1.49-.98 1.68-6.78 1.81-8.41.66-9.39-3.57-17.77-.88-27.43 3.73-13.35 18.95-17.66 25.54-28.92 6.34-10.83 3.86-25.43 6.04-37.41M8755.76 5379.1c-2.36-2.36-6.36 4.77-7.26 6.07-4.71 6.76-8.57 16.12-7.48 24.53 2.13 16.02 22.51 23.89 23.31 42.23.35 7.53-3.94 15.53-7.69 21.76-.45.75-5.19 8.62-6.12 6.49M8879.7 5366.6c0-12.29-5.19-29.8-4-42.68 1.02-11.09 10.22-18.2 10.22-30.62M8658.65 5030.07c-7.16-1.81-12.83 20.46-12.83 24.91 0 7.13 5.72 13.57 8.52 19.79 6.94 15.35 10.14 44.38-6.65 55.13M8618.84 4980.32c0-4.79 2.11-8.84 1.04-13.84-1.57-7.34-8.35-17.08-5.19-24.66 4.74-11.28 18.28-14.58 22.03-26.82 3.6-11.79-.63-24.67 2.82-36.61M8471.84 5381.81c-5.14 3.09 11.79 25.25 13.01 31.21 3.83 18.73-6.81 38.05-.18 56.3M8515.61 5344.59c0-22.93-29.03-21.71-43.26-28.3-10.47-4.85-13.86-21.48-15.31-31.59M8551.37 5260.54c0-18.68-20.44-26.79-32.67-37.3-15.97-13.73-19.99-37.91-11.15-57.34M8542.94 5295.45c-.88.37-2.98 1.09-2.53 2.34 1.28 3.54 6.89 5.8 9.5 8.51 5.56 5.77 9.81 13.14 12.58 20.7 7.74 21.31-.56 44.54 5.11 65.75M8402.91 5053.19c-.77-1.17 4.74 18.79 6.6 22.57 7.22 14.68 19.48 23.09 19.73 41 .07 4.95-.28 14.34-6.35 15.78M8397.3 5051.95c-14.34 14.34-8.56 35.89-4.63 53.1.97 4.23 4.73 19.66-1.11 22.01M8427.51 5010.65c-4.72-9.47-7.44-17.64-19.48-20.67-7.17-1.78-14.39.85-20.97-3.62-9.93-6.76-11.29-22.7-10.72-33.55M8459.2 4929.07c-7.34-9.79-25.78-18.44-28.24-29.9-1.67-7.8 1.81-16.39 2.84-24.06 1.68-12.47.73-25.43-4.87-36.61M8451.13 4970.55c0 2.51 5.07 3.81 6.53 4.45 5.19 2.34 9.43 6.09 12.77 10.67 7.43 10.19 9.29 40.68 22.86 44.96 4.87 1.52 9.47-1.62 14.31-.88M8353.83 5252.35c0 2.29 8.9 8.46 10.48 9.92 10.24 9.5 27.76 16.6 34.1 29.3 1.15 2.28 6.02 19.82 1.11 20.51M8351.24 5248.09c-8.66 12.99-9.94 38.26-4.38 52.15 2.98 7.45 10.17 14.45 10.67 22.75.93 15.62-12.12 26.42-16.71 40.23M8352.41 5172.6c-.51.27-6.17-3.64-7.4-3.88-5.68-1.09-11.83-.83-17.02 1.91-11.38 6.04-18.79 17.22-29.1 24.61-12.11 8.7-25.75 12.03-39.46 17.22M8348.71 5085.55c-3.38-6.76.38-26.5 4.5-32.44 4.62-6.62 12.18-8.14 15.48-16.44 3.36-8.49.95-21.15 6.04-28.81M8363.26 5141c-.77 0 1.91-.19 2.72 0 2.85.61 5.74 1.11 8.38 2.44 6.13 3.12 9.61 8.12 12.27 14.27 4.36 10.03 8.5 27.48 18.13 33.76 14.3 9.37 33.68-1.06 42.36 14.13M8779.58 4722.47c0-16.25-10.17-27.85-11.23-43.9-1.07-16.02 9.07-26.82 11.84-41.66 2.55-13.65-2.64-31.88 1.59-44.6M8811.58 4755.89c-8.11.48-13.14 14.26-14.5 20.73-2.71 12.9 3.73 26.74-.24 39.08-6.3 19.59-24.66 33.39-26.02 55.18M8838.96 4779.33c0-5.21 8.3-4.12 11.02-2.47 11.73 7.07 36.87 31.1 49.14 9.63"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8842.29 4778.59c-5.22 1.94-3.22 15.91-3.09 19.84.19 6.2-.21 13.87 2.96 19.43 6.2 10.93 23.68 20.56 15.96 36.02M8574.12 4578.88c3.64 0 12.93 9.63 15.54 12.21 11.94 11.76 16.92 33.68 14.55 50.12-1.57 11.1-5.29 22.62-2.53 33.85 3.57 14.47 14.48 26.07 17.78 40.95M8570 4580.79c-12 5.4-9.77 31.21-9.93 41.43-.29 19 8.41 33.36 12.88 51.06 3.64 14.37-2.66 37.3-11.57 48.77M8626.72 4527.9c0 2.98 6.68 6.84 8.65 8.75 3.91 3.83 6.25 9.79 7.5 15.03 3.91 16.15.98 33.16 3.78 49.47 2.84 16.71 11.49 31.69 14.28 48.53M8637.84 4456.91c-3.4-8.46-10.72-1.35-16.28 2.53-10.59 7.4-24.69 20.62-32.68 31.02M8160.41 4916.65c-2.58 0-1.29 10.43-1.29 11.76 0 14.18 11.58 21.47 13.56 34.53 3 19.77-19.85 41.14-23.74 60.56M8155.05 4919.29c-27.22 10.9-33.53 41.66-49.82 63.4-6.72 8.97-19.48 10.96-25.28 19.66M8248.83 4869.61c-9.79 2.79-11.25 22.24-9.62 30.2 2.13 10.4 9.25 19.1 12.39 29.16 3.48 11.12 2.43 23.17.62 34.53-.91 5.73-1.88 16.02-7.28 19.61M8206.11 4883.71c-2.17-1.44-.75-10.86-1.48-13.3-2.11-7.16-9.2-12.94-15.66-16.05-18.01-8.7-60.39-5.4-63.07-31.37M8318.56 4844.94c-1.86-2.79-2.37-6.62-3.51-9.74-10.12-27.67 14.98-31.05 27.13-51.99 8.09-13.94 7.39-32.54 9.25-48.02M8258.75 4799.87c-5.53 1.38-9.13 9.28-15.66 8.3-23.4-3.49-36.09-36.29-61.04-34.51M8258.69 4808.25c-11.28 4.1 1.33 28.95 7.46 31.69M8309.38 4716.75c-5.48-7.05-5.76-21.23-15.48-24.61-7.05-2.45-15.81 4.5-22.2 6.17-12.4 3.25-26.99-3.93-37.42-9.92-3.59-2.08-9.06-4.23-10.48-8.51M8302.65 4648.43c3.19-6.36 17.43-7.59 22.88-5.25 15.75 6.82 21.23 29.11 39.21 34.65 9.71 3 23.71-2.42 33.79-3.75M7975.1 4821.67c-.38-.08 7.97-2.13 9.19-2.29 7.46-1.04 14.05-1.36 19.79 4.39 4.74 4.73 7.26 12.66 13.44 15.88 4.28 2.26 8.71-.53 12.52-2.45 9.54-4.84 16.99-10.32 28.11-11.22M7915.42 4906.89c-5.41 1.78-10.97 1.09-16.28 3.51-13.61 6.15-29.6 20.33-40.45 30.57-7.65 7.24-13.36 18.12-21.7 24.24-7.2 5.27-19.19-3.3-28.24 3.38M7879.22 5023.72c-3.74 20.57 18.88 23.55 27.32 37.62 16.17 26.95 15.76 60.85 29.22 89.27M7873.92 5036.11c-2.59-7.77-21.63 17.46-24.29 19.98-15.33 14.43-36.55 32.38-57.77 36.62M7892.23 4966.3c-2.87-4.31 11.51-2.29 12.15-2.16 9.05 2.03 16.98 7.13 22.63 14.45 10.27 13.28 14.25 26.53 30.15 34.7 10.32 5.32 22.18 4.89 32.31 10.43M7933.01 4886.14c-3.15-3.16 3-1.2 6.6-1.78 7.58-1.28 16.09-1.12 21.52 5.11 5.44 6.25 5.91 15.27 10.6 22.08 9.07 13.12 27.59 23.79 42.55 28.79M7961.66 4843.54c-4.93-8.2-25.93.74-31.45 2.55-26.23 8.6-50.28 19.42-77.25 6.52M7552.81 4768.08c2.4 1.19-4.46-10.22-4.68-10.54-4.75-6.76-10.68-13.97-12.27-22.27-3.36-17.45 13.34-35.23-1.73-50.98-3.43-3.59-6.62-6.46-10.85-9.07M7554.78 4770.12c-15.09 2.51-43.05-1.06-52.16 12.27-7.14 10.43-8.01 24.61-11.28 36.56-.77 2.82-2.17 11.6-6.29 11.6"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.554}
      d="M7612.69 4784.25c-3.77 0-7.48 23.44-8.15 26.34-4.44 19.18-11.49 63.85-40.94 61.7"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M7629.39 4788c0-13.22 10.22-22.21 2.71-36.87-8.09-15.83-44.71-29.59-32.74-52.79M7719.23 4778.43c-.59.1.37-6.12.3-7.03-.3-4.44-1.9-8.94-3.94-12.88-12.23-23.54-25.65-40.78-6.6-66.41M7704.96 4779.01c-4.6-.93-3.79 5.8-4.38 9.18-1.86 10.7-4.36 21.31-9.06 31.16-8.49 17.77-29.78 24.61-39.34 42.09M7648.75 4671.66c0-17.4-22.34-20.86-33.54-30.36-12.27-10.38-18.73-27.8-22.51-42.89M7647.39 4673.31c2.07-1.04-2.94 3.61-4 5.66-2.4 4.63-3.92 9.85-4.63 14.98-1.71 12.48 6.31 26.4 14.49 35.23M7705.6 4641.24c-.27 1.89-.29-3.59-.37-4.26-.35-3.03-1.01-6.01-2.28-8.8-3.84-8.49-7.73-21.77-14.37-28.18-8.39-8.12-27.8-3.99-38.66-6.17-1.97-.4-10.6-.7-10.6-3.89M7772.68 4622.38c-11.79 7.37-5.79 30.62-1.54 40.81 4.67 11.23 15.51 16.82 22.26 26.4 9.09 12.9 6.3 36.45-1.98 49.33M7825.52 4600.06c-.37.45-1.58 2.71-2.09 2.71-.21 0-1.39-4.02-1.48-4.18-1.23-2.2-3.37-3.96-5.31-5.5-8.07-6.34-16.33-9.37-26.32-11.9-20.43-5.19-35.92 10.99-53.95 15.86M7984.97 4464.79c-3.05 1.3.3-19.08 2.9-22.14 4.92-5.8 16.81-3.88 23.36-8.14 17.62-11.47 11.04-38.85 29.97-48.03M8008.4 4485.86c0 .93 9-1.07 9.8-1.18 5.23-.58 10.76-.77 15.97.08 11.23 1.81 21.56 10.91 32.99 10.91 12.2 0 25.17-11.76 34.34-18.57M7906.54 4435.07c-2.02 0-4.54 6.33-5.92 8.06-5.75 7.26-11.63 15.59-18.93 21.34-11.7 9.23-36.21 9.04-50.37 12.95M7878.05 4407.69c-3.54 0-7.31-3.09-10.91-3.65-8.24-1.27-18.91.78-26.57 3.6-14.46 5.26-25.86 18.46-40.14 22.85M7892.3 4425.01c-2.33 0 1.7-4.68 1.97-4.92 4.63-4.36 10.75-7.29 16.15-10.48 14.57-8.65 32.07-13.71 44.27-25.92M8145.95 4432.97c7.33 5.48 27.6 6.09 35.27 1.12 8-5.22 13.39-14.61 19.98-21.34 13.44-13.73 32.16-24.43 51.42-26.9M8172.53 4507.39c9.84-4.93 23.34 6.38 32.61 7.9 12.36 1.99 36.25-9.9 47.66-14.98M8125.33 4411.07c3.04 6.07-7.01 14.71-10.79 17.32-11.72 8.12-40.56 21.45-54.99 16.05M8330.37 4295.52c4.92-12.27 28.85-10.75 37.12-20.94 9.5-11.73 7.49-29.51 13.25-43.05 6.76-15.88 20.67-26.58 30.95-39.96M8321 4246.88c-12.82 0-24.41 8.54-37.12 10.3-12.54 1.73-24.38-3.01-36.75-2.77-6.42.13-14.88 2.61-18.74 8.06M8350.41 4329.25c-7.76 5.83-6.97 19.93-12.52 27.7-13.13 18.39-39.8 20.09-41.06 46.54M8373.71 4349.37c5.22-10.46 2.57-22.88 9.07-32.94 6.45-9.98 20.02-14.74 24.17-26.13M8319.39 4221.92c5.61-11.23 12.49-21.93 21.64-30.52 6.25-5.88 14.02-8.59 19-16.04 6.37-9.55 7.43-21.58 10.6-32.38M8318.35 4220.06c0-21.53-5.2-37.3 9.68-56.41M8112.47 4368.84c-1.8 0 .21-5.11.5-5.75 2.13-4.78 6.73-10.03 11.22-12.55 6.08-3.46 12.14-2.08 18.62-3.41 9.4-1.92 29.56-14.53 31.38-25.46M8107.42 4371.42c0-16.2-13.91-30.94 1.54-43.82M8161.71 3980.28c-1.72 1.7.98 5.14-.19 7.26-4.52 8.25-12.66 17.06-12.45 26.96.57 27.7 15.72 42.22 2.71 70.11M7576.95 4257.6c-16.6 0-33.89 26.15-37.92 40.57-2.65 9.47-2.01 18.84-9.19 26.53-3.5 3.75-9.57 4.1-14.24 5.16M7577.88 4255.92c-25.64 0-29.12-15.61-40.26-35.57M7708.77 4279.55c-6.79-2.71-10.9 7.24-13.81 11.84-4.19 6.68-7.98 13.73-7.77 21.85.24 8.88 6.41 24.63-2.95 30.89M7701.62 4280c-2.53 2.53-7.78-1.41-10.85-1.73-13.02-1.35-23.53-2.92-31.94-14.13M7524.54 3935.1c-28.47 0-22.03-25.84-28.73-45.93"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M7521.52 3939.94c0-8.06-8.16-4.13-13.07-1.92-12.26 5.54-26.71 8.52-38.35 14.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M8926.5 3734.94s-353.61 359.19-491.51 569.38c-137.92 210.19-516.18 468.28-516.18 468.28s439.46-243 577.37-436.35c128.48-180.13 436.35-500.21 436.35-500.21s-165.84 435.74-248.77 653.62c-105.31 276.71-513.51 854.98-513.51 854.98s527.48-595.99 639.89-872.7c82.43-202.87 164.96-635.9 164.96-635.9s34.59 508.83 34.59 763.62c0 262.95-7.98 1000.25-7.98 1000.25s57.66-750.15 74.5-1000.25c15.38-228.32-53.71-747.16-53.71-747.16s114.54 375.06 175.5 559.5c69.18 209.32 258.68 698.51 258.68 698.51S9311.2 4583.69 9250 4373.5c-57.31-196.86-196.5-549.5-196.5-549.5s502.51 382.75 632 549.5c104.17 134.12 364.5 545.44 364.5 545.44s-171.28-437.79-274.04-574.71C9645.14 4169.96 9053.5 3787 9053.5 3787s367.24 186.39 517.11 255.11c139.74 64.1 410.23 174.41 410.23 174.41l-426.3-245.39-506.04-236.19z"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8635.89 4746.71c43.4 37.23 93.63 118.06 100.98 175.16 9.79 75.85 24.05 67.6 35.33 146.52 6.81 47.68 30.7 99.56 30.7 148.81 0 68.06 27.62 140.67 27.62 209.98 0 9.02 27.78 347.51-6.25 153.82-9.58-54.44-32.83-248.94-52.31-307.31-27.96-83.92-22.03-201.18-61.06-279.24-8.62-17.24-40.84-116.06-56.04-146.44-11.65-23.34-32.94-39.3-49.06-55.4"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M8635.89 4746.71c43.4 37.23 93.63 118.06 100.98 175.16 9.79 75.85 24.05 67.6 35.33 146.52 6.81 47.68 30.7 99.56 30.7 148.81 0 68.06 27.62 140.67 27.62 209.98 0 9.02 27.78 347.51-6.25 153.82-9.58-54.44-32.83-248.94-52.31-307.31-27.96-83.92-22.03-201.18-61.06-279.24-8.62-17.24-40.84-116.06-56.04-146.44-11.65-23.34-32.94-39.3-49.06-55.4"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9308.62 4554.24c-1.25-1.25 70.9 8.06 87.85 13.97 9.74 3.4 19.29 7.5 27.78 13.46 55 38.71 102.46 89.9 163.74 118.99 37.59 17.85 77.5 27.99 118.64 27.45 16.07-.21 32.62-3.16 48.07-3.16 2.11 0 80.09-16.02 76.69-12.48-29.19 30.36-125.51 54.33-155.39 55.58-90.73 3.78-194.68-43.5-261.25-102.67-2.23-1.97-4.23-4.21-6.46-6.15-1.73-1.49-3.41-2.79-5.17-4.18-1.73-1.33-3.4-2.71-5.16-3.99-32.22-23.17-82.67-47.94-81.71-48.93"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M9308.62 4554.24c-1.25-1.25 70.9 8.06 87.85 13.97 9.74 3.4 19.29 7.5 27.78 13.46 55 38.71 102.46 89.9 163.74 118.99 37.59 17.85 77.5 27.99 118.64 27.45 16.07-.21 32.62-3.16 48.07-3.16 2.11 0 80.09-16.02 76.69-12.48-29.19 30.36-125.51 54.33-155.39 55.58-90.73 3.78-194.68-43.5-261.25-102.67-2.23-1.97-4.23-4.21-6.46-6.15-1.73-1.49-3.41-2.79-5.17-4.18-1.73-1.33-3.4-2.71-5.16-3.99-32.22-23.17-82.67-47.94-81.71-48.93"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8345.34 4427.93c-9.7-6.46-14.38-18.59-24.63-24.47-56.89-32.52-125.84-35.26-186.19-60.4-49.87-20.78-98.13-53.35-143.94-81.52-39.72-24.45-80.16-52.9-114.14-84.88-27.24-25.62-124.16-99.59-118.27-92.64 27.48 32.38 150.2 152.69 167 168.2 86.23 79.59 164.93 107.36 267.42 152.91 34.6 15.38 69.35 63.83 95.65 75.54 26.7 11.87 34.5-34.16 49.28-51.4 2.05-2.4 9.15-1.84 8.15-4.85"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M8345.34 4427.93c-9.7-6.46-14.38-18.59-24.63-24.47-56.89-32.52-125.84-35.26-186.19-60.4-49.87-20.78-98.13-53.35-143.94-81.52-39.72-24.45-80.16-52.9-114.14-84.88-27.24-25.62-124.16-99.59-118.27-92.64 27.48 32.38 150.2 152.69 167 168.2 86.23 79.59 164.93 107.36 267.42 152.91 34.6 15.38 69.35 63.83 95.65 75.54 26.7 11.87 34.5-34.16 49.28-51.4 2.05-2.4 9.15-1.84 8.15-4.85"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9780.67 4367.54c20.76 0 60.05 11.25 82.86 13.81 61.8 6.86 129.89-7.66 187.67-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.32 89.21-43.74 7.29-72.37 13.2-110.98-9.34-20.33-11.87-5.82-37.28-17.13-51.4-2.88-3.6-6.95.53-4.5 2.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M9780.67 4367.54c20.76 0 60.05 11.25 82.86 13.81 61.8 6.86 129.89-7.66 187.67-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.32 89.21-43.74 7.29-72.37 13.2-110.98-9.34-20.33-11.87-5.82-37.28-17.13-51.4-2.88-3.6-6.95.53-4.5 2.98"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9064 4689.85c-6.68-6.67 25.78 52.74 29.45 61.89 14.05 35.12 35.2 71.01 52.1 105.34 34.48 70.03 78.33 138.65 124.78 201.49 18.79 25.44 44.67 44.65 62.74 70.72 21.47 31.05 45.44 59.36 69.87 87.88 8.51 9.9 20.41 26.08 24.48 38.26.88 2.64 64.01 127.56 64.01 127.56s-93.76-141.71-105.28-150.84c-37.41-29.69-79.42-87.75-103.98-116.46-83.17-97.19-90.01-135.93-168.58-236.32-24.16-30.86-49.75-68.19-49.75-108.15 0-13.81-17.03-41.06-16.63-38.64"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M9064 4689.85c-6.68-6.67 25.78 52.74 29.45 61.89 14.05 35.12 35.2 71.01 52.1 105.34 34.48 70.03 78.33 138.65 124.78 201.49 18.79 25.44 44.67 44.65 62.74 70.72 21.47 31.05 45.44 59.36 69.87 87.88 8.51 9.9 20.41 26.08 24.48 38.26.88 2.64 64.01 127.56 64.01 127.56s-93.76-141.71-105.28-150.84c-37.41-29.69-79.42-87.75-103.98-116.46-83.17-97.19-90.01-135.93-168.58-236.32-24.16-30.86-49.75-68.19-49.75-108.15 0-13.81-17.03-41.06-16.63-38.64"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8565.65 4743.76c4.84-4.84-12.59 5.48-18.65 8.65-11.58 6.06-24.77 7.98-36.77 13.3-36.71 16.34-77.09 30.41-116.31 39.11-54.02 12-110.31 14.82-164.89 23.63-45.48 7.34-90 20.3-135.45 27.62-16.64 2.68-141.98 39.61-149.72 41.42-137.08 32.41 157.22-15.83 172.18-18.78 52.28-10.32 107.86-30.78 160.74-34.62 71.83-5.18 153.96 10.25 223.97-9.31 37.23-10.4 52.29-55.21 66.07-86.2.53-1.23 3.46-7.83 4.66-7.83"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M8565.65 4743.76c4.84-4.84-12.59 5.48-18.65 8.65-11.58 6.06-24.77 7.98-36.77 13.3-36.71 16.34-77.09 30.41-116.31 39.11-54.02 12-110.31 14.82-164.89 23.63-45.48 7.34-90 20.3-135.45 27.62-16.64 2.68-141.98 39.61-149.72 41.42-137.08 32.41 157.22-15.83 172.18-18.78 52.28-10.32 107.86-30.78 160.74-34.62 71.83-5.18 153.96 10.25 223.97-9.31 37.23-10.4 52.29-55.21 66.07-86.2.53-1.23 3.46-7.83 4.66-7.83"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.909}
      d="M9665.55 4051.54c3.3-13.23 29.37-13.6 37.94-12.78 37.22 3.57 65.58 34.7 117.55 31.56 70.48-4.28 75.29-41.9 126.19-60.85 41.64-15.48 85.37-3.48 127.57 1.86M9973.97 4389.92c-5.19-7.77 8.09-26.88 11.58-33.42 22.05-41.19 74.25-36.93 96.75-72 40.1-62.34 1.2-160.28 77.5-202.48M10121.5 4365.17c95.8 22.3 69.6 61.04 128.7 100.63 39.5 26.5 81.7 20.03 125.9 26.37M9986.9 4757.47c-9.26-16.95 53 18.38 66.7 34.61 51.4 60.72 48.5 72.93 129.6 78.41 13.9.93 51 7.85 57.9-9.04M9785.49 4515.98c-54.41 9.61-91.74 52.76-140.56 68.3-26.8 8.51-84.67-6.33-110.5-13.97M9589.53 4752.94c-23.2 5.8-26.5 50.66-18.23 67.23 15.2 30.41 52.55 44.38 69.34 74.66 23.02 41.51 8.76 88.79 11.74 133.54 1.35 20.54 7.45 39.96 7.45 60.82M9404.91 4571.38c17.13-11.44 1.73-91.77 11.3-120.88 17.43-53.05 69.63-81.1 112.36-113.16M9342.59 4811.5c-38.68 0-65.23 48.82-59.75 83.86 2.82 18.02 15.85 31.75 16.36 50.88.45 16.63-11.92 54.19-34.46 51.37M9396.53 5227.37c-8.84-23.95 43.95-38.05 57.36-33.13 18.54 6.79 28.44 24.93 44.59 35.39 55 35.7 107.73 44.91 164.67 4.39M9235.98 4300.6c-7.37-12.88 39.75-33.34 47.52-35.41 26.02-6.9 48.5 12.95 74.68 10.8 33.1-2.77 55.4-30.97 85.07-42.2M9023.93 5019.44c-12.56-3.12-21.85 2.82-32.23 9.2-51.21 31.53-26.04 74.07-57.49 107.41-19.98 21.21-53.72 5.51-72.43 33.55M9018.74 5265.57c-1.17-.45-.35-.45.26-.53 9.4-1.04 19.61 2.05 28.77 4.12 21.95 5.01 49.54 11.68 64.14 30.36 48.37 61.94 11.82 125.48 120.08 143.65 15.01 2.5 28.89 1.57 43.66-1.73M9023.26 4749.08c-13.97-13.99-45.07 17.06-56.43 25.84-16.77 12.93-32.78 29.59-54.6 32.99-44.57 6.97-75.14-27.96-89.85 35.81M9006.95 5469.99c.43-.45-19.93 11.79-24.77 17.69-13.01 15.91-14.42 34.99-16.89 54.71-2.77 22.16 2.71 42.97-6.52 64.17-28.18 64.63-53.14 54.6-59.1 124.87M8813.12 5485.96c-62.23-31.13-75.67 125.82-97.17 152.03-24.5 29.85-66.43 51.3-85.19 84.66M8780.39 5319.95c-42.99-48.37-112.86-39.27-156.82 5.86-21.2 21.76-25.3 59.41-51.11 77.08-19.85 13.59-81.39 4.52-108.09 9.84M8759.48 5086.08c12.43-43.47 60.11-21.58 84.26-30.09 23.18-8.17 39.97-39.78 58.33-54.86 15.43-12.67 38.79-21.58 49.51-38.98M8683.46 4905.68c-11.7-8.78-36.39 14.9-42.46 21.85-29.72 33.98-33.95 82.05-56.17 120.31-32.14 55.48-115.26 60.16-162.79 98.53M8808.33 5364.55c-1.65-1.68-.61-2.19 1.22-3.46 11.15-7.83 33.72-13.68 45.5-5.19 48.16 34.59 54.81 36.85 104.91 4.79M8240.87 5259.39c-9 2.98-18.54 46.3-16.51 57.9 2.84 16.23 13.04 32.41 18.64 47.79 16.35 44.99 13.77 92.53-7.86 135.77M8269.48 5195.09c-18.55-18.55-62.42 2.85-77.34 14.23-26.59 20.36-46.07 48.16-72.28 68.7-29.49 23.1-109.76 34.83-144.56 37.15M8381.17 5062.11c-20.64 3.86-18.48 53.48-15.84 67.34 4.13 21.69 22.64 41.06 31.82 61.12 18.49 40.42 24.5 88.76 17.7 132.45M8397.28 4994.88c-21-3.49-78.38 41.61-106.23 48.05-34.11 7.93-74.22 14.16-109.15 10.8-16.32-1.57-36.73-14.74-52.19-12.53M7985.15 4896.24c-9.2 0-30.89 57.07-31.68 65.61-5.16 55.53 28.21 149.06-37.01 180.13M8042.52 4873.87c0 7.96-1.61-5.88-2.39-7.85-4.04-10.08-14.22-21.58-23.17-27.54-8-5.35-19.19-4.65-26.62-10.53-16.92-13.36-3.11-59.44-.93-79.08M8264.69 4832.73c0-59.41-44.03-30.09-69.88-74.39-17.11-29.35 2.91-63.64-5.99-94.8M8428.83 4808.92c-6.58-8.78-2.06-40.84-7.19-53.64-8.93-22.35-32.5-33.15-42.47-54.47-18.85-40.28 8.03-70.16 21.3-105.54M8339.77 4824.48c-22.15 3.52-68.48 60.83-75.07 83.34-4.35 14.87-.91 36.45-9.85 49.11-15.79 22.35-63.86 40.58-85.86 55.26M8022.69 4703.61c-13.43-1.22-21.75-25.22-36.34-30.07-40.84-13.62-105.9 28.69-97.31-53M8117.87 4638c-2.28 13.78-11.6 68.43-12.65 82-1.46 19 11.13 36.5 14.64 55.23 2.87 15.28-19.15 45.26-27.02 57.5M8200.27 4576.49c-2.73 5.45-2.92-11.9-5.46-17.43-6.3-13.7-14.62-22.99-29.15-27.96-55.74-19.06-84.97 14.97-121.27-57.64M8237.27 4396.92c-21.64-11.47-19.14-60-13.97-79.35 8.24-30.91 40.57-52.81 56.97-79.2 17.45-28.07 16.55-75.35 9.85-106.64M8044.25 4301.61c-7.61-6.12 4.53-23.42 8.39-28.5 17.58-23.17 47.26-34.48 63.76-58.85 26.78-39.49 9.6-107.89-1.33-151.61M7903.68 4211.34c1.99 6.97-20.23 33.81-24.09 39-36.33 48.98-102.74 46.75-160.54 50.61M8098.7 4358.71c-19.35 3.62-33.72 52.28-46.73 66.43-29.65 32.23-72.43 44.94-111.28 59.9M7856.03 4179.67c-3.04-1.01 8-17.24 9.32-19.05 14.8-20.17 39.35-29.16 53.78-49.25 24.32-33.87-13.16-79.44 25.42-108.23"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M7804.18 3895.51c-13.94 0-60.86 68.99-77.61 84.26M8134.31 4149.63c-.35 1.41 17.06-31.26 33.54-32.73 57.06-5.1 74.63 3.94 105.83-58.45M8110.88 4211.55c-1.2 2.39-16.93-19.75-25.69-21.85-12.31-2.93-41.31 10.91-49.39.8M7929.58 4033.44c0-10.03 3.16-26.34-3.2-35.02-9.42-12.85-47.43-22.72-35.28-44.59M7943.02 4010.4c-1.02-5.08 23.98-11.84 29.29-18.76 10.71-14.02 2.53-36.93 21.43-43.39"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M7949.94 4003.88c-12.38-15.49 3.5-44.54-7.45-61.78M8294.57 4131.72c-26.88-26.87 60.83-38.66 65.77-60.87"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8294.57 4139.25c-11.64-23.28-11.13-72.34 8.93-88.38M8277.94 4249.89c34.94-34.94 49.32 54.33 111.42 50.31M8225.1 4305.12c-31.15-41.53-55.77-29.08-38.74-80.14M8116.2 4068.19c-2.71 0-.87-20.3 2.27-22.38 9.18-6.12 27.84-1.38 39.53-8.38M7944.88 4485.04c-1.72-1.73-3.24 6.62-3.19 6.86 1.86 9.29 5.77 24.19 2.26 33.42-7.68 20.14-46.19 33.9-46.19 55.23M7940.69 4484.79c-29.09-29.08-84.97 29.49-120.41 26.27M8047.78 4478.17c-4.47-4.47 18.37-20.7 20.77-22.48 15.47-11.49 29.2-28.42 24.62-48.98M8088.52 4522.1c-26.57-5.29-56.24 24.64-62.17 49.01-1.82 7.5 2.47 17.64.13 24.08-1.35 3.72-8.84 21.6-12.24 19.55M8150.95 4527.45c-6 3.99-3.45-14.03-5.6-20.92-5.37-17.27-9.04-33.95 5.06-48.05M8195.67 4670.8c4.91-24.53 27.55-19.93 38.74-30.62 17.65-16.85 19.88-42.52 37.14-59.76M8400.75 4595.27c-10.13-30.41-25.76-58.7 6.31-81.15M8399.87 4601.97c9.8-6.51 23.5-2.26 32.08-11.3 33.89-35.68 15.79-68.38 76.68-87.33M8411.46 4738.17c-4.21-8.4 15.59-27.14 21.16-29.69 15.85-7.26 38.4-.32 55.78-6.25 24.73-8.46 37.58-35.02 54.05-53M8372.68 4682.91c-38.68-38.66-66.63 14.26-110.45 14.26M8235.47 4783.16c0-35.49 72.26-16.25 76.15-16.79 10.13-1.35 18.57-8.94 25.69-15.69M8111.95 4743.23c-5.38-21.52 28.04-52.52 42.33-62.05M7983.35 4823.1c-17.47-26.21-49.88 12.53-68.15 10.24M8025.15 4839.46c-.8 0-.98-.98-1.06-1.86-2.22-24.43 16.05-46.35 31.15-62.69M7959.79 5000.14c-1.72-1.73 1.82 2.26 2.4 2.79 7.31 6.57 18.23 9.26 27.55 11.31 25.42 5.61 52.05 10.27 77.88 13.46M7949.28 5085.07c-11.51-11.49-82.97 10.72-108.5-27.56M7917.73 5142.04c4.86 1.62 8.02 45.33 7.58 50.34M7916.8 5136.45c-33.41 12.96-68.9 22.46-94.78 48.32M8131.91 5042.74c-7.83-31.34-57.62-23.2-34.34-76.41M8123.52 5040.48c-29.57 5.16-54.1 39.64-66.29 64.01M8174.11 5007.33c-16.44 16.44-35.36-55.5-48.19-58.7M8264.36 4933.7c-.75-.24 12.38-9.92 13.05-10.37 7.53-4.98 19.45-12 28.75-11.71 12.81.4 12.63 16.92 21.17 23.55 13.2 10.27 32.96-1.44 44.72-8.39M8259.44 5052.72c-5.04-10.78-16.54 15.03-19.04 18.65-10.88 15.78-23.74 74.55-36.74 77.34M8299.77 5040.88c-17.48-34.97-23.14-41.27-4.26-71.5M8244.4 5500.59c-22.21 0-66.47 86.26-87.46 100.25"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8239.6 5499.39c8.91 8.91 4.29 41.99 7.72 54.6 3.14 11.49 14.16 18.38 20.37 28.07 13.58 21.23 19.3 45.79 19.3 70.56M8253.71 5420.74c-.63 1.89 1.97-8.57 4.13-11.73 5.13-7.48 13.91-15.19 22.36-18.36 25.15-9.45 48.42 12.27 68.43-15.46M8234.94 5354.97c-12.33 6.18-21.83 18.55-34.21 25.41-21.71 12.08-46.51 20.65-67.09 34.35M7976.57 5317.03c0-27.65-85.05-31.93-105.57-50.85"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M7979.89 5316.63c-42.61-2.85-65.93 118.45-79.34 126.59M8069.08 5300.8c-2.16-53.3-105.93-60.72-55.64-131.12M8164.26 5240.48c-56.58 42.44-8.55 110.34-24.23 158.95M8417.56 5250.46c-3.67-7.34 24.44-16.84 25.71-17.16 17.01-4.26 30.79 7.66 43.13 17.42 37.4 29.64 70.02 12.38 110.49-4.12M8417.31 5323.55c-12.16 0-14.23 23.79-14.5 31.69-1.43 41.29 16.11 54.04-15.85 89.98"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8417.31 5323.55c-3.1 0 6.23 4.34 9.32 4.52 5.99.38 13.37 1.84 19.3 3.06 23.23 4.85 36.36 18.6 61.64 16.79M8467.23 5415.13c3.94-7.85-26.58 25.33-31.01 33.82-16.71 31.95 0 55.21-34.08 80M8464.03 5413.29c-12.77-1.97-33.77-9.15-28.21-23.04M8550.17 5413c-3.6-13.33-34.17 29.48-36.88 35.02-20.69 42.33 4.92 91.2-26.62 130.85M8654.65 5301.33c-14.66 2.45-19.13-24.72-18.62-34.48 1.62-31.61 40.7-50.4 27.96-85.46M8582.79 5051.6c-10.33-7.37-15.25 39.72-15.2 41.13 1.33 29.16 18.18 54.79 14.13 85.2M8620.19 4976.92c-18.97-18.97-70.88 6.83-60.98-39.41M8424.24 5145.71c-5.99 0 4.34 17.24 5.85 20.75 5.98 13.97 5.38 24.06-5.06 34.49M8878.31 5373.73c12.37 6.19 29.21-13.36 30.33-24.75 4.55-45.5-27.7-59.12 22.77-95.17M8731.86 5597.38c-29.82 19.88 16.29 60.75 23.05 76.42 10.29 23.94 2.36 50.87-1.87 74.92M8673.97 5675.93c-.56 1.65-25.63-5.72-38.88-.94-35.06 12.62-61.51 48.72-101.02 48.72M8756.9 5517.8c-5.69-3.8-2.02-5.24-9.6-8.27-44.49-17.8-65.64 42.14-104.22-15.73M8934.47 5648.1c-3.88 0 6.81-3.78 10.38-5.32 9.34-4.02 15.43-2.05 22.11 5.32 22.83 25.25 43.61 43.58 80.27 40.6M8899.67 5731.43c-7.74-1.65-6.7-7.72-16.57-5.86-27.99 5.25-39.33 52.18-79.88 56.44M8967.36 5522.7c-21.15-21.16-57.82-26.4-76.41-49.65M9111.91 5300.26c-1.91-1.91-.08-10.93-1.19-14.12-17.22-48.75 20.27-102.2 58.56-132.85M9160.63 5403.16c-13.04 7.82 45.1 16.54 63.11 8.11 36.74-17.19 44.78-51.88 72.8-76.81M9221.45 5444.58c5.4-23.97-47.44 42.2-49.91 56.97-6.49 39.03 41.27 56.96 8.14 94.64M9266.5 5444.58c-16.36-20.43 91.92-71.41 104.86-79.5M9267.14 5444.58c-6.04 12.08 32.88 15.57 40.6 21.82 20.86 16.89 38.47 55.53 68.27 32.33M8828.76 4849.39c0-7.34-7.42 13.01-4.52 23.41 5.69 20.49 16.76 38.03 13.73 60.46-.88 6.49-9.58 30.51-20.25 23.41M8826.5 4845.93c-35.04 5.54-53.48 16.13-82.93 40.47M8893.47 4809.98c-6.25 0-14.79-9.39-19.16-13.06-56.88-47.39-28.62-65.75-58.05-115.4M8964.3 4960.39c-8.81 8.81-20.19-9.42-21.58-15.43-4.79-20.75-12.34-54.28 6.65-69.9"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8956.03 4960.53c10.88 12.69 37.32.82 50.6-1.33M8874.85 5030.31c-10.17-15.24-17.51-40.81-11.6-58.59 5.42-16.28 27.08-36.74 17.98-54.97M8877.91 5154.75c-3.09 3.09 1.62 27.17 1.33 31.96-1.41 21.82-13.54 40.25-21.45 60.02M9284.03 4890.66c-10.3-10.33-6.07-27.27-21.42-38.21-18.73-13.33-58.56-14.95-70.16-36.21M9292.68 4966.14c49.65 33.07 24.21 50.53 28.76 99.03M9503.01 5234.89c11.22 19.67 35.33-18.28 37.01-29.42 2.76-18.52-16.31-58.41-5.86-72M9609.38 5258.34c-7.72 13.62 15.8 41.56 16.63 57.49 1.44 27.97-17.83 51.46-24.88 77.35M9666.34 5235.82c8.41-30.54 42.79-47.49 71.63-52.57M9669.14 5235.03c35.76 15.75 71.09 66.33 115.55 45.79M9664.88 5091c-35.95 15.38-36 61.07-37.67 94.51"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M9662.89 5093.8c27.27 12.32 51.67 36.8 56.83 67.74M9656.1 4943.76c.61-11.12 22.78.53 33.07 4.79 31.13 12.88 46.09 48.88 76.47 31.96M9620.42 4878.13c-11.94-19.91-73.59 30.28-100.23 25.57M9419.41 4496.08c3.14-6.28 14.23-14.1 19.45-18.22 42.73-33.85 51.88 56.4 101.42 16.76M9464.53 4389.73c-14.29-39.32-88.15-42.25-58.03-99.72M9535.36 4576.62c0-19.56-44.91 6.25-55.77-7.18M9651.31 4575.02c-5.61-47.63-36.69-93.1-26.1-142.03M9613.9 4589.13c-17.37 5.8-9.02 64.81-6.78 78.81M9718.65 4542.8c54.87 38.21 46.75 54.17 43.53 112.09M10035.8 4779.36c64.3-42.86 17.6-77.99 70.9-120.61M10113.7 4861.09c32.4-50.31 32.6-132.15 98.2-147.48M10183.6 4872.93c-9.9 4.29-3.8 29.8-3.8 37.94 0 34.62 3.7 65.27-23.2 92.14M10243.3 4864.56c28.2-42.79 7.8-65.08 67.2-81.08"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10241.8 4862.02s10.6.96 12.4 1.2c9.3 1.33 19 4.87 26.2 11.04 16.6 14.18 21.6 39.41 41.1 50.21M9307.47 4268.99c-4.36 1.09 7.4-5.29 10.25-8.78 6.33-7.85 8.86-15.8 7.71-25.83-2.95-25.79-19.18-68.75-.93-91.32M9412.23 4256.75c-1.26 2.53 5.56 1.2 8.38 1.46 10.53.91 22.93.96 32.88 4.79 18.49 7.08 19.27 30.15 31.96 43.27M10381 4486.23c-7.1 0 13-22.51 14.6-23.41 2.7-1.47 4.2-1.92 7.9-2.16 36.9-2.23 46.9-23.04 75.9-41.66M10379.4 4490.89c12.3 12.34 87 48.58 113 48.58M10264.6 4476.79c-2.8-11.28-20.6 26.45-22.3 31.02-13.2 35.76 12 75.89-23.6 103.82M10313.4 4484.1c-4.4-56.51 1.3-58.74 48.6-91.44M10203.7 4404.24c8.4-37.12 38.1-44.78 66.7-64.98M10113.7 4164.48c-2.8-5.48 9.3 8.03 14 12 7.1 6.04 13.7 12.32 20.3 18.89 20.8 20.46 46.4 16.68 73.4 14.9M10091 4269.12c-58.9-9.81-51.5-27.06-50-86.79M10166.8 4079.82c14.1-42.39 4.2-50.29 42.9-73.46M10164.8 4085c-4.5-4.52 12.7 2.13 18.8 4.02 9.9 3.01 19.3 7.37 29.2 10.51 31.7 10 57.1-9.07 83.8-23.04M10087.7 4015.53c-1.1-2.76-7.4-4.01-7.7-5.05-6.3-25.36 57.1-52.58 74.7-56.59"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10082.7 4011.27c-5.9 26.61 42.5 16.23 69.9 7.19M9931.45 4020.99c-3.4-17.03 30.49-97.57 14.37-113.69M9863.29 4056.8c-27.99 35.97 57.36 52.55 36.61 101.82M9650.43 4966.14c-1.83 2.42-19.58-5.06-23.44-5.19-14.36-.56-30.27 7.58-43.26 12.9-21.02 8.6-39.51 47.2-62.55 35.68"
    />
    <path fill="#3F4142" d="M12877 3876h-40v60h40z" />
    <path
      fill="#257676"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12920 4045h-126v659h126z"
    />
    <path
      fill="#A7C7C6"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 4162.39h-125.1v541.13h125.1z"
    />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.405}
      d="M12919.5 4200.72h-125.1v471.31h125.1z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12940.9 3946.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91z"
      clipRule="evenodd"
    />
    <path
      fill="#D9D9D9"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.157}
      d="M12843.7 4236.6c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 4277.33c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M12843.7 4318.06c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 4358.79c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 4399.52c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12843.7 4440.24c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M12843.7 4480.97c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 4521.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 4643.88c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M12843.7 4562.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12843.7 4603.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12871.1 4657.97c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M12872.3 4252.64c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12872.3 4293.37c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12872.3 4334.1c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 4374.83c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 4415.56c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 4456.29c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 4497.01c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 4619.2c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 4537.74c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12872.3 4578.47c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12899.7 4644.28c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M12900 4237.62c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 4277.23c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12900 4317.96c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12900 4358.69c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12900 4399.42c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 4440.15c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 4480.87c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12899.7 4603.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M12899.7 4521.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M12899.7 4562.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M12816.4 4659.97c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M12816.4 4253.19c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12816.4 4293.92c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M12816.4 4334.65c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12816.4 4375.38c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12816.4 4416.1c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12816.4 4456.83c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M12816.4 4497.56c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M12816.4 4619.75c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12816.4 4538.29c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12816.4 4579.02c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m12794.4 4702.93 125.1.82s-41 25.25-62 25.25-63.1-26.07-63.1-26.07"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M12908.5 3935.55v109.1h-6.7l-7.1 658.29-31.7 24.56 56.5-24.56v-658.29s15.7 3.64 20.5-5.15 0-101.5 0-101.5z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 4044.64h-125.1v658.88h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 4162.39h-125.1v541.13h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 4200.72h-125.1v471.31h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12940.9 3946.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91zM12794.4 4703.75h125.1s-36.5 25.07-61.5 25.07-63.6-25.07-63.6-25.07"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M13136 4423h-40v60h40z" />
    <path
      fill="#257676"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13179 4592h-126v659h126z"
    />
    <path
      fill="#A7C7C6"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 4709.39h-125.1v541.13h125.1z"
    />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.405}
      d="M13178.5 4747.72h-125.1v471.31h125.1z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13199.9 4493.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91z"
      clipRule="evenodd"
    />
    <path
      fill="#D9D9D9"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.157}
      d="M13102.7 4783.6c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 4824.33c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13102.7 4865.06c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 4905.79c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13102.7 4946.51c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 4987.24c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 5027.97c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 5068.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 5190.88c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13102.7 5109.43c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 5150.15c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13130.1 5204.97c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13131.3 4799.64c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13131.3 4840.37c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13131.3 4881.1c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 4921.83c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 4962.56c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 5003.29c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 5044.01c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13131.3 5166.2c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 5084.74c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13131.3 5125.47c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13158.7 5191.28c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13159 4784.62c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4824.23c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13159 4864.96c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4905.69c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4946.42c5.5 0 10-4.7 10-10.5s-4.5-10.49-10-10.49c-5.6 0-10 4.69-10 10.49s4.4 10.5 10 10.5M13159 4987.15c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 5027.87c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13158.7 5150.15c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-10 4.7-10 10.5s4.5 10.49 10 10.49M13158.7 5068.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13158.7 5109.43c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13075.4 5206.97c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13075.4 4800.19c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13075.4 4840.92c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 4881.65c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13075.4 4922.38c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 4963.11c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 5003.83c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13075.4 5044.56c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13075.4 5166.75c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 5085.29c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13075.4 5126.02c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13053.4 5249.94 125.1.82s-41 25.24-62 25.24-63.1-26.06-63.1-26.06"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13167.5 4482.55v109.1h-6.7l-7.1 658.29-31.7 24.56 56.5-24.56v-658.29s15.7 3.64 20.5-5.15 0-101.5 0-101.5z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 4591.64h-125.1v658.88h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 4709.39h-125.1v541.13h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 4747.72h-125.1v471.31h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13199.9 4493.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91zM13053.4 5250.76h125.1s-36.5 25.06-61.5 25.06-63.6-25.06-63.6-25.06"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M13395 4993h-40v60h40z" />
    <path
      fill="#257676"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13438 5162h-126v659h126z"
    />
    <path
      fill="#A7C7C6"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 5279.39h-125.1v541.13h125.1z"
    />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.405}
      d="M13437.5 5317.72h-125.1v471.31h125.1z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13458.9 5063.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91z"
      clipRule="evenodd"
    />
    <path
      fill="#D9D9D9"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.157}
      d="M13361.7 5353.6c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13361.7 5394.33c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 5435.06c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 5475.79c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 5516.52c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 5557.24c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13361.7 5597.97c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13361.7 5638.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13361.7 5760.88c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13361.7 5679.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 5720.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13389.1 5774.97c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5369.64c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5410.37c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5451.1c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5491.83c5.6 0 10-4.7 10-10.5s-4.4-10.49-10-10.49c-5.5 0-9.9 4.69-9.9 10.49s4.4 10.5 9.9 10.5M13390.3 5532.56c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13390.3 5573.29c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13390.3 5614.01c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5736.2c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5654.74c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5695.47c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13417.7 5761.28c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M13418 5354.62c5.5 0 10-4.7 10-10.5s-4.5-10.5-10-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.5 10 10.5M13418 5394.23c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13418 5434.96c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13418 5475.69c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13418 5516.42c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13418 5557.15c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13418 5597.87c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13417.7 5720.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M13417.7 5638.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13417.7 5679.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M13334.4 5776.98c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 5370.19c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 5410.92c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 5451.65c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13334.4 5492.38c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 5533.1c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13334.4 5573.83c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 5614.56c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13334.4 5736.75c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 5655.29c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13334.4 5696.02c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13312.4 5819.93 125.1.82s-41 25.25-62 25.25-63.1-26.07-63.1-26.07"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13426.5 5052.55v109.1h-6.7l-7.1 658.29-31.7 24.56 56.5-24.56v-658.29s15.7 3.64 20.5-5.15 0-101.5 0-101.5z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 5161.65h-125.1v658.87h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 5279.39h-125.1v541.13h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 5317.72h-125.1v471.31h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13458.9 5063.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91zM13312.4 5820.76h125.1s-36.5 25.06-61.5 25.06-63.6-25.06-63.6-25.06"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.5}
      d="M12994.2 2159.66h-40.2v231.89h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.609}
      d="M12994.2 2205.02h-40.2v132.63h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.5}
      d="M12994.2 2672.22h-40.2v231.89h40.2zM13749.1 2672.22h-40.2v231.89h40.2zM13749.1 2151.96h-40.2v231.89h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.609}
      d="M12994.2 2717.57h-40.2v132.63h40.2z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.499}
      d="M13708.9 2079.22c0-39.31-31.9-71.22-71.2-71.22H13068c-39.3 0-71.2 31.91-71.2 71.22v896.51c0 39.31 31.9 71.22 71.2 71.22h569.7c39.3 0 71.2-31.91 71.2-71.22z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.501}
      d="M13666.3 2114.99c0-34.6-28.1-62.69-62.7-62.69H13102c-34.6 0-62.6 28.09-62.6 62.69v824.98c0 34.6 28 62.69 62.6 62.69h501.6c34.6 0 62.7-28.09 62.7-62.69z"
      clipRule="evenodd"
    />
    <circle cx={13351.9} cy={2594.05} r={55} fill="#257676" />
    <circle cx={13247.4} cy={2596.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle cx={13401.9} cy={2502.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle cx={13406.4} cy={2683.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle
      cx={13209.4}
      cy={2527.05}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle
      cx={13364.9}
      cy={2751.05}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle
      cx={13481.4}
      cy={2504.55}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle cx={13238.4} cy={2458.55} r={13} fill="#257676" fillOpacity={0.4} />
    <circle cx={13526.4} cy={2563.55} r={13} fill="#257676" fillOpacity={0.4} />
    <circle cx={13291.4} cy={2760.55} r={13} fill="#257676" fillOpacity={0.4} />
    <path
      fill="#257676"
      d="M13110.6 2257.55v-72.38h53.7v11.37h-41v18.82h36.3v11.48h-36.3v19.34h41.5v11.37zm67.7 0v-54.6h12.7v8.38c3.6-5.07 8.4-9.51 17-9.51 12.4 0 19.5 8.17 19.5 20.89v34.84h-12.6v-31.02c0-8.58-4.2-13.34-11.6-13.34s-12.3 4.97-12.3 13.55v30.81zm83 1.04c-7.9 0-16.2-2.69-23.2-8.17l5.6-8.48c6.1 4.45 12.2 6.72 17.9 6.72 5.4 0 8.5-2.27 8.5-5.89v-.21c0-4.14-5.8-5.69-12.2-7.65-8-2.17-17.1-5.59-17.1-15.93v-.2c0-10.45 8.6-16.76 19.5-16.76 6.9 0 14.2 2.38 20 6.21l-4.9 8.89c-5.3-3.2-10.9-5.17-15.5-5.17-4.8 0-7.6 2.38-7.6 5.38v.21c0 3.92 5.9 5.79 12.3 7.75 7.9 2.48 17 6.1 17 15.93v.2c0 11.48-8.9 17.17-20.3 17.17m58.1.21c-15.7 0-28-11.48-28-28.34v-.21c0-15.71 11-28.43 26.7-28.43 17.3 0 26.1 13.65 26.1 29.37 0 1.13-.1 2.27-.2 3.51h-40.1c1.3 9 7.5 13.86 15.7 13.86 6.2 0 10.4-2.28 14.8-6.52l7.3 6.52c-5.2 6.2-12.3 10.24-22.3 10.24m-15.6-32.37h28c-.8-7.96-5.6-14.38-13.8-14.38-7.8 0-13.1 5.8-14.2 14.38m52.9 31.12v-54.6h12.6v8.28c3.5-4.86 8.3-9.41 16.6-9.41 7.9 0 13.5 3.82 16.4 9.61 4.4-5.79 10.1-9.61 18.4-9.61 12 0 19.1 7.55 19.1 20.89v34.84h-12.5v-31.02c0-8.68-4-13.34-11.1-13.34-6.9 0-11.6 4.76-11.6 13.55v30.81h-12.6v-31.12c0-8.58-4-13.24-11-13.24s-11.7 5.17-11.7 13.55v30.81zm129.4 1.14c-9.1 0-14.8-4.55-18.6-9.61v8.47h-12.7v-75.48h12.7v29.98c4-5.68 9.6-10.23 18.6-10.23 12.8 0 25.3 10.13 25.3 28.33v.21c0 18.2-12.4 28.33-25.3 28.33m-3-10.86c8.6 0 15.6-6.72 15.6-17.47v-.21c0-10.55-7.3-17.47-15.6-17.47-8.6 0-16 7.03-16 17.47v.21c0 10.44 7.4 17.47 16 17.47m41.8 9.72v-75.48h12.7v75.48zm54 1.25c-15.7 0-28-11.48-28-28.34v-.21c0-15.71 11.1-28.43 26.7-28.43 17.4 0 26.2 13.65 26.2 29.37 0 1.13-.1 2.27-.3 3.51h-40.1c1.4 9 7.6 13.86 15.7 13.86 6.2 0 10.4-2.28 14.8-6.52l7.4 6.52c-5.3 6.2-12.3 10.24-22.4 10.24m-15.6-32.37h28c-.8-7.96-5.5-14.38-13.8-14.38-7.8 0-13 5.8-14.2 14.38m-393.3 147.08c-10.6 0-19.2-3.44-27.3-10.69l4.7-5.54c7 6.4 13.7 9.45 22.9 9.45 9.1 0 14.9-4.77 14.9-11.36v-.19c0-6.2-3.3-9.64-17.3-12.69-15.4-3.34-22.5-8.31-22.5-19.29v-.19c0-10.4 9.3-18.23 22-18.23 9.8 0 16.6 2.77 23.5 8.21l-4.4 5.82c-6.2-5.06-12.4-7.25-19.3-7.25-8.8 0-14.2 4.68-14.2 10.79v.19c0 6.3 3.3 9.92 18.1 12.98 14.9 3.34 21.8 8.68 21.8 18.9v.19c0 11.45-9.6 18.9-22.9 18.9m59.2.19c-14.5 0-25.3-11.74-25.3-25.58v-.19c0-14.03 10.8-25.78 25.3-25.78 9.4 0 15.1 3.82 19.8 8.79l-4.9 5.15c-3.9-4.1-8.2-7.44-15-7.44-10 0-17.7 8.4-17.7 19.09v.19c0 10.69 7.9 19.18 18.2 19.18 6.4 0 11.1-3.15 15.1-7.35l4.6 4.39c-4.9 5.64-10.8 9.55-20.1 9.55m32.5-61.28v-8.12h8.4v8.12zm.5 60.13v-49.35h7.3v49.35zm45.9 1.15c-13.4 0-24.6-10.4-24.6-25.68v-.19c0-14.22 9.9-25.68 23.7-25.68 14.6 0 23 11.65 23 26.06 0 1.05 0 1.53-.1 2.39h-39.1c1 10.69 8.5 16.7 17.3 16.7 6.9 0 11.5-2.76 15.6-6.96l4.6 4.1c-5 5.63-10.9 9.26-20.4 9.26m-17.1-28.54h31.7c-.7-8.88-5.8-16.8-15.7-16.8-8.7 0-15 7.25-16 16.8m52.1 27.39v-49.35h7.3v8.6c3.3-5.35 8.4-9.65 16.9-9.65 11.8 0 18.9 8.02 18.9 19.76v30.64h-7.4v-28.82c0-9.17-4.8-14.89-13.6-14.89-8.5 0-14.8 6.2-14.8 15.46v28.25zm75.3.86c-8 0-13.9-3.91-13.9-13.93v-29.78h-6.9v-6.5h6.9v-14.89h7.3v14.89h15.7v6.5h-15.7v28.82c0 6.11 3.3 8.21 8.3 8.21 2.6 0 4.6-.48 7.2-1.72v6.3c-2.6 1.44-5.4 2.1-8.9 2.1m22.3-60.99v-8.12h8.4v8.12zm.4 60.13v-49.35h7.4v49.35zm27.2 0v-42.85h-6.8v-6.4h6.8v-4.3c0-5.63 1.4-9.83 4.3-12.69 2.6-2.58 6.1-3.82 10.6-3.82 3.4 0 5.7.38 8.1 1.24v6.4c-2.7-.77-4.6-1.24-7.1-1.24-5.8 0-8.6 3.53-8.6 10.5v4.01h15.6v6.3h-15.5v42.85zm33 0v-49.35h7.3v49.35zm-.5-60.13v-8.12h8.4v8.12zm47.2 61.28c-14.5 0-25.3-11.74-25.3-25.58v-.19c0-14.03 10.8-25.78 25.3-25.78 9.4 0 15.1 3.82 19.8 8.79l-4.9 5.15c-3.9-4.1-8.2-7.44-15-7.44-10 0-17.7 8.4-17.7 19.09v.19c0 10.69 7.9 19.18 18.2 19.18 6.4 0 11.1-3.15 15.1-7.35l4.6 4.39c-4.9 5.64-10.8 9.55-20.1 9.55"
    />
    <path fill="#3F4142" d="M14410 2182h-48v60h48z" />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14265.6 2183.64-59.3-227.09h372.6l-56 226.08z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14444 1109h-115.8v47.93h115.8zM14612.8 1381.7h-51.2v74.13h51.2zM14202.5 1381.7h-44.1v74.13h44.1z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14080.5 1345.21-.3-64.62 113.9-123.5 373.9-.16 124.1 117.25-2 71.03z"
      clipRule="evenodd"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14605.9 1917.99c0-7.1-5.8-12.85-12.9-12.85h-417c-7.1 0-12.9 5.75-12.9 12.85v25.71c0 7.09 5.8 12.85 12.9 12.85h417c7.1 0 12.9-5.76 12.9-12.85z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14652.6 1491.65c0-19.77-16.1-35.82-35.8-35.82h-466.7c-19.8 0-35.8 16.05-35.8 35.82 0 19.76 16 35.81 35.8 35.81h466.7c19.7 0 35.8-16.05 35.8-35.81M14187.3 1782.14l-100.5 123h595.4l-99.1-125.9zM14176.5 1656.24l-100.6 123h595.5l-99.2-125.89z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14187.3 1530.35-100.5 123h595.4l-99.1-125.89z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14714.2 1332.93H14058v52.82h656.2z"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m14532.1 1156.93 119.5 128.63 5.6 47.27 34.9 1.04v-57.7l-122.1-119.24zM14552.3 1529l67.1 124.35h62.8l-97.5-125.89zM14545.1 1656.89l67.1 124.35h62.8l-97.5-125.89zM14545.3 1956.25l-65.5 226.39 42.8 1 54.3-225.04z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      d="M14444 1109h-18.6v47.93h18.6zM14710.6 1332.93h-30.8v47.94h30.8z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14187.3 1782.14-100.5 123h595.4l-99.1-125.9zm-10.8-125.9-100.6 123h595.5l-99.2-125.89zm10.8-125.89-100.5 123h595.4l-99.1-125.89zm-106.8-197.42-.3-52.35 113.9-123.49 373.9-.16 124.1 117.25-1.7 58.75h23.8v52.82h-101.4v70.08h3.9c19.8 0 35.9 16.05 35.9 35.81 0 19.77-16.1 35.82-35.9 35.82h-466.6c-19.8 0-35.8-16.05-35.8-35.82 0-19.76 16-35.81 35.8-35.81h8.3v-70.08H14058v-52.82zm122 52.82v70.08h359.1v-70.08zM14444 1109h-115.8v47.93h115.8z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14714.2 1332.93H14058v52.82h656.2z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14265.6 2183.64-59.3-227.09h372.6l-56 226.08z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M13534 3047.19c0 98.47 852 98.47 852-805.19"
    />
    <path
      fill="#8C8C8C"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.88}
      d="m13780.8 4183.84-2 431.13 14.4 38.65 14.7-41.34v-428.44zM13842.7 4183.84l-2 431.13 14.4 38.65 14.7-41.34v-428.44zM13904.4 4183.84l-2.1 431.13 14.4 38.65 14.8-41.34v-428.44z"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M13876.2 3857h-40v60h40z" />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13967.5 3939.36c0-12.39-10-22.45-22.4-22.45h-179.6c-12.4 0-22.5 10.06-22.5 22.45v293c0 12.39 10.1 22.45 22.5 22.45h179.6c12.4 0 22.4-10.06 22.4-22.45z"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3960.41c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3950.68h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 4002.71c0-5.37-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.35-9.7 9.72s4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3992.99h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.65 25.4-19.44"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 4214.23c0-5.37-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.35-9.7 9.72s4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 4204.51h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.65 25.4-19.44"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 4045.02c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 4035.29h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 4087.32c0-5.37-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.35-9.7 9.72s4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 4077.6h6.8c5.4 0 9.7 4.35 9.7 9.72s-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.65 25.4-19.44"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 4129.62c0-5.36-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.36-9.7 9.72 0 5.37 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 4119.9h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.73-9.7 9.73h-32.2c18.4-5.01 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 4171.93c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 4162.2h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45M13801.1 4254.81l-1.5 356.27-6.3 42.54 14.6-41.9v-356.71zM13863.8 4254.81l-1.6 356.27-6.2 42.54 14.6-41.9v-356.71zM13924.7 4254.81l-1.6 356.27-6.2 42.54 14.6-41.9v-356.71z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M13376 3046.95c0 975.62-.4 970.42-.4 1946.05M13310 3046.95c0 716.52-193.4 659.52-193.4 1376.05M13240 3046.95c0 468.92-382.4 360.12-382.4 829.05M13163 3044c0 139.71-599 107.29-599 247M13454 3047c0 509.14 402 300.86 402 810"
    />
    <path
      fill="url(#PulseLogicFig_svg__a)"
      stroke="#8C8E8F"
      strokeWidth={20}
      d="M16398 162h3237v3574h-3237z"
    />
    <g clipPath="url(#PulseLogicFig_svg__b)">
      <path
        fill="#8C8E90"
        stroke="#414344"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={10}
        d="M18388 1254v-166h920v166z"
      />
      <path
        fill="#8C8E90"
        stroke="#414344"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={10}
        d="M18388 1254v-166h22v166zM19286 1254v-166h22v166z"
      />
      <path
        fill="#357068"
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={7.598}
        d="M19273.2 1110.19h-849.9v128.95h849.9z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M18518.9 1113.55h-62.5v79.57h62.5z"
      />
      <path
        fill="#8C8C8C"
        d="M18478.5 1177.95c5 0 9.1-4.11 9.1-9.17 0-5.07-4.1-9.17-9.1-9.17-5.1 0-9.2 4.1-9.2 9.17 0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18472.2 1168.78h12.6M18478.5 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M18498.9 1177.95c5 0 9.1-4.11 9.1-9.17 0-5.07-4.1-9.17-9.1-9.17-5.1 0-9.2 4.1-9.2 9.17 0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18492.6 1168.78h12.6M18498.9 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M18514.7 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M18597 1113.55h-62.5v79.57h62.5z"
      />
      <path
        fill="#8C8C8C"
        d="M18556.6 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17-5 0-9.1 4.1-9.1 9.17 0 5.06 4.1 9.17 9.1 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18550.3 1168.78h12.6M18556.6 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M18577 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17s-9.2 4.1-9.2 9.17c0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18570.7 1168.78h12.6M18577 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M18592.8 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M18675.2 1113.55h-62.5v79.57h62.5z"
      />
      <path
        fill="#8C8C8C"
        d="M18634.8 1177.95c5 0 9.1-4.11 9.1-9.17 0-5.07-4.1-9.17-9.1-9.17-5.1 0-9.2 4.1-9.2 9.17 0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18628.5 1168.78h12.6M18634.8 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M18655.2 1177.95c5 0 9.1-4.11 9.1-9.17 0-5.07-4.1-9.17-9.1-9.17-5.1 0-9.2 4.1-9.2 9.17 0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18648.9 1168.78h12.6M18655.2 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M18671 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M18753.3 1113.55h-62.4v79.57h62.4z"
      />
      <path
        fill="#8C8C8C"
        d="M18712.9 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17-5 0-9.1 4.1-9.1 9.17 0 5.06 4.1 9.17 9.1 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18706.6 1168.78h12.6M18712.9 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M18733.3 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17-5 0-9.1 4.1-9.1 9.17 0 5.06 4.1 9.17 9.1 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18727 1168.78h12.6M18733.3 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M18749.2 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M18831.5 1113.55h-62.5v79.57h62.5z"
      />
      <path
        fill="#8C8C8C"
        d="M18791.1 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17s-9.2 4.1-9.2 9.17c0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18784.8 1168.78h12.6M18791.1 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M18811.5 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17s-9.2 4.1-9.2 9.17c0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18805.2 1168.78h12.6M18811.5 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M18827.3 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M18909.7 1113.55h-62.5v79.57h62.5z"
      />
      <path
        fill="#8C8C8C"
        d="M18869.3 1177.95c5 0 9.1-4.11 9.1-9.17 0-5.07-4.1-9.17-9.1-9.17-5.1 0-9.2 4.1-9.2 9.17 0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18862.9 1168.78h12.7M18869.3 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M18889.6 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17-5 0-9.1 4.1-9.1 9.17 0 5.06 4.1 9.17 9.1 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18883.3 1168.78h12.6M18889.6 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M18905.5 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M18987.8 1113.55h-62.5v79.57h62.5z"
      />
      <path
        fill="#8C8C8C"
        d="M18947.4 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17s-9.2 4.1-9.2 9.17c0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18941.1 1168.78h12.6M18947.4 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M18967.8 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17s-9.2 4.1-9.2 9.17c0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M18961.5 1168.78h12.6M18967.8 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M18983.6 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M19066 1113.55h-62.5v79.57h62.5z"
      />
      <path
        fill="#8C8C8C"
        d="M19025.6 1177.95c5 0 9.1-4.11 9.1-9.17 0-5.07-4.1-9.17-9.1-9.17-5.1 0-9.2 4.1-9.2 9.17 0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M19019.3 1168.78h12.6M19025.6 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M19046 1177.95c5 0 9.1-4.11 9.1-9.17 0-5.07-4.1-9.17-9.1-9.17-5.1 0-9.2 4.1-9.2 9.17 0 5.06 4.1 9.17 9.2 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M19039.7 1168.78h12.6M19046 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M19061.8 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.08}
        d="M19144.1 1113.55h-62.4v79.57h62.4z"
      />
      <path
        fill="#8C8C8C"
        d="M19103.7 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17-5 0-9.1 4.1-9.1 9.17 0 5.06 4.1 9.17 9.1 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M19097.4 1168.78h12.6M19103.7 1174.45v-12.6"
      />
      <path
        fill="#8C8C8C"
        d="M19124.1 1177.95c5.1 0 9.2-4.11 9.2-9.17 0-5.07-4.1-9.17-9.2-9.17-5 0-9.1 4.1-9.1 9.17 0 5.06 4.1 9.17 9.1 9.17"
      />
      <path
        stroke="#4D4D4D"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={2.085}
        d="M19117.8 1168.78h12.6M19124.1 1174.45v-12.6"
      />
      <path
        fill="#CDA024"
        fillOpacity={0.6}
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={5.916}
        d="M19139.9 1110.2h-54.1v79.56h54.1z"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.213}
        d="M19254.1 1133.54h-61.5v60.92h61.5z"
      />
      <path
        fill="#8D9091"
        stroke="#45484A"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={6.216}
        d="M19250.4 1137.21h-54.1v53.58h54.1z"
      />
      <path
        fill="#45484A"
        d="M19223.4 1180.12c9.4 0 17-7.63 17-17.04s-7.6-17.03-17-17.03-17.1 7.62-17.1 17.03 7.7 17.04 17.1 17.04"
      />
      <path
        fill="#fff"
        d="M18473 1225v-17.9h5.4l3.3 12.21 3.2-12.21h5.4v17.9h-3.3v-14.09l-3.6 14.09h-3.5l-3.5-14.09V1225zm28.9 0h-3.4v-12.93c-1.3 1.17-2.7 2.04-4.4 2.6v-3.11c.9-.29 1.8-.85 2.9-1.66 1-.82 1.7-1.78 2.1-2.87h2.8zM18554.5 1225v-17.9h5.4l3.3 12.21 3.2-12.21h5.4v17.9h-3.4v-14.09l-3.5 14.09h-3.5l-3.5-14.09V1225zm31.7-3.19v3.19h-12q.15-1.8 1.2-3.42c.6-1.08 1.9-2.51 3.8-4.29 1.6-1.45 2.5-2.42 2.9-2.93.4-.71.7-1.41.7-2.1 0-.77-.2-1.36-.6-1.76-.5-.42-1-.62-1.7-.62-.8 0-1.3.21-1.8.64-.4.43-.6 1.15-.7 2.15l-3.4-.34c.2-1.89.8-3.24 1.9-4.07 1.1-.82 2.4-1.23 4-1.23 1.8 0 3.2.48 4.2 1.43s1.5 2.14 1.5 3.55c0 .81-.1 1.58-.4 2.31-.3.72-.8 1.48-1.4 2.28-.4.53-1.2 1.29-2.2 2.28q-1.65 1.5-2.1 1.98c-.3.33-.5.64-.7.95zM18627 1225v-17.9h5.4l3.2 12.21 3.3-12.21h5.4v17.9h-3.4v-14.09l-3.5 14.09h-3.5l-3.6-14.09V1225zm20-4.75 3.3-.4c.1.84.4 1.49.9 1.94.4.45 1 .67 1.6.67.7 0 1.3-.27 1.8-.8.5-.54.8-1.27.8-2.18 0-.86-.3-1.54-.7-2.05-.5-.5-1.1-.76-1.7-.76-.5 0-1 .09-1.6.26l.4-2.79q1.35.03 2.1-.6c.5-.43.7-1 .7-1.71 0-.6-.2-1.08-.5-1.44-.4-.36-.8-.54-1.4-.54s-1.1.2-1.5.61c-.5.41-.7 1-.8 1.78l-3.2-.53c.3-1.09.6-1.95 1-2.59.5-.65 1.1-1.16 1.9-1.53s1.7-.56 2.7-.56c1.6 0 3 .54 4 1.61.8.88 1.3 1.87 1.3 2.98 0 1.57-.9 2.82-2.6 3.76 1 .22 1.8.71 2.4 1.48.7.76 1 1.69 1 2.77 0 1.57-.6 2.91-1.7 4.02-1.2 1.1-2.6 1.66-4.3 1.66s-3-.47-4.1-1.4q-1.5-1.395-1.8-3.66M18716.8 1225h-3.9l-1.5-4.06h-7.2l-1.5 4.06h-3.8l7-17.9h3.8zm-6.6-7.08-2.5-6.64-2.4 6.64zm20 .5 3.5 1.11c-.5 1.95-1.4 3.41-2.7 4.36-1.2.94-2.8 1.42-4.7 1.42-2.4 0-4.3-.81-5.9-2.43-1.5-1.63-2.3-3.85-2.3-6.67 0-2.98.8-5.29 2.3-6.93 1.6-1.65 3.6-2.48 6.1-2.48 2.2 0 4 .65 5.3 1.94.9.77 1.5 1.86 1.9 3.3l-3.6.85c-.2-.93-.7-1.66-1.3-2.2-.7-.53-1.5-.8-2.5-.8-1.3 0-2.4.47-3.2 1.43q-1.2 1.425-1.2 4.62c0 2.26.4 3.88 1.2 4.84s1.9 1.44 3.2 1.44c.9 0 1.7-.31 2.4-.92q1.05-.915 1.5-2.88m14.7 6.58h-3.5v-12.93c-1.2 1.17-2.7 2.04-4.4 2.6v-3.11c.9-.29 1.9-.85 2.9-1.66 1.1-.82 1.8-1.78 2.2-2.87h2.8zM18794.2 1225h-3.9l-1.6-4.06h-7.2l-1.4 4.06h-3.9l7-17.9h3.8zm-6.7-7.08-2.4-6.64-2.5 6.64zm20.1.5 3.5 1.11c-.6 1.95-1.5 3.41-2.7 4.36-1.3.94-2.8 1.42-4.8 1.42-2.3 0-4.3-.81-5.8-2.43-1.6-1.63-2.3-3.85-2.3-6.67 0-2.98.7-5.29 2.3-6.93 1.5-1.65 3.5-2.48 6.1-2.48 2.1 0 3.9.65 5.3 1.94.8.77 1.4 1.86 1.8 3.3l-3.6.85c-.2-.93-.6-1.66-1.3-2.2-.7-.53-1.5-.8-2.4-.8-1.4 0-2.4.47-3.3 1.43q-1.2 1.425-1.2 4.62c0 2.26.4 3.88 1.2 4.84s1.9 1.44 3.2 1.44c1 0 1.8-.31 2.5-.92q1.05-.915 1.5-2.88m17.4 3.39v3.19h-12q.15-1.8 1.2-3.42c.6-1.08 1.9-2.51 3.8-4.29 1.6-1.45 2.5-2.42 2.9-2.93.4-.71.7-1.41.7-2.1 0-.77-.2-1.36-.7-1.76-.4-.42-.9-.62-1.7-.62-.7 0-1.2.21-1.7.64-.4.43-.6 1.15-.7 2.15l-3.4-.34c.2-1.89.8-3.24 1.9-4.07 1.1-.82 2.4-1.23 4-1.23 1.8 0 3.2.48 4.2 1.43s1.5 2.14 1.5 3.55c0 .81-.1 1.58-.4 2.31-.3.72-.8 1.48-1.4 2.28-.4.53-1.2 1.29-2.2 2.28q-1.65 1.5-2.1 1.98c-.3.33-.5.64-.7.95zM18869.6 1225h-4l-1.5-4.06h-7.2l-1.5 4.06h-3.8l7-17.9h3.8zm-6.7-7.08-2.5-6.64-2.4 6.64zm20 .5 3.6 1.11c-.6 1.95-1.5 3.41-2.7 4.36-1.3.94-2.9 1.42-4.8 1.42-2.4 0-4.3-.81-5.8-2.43-1.6-1.63-2.3-3.85-2.3-6.67 0-2.98.7-5.29 2.3-6.93 1.5-1.65 3.5-2.48 6-2.48 2.2 0 4 .65 5.4 1.94.8.77 1.4 1.86 1.8 3.3l-3.6.85c-.2-.93-.6-1.66-1.3-2.2-.7-.53-1.5-.8-2.4-.8-1.4 0-2.5.47-3.3 1.43q-1.2 1.425-1.2 4.62c0 2.26.4 3.88 1.2 4.84s1.9 1.44 3.2 1.44c.9 0 1.8-.31 2.5-.92.6-.61 1.1-1.57 1.4-2.88m5.8 1.83 3.3-.4c.1.84.4 1.49.9 1.94.4.45 1 .67 1.6.67.8 0 1.3-.27 1.8-.8.5-.54.8-1.27.8-2.18 0-.86-.3-1.54-.7-2.05-.5-.5-1.1-.76-1.7-.76-.5 0-1 .09-1.6.26l.4-2.79q1.35.03 2.1-.6c.5-.43.7-1 .7-1.71 0-.6-.2-1.08-.5-1.44-.4-.36-.8-.54-1.4-.54s-1.1.2-1.5.61c-.5.41-.7 1-.8 1.78l-3.2-.53c.3-1.09.6-1.95 1-2.59.5-.65 1.1-1.16 1.9-1.53s1.7-.56 2.7-.56c1.6 0 3 .54 4 1.61.8.88 1.3 1.87 1.3 2.98 0 1.57-.9 2.82-2.6 3.76 1 .22 1.8.71 2.4 1.48.7.76 1 1.69 1 2.77 0 1.57-.6 2.91-1.7 4.02-1.2 1.1-2.6 1.66-4.3 1.66s-3-.47-4.1-1.4q-1.5-1.395-1.8-3.66M18948.5 1225h-4l-1.5-4.06h-7.2l-1.5 4.06h-3.8l7-17.9h3.8zm-6.7-7.08-2.4-6.64-2.5 6.64zm20.1.5 3.5 1.11c-.6 1.95-1.5 3.41-2.7 4.36-1.3.94-2.9 1.42-4.8 1.42-2.4 0-4.3-.81-5.8-2.43-1.6-1.63-2.3-3.85-2.3-6.67 0-2.98.7-5.29 2.3-6.93 1.5-1.65 3.5-2.48 6-2.48 2.2 0 4 .65 5.4 1.94.8.77 1.4 1.86 1.8 3.3l-3.6.85c-.2-.93-.6-1.66-1.3-2.2-.7-.53-1.5-.8-2.4-.8-1.4 0-2.4.47-3.3 1.43q-1.2 1.425-1.2 4.62c0 2.26.4 3.88 1.2 4.84s1.9 1.44 3.2 1.44c.9 0 1.8-.31 2.5-.92q1.05-.915 1.5-2.88m12.5 6.58v-3.6h-7.3v-3l7.8-11.37h2.9v11.35h2.2v3.02h-2.2v3.6zm0-6.62v-6.11l-4.1 6.11zM19028.3 1225h-3.9l-1.6-4.06h-7.1l-1.5 4.06h-3.9l7-17.9h3.8zm-6.7-7.08-2.4-6.64-2.4 6.64zm20.1.5 3.5 1.11c-.6 1.95-1.4 3.41-2.7 4.36-1.2.94-2.8 1.42-4.8 1.42-2.3 0-4.3-.81-5.8-2.43-1.5-1.63-2.3-3.85-2.3-6.67 0-2.98.8-5.29 2.3-6.93 1.5-1.65 3.6-2.48 6.1-2.48 2.2 0 3.9.65 5.3 1.94.8.77 1.4 1.86 1.8 3.3l-3.5.85c-.3-.93-.7-1.66-1.4-2.2-.6-.53-1.5-.8-2.4-.8-1.3 0-2.4.47-3.2 1.43-.9.95-1.3 2.49-1.3 4.62 0 2.26.4 3.88 1.2 4.84.9.96 1.9 1.44 3.2 1.44 1 0 1.8-.31 2.5-.92q1.05-.915 1.5-2.88m5.9 1.98 3.4-.36c.1.78.4 1.39.9 1.85.5.44 1 .67 1.6.67.7 0 1.4-.29 1.9-.87.4-.58.7-1.46.7-2.63 0-1.1-.3-1.93-.7-2.47-.5-.55-1.2-.83-2-.83-.9 0-1.8.43-2.6 1.31l-2.8-.41 1.8-9.31h9v3.21h-6.4l-.6 3.04c.8-.38 1.6-.58 2.4-.58 1.5 0 2.8.56 3.8 1.67 1.1 1.1 1.6 2.54 1.6 4.3 0 1.48-.4 2.79-1.3 3.95q-1.65 2.37-4.8 2.37c-1.7 0-3-.45-4-1.34-1.1-.88-1.7-2.07-1.9-3.57M19104.4 1225h-3.9l-1.6-4.06h-7.1l-1.5 4.06h-3.8l7-17.9h3.8zm-6.6-7.08-2.5-6.64-2.4 6.64zm20 .5 3.5 1.11c-.5 1.95-1.4 3.41-2.7 4.36-1.2.94-2.8 1.42-4.7 1.42-2.4 0-4.3-.81-5.9-2.43-1.5-1.63-2.3-3.85-2.3-6.67 0-2.98.8-5.29 2.3-6.93 1.6-1.65 3.6-2.48 6.1-2.48 2.2 0 4 .65 5.3 1.94.9.77 1.5 1.86 1.9 3.3l-3.6.85c-.2-.93-.7-1.66-1.3-2.2-.7-.53-1.5-.8-2.5-.8-1.3 0-2.4.47-3.2 1.43q-1.2 1.425-1.2 4.62c0 2.26.4 3.88 1.2 4.84s1.8 1.44 3.1 1.44c1 0 1.8-.31 2.5-.92q1.05-.915 1.5-2.88m17.5-6.93-3.3.36c-.1-.68-.3-1.19-.7-1.51-.3-.33-.7-.49-1.3-.49-.7 0-1.3.33-1.8.98s-.8 2-1 4.06c.9-1.01 1.9-1.51 3.2-1.51 1.4 0 2.7.54 3.7 1.63 1 1.1 1.5 2.5 1.5 4.23 0 1.83-.5 3.3-1.6 4.41-1.1 1.1-2.4 1.66-4.1 1.66q-2.7 0-4.5-2.1c-1.1-1.41-1.7-3.72-1.7-6.91 0-3.28.6-5.65 1.8-7.1 1.2-1.44 2.8-2.17 4.7-2.17 1.4 0 2.5.38 3.4 1.15.9.76 1.5 1.86 1.7 3.31m-7.8 7.48c0 1.11.3 1.98.8 2.59.5.6 1.1.9 1.7.9.7 0 1.2-.25 1.6-.74.5-.5.7-1.31.7-2.45 0-1.16-.3-2.01-.7-2.55-.5-.54-1-.81-1.7-.81s-1.2.26-1.7.78c-.5.51-.7 1.27-.7 2.28M19182.8 1207.1h6.6c1.5 0 2.6.12 3.4.35 1.1.31 2 .85 2.7 1.64.8.79 1.3 1.76 1.7 2.91.4 1.14.6 2.55.6 4.22 0 1.48-.2 2.75-.5 3.81-.5 1.3-1.1 2.36-2 3.16-.6.61-1.4 1.09-2.5 1.43-.8.25-1.9.38-3.2.38h-6.8zm3.6 3.03v11.85h2.7c1 0 1.8-.05 2.2-.17.6-.14 1.1-.39 1.5-.74.3-.35.7-.92.9-1.72.3-.81.4-1.9.4-3.29 0-1.38-.1-2.44-.4-3.18-.2-.74-.6-1.32-1-1.73-.5-.42-1-.7-1.7-.85-.5-.11-1.5-.17-3-.17zm14.5.15v-3.18h3.4v3.18zm0 14.72v-12.96h3.4V1225zm5.7-3.7 3.5-.52c.1.66.4 1.17.8 1.52.5.34 1.1.51 1.9.51.9 0 1.6-.16 2-.48.3-.23.5-.54.5-.92 0-.26-.1-.47-.3-.65-.1-.16-.5-.31-1.1-.45-2.8-.61-4.5-1.17-5.3-1.67-1-.7-1.5-1.67-1.5-2.92 0-1.12.4-2.06 1.3-2.83.9-.76 2.3-1.15 4.1-1.15s3.1.29 4 .87 1.5 1.43 1.8 2.56l-3.3.6c-.1-.5-.4-.89-.7-1.16-.4-.27-1-.4-1.7-.4-.9 0-1.5.13-1.9.38-.3.18-.4.41-.4.69 0 .25.1.45.3.63.3.22 1.4.55 3.2.96 1.8.42 3.1.92 3.8 1.53.8.61 1.1 1.46 1.1 2.55q0 1.785-1.5 3.06c-1 .86-2.4 1.28-4.4 1.28-1.7 0-3.1-.36-4.2-1.07-1-.72-1.7-1.69-2-2.92m17.7-5.31-3.1-.56c.3-1.25.9-2.18 1.8-2.78.8-.61 2.1-.91 3.8-.91 1.5 0 2.7.19 3.4.55.8.36 1.3.82 1.6 1.38s.5 1.58.5 3.07l-.1 4c0 1.14.1 1.98.2 2.53.1.53.3 1.11.6 1.73h-3.4c-.1-.23-.2-.57-.3-1.01-.1-.21-.1-.34-.1-.41-.6.57-1.3 1-1.9 1.29-.7.28-1.4.42-2.2.42-1.3 0-2.3-.36-3.1-1.08-.8-.73-1.2-1.64-1.2-2.75q0-1.095.6-1.95c.3-.58.8-1.02 1.4-1.32.7-.31 1.6-.58 2.8-.81q2.4-.45 3.3-.84v-.34c0-.66-.2-1.13-.5-1.41q-.45-.42-1.8-.42c-.7 0-1.1.12-1.5.36-.3.24-.6.66-.8 1.26m4.6 2.78c-.5.15-1.1.33-2.1.53s-1.6.4-1.9.6c-.4.31-.6.72-.6 1.21 0 .48.1.89.5 1.24s.8.53 1.4.53 1.2-.21 1.7-.61c.5-.31.7-.69.9-1.14 0-.29.1-.85.1-1.67zm6.6 6.23v-17.9h3.4v6.45c1.1-1.2 2.3-1.81 3.8-1.81 1.6 0 2.9.58 3.9 1.72s1.6 2.78 1.6 4.92c0 2.22-.6 3.92-1.6 5.12-1.1 1.19-2.4 1.79-3.9 1.79-.7 0-1.4-.18-2.2-.55-.7-.37-1.3-.92-1.8-1.64v1.9zm3.4-6.76c0 1.34.2 2.33.6 2.98.6.91 1.4 1.36 2.4 1.36.8 0 1.4-.32 1.9-.96.6-.65.8-1.67.8-3.07 0-1.48-.2-2.54-.8-3.19-.5-.66-1.2-.99-2-.99q-1.2 0-2.1.96c-.5.64-.8 1.61-.8 2.91m12 6.76v-17.9h3.5v17.9zm14.5-4.13 3.4.58c-.4 1.25-1.1 2.21-2.1 2.87-.9.65-2.1.97-3.5.97-2.3 0-3.9-.73-5-2.21-.9-1.18-1.3-2.67-1.3-4.46 0-2.15.6-3.83 1.7-5.05q1.65-1.83 4.2-1.83c2 0 3.5.64 4.6 1.92 1.1 1.27 1.6 3.22 1.6 5.85h-8.6c0 1.01.3 1.81.8 2.38.6.56 1.2.84 2 .84.6 0 1-.15 1.4-.44.3-.29.6-.76.8-1.42m.2-3.46c0-1-.3-1.75-.8-2.26q-.75-.78-1.8-.78c-.7 0-1.3.27-1.8.82-.5.54-.7 1.28-.7 2.22z"
      />
      <rect
        width={1022.5}
        height={627}
        x={18337}
        y={499}
        fill="#8C8E8E"
        stroke="#424546"
        strokeWidth={10}
        rx={45}
      />
      <g filter="url(#PulseLogicFig_svg__c)">
        <g clipPath="url(#PulseLogicFig_svg__d)">
          <path fill="#fff" d="M18399 543h898v538.8h-898z" />
          <g filter="url(#PulseLogicFig_svg__e)">
            <g clipPath="url(#PulseLogicFig_svg__f)">
              <path
                fill="#F8F9FA"
                d="M18425.9 742.804c0-4.959 4.1-8.98 9-8.98h826.2c4.9 0 9 4.021 9 8.98v236.848c0 4.959-4.1 8.98-9 8.98h-826.2c-4.9 0-9-4.021-9-8.98z"
              />
              <path
                fill="#212B36"
                d="M18456.6 781.605V768.62h4.8c.9 0 1.8.165 2.5.494q1.05.485 1.8 1.437.6.952.6 2.326 0 1.293-.6 2.209c-.3.611-.9 1.078-1.6 1.401q-1.05.485-2.4.485h-2.5v4.633zm2.6-6.663h2.4c.7 0 1.2-.209 1.6-.628.5-.425.7-.949.7-1.572 0-.646-.2-1.158-.7-1.535-.4-.384-1-.575-1.6-.575h-2.4zm12.2 6.843c-.5 0-.9-.066-1.3-.197-.4-.132-.8-.327-1.1-.584a2.56 2.56 0 0 1-.9-.952q-.3-.566-.3-1.311v-6.421h2.7v6.089c0 .431.1.784.4 1.059q.45.414 1.2.413.75 0 1.2-.395c.3-.269.5-.643.5-1.122v-6.044h2.6v9.285h-2l-.3-1.84q-.15.816-.6 1.257c-.3.287-.6.485-1 .592-.4.114-.8.171-1.1.171m10.2-.018c-.6 0-1.2-.081-1.6-.242q-.6-.243-.9-.638-.3-.404-.3-.889c-.1-.329-.1-.661-.1-.997v-10.74h2.5v10.417q0 .512.3.835c.1.21.4.338.8.386l.4.027v1.617c-.1.059-.3.11-.5.152q-.3.072-.6.072m6.6.018c-.7 0-1.3-.105-1.9-.314q-.9-.324-1.5-1.006c-.4-.461-.7-1.057-.8-1.787h2.3c0 .329.2.59.4.781s.4.33.7.413c.3.078.5.117.8.117q.75 0 1.2-.233c.3-.162.4-.408.4-.737 0-.251-.1-.452-.2-.601q-.3-.225-.9-.342l-1.7-.341c-.8-.174-1.5-.467-2-.88-.5-.419-.7-1.012-.7-1.778 0-.557.1-1.057.4-1.5s.8-.793 1.3-1.05c.6-.258 1.3-.386 2.2-.386q1.65 0 2.7.754c.7.503 1.1 1.212 1.1 2.128h-2.2q-.15-.538-.6-.826c-.2-.198-.6-.296-1-.296q-.75 0-1.2.242c-.3.162-.4.407-.4.736 0 .246.1.44.4.584.2.138.6.258 1.1.359l1.5.342q.75.188 1.2.52c.4.216.6.452.8.71s.3.518.4.781c0 .258.1.491.1.701 0 .616-.2 1.143-.5 1.58-.3.431-.8.76-1.4.988s-1.3.341-2 .341m10 0c-1 0-1.8-.192-2.5-.575-.7-.389-1.2-.937-1.6-1.643q-.6-1.06-.6-2.496 0-1.392.6-2.506.45-1.122 1.5-1.769 1.05-.655 2.4-.655 1.5 0 2.4.601c.7.395 1.1.949 1.5 1.662.3.706.5 1.523.5 2.451v.709h-6.3q0 .71.3 1.24.15.52.6.808c.3.185.7.278 1.1.278.5 0 .8-.095 1.2-.287.3-.192.6-.506.7-.943h2.4c-.2.659-.4 1.221-.8 1.688-.5.467-1 .823-1.6 1.069q-.9.368-1.8.368m-2.1-5.783h3.8c0-.371-.1-.712-.2-1.024-.1-.311-.4-.557-.6-.736-.3-.18-.7-.27-1.1-.27s-.7.099-1 .297c-.3.191-.5.443-.7.754-.1.311-.2.638-.2.979m8.2 5.603V768.62h2.7v10.767h5.6v2.218zm13.9.18c-.9 0-1.7-.194-2.3-.584-.7-.389-1.2-.94-1.6-1.652s-.5-1.556-.5-2.532.1-1.829.5-2.56c.4-.73.9-1.299 1.6-1.706q.9-.61 2.4-.61c.9 0 1.7.2 2.3.601.7.395 1.2.958 1.6 1.688.4.731.5 1.593.5 2.587 0 .934-.1 1.76-.5 2.478q-.6 1.069-1.5 1.679c-.7.408-1.5.611-2.5.611m.1-1.949c.4 0 .8-.134 1.1-.404q.45-.403.6-1.059c.1-.443.2-.925.2-1.446 0-.491-.1-.955-.2-1.392q-.15-.655-.6-1.06c-.3-.269-.7-.404-1.1-.404q-.75 0-1.2.386c-.2.252-.5.596-.6 1.033-.1.431-.2.91-.2 1.437 0 .485.1.952.2 1.401q.15.665.6 1.086.45.423 1.2.422m10.4 4.841c-1.6 0-2.9-.21-3.8-.629q-1.2-.629-1.2-1.652c0-.318 0-.584.2-.8q.3-.323.6-.511.3-.198.6-.297c.2-.072.3-.119.4-.143-.1-.054-.3-.132-.5-.234-.1-.108-.3-.251-.5-.431-.1-.185-.2-.425-.2-.718 0-.33.2-.635.5-.916s.8-.476 1.4-.584c-.6-.287-1.1-.676-1.4-1.167s-.4-.994-.4-1.509c0-.611.1-1.134.5-1.572.4-.437.9-.769 1.6-.996.7-.228 1.4-.342 2.3-.342q.9 0 1.5.207.6.197 1.2.521c.1-.054.3-.123.5-.207.2-.09.5-.185.7-.287.3-.108.6-.213.8-.314.3-.108.5-.204.7-.288v2.03l-1.6.26c0 .162.1.335.1.521s.1.338.1.458c0 .539-.2 1.042-.5 1.509s-.8.844-1.4 1.131-1.4.431-2.3.431c-.1 0-.3-.003-.5-.009s-.3-.015-.5-.027c-.3.018-.5.063-.7.135-.1.072-.2.156-.2.251 0 .144.2.24.4.288q.45.063 1.2.116.3.018.9.045c.3.018.7.042 1.1.072 1.1.078 2 .359 2.5.844q.9.719.9 1.814c0 .868-.5 1.584-1.3 2.147-.8.568-2 .853-3.7.853m.4-1.464c.8 0 1.3-.09 1.6-.27.3-.179.5-.437.5-.772 0-.281-.2-.509-.4-.682-.2-.18-.6-.285-1-.315l-2.2-.143c-.3-.012-.5.03-.7.125-.2.096-.4.228-.5.396-.1.167-.2.347-.2.538 0 .39.3.674.7.853.5.18 1.2.27 2.2.27m-.5-6.529q.75 0 1.2-.404c.3-.275.5-.646.5-1.113 0-.485-.2-.874-.5-1.168q-.45-.44-1.2-.44t-1.2.44c-.3.294-.4.683-.4 1.168 0 .461.1.829.4 1.104q.45.413 1.2.413m7.1 4.921v-9.285h2.5v9.285zm0-10.614v-2.362h2.5v2.362zm8.8 10.794c-.8 0-1.6-.192-2.3-.575s-1.2-.931-1.6-1.643q-.6-1.077-.6-2.568 0-1.437.6-2.533c.4-.73.9-1.299 1.6-1.706.6-.413 1.4-.619 2.3-.619.8 0 1.5.158 2 .475.6.318 1.1.746 1.4 1.285s.5 1.14.5 1.805h-2.1l-.3-.728q-.15-.368-.6-.601-.3-.243-.9-.243c-.6 0-1.1.237-1.4.71q-.6.7-.6 2.137c0 .904.2 1.622.5 2.155.4.527.9.79 1.6.79.4 0 .6-.087.9-.26.2-.174.4-.38.5-.62q.3-.368.3-.682h2.1c0 .64-.2 1.221-.5 1.742-.4.515-.8.925-1.4 1.23-.5.299-1.2.449-2 .449m10.1-.18V768.62h2.7v12.985zm5.2 0v-9.285h2.6v2.2q.15-.71.6-1.239c.3-.359.6-.638 1-.835.4-.204.8-.305 1.3-.305.1 0 .2.006.2.017.1.006.2.018.2.036v2.497c0-.024-.1-.039-.2-.045s-.1-.012-.2-.018c-.5-.042-.9-.027-1.3.045q-.6.107-.9.368c-.2.174-.4.386-.5.638-.1.251-.1.532-.1.844v5.082zm7.4 0v-9.285h2.6v2.2q.15-.71.6-1.239c.3-.359.6-.638 1-.835.4-.204.8-.305 1.3-.305.1 0 .2.006.2.017.1.006.2.018.2.036v2.497c0-.024-.1-.039-.2-.045s-.1-.012-.2-.018c-.5-.042-.9-.027-1.3.045q-.6.107-.9.368c-.2.174-.4.386-.5.638-.1.251-.1.532-.1.844v5.082zm7.5 0v-9.285h2.5v9.285zm-.1-10.614v-2.362h2.6v2.362zm9.1 13.686c-1.7 0-2.9-.21-3.8-.629s-1.3-.97-1.3-1.652q0-.476.3-.8c.1-.215.3-.386.5-.511.3-.132.5-.231.7-.297.1-.072.3-.119.3-.143-.1-.054-.2-.132-.4-.234-.2-.108-.4-.251-.5-.431-.2-.185-.2-.425-.2-.718 0-.33.1-.635.4-.916.4-.282.8-.476 1.5-.584-.6-.287-1.1-.676-1.4-1.167s-.5-.994-.5-1.509q0-.916.6-1.572t1.5-.996c.7-.228 1.5-.342 2.3-.342.6 0 1.2.069 1.6.207.4.132.8.305 1.1.521.1-.054.3-.123.5-.207.3-.09.5-.185.8-.287.2-.108.5-.213.8-.314q.3-.162.6-.288v2.03l-1.6.26c.1.162.1.335.2.521v.458c0 .539-.1 1.042-.5 1.509-.3.467-.7.844-1.4 1.131-.6.287-1.4.431-2.3.431-.1 0-.2-.003-.4-.009s-.4-.015-.5-.027c-.4.018-.6.063-.7.135-.2.072-.2.156-.2.251 0 .144.1.24.4.288.2.042.7.081 1.2.116.2.012.5.027.8.045s.7.042 1.1.072c1.2.078 2 .359 2.6.844.5.479.8 1.084.8 1.814q0 1.302-1.2 2.147c-.8.568-2.1.853-3.7.853m.4-1.464q1.05 0 1.5-.27c.4-.179.5-.437.5-.772 0-.281-.1-.509-.4-.682-.2-.18-.5-.285-1-.315l-2.1-.143c-.3-.012-.5.03-.8.125-.2.096-.3.228-.5.396-.1.167-.1.347-.1.538 0 .39.2.674.7.853.5.18 1.2.27 2.2.27m-.5-6.529q.75 0 1.2-.404c.3-.275.4-.646.4-1.113 0-.485-.1-.874-.4-1.168q-.45-.44-1.2-.44t-1.2.44c-.3.294-.5.683-.5 1.168 0 .461.2.829.5 1.104q.45.413 1.2.413m9.5 5.101c-.5 0-1.1-.111-1.6-.332-.4-.222-.8-.542-1.1-.961-.3-.425-.4-.94-.4-1.545 0-1.017.4-1.79 1.1-2.316.8-.533 2-.809 3.7-.827l1.1-.018v-.556c0-.425-.1-.752-.4-.979-.2-.234-.6-.347-1.1-.341-.4.006-.8.095-1.1.269s-.6.476-.7.907h-2.2q0-1.006.6-1.652c.3-.437.8-.761 1.4-.97q.9-.323 2.1-.323c1 0 1.7.119 2.3.359q.9.35 1.2 1.014c.3.438.4.958.4 1.563v6.528h-2.2l-.2-1.598q-.45 1.007-1.2 1.392c-.4.257-1 .386-1.7.386m.9-1.724c.3 0 .5-.042.7-.126q.3-.135.6-.35c.2-.15.3-.317.4-.503.2-.186.2-.377.2-.575v-1.374l-.9.018q-.75.009-1.2.162c-.4.096-.7.254-1 .476q-.3.332-.3.898c0 .431.1.769.4 1.015.3.239.7.359 1.1.359m10.2 1.643c-.8 0-1.4-.105-1.9-.314q-.6-.315-.9-.88c-.2-.377-.2-.814-.2-1.311v-5.056h-1.6v-1.823h1.6l.7-2.802h1.9v2.793h2v1.832h-2v4.948c0 .228 0 .398.1.512 0 .108.1.18.2.215.2.03.3.045.5.045h1.3v1.617q-.3.081-.6.152c-.3.048-.6.072-1.1.072m3.5-.099v-9.285h2.5v9.285zm0-10.614v-2.362h2.5v2.362zm8.8 10.794c-.9 0-1.7-.194-2.3-.584-.7-.389-1.2-.94-1.6-1.652q-.6-1.068-.6-2.532t.6-2.56c.4-.73.9-1.299 1.6-1.706.6-.407 1.4-.61 2.3-.61q1.5 0 2.4.601c.7.395 1.2.958 1.6 1.688.3.731.5 1.593.5 2.587 0 .934-.2 1.76-.5 2.478q-.6 1.069-1.5 1.679c-.7.408-1.5.611-2.5.611m0-1.949q.75 0 1.2-.404.3-.403.6-1.059c.1-.443.2-.925.2-1.446 0-.491-.1-.955-.2-1.392q-.15-.655-.6-1.06-.45-.404-1.2-.404c-.4 0-.8.129-1.1.386q-.45.378-.6 1.033c-.1.431-.2.91-.2 1.437 0 .485.1.952.2 1.401q.15.665.6 1.086c.3.282.7.422 1.1.422m6.3 1.769v-9.285h2.6v1.311q.15-.341.6-.655c.2-.216.5-.392.8-.53.4-.138.8-.207 1.3-.207.6 0 1.1.111 1.6.333q.75.332 1.2 1.05c.3.473.4 1.093.4 1.859v6.124h-2.6v-5.801c0-.502-.1-.88-.4-1.131-.3-.252-.7-.377-1.1-.377q-.45 0-.9.152-.3.153-.6.458t-.3.755v5.944zM18456.6 807.828v-11.362h3.9q1.2 0 2.1.409 1.05.409 1.5 1.21.6.802.6 1.972a3.9 3.9 0 0 1-.5 1.933c-.4.534-.8.94-1.4 1.218q-.9.417-2.1.416h-2.6v4.204zm1.5-5.429h2.5c.8 0 1.4-.218 1.9-.653.5-.434.8-1.026.8-1.775 0-.755-.3-1.326-.8-1.713-.5-.388-1.1-.582-1.9-.582h-2.5zm8.2 5.429v-8.125h1.4v1.564c.2-.388.3-.707.6-.959.2-.256.5-.447.8-.573.4-.126.7-.189 1-.189.1 0 .3.008.4.024s.2.042.2.078v1.407q0-.055-.3-.071a2 2 0 0 0-.3-.023q-.45-.032-.9.063c-.3.057-.5.159-.7.306s-.4.34-.5.581c-.2.236-.2.524-.2.865v5.052zm9.5.157c-.8 0-1.4-.165-2-.495s-1-.804-1.4-1.422c-.3-.618-.5-1.359-.5-2.224 0-.853.2-1.603.5-2.247s.7-1.147 1.3-1.509c.5-.361 1.2-.542 2-.542.7 0 1.4.165 1.9.495q.9.495 1.2 1.399c.3.597.4 1.307.4 2.129v.535h-5.8q0 .77.3 1.398c.1.414.4.744.7.99.4.247.8.37 1.4.37.5 0 .9-.121 1.3-.362s.6-.589.7-1.045h1.4c-.1.55-.3 1.014-.7 1.391q-.45.566-1.2.856-.75.283-1.5.283m-2.4-4.864h4.4c0-.466 0-.885-.2-1.257-.2-.377-.4-.673-.7-.888q-.45-.33-1.2-.33c-.5 0-1 .123-1.3.37-.3.241-.6.552-.7.935q-.3.566-.3 1.17m7.8 1.226v-1.139l4-.016v1.147zm7.6 3.481-2.5-8.125h1.3l1.9 6.247h.1l1.9-6.247h1.1l1.9 6.231h.1l1.8-6.231h1.3l-2.4 8.125h-1.5l-1.8-5.995-1.8 5.995zm13.8.157c-.7 0-1.4-.165-2-.495-.5-.33-1-.804-1.3-1.422s-.5-1.359-.5-2.224c0-.853.1-1.603.4-2.247s.7-1.147 1.3-1.509 1.2-.542 2-.542 1.4.165 2 .495q.75.495 1.2 1.399c.2.597.4 1.307.4 2.129v.535h-5.8c0 .513 0 .979.2 1.398.2.414.4.744.8.99.3.247.8.37 1.3.37s1-.121 1.3-.362c.4-.241.7-.589.8-1.045h1.3q-.15.825-.6 1.391c-.4.377-.8.663-1.3.856q-.6.283-1.5.283m-2.3-4.864h4.4q0-.699-.3-1.257c-.1-.377-.4-.673-.7-.888q-.45-.33-1.2-.33c-.5 0-.9.123-1.3.37-.3.241-.5.552-.7.935-.2.377-.2.767-.2 1.17m10.4 4.746c-.6 0-1-.076-1.3-.227s-.5-.378-.7-.676c-.1-.299-.1-.665-.1-1.1v-5.1h-1.4v-1.061h1.4l.4-2.365h1v2.358h1.9v1.068h-1.9v5.053c0 .288.1.5.1.636q.15.197.3.252.3.054.6.055h.9v.974c-.1.037-.2.068-.5.094-.2.026-.4.039-.7.039m5.3 0c-.5 0-1-.076-1.3-.227a1.15 1.15 0 0 1-.6-.676c-.2-.299-.2-.665-.2-1.1v-5.1h-1.3v-1.061h1.3l.4-2.365h1.1v2.358h1.8v1.068h-1.8v5.689q.15.197.3.252.3.054.6.055h.9v.974c-.1.037-.2.068-.4.094s-.5.039-.8.039m3.2-.039v-8.125h1.4v8.125zm0-9.845v-1.509h1.4v1.509zm3.9 9.845v-8.125h1.4v1.179c.2-.225.3-.437.6-.636.2-.199.5-.359.8-.48.4-.12.7-.18 1.2-.18s1 .102 1.4.306.8.524 1 .959c.3.429.4.984.4 1.665v5.312h-1.4v-5.17c0-.634-.2-1.103-.5-1.407-.4-.309-.8-.463-1.3-.463-.4 0-.7.06-1 .181-.4.115-.6.293-.8.534q-.3.353-.3.896v5.429zm12.5 2.687c-1.2 0-2.2-.186-2.9-.557-.8-.367-1.1-.894-1.1-1.58 0-.293.1-.542.2-.746.1-.21.3-.383.5-.519s.3-.243.5-.322q.3-.126.3-.181-.15-.079-.3-.196c-.1-.079-.3-.184-.4-.315-.1-.13-.1-.301-.1-.51q0-.386.3-.707c.3-.215.6-.375 1.1-.48-.5-.241-.8-.56-1.1-.958s-.4-.831-.4-1.297c0-.524.2-.979.4-1.367.3-.388.7-.684 1.3-.888q.75-.314 1.8-.314c.6 0 1 .063 1.4.188.3.121.7.294 1 .519.1-.037.2-.092.4-.165q.3-.118.6-.252.3-.133.6-.251c.2-.084.3-.147.5-.189l-.1 1.344-1.4.267c.1.168.2.351.2.55.1.199.1.385.1.558 0 .477-.1.909-.4 1.297-.2.387-.6.696-1.1.927-.5.23-1.1.346-1.9.346h-.2l-.3-.016c-.5.016-.9.078-1.1.188q-.3.157-.3.354 0 .228.3.314.45.087 1.2.15c.2.01.5.023.8.039s.6.037 1 .063c.8.052 1.5.27 1.9.652.5.382.7.898.7 1.548 0 .738-.3 1.341-1 1.807q-.9.699-3 .699m.3-.935c.7 0 1.3-.112 1.7-.338q.6-.337.6-1.021 0-.487-.3-.794-.45-.314-1.2-.361l-2.2-.149c-.2-.011-.5.042-.7.157-.2.11-.4.264-.5.463q-.3.299-.3.676c0 .43.3.765.7 1.006.5.241 1.2.361 2.2.361m-.2-5.798c.5 0 1-.137 1.4-.409.3-.272.5-.676.5-1.21 0-.55-.2-.969-.5-1.257-.4-.288-.9-.433-1.4-.433q-.9 0-1.5.441c-.4.288-.5.704-.5 1.249 0 .513.1.911.5 1.194q.45.425 1.5.425m9.5 4.046v-.903l4.6-6.153h-4.4v-1.069h6.1v.904l-4.6 6.153h4.7v1.068zm11.3.157c-.7 0-1.4-.159-1.9-.479-.6-.325-1-.799-1.3-1.422a5.2 5.2 0 0 1-.5-2.287c0-.848.2-1.592.4-2.231.3-.639.8-1.134 1.3-1.485.6-.357 1.2-.535 2-.535s1.4.165 2 .495c.5.325 1 .804 1.3 1.438s.4 1.407.4 2.318c0 .828-.1 1.556-.4 2.185q-.45.942-1.2 1.477-.9.526-2.1.526m0-1.147c.5 0 .9-.123 1.3-.369.3-.246.6-.6.7-1.061q.3-.691.3-1.642c0-.582-.1-1.103-.2-1.564-.2-.466-.4-.835-.8-1.108-.3-.272-.7-.408-1.3-.408-.4 0-.9.123-1.2.369-.3.241-.6.592-.8 1.053s-.2 1.013-.2 1.658c0 .571 0 1.089.2 1.556.1.466.4.835.7 1.107.4.273.8.409 1.3.409m5.7.99v-8.125h1.4v1.179c.1-.225.3-.437.5-.636.3-.199.5-.359.9-.48.3-.12.7-.18 1.1-.18.5 0 1 .102 1.4.306.5.204.8.524 1.1.959.2.429.4.984.4 1.665v5.312h-1.5v-5.17c0-.634-.2-1.103-.5-1.407-.3-.309-.7-.463-1.3-.463-.3 0-.7.06-1 .181-.3.115-.6.293-.8.534q-.3.353-.3.896v5.429zm12.5.157c-.8 0-1.4-.165-2-.495s-1-.804-1.4-1.422c-.3-.618-.5-1.359-.5-2.224 0-.853.2-1.603.5-2.247s.7-1.147 1.3-1.509c.5-.361 1.2-.542 2-.542.7 0 1.4.165 1.9.495q.75.495 1.2 1.399c.3.597.4 1.307.4 2.129v.535h-5.8q0 .77.3 1.398c.1.414.4.744.7.99.4.247.8.37 1.4.37.5 0 .9-.121 1.3-.362s.6-.589.7-1.045h1.4c-.1.55-.3 1.014-.7 1.391q-.45.566-1.2.856-.75.283-1.5.283m-2.4-4.864h4.4c0-.466 0-.885-.2-1.257-.2-.377-.4-.673-.7-.888q-.45-.33-1.2-.33c-.5 0-1 .123-1.3.37-.3.241-.6.552-.7.935q-.3.566-.3 1.17m10.7 4.864c-.5 0-1.1-.086-1.6-.259q-.6-.267-1.2-.825-.45-.566-.6-1.438h1.4c0 .32.2.587.4.801.1.21.4.37.7.48q.45.157.9.157c.6 0 1-.102 1.3-.307.4-.204.5-.518.5-.942 0-.299 0-.537-.2-.715-.2-.184-.5-.317-.8-.401l-1.7-.417c-.7-.157-1.2-.403-1.6-.738q-.6-.502-.6-1.407c0-.476.1-.895.4-1.257.2-.361.5-.647 1-.856.5-.21 1-.315 1.7-.315.9 0 1.6.199 2.2.597.5.393.8.972.8 1.737h-1.3c0-.388-.2-.694-.5-.919q-.45-.346-1.2-.346c-.5 0-.9.105-1.3.314-.3.205-.5.524-.5.959 0 .288.2.516.4.683.2.163.6.299 1 .409l1.6.409c.4.099.7.23 1 .393q.3.243.6.542.15.298.3.628v.621q0 .747-.3 1.289c-.3.356-.6.633-1.1.833-.5.193-1 .29-1.7.29m8.8-.157v-8.125h1.5v8.125zm0-9.845v-1.509h1.5v1.509zm4 9.845v-8.125h1.4v1.179c.1-.225.3-.437.5-.636.3-.199.5-.359.9-.48.3-.12.7-.18 1.1-.18.5 0 1 .102 1.4.306.5.204.8.524 1.1.959.2.429.4.984.4 1.665v5.312h-1.5v-5.17c0-.634-.1-1.103-.5-1.407-.3-.309-.7-.463-1.3-.463-.3 0-.7.06-1 .181-.3.115-.6.293-.8.534q-.3.353-.3.896v5.429zm12.9 2.53v-10.655h1.4v1.415c.1-.168.3-.343.4-.527.1-.183.3-.353.5-.51.3-.158.5-.286.8-.385s.6-.15 1-.15c.7 0 1.2.15 1.7.448q.75.44 1.2 1.352c.3.607.4 1.377.4 2.31 0 .932-.1 1.721-.4 2.365q-.45.958-1.2 1.461t-1.8.503c-.4 0-.7-.052-1-.157-.3-.099-.5-.23-.7-.393-.2-.167-.4-.345-.5-.534-.2-.189-.3-.369-.4-.542v3.999zm3.7-3.504c.7 0 1.2-.254 1.7-.762q.6-.77.6-2.389 0-1.39-.6-2.208c-.4-.545-.9-.817-1.7-.817-.7 0-1.3.28-1.7.841q-.6.832-.6 2.184 0 .871.3 1.587c.2.477.4.857.7 1.139.4.283.8.425 1.3.425m5.6.974v-8.125h1.4v1.564c.2-.388.3-.707.6-.959.2-.256.5-.447.8-.573.4-.126.7-.189 1-.189.1 0 .3.008.4.024s.2.042.2.078v1.407q0-.055-.3-.071a2 2 0 0 0-.3-.023q-.45-.032-.9.063c-.3.057-.5.159-.7.306s-.4.34-.5.581c-.2.236-.2.524-.2.865v5.052zm9.5.157c-.8 0-1.4-.165-2-.495s-1-.804-1.4-1.422c-.3-.618-.4-1.359-.4-2.224 0-.853.1-1.603.4-2.247s.7-1.147 1.3-1.509c.5-.361 1.2-.542 2-.542.7 0 1.4.165 1.9.495q.9.495 1.2 1.399c.3.597.4 1.307.4 2.129v.535h-5.8q0 .77.3 1.398c.1.414.4.744.7.99.4.247.8.37 1.4.37.5 0 .9-.121 1.3-.362s.6-.589.7-1.045h1.4c-.1.55-.3 1.014-.7 1.391q-.45.566-1.2.856-.75.283-1.5.283m-2.4-4.864h4.4c0-.466 0-.885-.2-1.257-.1-.377-.4-.673-.7-.888q-.45-.33-1.2-.33c-.5 0-1 .123-1.3.37-.3.241-.6.552-.7.935q-.3.566-.3 1.17m7.9 7.237v-10.655h1.4v1.415c.1-.168.2-.343.4-.527.1-.183.3-.353.5-.51s.5-.286.8-.385.6-.15 1-.15c.6 0 1.2.15 1.7.448q.75.44 1.2 1.352c.2.607.4 1.377.4 2.31 0 .932-.2 1.721-.4 2.365q-.45.958-1.2 1.461t-1.8.503c-.4 0-.7-.052-1-.157-.3-.099-.5-.23-.7-.393-.2-.167-.4-.345-.5-.534-.2-.189-.3-.369-.4-.542v3.999zm3.7-3.504c.7 0 1.2-.254 1.6-.762.5-.514.7-1.31.7-2.389q0-1.39-.6-2.208c-.4-.545-1-.817-1.7-.817-.8 0-1.3.28-1.7.841q-.6.832-.6 2.184 0 .871.3 1.587c.1.477.4.857.7 1.139.4.283.8.425 1.3.425m7.8 1.131c-.5 0-1-.091-1.4-.275q-.6-.282-.9-.809c-.3-.351-.4-.775-.4-1.273 0-.901.3-1.571 1-2.011q.9-.66 3-.708l1.4-.039v-.636c0-.498-.1-.891-.4-1.179-.3-.293-.8-.44-1.4-.44q-.75.007-1.2.33c-.4.215-.6.566-.7 1.053h-1.3c0-.529.2-.974.4-1.336q.45-.55 1.2-.833c.5-.188 1-.283 1.7-.283s1.3.1 1.7.299c.5.199.9.492 1.1.88q.3.582.3 1.43v5.673h-1.2l-.1-1.524q-.45.951-1.2 1.32c-.5.241-1 .361-1.6.361m.4-1.045c.3 0 .6-.05.8-.149.3-.1.6-.233.8-.401.2-.173.4-.364.5-.573.2-.215.2-.435.2-.66v-1.391l-1.2.023q-.9.016-1.5.189c-.4.115-.7.296-1 .542q-.3.369-.3.967c0 .455.2.812.5 1.068q.45.385 1.2.385m6 .888v-8.125h1.4v1.564q.15-.582.6-.959c.2-.256.5-.447.8-.573s.7-.189 1-.189q.15 0 .3.024.3.024.3.078v1.407q-.15-.055-.3-.071a2 2 0 0 0-.3-.023q-.45-.032-.9.063c-.3.057-.5.159-.8.306-.2.147-.3.34-.5.581-.1.236-.1.524-.1.865v5.052zm8.1.157c-.5 0-1-.091-1.4-.275q-.6-.282-.9-.809-.3-.526-.3-1.273 0-1.351.9-2.011t3-.708l1.5-.039v-.636c0-.498-.2-.891-.5-1.179-.3-.293-.7-.44-1.4-.44q-.6.007-1.2.33c-.4.215-.6.566-.7 1.053h-1.3c.1-.529.2-.974.5-1.336.2-.367.6-.644 1.1-.833s1.1-.283 1.7-.283q1.05 0 1.8.299c.4.199.8.492 1 .88.3.388.4.864.4 1.43v5.673h-1.3l-.1-1.524q-.45.951-1.2 1.32c-.5.241-1 .361-1.6.361m.5-1.045c.2 0 .5-.05.8-.149.3-.1.5-.233.7-.401q.3-.26.6-.573c.1-.215.2-.435.2-.66v-1.391l-1.2.023c-.7.011-1.2.074-1.6.189q-.6.173-.9.542t-.3.967c0 .455.1.812.4 1.068.4.257.8.385 1.3.385m8.6.927c-.6 0-1-.076-1.3-.227s-.5-.378-.7-.676c-.1-.299-.2-.665-.2-1.1v-5.1h-1.3v-1.061h1.4l.3-2.365h1.1v2.358h1.8v1.068h-1.8v5.053c0 .288 0 .5.1.636q.15.197.3.252t.6.055h.9v.974c-.1.037-.3.068-.5.094s-.4.039-.7.039m3.2-.039v-8.125h1.4v8.125zm-.1-9.845v-1.509h1.5v1.509zm7.1 10.002c-.7 0-1.4-.159-1.9-.479-.6-.325-1-.799-1.3-1.422a5.2 5.2 0 0 1-.5-2.287c0-.848.2-1.592.5-2.231.2-.639.7-1.134 1.2-1.485q.9-.535 2.1-.535c.7 0 1.4.165 1.9.495.6.325 1 .804 1.3 1.438s.4 1.407.4 2.318c0 .828-.1 1.556-.4 2.185q-.45.942-1.2 1.477c-.6.351-1.2.526-2.1.526m.1-1.147q.6 0 1.2-.369c.3-.246.6-.6.7-1.061q.3-.691.3-1.642c0-.582-.1-1.103-.2-1.564-.2-.466-.4-.835-.7-1.108-.4-.272-.8-.408-1.3-.408s-1 .123-1.3.369c-.3.241-.6.592-.8 1.053-.1.461-.2 1.013-.2 1.658 0 .571 0 1.089.2 1.556.2.466.4.835.7 1.107.4.273.8.409 1.4.409m5.6.99v-8.125h1.4v1.179c.1-.225.3-.437.5-.636.3-.199.5-.359.9-.48.3-.12.7-.18 1.1-.18.5 0 1 .102 1.4.306.5.204.8.524 1.1.959.2.429.4.984.4 1.665v5.312h-1.5v-5.17c0-.634-.1-1.103-.5-1.407-.3-.309-.7-.463-1.3-.463-.3 0-.7.06-1 .181-.3.115-.6.293-.8.534q-.3.353-.3.896v5.429zm14 0v-7.064h-1.8v-1.061h1.8v-1.257c0-.644.1-1.134.4-1.469q.6-.511 1.5-.511h1.6v1.03h-1.2c-.4 0-.6.089-.7.267-.2.178-.2.448-.2.809v1.131h2v1.061h-2v7.064zm8.2.157c-.7 0-1.4-.159-1.9-.479-.6-.325-1-.799-1.3-1.422a5.2 5.2 0 0 1-.5-2.287c0-.848.2-1.592.5-2.231.2-.639.7-1.134 1.2-1.485q.9-.535 2.1-.535c.7 0 1.4.165 1.9.495.6.325 1 .804 1.3 1.438s.4 1.407.4 2.318c0 .828-.1 1.556-.4 2.185q-.45.942-1.2 1.477c-.6.351-1.2.526-2.1.526m.1-1.147q.6 0 1.2-.369c.3-.246.6-.6.7-1.061q.3-.691.3-1.642c0-.582-.1-1.103-.2-1.564-.2-.466-.4-.835-.7-1.108-.4-.272-.8-.408-1.3-.408s-1 .123-1.3.369c-.3.241-.6.592-.8 1.053-.1.461-.2 1.013-.2 1.658 0 .571 0 1.089.2 1.556.2.466.4.835.7 1.107.4.273.8.409 1.4.409m5.6.99v-8.125h1.4v1.564c.1-.388.3-.707.5-.959q.45-.384.9-.573a2.44 2.44 0 0 1 1.3-.165q.15.024.3.078v1.407q-.15-.055-.3-.071a2 2 0 0 0-.3-.023c-.3-.021-.7 0-.9.063-.3.057-.6.159-.8.306s-.4.34-.5.581c-.1.236-.2.524-.2.865v5.052zm9.9 0v-11.676h1.5v4.746c.1-.225.3-.435.5-.629.2-.199.5-.359.8-.479q.6-.189 1.2-.189c.5 0 1 .1 1.4.299.5.194.8.471 1.1.833q.3.542.3 1.288v5.807h-1.4v-5.516c0-.487-.2-.862-.5-1.123-.4-.268-.8-.401-1.3-.401-.4 0-.7.06-1 .181-.4.115-.6.293-.8.534q-.3.354-.3.903v5.422zm9.1 0v-8.125h1.4v8.125zm0-9.845v-1.509h1.5v1.509zm7.3 12.532q-1.95 0-3-.557c-.7-.367-1.1-.894-1.1-1.58 0-.293.1-.542.2-.746.2-.21.3-.383.5-.519q.3-.204.6-.322.15-.126.3-.181c-.1-.052-.2-.118-.4-.196q-.15-.118-.3-.315c-.1-.13-.2-.301-.2-.51 0-.257.2-.493.4-.707.2-.215.6-.375 1.1-.48-.5-.241-.9-.56-1.1-.958-.3-.398-.4-.831-.4-1.297 0-.524.1-.979.4-1.367q.45-.582 1.2-.888c.5-.209 1.2-.314 1.9-.314.5 0 1 .063 1.3.188.4.121.7.294 1 .519.1-.037.2-.092.4-.165q.3-.118.6-.252.3-.133.6-.251c.2-.084.4-.147.5-.189v1.344l-1.4.267c.1.168.1.351.2.55v.558q0 .715-.3 1.297-.45.58-1.2.927c-.5.23-1.1.346-1.9.346h-.2c-.1-.006-.2-.011-.2-.016q-.9.023-1.2.188-.3.157-.3.354c0 .152.1.257.4.314q.3.087 1.2.15c.2.01.4.023.7.039s.7.037 1 .063c.9.052 1.5.27 2 .652.4.382.7.898.7 1.548 0 .738-.3 1.341-1 1.807q-1.05.699-3 .699m.2-.935q1.2 0 1.8-.338.6-.337.6-1.021c0-.325-.2-.589-.4-.794-.2-.209-.6-.33-1.1-.361l-2.3-.149q-.3-.016-.6.157c-.3.11-.4.264-.6.463-.1.199-.2.425-.2.676 0 .43.2.765.7 1.006.4.241 1.2.361 2.1.361m-.2-5.798c.6 0 1-.137 1.4-.409s.5-.676.5-1.21c0-.55-.1-.969-.5-1.257s-.8-.433-1.4-.433-1.1.147-1.4.441q-.6.432-.6 1.249c0 .513.2.911.5 1.194q.6.425 1.5.425m6.3 4.046v-11.676h1.4v4.746q.3-.338.6-.629c.2-.199.5-.359.8-.479.4-.126.7-.189 1.2-.189s1 .1 1.4.299c.4.194.8.471 1 .833.3.361.4.791.4 1.288v5.807h-1.4v-5.516c0-.487-.2-.862-.5-1.123-.4-.268-.8-.401-1.3-.401-.4 0-.7.06-1.1.181-.3.115-.5.293-.7.534q-.3.354-.3.903v5.422zm15.9.039c-.6 0-1-.076-1.3-.227s-.6-.378-.7-.676-.2-.665-.2-1.1v-5.1h-1.3v-1.061h1.4l.3-2.365h1.1v2.358h1.8v1.068h-1.8v5.053c0 .288 0 .5.1.636q.15.197.3.252t.6.055h.9v.974c-.1.037-.3.068-.5.094s-.4.039-.7.039m6.3.118c-.7 0-1.4-.165-2-.495-.5-.33-1-.804-1.3-1.422s-.5-1.359-.5-2.224c0-.853.1-1.603.4-2.247s.7-1.147 1.3-1.509 1.2-.542 2-.542 1.4.165 2 .495q.75.495 1.2 1.399c.2.597.4 1.307.4 2.129v.535h-5.8c0 .513 0 .979.2 1.398.2.414.4.744.8.99.3.247.8.37 1.3.37s1-.121 1.3-.362c.4-.241.7-.589.8-1.045h1.3q-.15.825-.6 1.391c-.4.377-.8.663-1.3.856q-.6.283-1.5.283m-2.3-4.864h4.4q0-.699-.3-1.257a1.33 1.33 0 0 0-.7-.888q-.45-.33-1.2-.33t-1.2.37c-.4.241-.6.552-.8.935-.2.377-.2.767-.2 1.17m7.8 4.707v-8.125h1.4v1.179q.3-.534.9-.935c.4-.267.9-.401 1.6-.401.2 0 .5.05.8.15.4.099.6.248.9.447q.45.3.6.731c.2-.398.6-.717 1-.958q.6-.37 1.5-.37c.3 0 .5.045.9.134.3.084.5.236.8.456.3.214.5.516.7.903.1.383.2.875.2 1.477v5.312h-1.4v-5.17q0-.739-.3-1.139-.15-.41-.6-.574c-.3-.11-.5-.165-.8-.165s-.5.05-.8.149c-.3.1-.5.267-.7.503q-.3.354-.3.967v5.429h-1.5v-5.594c0-.32-.1-.587-.2-.802-.2-.215-.4-.377-.7-.487-.2-.11-.5-.165-.7-.165q-.45 0-.9.165c-.2.11-.5.285-.7.526q-.3.354-.3.928v5.429zm13.6 2.53v-10.655h1.4l.1 1.415c0-.168.2-.343.3-.527.2-.183.3-.353.6-.51.2-.158.4-.286.7-.385s.7-.15 1-.15c.7 0 1.2.15 1.7.448q.75.44 1.2 1.352c.3.607.4 1.377.4 2.31 0 .932-.1 1.721-.4 2.365-.3.639-.6 1.126-1.2 1.461q-.75.503-1.8.503c-.4 0-.7-.052-1-.157-.2-.099-.5-.23-.7-.393-.2-.167-.4-.345-.5-.534s-.3-.369-.3-.542v3.999zm3.7-3.504c.7 0 1.2-.254 1.7-.762q.6-.77.6-2.389 0-1.39-.6-2.208c-.4-.545-.9-.817-1.7-.817-.7 0-1.3.28-1.7.841q-.6.832-.6 2.184 0 .871.3 1.587c.2.477.4.857.8 1.139q.45.425 1.2.425m9.1 1.131c-.8 0-1.4-.165-2-.495s-1-.804-1.4-1.422c-.3-.618-.4-1.359-.4-2.224 0-.853.1-1.603.4-2.247s.7-1.147 1.3-1.509c.5-.361 1.2-.542 2-.542.7 0 1.4.165 1.9.495q.9.495 1.2 1.399c.3.597.4 1.307.4 2.129v.535h-5.8q0 .77.3 1.398c.1.414.4.744.7.99.4.247.8.37 1.4.37.5 0 .9-.121 1.3-.362s.6-.589.7-1.045h1.4c-.1.55-.3 1.014-.7 1.391q-.45.566-1.2.856-.75.283-1.5.283m-2.4-4.864h4.4c0-.466 0-.885-.2-1.257-.1-.377-.4-.673-.7-.888q-.45-.33-1.2-.33c-.5 0-1 .123-1.3.37-.3.241-.6.552-.7.935q-.3.566-.3 1.17m7.9 4.707v-8.125h1.3v1.564q.3-.582.6-.959c.3-.256.5-.447.8-.573.4-.126.7-.189 1-.189.2 0 .3.008.4.024q.15.024.3.078v1.407q-.15-.055-.3-.071c-.2-.015-.3-.023-.4-.023q-.45-.032-.9.063c-.2.057-.5.159-.7.306s-.4.34-.5.581c-.1.236-.2.524-.2.865v5.052zm8.1.157c-.6 0-1-.091-1.4-.275-.4-.188-.7-.458-1-.809q-.3-.526-.3-1.273 0-1.351.9-2.011c.7-.441 1.7-.676 3.1-.708l1.4-.039v-.636c0-.498-.1-.891-.4-1.179-.3-.293-.8-.44-1.4-.44-.5.005-.9.115-1.3.33q-.45.323-.6 1.053h-1.3c0-.529.2-.974.4-1.336.3-.367.7-.644 1.1-.833q.75-.283 1.8-.283c.7 0 1.2.1 1.7.299s.8.492 1.1.88q.3.582.3 1.43v5.673h-1.2l-.1-1.524q-.45.951-1.2 1.32c-.5.241-1 .361-1.6.361m.4-1.045c.3 0 .6-.05.8-.149.3-.1.5-.233.8-.401.2-.173.4-.364.5-.573.1-.215.2-.435.2-.66v-1.391l-1.2.023q-.9.016-1.5.189c-.5.115-.8.296-1 .542q-.3.369-.3.967c0 .455.2.812.5 1.068q.45.385 1.2.385m8.6.927c-.5 0-1-.076-1.3-.227a1.15 1.15 0 0 1-.6-.676c-.2-.299-.2-.665-.2-1.1v-5.1h-1.3v-1.061h1.3l.4-2.365h1.1v2.358h1.8v1.068h-1.8v5.689q.15.197.3.252.3.054.6.055h.9v.974c-.1.037-.2.068-.4.094s-.5.039-.8.039m6.1.118q-.75-.008-1.2-.18c-.4-.121-.7-.296-1-.527-.3-.23-.5-.516-.7-.856a2.36 2.36 0 0 1-.3-1.203v-5.516h1.5v5.367c0 .529.2.959.5 1.289q.45.495 1.5.495c.6 0 1-.155 1.4-.464q.6-.471.6-1.398v-5.289h1.4v8.125h-1.1l-.2-1.556c-.1.409-.3.739-.5.99q-.3.378-.9.558c-.3.116-.7.171-1 .165m6.2-.157v-8.125h1.4v1.564c.1-.388.3-.707.5-.959q.45-.384.9-.573a2.44 2.44 0 0 1 1.3-.165q.15.024.3.078v1.407q-.15-.055-.3-.071a2 2 0 0 0-.3-.023q-.45-.032-.9.063c-.3.057-.6.159-.8.306s-.4.34-.5.581c-.1.236-.2.524-.2.865v5.052zm9.4.157c-.7 0-1.4-.165-2-.495-.5-.33-1-.804-1.3-1.422s-.5-1.359-.5-2.224c0-.853.1-1.603.4-2.247s.8-1.147 1.3-1.509c.6-.361 1.2-.542 2-.542s1.4.165 2 .495q.75.495 1.2 1.399c.3.597.4 1.307.4 2.129v.535h-5.8c0 .513.1.979.2 1.398.2.414.5.744.8.99.3.247.8.37 1.3.37s1-.121 1.3-.362c.4-.241.7-.589.8-1.045h1.3q-.15.825-.6 1.391c-.4.377-.8.663-1.3.856q-.6.283-1.5.283m-2.3-4.864h4.4c0-.466-.1-.885-.2-1.257-.2-.377-.4-.673-.8-.888q-.45-.33-1.2-.33t-1.2.37c-.4.241-.6.552-.8.935-.1.377-.2.767-.2 1.17m10.7 4.864c-.6 0-1.1-.086-1.6-.259q-.75-.267-1.2-.825-.45-.566-.6-1.438h1.3c.1.32.2.587.4.801.2.21.4.37.7.48.3.105.6.157 1 .157.5 0 1-.102 1.3-.307.3-.204.5-.518.5-.942q0-.448-.3-.715c-.1-.184-.4-.317-.8-.401l-1.7-.417q-.9-.236-1.5-.738t-.6-1.407q0-.714.3-1.257c.3-.361.6-.647 1.1-.856.4-.21 1-.315 1.7-.315q1.35 0 2.1.597c.6.393.8.972.9 1.737h-1.3c-.1-.388-.3-.694-.5-.919q-.45-.346-1.2-.346c-.6 0-1 .105-1.3.314-.3.205-.5.524-.5.959 0 .288.1.516.4.683.2.163.5.299 1 .409l1.6.409q.6.148.9.393.45.243.6.542.3.298.3.628c.1.215.1.422.1.621 0 .498-.1.927-.4 1.289-.2.356-.6.633-1 .833-.5.193-1.1.29-1.7.29m11.5 0c-1 0-1.9-.361-2.5-1.084q-.9-1.084-.9-3.167c0-.843.1-1.579.4-2.208a2.8 2.8 0 0 1 1.1-1.461q.75-.519 1.8-.519c.4 0 .8.05 1.1.15.2.099.5.225.7.377q.3.228.6.471.15.244.3.448v-4.84h1.4v11.676h-1.1l-.1-1.666q-.15.236-.3.55c-.1.205-.3.406-.5.605-.2.194-.4.354-.8.48q-.45.188-1.2.188m.3-1.115c.8 0 1.4-.249 1.7-.747q.6-.755.6-2.459 0-.951-.3-1.619c-.1-.445-.4-.783-.7-1.014-.3-.235-.7-.353-1.3-.353-.7 0-1.2.238-1.6.715q-.6.715-.6 2.271c0 1.016.1 1.804.5 2.365.4.56 1 .841 1.7.841m9.1 1.115q-.6-.008-1.2-.18c-.3-.121-.7-.296-1-.527-.2-.23-.5-.516-.6-.856a2.36 2.36 0 0 1-.3-1.203v-5.516h1.5v5.367c0 .529.1.959.5 1.289.3.33.8.495 1.4.495q.9 0 1.5-.464c.3-.314.5-.78.5-1.398v-5.289h1.5v8.125h-1.2l-.1-1.556c-.1.409-.3.739-.5.99q-.45.378-.9.558c-.3.116-.7.171-1.1.165m6.3-.157v-8.125h1.3v1.564q.3-.582.6-.959c.3-.256.5-.447.9-.573q.45-.189.9-.189c.2 0 .3.008.4.024q.15.024.3.078v1.407q-.15-.055-.3-.071c-.2-.015-.3-.023-.4-.023q-.45-.032-.9.063c-.2.057-.5.159-.7.306s-.4.34-.5.581c-.1.236-.2.524-.2.865v5.052zm6.1 0v-8.125h1.4v8.125zm0-9.845v-1.509h1.5v1.509zm4 9.845v-8.125h1.4v1.179c.1-.225.3-.437.5-.636.3-.199.5-.359.9-.48.3-.12.7-.18 1.1-.18.5 0 1 .102 1.4.306.5.204.8.524 1.1.959.2.429.4.984.4 1.665v5.312h-1.5v-5.17c0-.634-.2-1.103-.5-1.407-.3-.309-.8-.463-1.3-.463-.3 0-.7.06-1 .181-.3.115-.6.293-.8.534q-.3.353-.3.896v5.429zm12.5 2.687q-1.95 0-3-.557c-.7-.367-1.1-.894-1.1-1.58 0-.293.1-.542.2-.746.2-.21.3-.383.5-.519s.4-.243.5-.322c.2-.084.3-.144.4-.181-.1-.052-.2-.118-.4-.196q-.15-.118-.3-.315c-.1-.13-.2-.301-.2-.51 0-.257.1-.493.4-.707.2-.215.6-.375 1.1-.48q-.75-.361-1.2-.958c-.2-.398-.4-.831-.4-1.297 0-.524.2-.979.5-1.367q.45-.582 1.2-.888c.5-.209 1.1-.314 1.9-.314.5 0 1 .063 1.3.188.4.121.7.294 1 .519.1-.037.2-.092.4-.165q.3-.118.6-.252.3-.133.6-.251c.2-.084.4-.147.5-.189v1.344l-1.4.267c0 .168.1.351.2.55v.558c0 .477-.1.909-.4 1.297-.2.387-.6.696-1.1.927-.5.23-1.1.346-1.9.346h-.2c-.1-.006-.2-.011-.2-.016q-.9.023-1.2.188-.3.157-.3.354c0 .152.1.257.4.314.2.058.6.108 1.1.15.3.01.5.023.8.039s.6.037 1 .063c.9.052 1.5.27 2 .652.4.382.7.898.7 1.548 0 .738-.4 1.341-1 1.807q-1.05.699-3 .699m.2-.935q1.2 0 1.8-.338.6-.337.6-1.021c0-.325-.2-.589-.4-.794-.3-.209-.6-.33-1.1-.361l-2.3-.149q-.3-.016-.6.157-.45.165-.6.463c-.2.199-.2.425-.2.676 0 .43.2.765.7 1.006.4.241 1.2.361 2.1.361m-.2-5.798c.6 0 1-.137 1.4-.409s.5-.676.5-1.21c0-.55-.1-.969-.5-1.257s-.8-.433-1.4-.433q-.9 0-1.5.441c-.3.288-.5.704-.5 1.249 0 .513.2.911.5 1.194q.6.425 1.5.425m13.1 4.085c-.5 0-1-.076-1.3-.227a1.15 1.15 0 0 1-.6-.676c-.2-.299-.2-.665-.2-1.1v-5.1h-1.3v-1.061h1.3l.4-2.365h1v2.358h1.9v1.068h-1.9v5.053c0 .288.1.5.1.636q.15.197.3.252.3.054.6.055h.9v.974c-.1.037-.2.068-.4.094s-.5.039-.8.039m3.1-.039v-11.676h1.5v4.746c.1-.225.3-.435.5-.629.2-.199.5-.359.8-.479q.6-.189 1.2-.189c.5 0 1 .1 1.4.299.5.194.8.471 1.1.833q.3.542.3 1.288v5.807h-1.4v-5.516c0-.487-.2-.862-.5-1.123-.4-.268-.8-.401-1.3-.401-.4 0-.7.06-1 .181-.4.115-.6.293-.8.534q-.3.354-.3.903v5.422zm12.5.157c-.7 0-1.4-.165-2-.495-.5-.33-1-.804-1.3-1.422s-.5-1.359-.5-2.224c0-.853.1-1.603.4-2.247s.8-1.147 1.3-1.509c.6-.361 1.2-.542 2-.542s1.4.165 2 .495q.75.495 1.2 1.399c.2.597.4 1.307.4 2.129v.535h-5.8c0 .513 0 .979.2 1.398.2.414.4.744.8.99.3.247.8.37 1.3.37s1-.121 1.3-.362c.4-.241.7-.589.8-1.045h1.3q-.15.825-.6 1.391c-.4.377-.8.663-1.3.856q-.6.283-1.5.283m-2.3-4.864h4.4c0-.466-.1-.885-.2-1.257-.2-.377-.4-.673-.8-.888q-.45-.33-1.2-.33t-1.2.37c-.4.241-.6.552-.8.935-.2.377-.2.767-.2 1.17m14.3 4.864c-1.1 0-1.9-.361-2.5-1.084q-.9-1.084-.9-3.167 0-1.264.3-2.208c.3-.628.6-1.115 1.1-1.461s1.1-.519 1.9-.519c.4 0 .7.05 1 .15s.6.225.8.377.4.309.5.471q.3.244.3.448v-4.84h1.5v11.676h-1.1l-.2-1.666c0 .157-.1.341-.2.55-.1.205-.3.406-.5.605-.2.194-.5.354-.8.48q-.45.188-1.2.188m.2-1.115q1.35 0 1.8-.747c.4-.503.5-1.323.5-2.459 0-.634 0-1.174-.2-1.619s-.4-.783-.7-1.014c-.3-.235-.8-.353-1.3-.353-.7 0-1.2.238-1.7.715q-.6.715-.6 2.271 0 1.524.6 2.365c.4.56.9.841 1.6.841m8.5 1.115c-.5 0-1-.091-1.4-.275-.4-.188-.7-.458-1-.809q-.3-.526-.3-1.273 0-1.351.9-2.011c.7-.441 1.7-.676 3.1-.708l1.4-.039v-.636c0-.498-.1-.891-.4-1.179-.3-.293-.8-.44-1.4-.44q-.75.007-1.2.33c-.4.215-.6.566-.7 1.053h-1.3c0-.529.2-.974.4-1.336q.45-.55 1.2-.833c.4-.188 1-.283 1.7-.283s1.3.1 1.7.299c.5.199.8.492 1.1.88q.3.582.3 1.43v5.673h-1.2l-.1-1.524q-.45.951-1.2 1.32c-.5.241-1 .361-1.6.361m.4-1.045c.3 0 .6-.05.8-.149.3-.1.6-.233.8-.401.2-.173.4-.364.5-.573.1-.215.2-.435.2-.66v-1.391l-1.2.023q-.9.016-1.5.189c-.5.115-.8.296-1 .542q-.3.369-.3.967c0 .455.2.812.5 1.068q.45.385 1.2.385m6.5 3.481c-.4 0-.8-.034-.9-.102l-.3-.102v-.943l.8.016c.3.01.6-.011.8-.063s.3-.123.4-.212q.3-.134.3-.299c.1-.11.1-.215.2-.314l.3-.77-3.2-7.929h1.5l2.4 6.271 2.3-6.271h1.5l-3.5 8.738c-.2.513-.4.914-.7 1.202-.2.288-.5.49-.8.605s-.7.173-1.1.173m6.5-2.593v-1.854h1.7v1.854z"
              />
              <path
                fill="#637381"
                d="M18441.3 973.472c-1.1 0-1.9-.417-2.6-1.252q-.9-1.26-.9-3.725c0-1.109.2-2.038.4-2.788.3-.75.7-1.313 1.3-1.691q.75-.565 1.8-.565c1 0 1.9.424 2.5 1.273.6.844 1 2.094 1 3.751 0 1.648-.4 2.894-1 3.738-.6.84-1.5 1.259-2.5 1.259m0-1.077c.7 0 1.2-.306 1.6-.916.3-.615.5-1.614.5-2.997 0-1.41-.2-2.425-.5-3.044-.4-.625-.9-.937-1.6-.937s-1.2.315-1.6.943q-.6.936-.6 3.038 0 2.067.6 2.99c.4.615.9.923 1.6.923m8.4 1.077c-.8 0-1.4-.114-2-.343-.5-.234-1-.559-1.3-.977s-.4-.907-.4-1.468q0-.566.3-1.084c.2-.346.4-.64.7-.883q.45-.363.9-.458c-.4-.188-.8-.462-1.1-.821-.2-.359-.4-.804-.4-1.334 0-.565.2-1.046.4-1.441q.45-.593 1.2-.902c.5-.207 1.1-.31 1.7-.31s1.2.103 1.7.31c.5.206.9.507 1.1.902.3.395.5.876.5 1.441 0 .53-.2.975-.5 1.334-.2.359-.6.633-1.1.821.4.063.7.216 1 .458s.5.537.7.883q.3.518.3 1.084c0 .561-.1 1.051-.5 1.468q-.45.627-1.2.977c-.6.229-1.3.343-2 .343m0-1.01c.7 0 1.3-.162 1.7-.485.5-.328.7-.761.7-1.3q0-.532-.3-.949c-.2-.279-.5-.496-.8-.654-.4-.161-.8-.242-1.3-.242s-.9.081-1.3.242c-.3.158-.6.375-.8.654q-.3.418-.3.949c0 .539.2.972.7 1.3.4.323 1 .485 1.7.485m0-4.728c.6 0 1.1-.146 1.4-.438q.6-.437.6-1.219 0-.788-.6-1.239c-.3-.305-.8-.458-1.4-.458q-.9 0-1.5.458c-.3.305-.5.719-.5 1.239s.2.928.5 1.219q.6.438 1.5.438m5.1.485v-1.583h1.5v1.583zm0 5.065v-1.569h1.5v1.569zm6.4.188q-1.05-.006-1.8-.37-.75-.363-1.2-1.017c-.3-.44-.4-.961-.5-1.563h1.3c.1.607.3 1.071.7 1.395q.6.485 1.5.485c.5 0 .9-.075 1.3-.223.3-.152.6-.361.8-.626q.3-.398.3-.93 0-.585-.3-.99c-.3-.269-.5-.473-.9-.612a3.8 3.8 0 0 0-1.3-.223l-.8-.02v-1.057l.8-.021c.4-.008.8-.089 1.1-.242.4-.157.6-.361.8-.613q.3-.383.3-.842c0-.269-.1-.518-.2-.747-.2-.234-.4-.42-.7-.559q-.45-.21-1.2-.209c-.3 0-.7.069-1 .209-.3.134-.6.343-.8.626q-.3.425-.3 1.098h-1.2c0-.629.1-1.163.4-1.603q.45-.668 1.2-1.017c.6-.234 1.1-.35 1.7-.35q1.05 0 1.8.296.75.29 1.2.849c.3.372.5.828.5 1.367 0 .48-.2.916-.5 1.306-.3.387-.8.69-1.4.91.4.116.8.287 1.1.512.3.224.6.5.8.828.1.323.2.696.2 1.118 0 .444-.1.844-.2 1.199-.2.35-.5.649-.8.896q-.6.363-1.2.559-.75.188-1.5.181m6.9-.148v-7.752h-1.9v-.815c.6 0 1-.042 1.4-.128.3-.085.5-.215.7-.39.1-.175.2-.393.2-.654h.9v9.739zM18786.6 973.472c-.6-.004-1.2-.128-1.7-.37q-.75-.363-1.2-1.017c-.3-.44-.5-.961-.5-1.563h1.3c0 .607.3 1.071.7 1.395q.6.485 1.5.485.75 0 1.2-.223.6-.228.9-.626t.3-.93c0-.39-.2-.72-.4-.99q-.3-.403-.9-.612-.45-.216-1.2-.223l-.9-.02v-1.057l.9-.021c.4-.008.8-.089 1.1-.242.3-.157.6-.361.8-.613q.3-.383.3-.842 0-.404-.3-.747c-.1-.234-.4-.42-.7-.559s-.7-.209-1.1-.209-.7.069-1 .209c-.3.134-.6.343-.8.626q-.3.425-.3 1.098h-1.3c0-.629.2-1.163.5-1.603q.45-.668 1.2-1.017c.5-.234 1.1-.35 1.7-.35q1.05 0 1.8.296.75.29 1.2.849c.3.372.4.828.4 1.367 0 .48-.1.916-.4 1.306-.3.387-.8.69-1.4.91.4.116.8.287 1.1.512.3.224.6.5.7.828q.3.485.3 1.118 0 .666-.3 1.199c-.2.35-.4.649-.8.896q-.45.363-1.2.559-.6.188-1.5.181m5.3-.148v-1.158q0-.748.3-1.293c.1-.364.4-.681.7-.95.3-.274.6-.519 1-.734.4-.216.7-.422 1.1-.62.4-.202.7-.411 1-.626.3-.22.6-.467.8-.741.1-.278.2-.606.2-.983 0-.494-.1-.896-.5-1.206-.3-.31-.8-.464-1.4-.464q-.9 0-1.5.538c-.4.36-.6.838-.7 1.435h-1.2c0-.561.1-1.073.4-1.536.3-.467.6-.839 1.2-1.118q.75-.417 1.8-.417c.7 0 1.3.116 1.7.35q.75.343 1.2.97c.2.413.4.896.4 1.448q0 .754-.3 1.293c-.2.359-.5.671-.8.936q-.45.39-.9.701c-.4.206-.8.406-1.1.599-.4.189-.7.388-1 .599-.3.207-.6.445-.8.714-.1.27-.2.591-.2.963v.196h5.1v1.104zm11.5 0v-6.964h1.2v1.01c.2-.305.4-.572.8-.801.3-.229.7-.343 1.3-.343.2 0 .5.042.8.127.2.086.5.214.7.384.2.171.4.38.5.627q.3-.512.9-.822.45-.316 1.2-.316c.3 0 .5.038.8.114.2.072.5.202.7.391q.3.276.6.774c.1.328.2.75.2 1.266v4.553h-1.3v-4.431c0-.422 0-.748-.2-.977-.1-.233-.3-.397-.5-.492s-.5-.141-.7-.141-.4.043-.7.128q-.3.128-.6.431t-.3.828v4.654h-1.2v-4.795c0-.274-.1-.503-.2-.687-.2-.184-.3-.323-.6-.418a1.4 1.4 0 0 0-.6-.141c-.3 0-.5.047-.7.141q-.45.142-.6.452-.3.303-.3.794v4.654zm11.7 0v-6.964h1.2v6.964zm-.1-8.439v-1.293h1.3v1.293zm3.4 8.439v-6.964h1.2v1.01c.2-.193.3-.374.5-.545s.5-.308.7-.411c.3-.103.7-.155 1-.155q.75 0 1.2.263.6.262.9.822c.3.368.4.844.4 1.427v4.553h-1.3v-4.431c0-.544-.1-.946-.4-1.206-.3-.265-.7-.397-1.1-.397q-.45 0-.9.155c-.3.098-.5.251-.7.458-.1.202-.2.458-.2.767v4.654zm13.5.135c-1 0-1.7-.31-2.2-.93-.5-.619-.8-1.524-.8-2.714q0-1.084.3-1.892c.2-.539.6-.957 1-1.253s.9-.444 1.6-.444c.3 0 .6.042.8.127.3.086.5.194.7.324s.4.265.5.404.2.267.2.384v-4.149h1.3v10.008h-1l-.1-1.428c0 .135-.1.292-.2.472-.1.175-.2.348-.4.518-.2.167-.4.304-.7.411-.3.108-.6.162-1 .162m.2-.956q1.05 0 1.5-.64c.3-.431.4-1.134.4-2.108 0-.544 0-1.006-.2-1.388q-.15-.572-.6-.869c-.3-.202-.6-.303-1.1-.303-.6 0-1 .205-1.4.613s-.5 1.058-.5 1.947c0 .871.1 1.546.5 2.027.3.48.7.721 1.4.721m7.8.956c-.4-.005-.7-.056-1-.155q-.45-.155-.9-.451a5 5 0 0 1-.6-.734c-.1-.297-.2-.64-.2-1.031v-4.728h1.3v4.6c0 .454.1.822.4 1.105s.7.424 1.3.424q.75 0 1.2-.397c.3-.27.5-.669.5-1.199v-4.533h1.2v6.964h-1l-.1-1.333c-.1.35-.2.633-.4.848-.2.216-.5.375-.8.478q-.45.148-.9.142m5.3-.135v-6.964h1.2v1.34c.1-.332.3-.606.5-.821.2-.22.5-.384.7-.492q.45-.161.9-.161.15 0 .3.02c.1.013.2.036.2.067v1.206c0-.032-.1-.052-.2-.061q-.15-.02-.3-.02c-.3-.018-.5 0-.8.054q-.3.074-.6.262c-.2.126-.4.292-.5.499-.1.202-.1.449-.1.741v4.33zm7 .135q-.6 0-1.2-.236c-.3-.161-.6-.393-.8-.694q-.3-.45-.3-1.091c0-.772.3-1.347.8-1.724.6-.377 1.4-.579 2.6-.606l1.3-.034v-.545c0-.427-.2-.763-.4-1.01q-.45-.378-1.2-.378c-.4.005-.8.099-1.1.283q-.45.276-.6.903h-1.1c.1-.454.2-.835.4-1.145.3-.314.6-.552 1-.714s.9-.242 1.4-.242c.7 0 1.2.085 1.6.255q.6.257.9.755t.3 1.226v4.862h-1.1l-.1-1.306c-.3.543-.6.92-1 1.131-.4.207-.9.31-1.4.31m.4-.896c.2 0 .5-.042.7-.128q.3-.128.6-.343c.2-.148.4-.312.5-.492.1-.184.2-.373.2-.566v-1.192l-1.1.02c-.5.009-1 .063-1.3.162-.4.099-.6.254-.8.465q-.3.317-.3.828c0 .391.2.696.4.916.3.22.7.33 1.1.33m7.4.795q-.75 0-1.2-.195a1.27 1.27 0 0 1-.5-.58c-.1-.256-.2-.57-.2-.943v-4.371h-1.1v-.909h1.2l.3-2.027h.9v2.02h1.6v.916h-1.6v4.331c0 .247 0 .429.1.546 0 .112.1.184.2.215.1.032.3.047.5.047h.8v.835c-.1.032-.2.059-.4.081q-.3.034-.6.034m2.7-.034v-6.964h1.2v6.964zm-.1-8.439v-1.293h1.3v1.293zm6.2 8.574c-.7 0-1.2-.137-1.7-.411-.5-.278-.9-.685-1.1-1.219-.3-.534-.4-1.188-.4-1.96q0-1.09.3-1.913c.3-.547.7-.972 1.1-1.272q.75-.458 1.8-.458c.6 0 1.2.141 1.6.424.5.278.9.689 1.1 1.232.3.544.4 1.206.4 1.987q0 1.065-.3 1.872c-.3.539-.6.961-1.1 1.267-.5.301-1 .451-1.7.451m0-.983c.4 0 .7-.106 1-.317s.5-.514.7-.909c.1-.395.2-.864.2-1.408 0-.498-.1-.945-.2-1.34q-.15-.6-.6-.95c-.3-.233-.7-.35-1.1-.35s-.8.106-1.1.317c-.3.206-.5.507-.7.902-.1.395-.2.869-.2 1.421 0 .49.1.934.2 1.334.1.399.4.716.6.949q.45.351 1.2.351m4.8.848v-6.964h1.2v1.01c.1-.193.3-.374.5-.545s.4-.308.7-.411.6-.155 1-.155q.6 0 1.2.263.6.262.9.822.3.552.3 1.427v4.553h-1.2v-4.431c0-.544-.2-.946-.5-1.206-.2-.265-.6-.397-1.1-.397-.3 0-.6.051-.8.155-.3.098-.5.251-.7.458q-.3.303-.3.767v4.654zM19224.7 973.472c-1 0-1.9-.417-2.5-1.252q-.9-1.26-.9-3.725c0-1.109.1-2.038.4-2.788q.45-1.125 1.2-1.691.75-.565 1.8-.565c1.1 0 1.9.424 2.6 1.273q.9 1.266.9 3.751 0 2.472-.9 3.738c-.7.84-1.5 1.259-2.6 1.259m0-1.077c.7 0 1.3-.306 1.6-.916q.6-.922.6-2.997 0-2.115-.6-3.044c-.3-.625-.9-.937-1.6-.937-.6 0-1.2.315-1.5.943q-.6.936-.6 3.038 0 2.067.6 2.99c.3.615.9.923 1.5.923m8 1.077q-.75 0-1.5-.303-.75-.31-1.2-.875c-.3-.377-.5-.829-.5-1.354h1.2c.1.445.3.806.7 1.084.3.274.8.411 1.3.411s1-.15 1.4-.451.8-.766 1-1.394c.2-.629.2-1.435.2-2.418-.1.341-.3.642-.5.902q-.45.384-.9.607c-.4.148-.7.222-1.2.222-.6 0-1.2-.126-1.6-.377a3 3 0 0 1-1.2-1.078c-.3-.467-.4-1.026-.4-1.677s.1-1.226.4-1.724q.45-.747 1.2-1.172t1.8-.424c.7 0 1.4.195 1.9.586.6.386 1 .943 1.3 1.67.3.723.4 1.592.4 2.606 0 1.091-.1 2.021-.4 2.789-.3.767-.7 1.356-1.3 1.764q-.9.606-2.1.606m.2-4.627c.3 0 .7-.083 1-.249s.6-.386.8-.66q.3-.417.3-.909 0-.754-.3-1.327c-.1-.386-.4-.687-.7-.902-.3-.22-.7-.33-1.1-.33s-.8.094-1.1.283-.5.451-.7.788q-.3.505-.3 1.171 0 .977.6 1.556.45.579 1.5.579m5-.626v-1.583h1.5v1.583zm0 5.065v-1.569h1.5v1.569zm6.4.188c-1 0-1.9-.417-2.5-1.252q-.9-1.26-.9-3.725c0-1.109.1-2.038.4-2.788q.45-1.125 1.2-1.691c.5-.377 1.2-.565 1.9-.565 1 0 1.9.424 2.5 1.273q.9 1.266.9 3.751 0 2.472-.9 3.738c-.6.84-1.5 1.259-2.6 1.259m.1-1.077q1.05 0 1.5-.916.6-.922.6-2.997 0-2.115-.6-3.044c-.3-.625-.9-.937-1.5-.937-.7 0-1.3.315-1.6.943q-.6.936-.6 3.038 0 2.067.6 2.99c.3.615.9.923 1.6.923m8.1 1.077q-1.05-.006-1.8-.37-.75-.363-1.2-1.017c-.3-.44-.4-.961-.5-1.563h1.3c.1.607.3 1.071.7 1.395q.6.485 1.5.485c.5 0 .9-.075 1.3-.223.3-.152.6-.361.8-.626q.3-.398.3-.93 0-.585-.3-.99-.3-.403-.9-.612a3.8 3.8 0 0 0-1.3-.223l-.8-.02v-1.057l.8-.021c.4-.008.8-.089 1.1-.242.4-.157.6-.361.8-.613q.3-.383.3-.842c0-.269 0-.518-.2-.747-.2-.234-.4-.42-.7-.559q-.45-.21-1.2-.209c-.3 0-.6.069-1 .209-.3.134-.5.343-.8.626q-.3.425-.3 1.098h-1.2c0-.629.1-1.163.4-1.603.3-.445.7-.784 1.3-1.017.5-.234 1-.35 1.6-.35q1.05 0 1.8.296.75.29 1.2.849c.3.372.5.828.5 1.367 0 .48-.2.916-.5 1.306-.3.387-.8.69-1.4.91.4.116.8.287 1.1.512.4.224.6.5.8.828.2.323.2.696.2 1.118 0 .444-.1.844-.2 1.199-.2.35-.5.649-.8.896q-.6.363-1.2.559-.75.188-1.5.181"
              />
              <rect
                width={56.485}
                height={32.553}
                x={18458}
                y={904.445}
                fill="#B5BDC6"
                rx={5.613}
              />
              <rect
                width={56.485}
                height={32.553}
                x={18516}
                y={904.445}
                fill="#B5BDC6"
                rx={5.613}
              />
              <rect
                width={56.485}
                height={32.553}
                x={18574.1}
                y={904.445}
                fill="#B5BDC6"
                rx={5.613}
              />
              <rect
                width={305.962}
                height={32.553}
                x={18632.1}
                y={904.445}
                fill="#B5BDC6"
                rx={5.613}
              />
              <rect
                width={305.962}
                height={32.553}
                x={18939.7}
                y={904.445}
                fill="#B5BDC6"
                rx={5.613}
              />
              <rect
                width={787.657}
                height={15.715}
                x={18458}
                y={938.121}
                fill="#B5BDC6"
                rx={5.613}
              />
              <mask
                id="PulseLogicFig_svg__g"
                width={789}
                height={50}
                x={18457}
                y={904}
                maskUnits="userSpaceOnUse"
                style={{ maskType: "alpha" }}
              >
                <rect
                  width={56.485}
                  height={32.553}
                  x={18458}
                  y={904.445}
                  fill="#E0E0E0"
                  rx={5.613}
                />
                <rect
                  width={56.485}
                  height={32.553}
                  x={18516}
                  y={904.445}
                  fill="#E0E0E0"
                  rx={5.613}
                />
                <rect
                  width={56.485}
                  height={32.553}
                  x={18574.1}
                  y={904.445}
                  fill="#E0E0E0"
                  rx={5.613}
                />
                <rect
                  width={305.962}
                  height={32.553}
                  x={18632.1}
                  y={904.445}
                  fill="#E0E0E0"
                  rx={5.613}
                />
                <rect
                  width={305.962}
                  height={32.553}
                  x={18939.7}
                  y={904.445}
                  fill="#E0E0E0"
                  rx={5.613}
                />
                <rect
                  width={787.657}
                  height={15.715}
                  x={18458}
                  y={938.121}
                  fill="#E0E0E0"
                  rx={5.613}
                />
              </mask>
              <g mask="url(#PulseLogicFig_svg__g)">
                <path fill="#16A34A" d="M18458 904.445h152.197v49.39H18458z" />
              </g>
              <path
                fill="#fff"
                d="M18475 917.651v1.283h-5.7v-1.283zm-.1-5.782-4.9 7.065h-1.1v-.943l4.9-7.038h1.1zm-.6-.916v1.288h-5.4v-1.288zm1.2 5.076v-.115c0-.435.1-.835.2-1.201q.15-.554.6-.959c.2-.27.5-.48.8-.63q.6-.23 1.2-.23.75 0 1.2.23.6.225.9.63c.3.27.4.59.6.959.1.366.1.766.1 1.201v.115c0 .431 0 .831-.1 1.2-.2.365-.3.685-.6.959q-.3.406-.9.63-.45.225-1.2.225-.6 0-1.2-.225c-.3-.149-.6-.359-.8-.63q-.45-.411-.6-.959c-.1-.369-.2-.769-.2-1.2m1.6-.115v.115c0 .248 0 .48.1.696 0 .215.1.405.2.57.1.161.2.287.4.378.1.091.3.137.5.137.3 0 .4-.046.6-.137s.3-.217.4-.378c.1-.165.1-.355.2-.57 0-.216.1-.448.1-.696v-.115c0-.242-.1-.468-.1-.68-.1-.216-.1-.406-.2-.57-.1-.168-.2-.3-.4-.395s-.3-.142-.6-.142c-.2 0-.4.047-.5.142-.2.095-.3.227-.4.395-.1.164-.2.354-.2.57-.1.212-.1.438-.1.68m6.6-1.645v4.665h-1.6v-5.931h1.5zm-.3 1.491h-.4c0-.438.1-.833.2-1.184.1-.354.2-.656.5-.904.2-.252.4-.444.7-.576q.45-.202.9-.202c.3 0 .6.04.8.12q.3.12.6.384c.2.175.3.407.4.696s.1.641.1 1.058v3.782h-1.6v-3.788c0-.263 0-.467-.1-.614a1 1 0 0 0-.3-.307c-.2-.062-.3-.093-.5-.093q-.3 0-.6.126c-.1.084-.3.201-.4.351-.1.146-.1.318-.2.515 0 .198-.1.41-.1.636m7.7 3.283q-.6 0-1.2-.219-.6-.225-.9-.619-.45-.395-.6-.916c-.1-.35-.2-.723-.2-1.118v-.219c0-.449 0-.861.2-1.233.1-.373.3-.696.5-.97q.45-.411.9-.631.45-.224 1.2-.224c.4 0 .8.069 1.1.208s.6.336.8.592.4.563.5.921c.1.354.2.749.2 1.183v.658h-4.7v-1.052h3.1v-.121c0-.219 0-.414-.1-.586-.1-.176-.2-.314-.4-.417q-.15-.153-.6-.153c-.2 0-.3.045-.5.137-.1.091-.3.219-.4.383 0 .165-.1.359-.2.581v.943c0 .238 0 .457.1.658q0 .301.3.521c.1.146.2.259.4.339q.3.121.6.121c.3 0 .6-.055.8-.164.3-.114.5-.284.7-.51l.7.833c-.1.179-.3.351-.5.515s-.4.3-.7.406c-.3.102-.7.153-1.1.153m8.7-.109h-1.7v-1.283h1.7c.4 0 .8-.097 1.1-.29.3-.198.5-.485.7-.861.1-.376.2-.831.2-1.365v-.389c0-.409 0-.769-.1-1.08-.1-.31-.2-.571-.4-.783q-.3-.318-.6-.477-.45-.165-.9-.165h-1.8v-1.288h1.8q.9 0 1.5.274.6.269 1.2.773c.3.336.5.738.7 1.206q.3.696.3 1.551v.378a3.9 3.9 0 0 1-.3 1.551c-.2.468-.4.87-.7 1.206q-.6.499-1.2.773c-.5.179-.9.269-1.5.269m-.8-7.981v7.981h-1.6v-7.981zM18534.3 917.651v1.283h-5.7v-1.283zm-.1-5.782-4.8 7.065h-1.2v-.943l4.9-7.038h1.1zm-.6-.916v1.288h-5.4v-1.288zm1.3 5.076v-.115c0-.435 0-.835.2-1.201.1-.369.3-.689.5-.959q.3-.405.9-.63.45-.23 1.2-.23.6 0 1.2.23c.3.15.6.36.8.63q.45.405.6.959c.1.366.2.766.2 1.201v.115c0 .431-.1.831-.2 1.2q-.15.548-.6.959c-.2.271-.5.481-.8.63q-.6.225-1.2.225-.75 0-1.2-.225-.6-.224-.9-.63c-.2-.274-.4-.594-.5-.959-.2-.369-.2-.769-.2-1.2m1.5-.115v.115c0 .248.1.48.1.696.1.215.1.405.2.57.1.161.2.287.4.378s.3.137.6.137c.2 0 .4-.046.5-.137.2-.091.3-.217.4-.378.1-.165.2-.355.2-.57.1-.216.1-.448.1-.696v-.115c0-.242 0-.468-.1-.68 0-.216-.1-.406-.2-.57-.1-.168-.2-.3-.4-.395-.1-.095-.3-.142-.5-.142-.3 0-.4.047-.6.142s-.3.227-.4.395c-.1.164-.1.354-.2.57 0 .212-.1.438-.1.68m6.6-1.645v4.665h-1.6v-5.931h1.5zm-.2 1.491h-.5c0-.438.1-.833.2-1.184.1-.354.3-.656.5-.904.2-.252.4-.444.7-.576.3-.135.6-.202 1-.202.2 0 .5.04.7.12q.45.12.6.384c.2.175.3.407.4.696s.1.641.1 1.058v3.782h-1.5v-3.788c0-.263-.1-.467-.2-.614q0-.219-.3-.307c-.1-.062-.3-.093-.5-.093s-.4.042-.5.126c-.2.084-.3.201-.4.351q-.15.22-.3.515zm7.7 3.283c-.5 0-.9-.073-1.3-.219q-.45-.225-.9-.619-.3-.395-.6-.916c-.1-.35-.2-.723-.2-1.118v-.219c0-.449.1-.861.2-1.233q.15-.56.6-.97c.2-.274.5-.485.8-.631q.6-.224 1.2-.224c.4 0 .8.069 1.1.208s.6.336.8.592c.3.256.4.563.5.921.2.354.2.749.2 1.183v.658h-4.7v-1.052h3.2v-.121c0-.219-.1-.414-.2-.586 0-.176-.2-.314-.3-.417a1.3 1.3 0 0 0-.6-.153q-.3 0-.6.137-.15.137-.3.383c-.1.165-.2.359-.2.581-.1.22-.1.461-.1.724v.219c0 .238 0 .457.1.658q.15.301.3.521c.1.146.3.259.5.339q.15.121.6.121c.3 0 .5-.055.8-.164q.3-.171.6-.51l.8.833c-.1.179-.3.351-.5.515s-.5.3-.8.406c-.3.102-.6.153-1 .153m11.6-1.392v1.283h-4.3v-1.283zm-3.8-6.698v7.981h-1.6v-7.981zm3.2 3.251v1.249h-3.7v-1.249zm.5-3.251v1.288h-4.2v-1.288zM18592.4 917.651v1.283h-5.6v-1.283zm-.1-5.782-4.8 7.065h-1.2v-.943l4.9-7.038h1.1zm-.5-.916v1.288h-5.5v-1.288zm1.2 5.076v-.115c0-.435.1-.835.2-1.201.1-.369.3-.689.5-.959q.45-.405.9-.63.45-.23 1.2-.23.6 0 1.2.23.45.225.9.63c.2.27.4.59.5.959.1.366.2.766.2 1.201v.115c0 .431-.1.831-.2 1.2-.1.365-.3.685-.5.959q-.45.406-.9.63-.45.225-1.2.225-.6 0-1.2-.225-.45-.224-.9-.63c-.2-.274-.4-.594-.5-.959-.1-.369-.2-.769-.2-1.2m1.6-.115v.8109999999999999c.1.215.2.405.2.57.1.161.3.287.4.378q.3.137.6.137t.6-.137c.1-.091.3-.217.3-.378q.15-.248.3-.57v-1.491q-.15-.324-.3-.57-.15-.252-.3-.395-.3-.142-.6-.142t-.6.142c-.1.095-.3.227-.4.395 0 .164-.1.354-.2.57zm6.5-1.645v4.665h-1.6v-5.931h1.5zm-.2 1.491h-.4c0-.438 0-.833.1-1.184.2-.354.3-.656.5-.904.2-.252.5-.444.7-.576.3-.135.6-.202 1-.202.3 0 .5.04.8.12q.3.12.6.384.15.262.3.696c.1.289.2.641.2 1.058v3.782h-1.6v-3.788c0-.263-.1-.467-.1-.614a1 1 0 0 0-.3-.307q-.3-.093-.6-.093c-.2 0-.4.042-.5.126-.2.084-.3.201-.4.351-.1.146-.2.318-.2.515-.1.198-.1.41-.1.636m7.7 3.283q-.75 0-1.2-.219c-.4-.15-.7-.356-1-.619-.2-.263-.4-.569-.5-.916q-.3-.525-.3-1.118v-.219c0-.449.1-.861.2-1.233q.3-.56.6-.97.3-.411.9-.631c.3-.15.7-.224 1.1-.224s.8.069 1.1.208c.4.139.6.336.9.592.2.256.4.563.5.921.1.354.1.749.1 1.183v.658h-4.7v-1.052h3.2v-.121c0-.219-.1-.414-.1-.586-.1-.176-.2-.314-.4-.417q-.15-.153-.6-.153c-.2 0-.4.045-.5.137-.2.091-.3.219-.4.383-.1.165-.2.359-.2.581 0 .22-.1.461-.1.724v.219c0 .238.1.457.1.658q.15.301.3.521c.1.146.3.259.5.339q.3.121.6.121c.3 0 .6-.055.8-.164.2-.114.5-.284.6-.51l.8.833c-.1.179-.3.351-.5.515s-.5.3-.8.406c-.3.102-.6.153-1 .153m7.9-8.09v7.981h-1.7v-7.981zm3.2 3.409v1.283h-3.7v-1.283zm.3-3.409v1.288h-4v-1.288zM18774.5 917.651v1.283h-5.7v-1.283zm-.1-5.782-4.9 7.065h-1.1v-.943l4.9-7.038h1.1zm-.6-.916v1.288h-5.4v-1.288zm1.2 5.076v-.115c0-.435.1-.835.2-1.201.2-.369.3-.689.6-.959.2-.27.5-.48.8-.63q.6-.23 1.2-.23.75 0 1.2.23.6.225.9.63.45.405.6.959c.1.366.2.766.2 1.201v.115c0 .431-.1.831-.2 1.2q-.15.548-.6.959-.3.406-.9.63c-.3.15-.7.225-1.1.225q-.75 0-1.2-.225-.6-.224-.9-.63c-.3-.274-.4-.594-.6-.959-.1-.369-.2-.769-.2-1.2m1.6-.115v.115c0 .248 0 .48.1.696 0 .215.1.405.2.57.1.161.2.287.4.378q.15.137.6.137c.2 0 .4-.046.5-.137.2-.091.3-.217.4-.378.1-.165.2-.355.2-.57.1-.216.1-.448.1-.696v-.115c0-.242 0-.468-.1-.68 0-.216-.1-.406-.2-.57-.1-.168-.2-.3-.4-.395q-.15-.142-.6-.142c-.2 0-.4.047-.5.142-.2.095-.3.227-.4.395-.1.164-.2.354-.2.57-.1.212-.1.438-.1.68m6.6-1.645v4.665h-1.6v-5.931h1.5zm-.3 1.491h-.4c0-.438.1-.833.2-1.184.1-.354.3-.656.5-.904.2-.252.4-.444.7-.576q.45-.202.9-.202c.3 0 .6.04.8.12q.3.12.6.384c.2.175.3.407.4.696s.1.641.1 1.058v3.782h-1.6v-3.788c0-.263 0-.467-.1-.614 0-.146-.2-.248-.3-.307-.1-.062-.3-.093-.5-.093q-.3 0-.6.126c-.1.084-.2.201-.4.351-.1.146-.1.318-.2.515 0 .198-.1.41-.1.636m7.8 3.283c-.5 0-.9-.073-1.3-.219q-.6-.225-.9-.619-.45-.395-.6-.916c-.1-.35-.2-.723-.2-1.118v-.219c0-.449.1-.861.2-1.233s.3-.696.5-.97q.45-.411.9-.631c.4-.15.7-.224 1.2-.224.4 0 .8.069 1.1.208s.6.336.8.592.4.563.5.921c.1.354.2.749.2 1.183v.658h-4.7v-1.052h3.1v-.121c0-.219 0-.414-.1-.586q-.15-.263-.3-.417a1.3 1.3 0 0 0-.6-.153q-.3 0-.6.137-.15.137-.3.383-.15.248-.3.581v.943c0 .238 0 .457.1.658s.1.374.3.521c.1.146.3.259.4.339.2.081.4.121.7.121.2 0 .5-.055.7-.164.3-.114.5-.284.7-.51l.8.833c-.2.179-.3.351-.6.515-.2.165-.4.3-.7.406-.3.102-.7.153-1 .153m12.5-4.28v3.162q-.15.225-.6.488c-.2.172-.6.32-1 .444q-.6.186-1.5.186c-.5 0-.9-.084-1.4-.252-.4-.172-.8-.422-1.1-.751s-.5-.731-.7-1.206c-.1-.478-.2-1.025-.2-1.638v-.499c0-.614.1-1.16.2-1.639.2-.479.4-.882.7-1.211s.7-.579 1.1-.751.8-.258 1.3-.258c.7 0 1.3.113 1.7.34.5.223.8.534 1.1.932.2.394.3.848.4 1.359h-1.6c0-.27-.1-.506-.2-.707s-.3-.358-.5-.471c-.2-.114-.5-.17-.8-.17s-.5.056-.8.17c-.2.109-.4.272-.5.487-.1.216-.3.483-.3.801-.1.318-.1.687-.1 1.107v.51c0 .416 0 .785.1 1.107q.15.477.3.805.3.324.6.488c.3.11.5.165.8.165s.5-.022.7-.066.3-.097.4-.159q.15-.099.3-.186v-1.414h-1.5v-1.173zM18773.6 923.546v8.024h-1v-6.758l-2.1.746v-.916l2.9-1.096zm8 3.398v1.217c0 .654-.1 1.206-.2 1.655s-.3.812-.5 1.086-.5.473-.8.597c-.3.121-.7.181-1 .181q-.45 0-.9-.115c-.2-.077-.5-.199-.7-.367-.2-.172-.4-.395-.5-.669-.2-.274-.3-.607-.4-.998 0-.391-.1-.847-.1-1.37v-1.217c0-.654.1-1.202.2-1.644s.3-.796.5-1.063c.2-.271.5-.464.8-.581s.7-.176 1.1-.176c.3 0 .5.039.8.116.3.073.5.191.7.356.2.161.4.376.5.647.2.266.3.593.4.981 0 .387.1.842.1 1.364m-1 1.382v-1.552c0-.358-.1-.672-.1-.942 0-.274-.1-.508-.2-.702a2.6 2.6 0 0 0-.3-.471c-.1-.121-.3-.208-.4-.263a2 2 0 0 0-.5-.088c-.3 0-.5.046-.7.137-.2.088-.3.228-.5.422-.1.194-.2.448-.2.762-.1.314-.1.696-.1 1.145v2.5c.1.274.1.511.2.712q.15.296.3.488c.1.128.3.223.4.285q.3.088.6.088t.6-.143c.2-.095.4-.243.5-.444q.15-.307.3-.783c0-.322.1-.706.1-1.151m6.2-1.508v4.752h-1v-5.93h.9zm-.2 1.562-.5-.016c0-.406.1-.78.2-1.124.1-.347.2-.648.4-.904s.5-.453.8-.592c.3-.142.6-.214 1-.214.3 0 .5.04.8.121q.3.115.6.367c.2.168.3.384.4.647s.1.581.1.954v3.951h-1v-3.902c0-.311 0-.559-.1-.746s-.3-.321-.5-.405c-.2-.088-.4-.132-.7-.132s-.5.053-.7.159-.4.252-.5.439c-.1.186-.2.4-.2.641-.1.238-.1.49-.1.756m3.8-.559-.7.209c0-.326.1-.638.2-.938s.3-.566.5-.8.4-.418.7-.553c.3-.139.6-.209 1-.209.3 0 .6.042.8.126.3.084.5.214.7.39.1.171.3.392.4.663 0 .27.1.592.1.964v3.897h-1v-3.908c0-.332-.1-.59-.2-.772-.1-.187-.2-.316-.4-.39-.2-.076-.4-.115-.7-.115q-.3 0-.6.115c-.2.077-.3.183-.4.318q-.15.198-.3.455c-.1.172-.1.355-.1.548m6.3-2.181v5.93h-1v-5.93zm-1.1-1.573c0-.165.1-.303.2-.417s.2-.17.4-.17.4.057.5.17.1.252.1.417c0 .157 0 .292-.1.405-.1.11-.3.165-.5.165s-.3-.055-.4-.165c-.1-.113-.2-.248-.2-.405m3.8 2.839v4.664h-1.1v-5.93h1zm-.3 1.474-.4-.016c0-.406.1-.78.2-1.124.1-.347.3-.648.5-.904s.4-.453.7-.592c.3-.142.7-.214 1-.214s.6.04.8.121q.3.115.6.373c.2.171.3.394.4.668.1.271.1.601.1.992v3.886h-1v-3.897c0-.31-.1-.559-.1-.745-.1-.19-.3-.327-.4-.411-.2-.088-.4-.132-.7-.132-.2 0-.5.053-.7.159s-.4.252-.5.439c-.2.186-.3.4-.4.641 0 .238-.1.49-.1.756M18478.9 930.737v.833h-5.2v-.729l2.6-2.91c.4-.358.6-.661.8-.91.2-.252.3-.477.4-.674 0-.201.1-.406.1-.614 0-.263-.1-.501-.2-.712-.1-.216-.3-.388-.5-.516s-.4-.191-.7-.191q-.6 0-.9.208c-.2.135-.4.325-.5.57-.2.245-.2.526-.2.844h-1q0-.675.3-1.233c.2-.373.5-.669.8-.888q.6-.335 1.5-.335c.5 0 .9.09 1.3.269.3.175.6.424.8.745q.3.477.3 1.119c0 .233-.1.471-.1.712-.1.238-.2.475-.4.713-.1.237-.3.471-.4.701q-.3.345-.6.68l-2.2 2.318zm5-3.919v4.752h-1v-5.93h1zm-.2 1.562-.4-.016c0-.406 0-.78.1-1.124.1-.347.3-.648.5-.904s.4-.453.7-.592c.3-.142.7-.214 1.1-.214.2 0 .5.04.7.121q.45.115.6.367c.2.168.3.384.4.647s.2.581.2.954v3.951h-1v-3.902c0-.311-.1-.559-.2-.746s-.2-.321-.4-.405c-.2-.088-.4-.132-.7-.132s-.6.053-.8.159-.3.252-.4.439c-.2.186-.2.4-.3.641 0 .238-.1.49-.1.756m3.9-.559-.7.209c0-.326 0-.638.1-.938.2-.299.3-.566.5-.8s.5-.418.7-.553c.3-.139.7-.209 1-.209.4 0 .6.042.9.126q.3.126.6.39c.2.171.3.392.4.663.1.27.1.592.1.964v3.897h-1v-3.908c0-.332 0-.59-.1-.772-.1-.187-.3-.316-.5-.39-.2-.076-.4-.115-.7-.115-.2 0-.4.039-.5.115-.2.077-.4.183-.5.318-.1.132-.2.284-.2.455-.1.172-.1.355-.1.548m6.3-2.181v5.93h-1v-5.93zm-1.1-1.573c0-.165 0-.303.1-.417s.3-.17.5-.17.3.057.4.17.2.252.2.417c0 .157-.1.292-.2.405-.1.11-.2.165-.4.165s-.4-.055-.5-.165c-.1-.113-.1-.248-.1-.405m3.7 2.839v4.664h-1v-5.93h1zm-.2 1.474-.4-.016c0-.406 0-.78.1-1.124.1-.347.3-.648.5-.904s.5-.453.8-.592c.3-.142.6-.214 1-.214.3 0 .5.04.8.121.2.077.4.201.5.373.2.171.3.394.4.668.1.271.2.601.2.992v3.886h-1.1v-3.897c0-.31 0-.559-.1-.745-.1-.19-.2-.327-.4-.411a1.5 1.5 0 0 0-.6-.132c-.3 0-.5.053-.7.159q-.3.159-.6.439-.15.28-.3.641c-.1.238-.1.49-.1.756M18537 930.737v.833h-5.2v-.729l2.6-2.91c.3-.358.6-.661.7-.91.2-.252.3-.477.4-.674.1-.201.1-.406.1-.614 0-.263 0-.501-.1-.712-.1-.216-.3-.388-.5-.516s-.5-.191-.8-.191q-.45 0-.9.208c-.2.135-.4.325-.5.57s-.2.526-.2.844h-1q0-.675.3-1.233.3-.56.9-.888c.4-.223.9-.335 1.4-.335s1 .09 1.3.269c.4.175.7.424.8.745q.3.477.3 1.119c0 .233 0 .471-.1.712l-.3.713c-.1.237-.3.471-.5.701q-.3.345-.6.68l-2.1 2.318zm5-3.919v4.752h-1v-5.93h.9zm-.2 1.562-.5-.016c0-.406.1-.78.2-1.124.1-.347.2-.648.4-.904s.5-.453.8-.592c.3-.142.6-.214 1-.214.3 0 .6.04.8.121q.3.115.6.367c.2.168.3.384.4.647s.1.581.1.954v3.951h-1v-3.902c0-.311 0-.559-.1-.746s-.3-.321-.5-.405a1.5 1.5 0 0 0-.6-.132c-.3 0-.6.053-.8.159s-.4.252-.5.439c-.1.186-.2.4-.2.641-.1.238-.1.49-.1.756m3.8-.559-.7.209c0-.326.1-.638.2-.938s.3-.566.5-.8.4-.418.7-.553c.3-.139.6-.209 1-.209.3 0 .6.042.8.126.3.084.5.214.7.39.1.171.3.392.4.663 0 .27.1.592.1.964v3.897h-1v-3.908c0-.332-.1-.59-.2-.772-.1-.187-.2-.316-.4-.39-.2-.076-.4-.115-.7-.115q-.3 0-.6.115c-.2.077-.3.183-.4.318q-.15.198-.3.455c0 .172-.1.355-.1.548m6.3-2.181v5.93h-1v-5.93zm-1.1-1.573c0-.165.1-.303.2-.417s.2-.17.4-.17.4.057.5.17.1.252.1.417c0 .157 0 .292-.1.405-.1.11-.3.165-.5.165s-.3-.055-.4-.165c-.1-.113-.2-.248-.2-.405m3.8 2.839v4.664h-1v-5.93h.9zm-.3 1.474-.4-.016c0-.406.1-.78.2-1.124.1-.347.3-.648.5-.904s.4-.453.7-.592c.3-.142.7-.214 1-.214s.6.04.8.121q.3.115.6.373c.2.171.3.394.4.668.1.271.1.601.1.992v3.886h-1v-3.897c0-.31 0-.559-.1-.745-.1-.19-.3-.327-.4-.411-.2-.088-.4-.132-.7-.132-.2 0-.5.053-.7.159s-.4.252-.5.439c-.2.186-.3.4-.4.641 0 .238-.1.49-.1.756M18595.1 930.737v.833h-5.3v-.729l2.7-2.91c.3-.358.5-.661.7-.91.2-.252.3-.477.4-.674 0-.201.1-.406.1-.614 0-.263-.1-.501-.2-.712-.1-.216-.2-.388-.5-.516-.2-.128-.4-.191-.7-.191q-.6 0-.9.208c-.2.135-.4.325-.5.57s-.2.526-.2.844h-1q0-.675.3-1.233.3-.56.9-.888c.3-.223.8-.335 1.4-.335.5 0 .9.09 1.3.269.3.175.6.424.8.745q.3.477.3 1.119c0 .233 0 .471-.1.712-.1.238-.2.475-.4.713-.1.237-.2.471-.4.701q-.3.345-.6.68l-2.1 2.318zm4.9-3.919v4.752h-1v-5.93h1zm-.2 1.562-.4-.016c0-.406 0-.78.1-1.124.1-.347.3-.648.5-.904s.4-.453.7-.592c.3-.142.7-.214 1.1-.214.3 0 .5.04.7.121.3.077.5.199.7.367.1.168.3.384.4.647 0 .263.1.581.1.954v3.951h-1v-3.902c0-.311-.1-.559-.2-.746s-.2-.321-.4-.405c-.2-.088-.4-.132-.7-.132s-.5.053-.7.159-.4.252-.5.439q-.15.28-.3.641c0 .238-.1.49-.1.756m3.9-.559-.7.209c0-.326.1-.638.2-.938s.2-.566.4-.8.5-.418.8-.553c.2-.139.6-.209 1-.209.3 0 .6.042.8.126q.45.126.6.39c.2.171.3.392.4.663.1.27.1.592.1.964v3.897h-1v-3.908c0-.332 0-.59-.1-.772-.1-.187-.3-.316-.5-.39a1.7 1.7 0 0 0-.6-.115q-.45 0-.6.115c-.2.077-.3.183-.5.318-.1.132-.2.284-.2.455-.1.172-.1.355-.1.548m6.3-2.181v5.93h-1v-5.93zm-1.1-1.573c0-.165 0-.303.1-.417s.3-.17.5-.17.3.057.4.17.2.252.2.417c0 .157-.1.292-.2.405-.1.11-.2.165-.4.165s-.4-.055-.5-.165c-.1-.113-.1-.248-.1-.405m3.7 2.839v4.664h-1v-5.93h1zm-.2 1.474-.4-.016c0-.406 0-.78.1-1.124.2-.347.3-.648.5-.904s.5-.453.8-.592c.3-.142.6-.214 1-.214.3 0 .5.04.8.121q.3.115.6.373c.1.171.3.394.3.668.1.271.2.601.2.992v3.886h-1v-3.897c0-.31-.1-.559-.2-.745-.1-.19-.2-.327-.4-.411a1.5 1.5 0 0 0-.6-.132c-.3 0-.5.053-.7.159s-.4.252-.5.439c-.2.186-.3.4-.4.641-.1.238-.1.49-.1.756M19079.5 923.546v8.024h-1v-6.758l-2 .746v-.916l2.9-1.096zm8 3.398v1.217c0 .654 0 1.206-.1 1.655-.2.45-.3.812-.5 1.086-.3.274-.5.473-.8.597-.3.121-.7.181-1.1.181-.3 0-.6-.038-.8-.115a1.66 1.66 0 0 1-.7-.367 4 4 0 0 1-.6-.669q-.15-.411-.3-.998c-.1-.391-.1-.847-.1-1.37v-1.217c0-.654.1-1.202.2-1.644s.3-.796.5-1.063c.2-.271.5-.464.8-.581s.6-.176 1-.176q.45 0 .9.116c.2.073.5.191.7.356.2.161.3.376.5.647q.15.399.3.981c.1.387.1.842.1 1.364m-1 1.382v-2.4939999999999998c-.1-.274-.1-.508-.2-.702a2.6 2.6 0 0 0-.3-.471c-.2-.121-.3-.208-.5-.263-.1-.059-.3-.088-.5-.088q-.3 0-.6.137c-.2.088-.4.228-.5.422q-.15.291-.3.762c-.1.314-.1.696-.1 1.145v1.552c0 .358 0 .674.1.948 0 .274.1.511.2.712q.15.296.3.488c.1.128.2.223.4.285.2.059.3.088.5.088.3 0 .5-.048.7-.143s.3-.243.4-.444q.3-.307.3-.783c.1-.322.1-.706.1-1.151m6.2-1.508v4.752h-1v-5.93h1zm-.2 1.562-.4-.016c0-.406 0-.78.1-1.124.1-.347.3-.648.5-.904s.4-.453.7-.592c.3-.142.7-.214 1.1-.214.3 0 .5.04.7.121q.45.115.6.367c.2.168.4.384.4.647.1.263.2.581.2.954v3.951h-1v-3.902c0-.311-.1-.559-.2-.746s-.2-.321-.4-.405c-.2-.088-.4-.132-.7-.132s-.5.053-.7.159-.4.252-.5.439q-.15.28-.3.641c0 .238-.1.49-.1.756m3.9-.559-.7.209c0-.326.1-.638.2-.938s.2-.566.4-.8.5-.418.8-.553c.2-.139.6-.209 1-.209.3 0 .6.042.8.126q.45.126.6.39c.2.171.3.392.4.663.1.27.1.592.1.964v3.897h-1v-3.908c0-.332 0-.59-.1-.772-.1-.187-.3-.316-.5-.39a1.7 1.7 0 0 0-.6-.115q-.45 0-.6.115c-.2.077-.3.183-.5.318-.1.132-.2.284-.2.455-.1.172-.1.355-.1.548m6.3-2.181v5.93h-1v-5.93zm-1.1-1.573c0-.165 0-.303.1-.417s.3-.17.5-.17.3.057.4.17.2.252.2.417c0 .157-.1.292-.2.405-.1.11-.2.165-.4.165s-.4-.055-.5-.165c-.1-.113-.1-.248-.1-.405m3.7 2.839v4.664h-1v-5.93h1zm-.2 1.474-.4-.016c0-.406 0-.78.1-1.124.2-.347.3-.648.5-.904s.5-.453.8-.592c.3-.142.6-.214 1-.214.3 0 .5.04.8.121q.3.115.6.373c.1.171.3.394.3.668.1.271.2.601.2.992v3.886h-1v-3.897c0-.31-.1-.559-.2-.745-.1-.19-.2-.327-.4-.411a1.5 1.5 0 0 0-.6-.132c-.3 0-.5.053-.7.159s-.4.252-.5.439c-.2.186-.3.4-.4.641-.1.238-.1.49-.1.756M19082.6 917.651v1.283h-5.6v-1.283zm0-5.782-4.9 7.065h-1.1v-.943l4.8-7.038h1.2zm-.6-.916v1.288h-5.4v-1.288zm1.2 5.076v-.115c0-.435.1-.835.2-1.201q.15-.554.6-.959c.2-.27.5-.48.8-.63q.6-.23 1.2-.23.75 0 1.2.23.6.225.9.63t.6.959c.1.366.1.766.1 1.201v.115c0 .431 0 .831-.1 1.2q-.3.548-.6.959-.3.406-.9.63-.45.225-1.2.225-.6 0-1.2-.225c-.3-.149-.6-.359-.8-.63q-.45-.411-.6-.959c-.1-.369-.2-.769-.2-1.2m1.6-.115v.115c0 .248 0 .48.1.696 0 .215.1.405.2.57.1.161.2.287.4.378.1.091.3.137.5.137.3 0 .4-.046.6-.137s.3-.217.4-.378c.1-.165.1-.355.2-.57 0-.216.1-.448.1-.696v-.115c0-.242-.1-.468-.1-.68-.1-.216-.1-.406-.2-.57-.1-.168-.2-.3-.4-.395q-.3-.142-.6-.142c-.2 0-.4.047-.5.142-.2.095-.3.227-.4.395-.1.164-.2.354-.2.57-.1.212-.1.438-.1.68m6.6-1.645v4.665h-1.6v-5.931h1.5zm-.3 1.491h-.4c0-.438.1-.833.2-1.184.1-.354.2-.656.4-.904.2-.252.5-.444.8-.576q.45-.202.9-.202c.3 0 .6.04.8.12q.3.12.6.384c.1.175.3.407.4.696s.1.641.1 1.058v3.782h-1.6v-3.788c0-.263 0-.467-.1-.614a1 1 0 0 0-.3-.307c-.2-.062-.3-.093-.5-.093q-.3 0-.6.126c-.1.084-.3.201-.4.351-.1.146-.1.318-.2.515 0 .198-.1.41-.1.636m7.7 3.283q-.6 0-1.2-.219-.6-.225-.9-.619-.45-.395-.6-.916c-.2-.35-.2-.723-.2-1.118v-.219c0-.449 0-.861.2-1.233.1-.373.3-.696.5-.97q.45-.411.9-.631.45-.224 1.2-.224c.4 0 .7.069 1.1.208.3.139.6.336.8.592s.4.563.5.921c.1.354.2.749.2 1.183v.658h-4.7v-1.052h3.1v-.121c0-.219 0-.414-.1-.586-.1-.176-.2-.314-.4-.417q-.15-.153-.6-.153c-.2 0-.3.045-.5.137-.1.091-.3.219-.4.383-.1.165-.1.359-.2.581v.943c0 .238 0 .457.1.658q0 .301.3.521c.1.146.2.259.4.339q.3.121.6.121c.3 0 .6-.055.8-.164.3-.114.5-.284.7-.51l.7.833c-.1.179-.3.351-.5.515s-.4.3-.7.406c-.3.102-.7.153-1.1.153m11.6-4.839v1.282h-4.2v-1.282zm-3.7-3.251v7.981h-1.6v-7.981zm4.9 0v7.981h-1.7v-7.981zM18807.1 946.398h-2v-1.283h2c.3 0 .6-.051.8-.153.2-.106.3-.253.4-.439s.1-.396.1-.63c0-.238 0-.459-.1-.663s-.2-.369-.4-.494c-.2-.124-.5-.186-.8-.186h-1.5v6.692h-1.6v-7.98h3.1c.6 0 1.2.113 1.6.34.5.223.8.531 1 .926.3.395.4.846.4 1.354 0 .515-.1.961-.4 1.337-.2.377-.5.667-1 .872-.4.204-1 .307-1.6.307m7.5 1.425v-4.511h1.6v5.93h-1.5zm.2-1.217.5-.011c0 .395-.1.762-.2 1.102 0 .336-.2.628-.4.877-.1.244-.4.436-.7.575-.2.135-.6.203-.9.203s-.6-.04-.8-.121a1.7 1.7 0 0 1-.7-.389c-.1-.179-.3-.407-.4-.685-.1-.281-.1-.619-.1-1.014v-3.831h1.6v4.2860000000000005c.1.12.1.219.2.296q.15.115.3.164.15.05.3.05c.4 0 .6-.066.8-.198.2-.131.3-.31.4-.537.1-.23.1-.486.1-.767m4.2-2.066v4.702h-1.6v-5.93h1.5zm-.2 1.529h-.5c0-.413.1-.793.2-1.14.1-.351.2-.654.4-.91.2-.26.5-.461.8-.603.3-.143.6-.214 1-.214.2 0 .5.04.7.121q.3.115.6.367.15.246.3.647c.1.263.2.579.2.948v3.957h-1.6v-3.782c0-.27 0-.478-.1-.625a1 1 0 0 0-.3-.306c-.2-.059-.3-.088-.5-.088s-.4.042-.5.126c-.2.084-.3.201-.4.351-.1.146-.2.318-.2.515-.1.197-.1.409-.1.636m3.5-.181-.5.071c0-.387 0-.747.1-1.08.1-.332.2-.624.4-.877.2-.252.5-.447.7-.586.3-.143.7-.214 1-.214s.6.042.8.126q.3.121.6.389c.2.176.3.406.4.691s.1.634.1 1.047v3.787h-1.6v-3.787c0-.274 0-.482-.1-.625q0-.22-.3-.301c-.1-.059-.3-.088-.4-.088-.2 0-.4.038-.5.115-.2.073-.3.175-.4.307-.1.131-.2.285-.2.46-.1.172-.1.36-.1.565m6.4-1.436v7.07h-1.5v-8.21h1.4zm3.8 1.759v.115c0 .431-.1.832-.2 1.201s-.2.69-.4.964c-.2.271-.4.483-.7.636-.3.15-.6.225-1 .225s-.7-.073-1-.219c-.2-.147-.5-.351-.6-.614-.2-.267-.4-.576-.5-.927-.1-.35-.2-.727-.2-1.129v-.301c0-.431.1-.826.2-1.184.1-.362.3-.674.5-.937.1-.267.4-.473.6-.62.3-.146.6-.219 1-.219.3 0 .7.071 1 .214.3.142.5.347.7.614s.3.584.4.953c.1.37.2.779.2 1.228m-1.6.115v-.115c0-.252 0-.484-.1-.696 0-.215-.1-.404-.2-.564q-.15-.241-.3-.373c-.2-.091-.3-.137-.5-.137q-.3 0-.6.104c-.1.069-.3.17-.4.301 0 .132-.1.289-.2.472 0 .183 0 .389-.1.619v.762c.1.27.1.513.2.729.1.212.2.38.4.504s.4.187.7.187c.2 0 .4-.046.5-.137.1-.095.3-.225.3-.39.1-.164.2-.354.2-.57.1-.215.1-.447.1-.696M18853.3 945.042h.7q.6 0 .9-.175c.3-.121.4-.283.5-.488.2-.208.2-.442.2-.701 0-.307 0-.565-.1-.773s-.3-.366-.5-.472-.5-.159-.8-.159-.5.057-.7.17c-.2.11-.4.267-.5.472-.2.204-.2.446-.2.723h-1q0-.607.3-1.107c.2-.332.5-.597.8-.795.4-.197.8-.296 1.3-.296s.9.086 1.3.258c.4.168.6.42.8.756q.3.5.3 1.245c0 .2 0 .416-.1.646-.1.227-.2.439-.4.636s-.5.36-.8.488c-.3.124-.7.186-1.1.186h-.9zm0 .833v-.608h.9q.75 0 1.2.181c.4.121.6.281.8.482s.4.422.4.663c.1.238.2.475.2.713 0 .373-.1.703-.2.992-.2.289-.3.534-.6.734-.2.201-.5.353-.8.455s-.6.154-1 .154c-.3 0-.6-.049-1-.148-.3-.099-.5-.241-.8-.428-.2-.19-.4-.422-.5-.696-.1-.277-.2-.593-.2-.948h1c0 .278.1.521.2.729s.3.371.5.488c.3.113.5.17.8.17s.6-.053.8-.159c.3-.11.4-.274.6-.493.1-.22.1-.496.1-.828 0-.333 0-.605-.2-.817q-.15-.322-.6-.477-.3-.159-.9-.159zm10.1 2.823v.833h-5.2v-.729l2.6-2.91c.3-.358.5-.661.7-.91.2-.252.3-.477.4-.674.1-.201.1-.406.1-.614 0-.263-.1-.501-.2-.712-.1-.216-.2-.388-.4-.516s-.5-.192-.8-.192q-.45 0-.9.209c-.2.135-.4.325-.5.57s-.2.526-.2.844h-1q0-.675.3-1.233.3-.56.9-.888c.4-.223.8-.335 1.4-.335.5 0 .9.09 1.3.269.4.175.6.424.8.745q.3.477.3 1.118c0 .234 0 .472-.1.713l-.3.712c-.2.238-.3.472-.5.702q-.3.345-.6.68l-2.1 2.318zm5-3.919v4.752h-1v-5.93h.9zm-.2 1.562-.5-.016c0-.406 0-.78.2-1.124.1-.347.2-.648.4-.904s.5-.453.8-.592c.3-.143.6-.214 1-.214.3 0 .5.04.8.121q.3.115.6.367c.1.168.3.384.4.647s.1.581.1.953v3.952h-1v-3.902c0-.311-.1-.559-.2-.746s-.2-.321-.4-.405c-.2-.088-.4-.132-.7-.132s-.5.053-.7.159-.4.252-.5.439q-.15.28-.3.641zm3.8-.559-.7.209c0-.326.1-.638.2-.938s.2-.566.4-.8.5-.418.8-.553c.3-.139.6-.209 1-.209.3 0 .6.042.8.126.3.084.5.214.7.389.1.172.3.393.3.664.1.27.2.592.2.964v3.897h-1v-3.908c0-.332-.1-.59-.2-.772-.1-.187-.3-.317-.4-.39a2.3 2.3 0 0 0-.7-.115q-.3 0-.6.115c-.2.077-.3.183-.4.318-.2.132-.2.283-.3.455s-.1.355-.1.548m6.3-2.181v5.93h-1v-5.93zm-1.1-1.573c0-.165.1-.303.2-.417s.2-.17.4-.17.4.057.5.17.1.252.1.417c0 .157 0 .292-.1.405-.1.11-.3.165-.5.165s-.3-.055-.4-.165c-.1-.113-.2-.248-.2-.405m3.8 2.839v4.664h-1.1v-5.93h1zm-.3 1.474-.4-.016c0-.406.1-.78.2-1.124.1-.347.2-.648.5-.904.2-.256.4-.453.7-.592.3-.143.6-.214 1-.214.3 0 .6.04.8.121q.3.115.6.373c.2.171.3.394.4.668.1.271.1.601.1.992v3.886h-1v-3.897c0-.31-.1-.559-.2-.745 0-.19-.2-.327-.4-.411q-.15-.132-.6-.132c-.3 0-.5.053-.7.159s-.4.252-.5.439c-.2.186-.3.4-.4.641-.1.237-.1.49-.1.756"
              />
              <g filter="url(#PulseLogicFig_svg__h)">
                <rect
                  width={9.414}
                  height={59.492}
                  x={18605.5}
                  y={898.832}
                  fill="#fff"
                  rx={4.707}
                />
              </g>
              <g filter="url(#PulseLogicFig_svg__i)">
                <path
                  fill="#FF4242"
                  d="M19147.6 838.214c0-4.959 4-8.98 9-8.98h79.8c5 0 9 4.021 9 8.98v22.45c0 4.96-4 8.98-9 8.98h-79.8c-5 0-9-4.02-9-8.98z"
                  shapeRendering="crispEdges"
                />
                <path
                  fill="#fff"
                  d="M19198 855.126c-.5 0-1.1-.071-1.6-.212q-.9-.213-1.5-.637c-.5-.283-.8-.636-1.1-1.06s-.5-.922-.5-1.493h2.3c.1.345.3.636.5.872s.5.416.8.542c.4.126.8.189 1.3.189.3 0 .7-.053 1-.158.3-.104.6-.264.8-.479q.3-.322.3-.809c0-.388-.2-.679-.4-.872q-.45-.299-1.2-.472l-2.1-.463c-.6-.126-1.1-.32-1.6-.582-.4-.267-.8-.613-1-1.037-.3-.43-.4-.951-.4-1.564q0-1.06.6-1.831c.4-.513.9-.906 1.6-1.178.7-.278 1.4-.417 2.3-.417q1.35 0 2.4.464.9.456 1.5 1.241c.3.519.5 1.098.5 1.737h-2.3c-.1-.393-.2-.707-.4-.943-.2-.241-.4-.414-.7-.519-.4-.11-.7-.165-1.1-.165q-1.05 0-1.5.417c-.3.278-.5.6-.5.966 0 .346.1.626.4.841.2.21.6.369 1.1.479l2 .425q1.05.212 1.8.675c.4.304.8.674 1 1.108q.3.652.3 1.462 0 1.029-.6 1.815c-.4.519-.9.925-1.6 1.218q-1.05.44-2.4.44m9.6-.071c-.7 0-1.2-.091-1.6-.275-.4-.183-.7-.44-.8-.77q-.3-.495-.3-1.147v-4.424h-1.3v-1.595h1.4l.6-2.451h1.6v2.443h1.8v1.603h-1.8v4.33c0 .199.1.348.1.448.1.094.1.157.2.188.2.026.3.039.5.039h1.1v1.415c-.2.047-.3.091-.5.133-.3.042-.6.063-1 .063m6.3.071c-.7 0-1.4-.17-2-.511s-1.1-.822-1.4-1.446c-.3-.623-.5-1.362-.5-2.215 0-.854.2-1.601.5-2.24s.8-1.137 1.4-1.493q.9-.534 2.1-.534c.8 0 1.5.175 2 .526.6.346 1.1.839 1.4 1.478s.5 1.393.5 2.263c0 .817-.2 1.54-.5 2.168-.3.624-.8 1.113-1.3 1.47-.6.356-1.3.534-2.2.534m.1-1.705q.6 0 .9-.354.45-.353.6-.927c.1-.388.1-.809.1-1.265 0-.43 0-.836-.1-1.218s-.3-.691-.5-.927c-.3-.236-.6-.354-1-.354s-.8.113-1 .338q-.45.33-.6.904c-.1.377-.1.796-.1 1.257 0 .424 0 .833.1 1.226.1.387.3.704.5.951.3.246.6.369 1.1.369m5.4 4.078v-10.655h2.3l.1 1.171c.1-.194.2-.369.4-.527q.3-.243.6-.424c.2-.12.4-.212.7-.275.2-.068.5-.102.8-.102.6 0 1.1.149 1.6.448.5.293.8.749 1.1 1.367.3.613.4 1.393.4 2.342 0 .984-.1 1.794-.4 2.428q-.45.942-1.2 1.398t-1.8.456c-.2 0-.5-.037-.7-.11q-.3-.102-.6-.291t-.6-.432c-.1-.168-.2-.348-.4-.542v3.748zm4.1-4.055q.75 0 1.2-.62.6-.621.6-1.965c0-.785-.2-1.398-.5-1.838-.3-.446-.8-.668-1.3-.668-.6 0-1 .241-1.3.723-.3.476-.5 1.071-.5 1.783 0 .456.1.88.2 1.273q.3.59.6.951c.3.241.6.361 1 .361M19166.7 843.828h11.2v11.225h-11.2z"
                />
              </g>
              <g filter="url(#PulseLogicFig_svg__j)">
                <path
                  fill="#FFA726"
                  d="M19000.7 838.214c0-4.959 4-8.98 8.9-8.98h120.1c5 0 9 4.021 9 8.98v22.45c0 4.96-4 8.98-9 8.98h-120.1c-4.9 0-8.9-4.02-8.9-8.98z"
                  shapeRendering="crispEdges"
                />
                <path
                  fill="#fff"
                  d="M19051.1 854.72c-.6 0-1.1-.071-1.7-.213-.5-.141-1-.353-1.4-.636-.5-.283-.9-.636-1.1-1.061q-.45-.636-.6-1.493h2.4c.1.346.2.637.4.873q.45.353.9.542.6.188 1.2.188c.4 0 .7-.052 1.1-.157.3-.105.5-.264.7-.479.3-.215.4-.485.4-.81 0-.387-.2-.678-.5-.872-.3-.199-.6-.356-1.1-.471l-2.2-.464q-.9-.188-1.5-.581c-.5-.267-.8-.613-1.1-1.037q-.3-.645-.3-1.564 0-1.06.6-1.831c.4-.513.9-.906 1.6-1.178.6-.278 1.4-.417 2.2-.417q1.5 0 2.4.464 1.05.455 1.5 1.241c.4.519.5 1.098.5 1.737h-2.2c-.1-.393-.2-.707-.4-.943-.2-.241-.5-.414-.8-.519-.3-.11-.6-.165-1-.165q-1.05 0-1.5.417c-.4.277-.5.599-.5.966q0 .519.3.841.45.314 1.2.479l2 .424q1.05.213 1.8.676c.4.304.7.673 1 1.108q.3.652.3 1.462 0 1.029-.6 1.815c-.4.518-.9.924-1.6 1.218q-1.05.44-2.4.44m6.3-.158v-11.676h2.3v6.923l3-3.371h2.5l-3 3.237 3.1 4.887h-2.3l-2.2-3.504-1.1 1.147v2.357zm9.1 0v-8.124h2.2v8.124zm0-9.287v-2.067h2.3v2.067zm4.3 11.818v-10.655h2.3v1.171c.1-.194.2-.37.4-.527q.3-.244.6-.424c.2-.121.4-.212.7-.275.2-.068.5-.102.8-.102.6 0 1.1.149 1.6.448.5.293.8.749 1.1 1.367.3.613.4 1.393.4 2.341 0 .985-.1 1.794-.4 2.428q-.45.943-1.2 1.399c-.5.304-1.1.456-1.7.456-.3 0-.5-.037-.8-.11q-.3-.102-.6-.291c-.2-.126-.4-.27-.5-.432-.2-.168-.3-.349-.4-.542v3.748zm4-4.055c.5 0 .9-.207 1.3-.621.3-.413.5-1.068.5-1.964 0-.786-.2-1.399-.5-1.839-.3-.445-.8-.668-1.3-.668-.6 0-1 .241-1.3.723-.3.477-.4 1.072-.4 1.784 0 .456 0 .88.1 1.273q.3.59.6.951c.3.241.6.361 1 .361m8.9 1.524v-1.115l5.7-8.329h-5.3v-1.917h8.6v1.068l-5.8 8.353h5.7v1.94zm14 .158c-.8 0-1.5-.171-2-.511-.6-.341-1.1-.823-1.4-1.446s-.5-1.362-.5-2.216.2-1.6.5-2.239.8-1.137 1.4-1.493c.5-.356 1.2-.534 2-.534q1.2 0 2.1.526c.6.346 1.1.838 1.4 1.477s.5 1.394.5 2.263c0 .817-.2 1.54-.5 2.169-.3.623-.8 1.113-1.3 1.469-.6.357-1.3.535-2.2.535m0-1.705c.4 0 .8-.118 1-.354.3-.236.4-.545.6-.927.1-.388.1-.81.1-1.265 0-.43 0-.836-.1-1.218-.1-.383-.3-.692-.5-.927-.3-.236-.6-.354-1.1-.354q-.6 0-.9.338-.45.33-.6.904c-.1.377-.2.796-.2 1.257 0 .424.1.833.2 1.226.1.387.3.704.5.95.3.246.6.37 1 .37m5.5 1.547v-8.124h2.3v1.147c.1-.199.3-.39.5-.574.2-.188.4-.343.7-.463.4-.121.7-.181 1.1-.181.5 0 1 .097 1.4.291.5.194.8.5 1.1.919.3.414.4.956.4 1.627v5.358h-2.3v-5.075c0-.44-.1-.77-.4-.99-.3-.221-.6-.331-1-.331-.2 0-.5.045-.7.134q-.3.134-.6.401c-.1.178-.2.398-.2.66v5.201zm13.1.158q-1.2 0-2.1-.503c-.7-.341-1.1-.82-1.5-1.438-.3-.618-.5-1.346-.5-2.185 0-.811.2-1.542.5-2.192.3-.655.7-1.171 1.3-1.548.6-.382 1.3-.573 2.2-.573.8 0 1.5.175 2 .526.6.346 1 .83 1.3 1.454.3.618.5 1.333.5 2.145v.621h-5.5c0 .413.1.775.2 1.084q.15.456.6.707c.2.163.6.244.9.244.4 0 .8-.084 1.1-.252.2-.167.5-.442.6-.825h2q-.15.864-.6 1.477c-.4.409-.9.721-1.4.935s-1.1.323-1.6.323m-1.8-5.061h3.3c0-.324-.1-.623-.2-.895-.1-.273-.3-.488-.5-.645q-.45-.235-.9-.235-.6 0-.9.259-.45.252-.6.66c-.2.272-.2.558-.2.856M19017.9 855.053l7.9-5.612-7.9-5.613zm8.4-11.225v11.225l7.9-5.612z"
                />
              </g>
              <g filter="url(#PulseLogicFig_svg__k)">
                <path
                  fill="#6B7280"
                  d="M18881.7 838.214c0-4.959 4-8.98 9-8.98h90.9c4.9 0 9 4.021 9 8.98v22.45c0 4.96-4.1 8.98-9 8.98h-90.9c-5 0-9-4.02-9-8.98z"
                  shapeRendering="crispEdges"
                />
                <path
                  fill="#fff"
                  d="M18930.1 854.562v-11.361h4.2c.8 0 1.5.144 2.2.432q1.05.425 1.5 1.257.6.833.6 2.035c0 .754-.1 1.399-.5 1.933-.3.534-.8.943-1.4 1.226q-.9.424-2.1.424h-2.2v4.054zm2.3-5.83h2.1c.6 0 1.1-.183 1.4-.55q.6-.558.6-1.375 0-.849-.6-1.343c-.4-.336-.9-.503-1.4-.503h-2.1zm9.9 5.988c-.6 0-1-.097-1.4-.291-.5-.194-.8-.474-1-.841-.3-.372-.4-.822-.4-1.351 0-.891.3-1.567 1-2.028.7-.466 1.7-.707 3.2-.722l1-.016v-.487c0-.372-.1-.658-.4-.857-.2-.204-.5-.304-1-.298q-.45.007-.9.235t-.6.794h-1.9c0-.587.2-1.069.5-1.446q.45-.573 1.2-.848.9-.283 1.8-.283c.9 0 1.5.104 2 .314.5.204.9.5 1.1.888.3.382.4.838.4 1.367v5.712h-1.9l-.2-1.398c-.3.587-.7.993-1.1 1.218s-.9.338-1.4.338m.7-1.509q.3 0 .6-.11.3-.119.6-.306.15-.197.3-.44c.1-.163.2-.33.2-.503v-1.203l-.8.016c-.4.005-.8.053-1.1.142-.3.083-.6.222-.8.416q-.3.291-.3.786c0 .377.1.673.4.888.2.209.6.314.9.314m8.7 1.509c-.3 0-.7-.058-1.1-.173-.3-.115-.7-.286-1-.511s-.5-.503-.7-.833q-.3-.495-.3-1.147v-5.618h2.3v5.327c0 .377.2.686.4.927s.6.362 1.1.362c.4 0 .8-.115 1.1-.346.2-.236.4-.563.4-.982v-5.288h2.2v8.124h-1.7l-.3-1.61c-.1.476-.2.843-.5 1.1q-.45.377-.9.518c-.3.1-.6.15-1 .15m9.7 0c-.6 0-1.2-.092-1.7-.275-.5-.189-.9-.482-1.3-.88-.4-.404-.6-.925-.7-1.564h2c.1.288.2.516.4.684.1.167.4.288.6.361q.3.102.6.102c.5 0 .8-.068 1.1-.204.3-.142.4-.356.4-.644 0-.22-.1-.396-.2-.527-.2-.131-.4-.23-.8-.299l-1.4-.298c-.8-.152-1.3-.409-1.8-.77q-.6-.55-.6-1.556 0-.73.3-1.312.45-.582 1.2-.919c.5-.226 1.1-.338 1.9-.338q1.5 0 2.4.66t.9 1.862h-1.9c-.1-.314-.2-.555-.5-.723a1.9 1.9 0 0 0-1-.259q-.6 0-.9.212c-.3.141-.4.356-.4.644q0 .322.3.511c.2.12.5.225 1 .314l1.3.299c.4.11.8.262 1.1.456.3.188.5.395.7.62q.15.338.3.684c0 .225.1.429.1.613 0 .539-.2 1-.5 1.383q-.3.565-1.2.864c-.5.199-1.1.299-1.7.299m8.7 0q-1.2 0-2.1-.503c-.6-.341-1.1-.82-1.4-1.438q-.6-.927-.6-2.185c0-.811.2-1.542.5-2.192.3-.655.8-1.171 1.4-1.548.5-.382 1.3-.573 2.1-.573q1.2 0 2.1.526c.5.346 1 .83 1.2 1.454.3.618.5 1.333.5 2.145v.621h-5.5c0 .413.1.775.2 1.084q.3.456.6.707c.3.163.6.244 1 .244.3 0 .7-.084 1-.252q.45-.25.6-.825h2.1c-.1.576-.4 1.069-.7 1.477-.4.409-.8.721-1.4.935-.5.215-1 .323-1.6.323m-1.8-5.061h3.3c0-.324 0-.623-.2-.895-.1-.273-.3-.488-.5-.645s-.6-.235-.9-.235q-.6 0-.9.259-.45.252-.6.66c-.1.272-.2.558-.2.856M18903 855.986h3.7v-13.095h-3.7zm7.5-13.095v13.095h3.7v-13.095z"
                />
              </g>
              <path
                fill="#FFA726"
                d="M18455.1 849.443c0-7.44 6.1-13.47 13.5-13.47h63.3c7.5 0 13.5 6.03 13.5 13.47 0 7.439-6 13.47-13.5 13.47h-63.3c-7.4 0-13.5-6.031-13.5-13.47"
              />
              <path
                fill="#fff"
                d="M18468.6 841.023c-4.7 0-8.4 3.772-8.4 8.419s3.7 8.419 8.4 8.419c4.6 0 8.4-3.772 8.4-8.419s-3.8-8.419-8.4-8.419m-1.7 12.208v-7.577l5.1 3.788z"
              />
              <g clipPath="url(#PulseLogicFig_svg__l)">
                <path
                  fill="#fff"
                  d="M18483.3 854.219v-10.551h4.3c.8 0 1.5.127 2 .38q.75.371 1.2 1.058c.2.452.4.982.4 1.59q0 .847-.3 1.423c-.2.379-.4.691-.7.934-.3.238-.6.433-1 .584l2 4.582h-1.8l-1.8-4.283h-2.5v4.283zm1.8-5.691h2.1c.7 0 1.2-.156 1.6-.467q.6-.468.6-1.299 0-.818-.6-1.262c-.3-.297-.8-.445-1.4-.445h-2.3zm10.7 5.837c-.4 0-.8-.054-1.1-.161q-.6-.168-.9-.481c-.3-.214-.5-.477-.7-.788-.1-.312-.2-.674-.2-1.088v-5.173h1.8v4.969q0 .613.3 1.007.45.394 1.2.394t1.2-.372c.3-.253.4-.615.4-1.087v-4.911h1.8v7.545h-1.4l-.2-1.474c-.1.413-.2.739-.5.978-.2.233-.5.398-.8.496q-.45.146-.9.146m5.9-.146v-7.545h1.7v1.08c.1-.194.3-.382.5-.562s.4-.325.7-.437.7-.168 1.1-.168.9.092 1.3.277q.6.277.9.868c.3.394.4.903.4 1.525v4.962h-1.8v-4.75c0-.496-.1-.864-.4-1.102-.3-.243-.6-.365-1-.365-.3 0-.6.049-.8.146q-.45.139-.6.431-.3.284-.3.715v4.925zm8.5 0v-7.545h1.7v1.08c.2-.194.3-.382.5-.562s.5-.325.8-.437.6-.168 1-.168c.5 0 .9.092 1.3.277s.7.474 1 .868c.2.394.4.903.4 1.525v4.962h-1.8v-4.75c0-.496-.2-.864-.4-1.102-.3-.243-.7-.365-1.1-.365-.2 0-.5.049-.8.146q-.3.139-.6.431c-.1.189-.2.428-.2.715v4.925zm8.6 0v-7.545h1.7v7.545zm0-8.865v-1.678h1.7v1.678zm3.8 8.865v-7.545h1.7v1.08c.1-.194.3-.382.5-.562s.5-.325.8-.437c.2-.112.6-.168 1-.168.5 0 .9.092 1.3.277s.7.474 1 .868q.3.591.3 1.525v4.962h-1.7v-4.75c0-.496-.2-.864-.5-1.102-.2-.243-.6-.365-1-.365-.3 0-.5.049-.8.146q-.3.139-.6.431c-.2.189-.2.428-.2.715v4.925zm11.9 2.495c-1.3 0-2.2-.17-2.9-.511s-1.1-.807-1.1-1.401c0-.267.1-.491.2-.671.2-.18.3-.328.5-.445s.4-.207.5-.27q.3-.095.3-.138-.15-.073-.3-.19a.83.83 0 0 1-.4-.321.9.9 0 0 1-.2-.533c0-.253.2-.486.4-.7s.6-.368 1.1-.46c-.5-.229-.9-.537-1.1-.927-.3-.389-.4-.792-.4-1.211 0-.496.2-.922.4-1.277.3-.355.7-.627 1.3-.817q.75-.284 1.8-.284.75 0 1.2.167c.3.112.7.263.9.453.1-.039.3-.093.5-.161.1-.073.3-.15.5-.233q.3-.131.6-.248c.2-.083.4-.151.5-.205v1.467l-1.3.234c.1.141.1.294.2.459v.438c0 .438-.1.844-.4 1.218-.2.37-.6.667-1.1.891-.4.223-1.1.335-1.8.335q-.15 0-.3-.007l-.3-.015c-.4.015-.7.061-.8.139s-.2.163-.2.255q0 .198.3.263c.2.044.6.083 1.1.117.1.009.4.022.6.036.3.015.6.034 1 .059.8.053 1.5.27 1.9.649.5.374.7.861.7 1.459 0 .696-.3 1.267-1 1.715-.6.447-1.6.671-2.9.671m.3-1.043c.6 0 1.1-.088 1.4-.263s.5-.433.5-.773q0-.394-.3-.642c-.3-.166-.6-.263-1-.292l-1.9-.117q-.3-.023-.6.117c-.2.087-.3.211-.4.372-.2.155-.2.328-.2.518q0 .532.6.802c.4.185 1 .278 1.9.278m-.3-5.341c.4 0 .8-.117 1.1-.35.3-.239.4-.574.4-1.007 0-.448-.1-.796-.4-1.044-.3-.253-.7-.379-1.1-.379q-.75 0-1.2.379c-.3.253-.4.601-.4 1.044 0 .418.1.749.4.992q.45.365 1.2.365"
                />
              </g>
              <rect
                width={126.842}
                height={29.185}
                x={18559.5}
                y={834.848}
                fill="#000"
                fillOpacity={0.05}
                rx={14.592}
              />
              <path
                fill="#637381"
                d="M18583.9 854.34v-1.327q0-.747.3-1.286c.1-.364.4-.681.7-.95s.6-.507 1-.714c.4-.211.7-.408 1.1-.593.4-.188.7-.381 1-.579.3-.202.5-.426.7-.673q.3-.37.3-.883c0-.435-.1-.79-.5-1.064q-.45-.417-1.2-.417c-.6 0-1 .159-1.4.478-.3.319-.6.768-.6 1.347h-1.6c0-.593.1-1.132.4-1.616q.45-.728 1.2-1.159c.6-.292 1.2-.438 2-.438q1.05 0 1.8.364c.6.238.9.572 1.2 1.004.3.426.4.924.4 1.495 0 .498-.1.925-.2 1.279-.2.355-.5.663-.8.923q-.45.384-.9.68c-.4.198-.8.384-1.1.559-.4.171-.7.351-1 .539-.3.184-.5.395-.7.633q-.3.357-.3.856v.141h5.1v1.401zm9.9 0q0-.627.3-1.563c.2-.628.4-1.32.7-2.074.3-.759.6-1.542 1-2.351q.75-1.212 1.5-2.384h-5.3v-1.367h7.1v1.367c-.3.427-.7.921-1 1.482q-.45.835-.9 1.771c-.3.62-.6 1.242-.8 1.866-.3.619-.4 1.21-.6 1.771q-.15.841-.3 1.482zm6.7 0v-6.964h1.6v.997c.2-.306.5-.571.8-.795.4-.225.8-.337 1.4-.337.2 0 .5.043.7.128.3.085.5.211.7.377s.4.373.5.62q.45-.492.9-.808c.4-.211.8-.317 1.3-.317.2 0 .5.041.7.121.3.081.6.216.8.404s.4.447.5.775c.2.323.2.73.2 1.219v4.58h-1.6v-4.385c0-.345-.1-.617-.2-.815s-.3-.336-.5-.417q-.15-.128-.6-.128-.3 0-.6.114c-.2.077-.4.202-.5.378-.1.175-.2.41-.2.707v4.546h-1.7v-4.647c0-.243 0-.445-.1-.606-.2-.162-.3-.283-.5-.364q-.3-.128-.6-.128t-.6.128c-.2.085-.4.215-.5.39-.2.176-.2.402-.2.681v4.546zm15 0v-6.964h1.6v1.508c.1-.345.3-.639.5-.882.2-.247.4-.435.7-.566q.45-.195.9-.195.15 0 .3.014c.1.009.1.024.2.047v1.569c-.1-.022-.2-.038-.2-.047-.1-.009-.2-.014-.2-.014q-.6-.04-.9.041c-.3.054-.5.146-.7.276-.2.126-.3.287-.4.485-.1.193-.1.42-.1.68v4.048zm8.5.135q-1.05 0-1.8-.425-.75-.43-1.2-1.226c-.3-.529-.4-1.16-.4-1.892 0-.714.1-1.347.4-1.899.2-.557.6-.995 1.1-1.314q.75-.477 1.8-.478c.7 0 1.3.146 1.7.438.5.292.8.7 1.1 1.226q.3.781.3 1.832v.498h-4.8c0 .395.1.745.2 1.051q.15.457.6.72.45.256.9.256c.4 0 .8-.085 1.1-.256.2-.175.4-.44.5-.794h1.5q-.15.727-.6 1.232c-.3.337-.6.593-1.1.768-.4.175-.8.263-1.3.263m-1.8-4.257h3.3c0-.337-.1-.64-.2-.909-.1-.274-.3-.49-.5-.647a1.9 1.9 0 0 0-.9-.242q-.6 0-.9.262-.45.263-.6.681c-.1.274-.2.559-.2.855m6.4 4.122v-6.964h1.6v.997c.2-.306.5-.571.8-.795.4-.225.8-.337 1.4-.337.2 0 .5.043.7.128.3.085.5.211.7.377s.4.373.5.62q.45-.492.9-.808c.4-.211.8-.317 1.3-.317.2 0 .5.041.7.121.3.081.5.216.8.404.2.189.4.447.5.775.2.323.2.73.2 1.219v4.58h-1.6v-4.385c0-.345-.1-.617-.2-.815s-.3-.336-.5-.417q-.3-.128-.6-.128t-.6.114c-.2.077-.4.202-.5.378-.1.175-.2.41-.2.707v4.546h-1.7v-4.647c0-.243 0-.445-.1-.606-.2-.162-.3-.283-.5-.364q-.3-.128-.6-.128t-.6.128c-.2.085-.4.215-.5.39q-.3.263-.3.681v4.546zm13.9.135q-.75 0-1.2-.243-.6-.25-.9-.707-.3-.465-.3-1.125 0-1.152.9-1.737c.5-.391 1.4-.595 2.6-.613l1.1-.027v-.472c0-.368-.1-.655-.4-.862-.2-.211-.5-.314-1-.31a2 2 0 0 0-.9.243q-.45.229-.6.774h-1.3c0-.476.1-.873.4-1.192.2-.323.6-.563 1-.72q.6-.243 1.5-.243c.7 0 1.2.088 1.6.263q.6.263.9.761.3.492.3 1.192v4.883h-1.3l-.2-1.253q-.3.788-.9 1.091c-.4.198-.8.297-1.3.297m.5-1.112q.3 0 .6-.107c.2-.077.4-.178.5-.304.2-.13.3-.273.4-.431s.2-.321.2-.491v-1.098l-.9.013c-.4.005-.8.05-1.1.135s-.6.222-.7.411q-.3.276-.3.741c0 .354.1.633.4.835q.3.296.9.296m5 .977v-6.964h1.6v6.964zm0-8.183v-1.549h1.6v1.549zm3.5 8.183v-6.964h1.6v.997c.1-.18.3-.353.5-.519s.4-.301.7-.404c.2-.103.6-.155.9-.155q.75 0 1.2.256.6.257.9.801c.2.364.4.833.4 1.408v4.58h-1.7v-4.385c0-.458-.1-.797-.4-1.017q-.3-.336-.9-.336c-.3 0-.5.045-.7.134q-.45.129-.6.398c-.2.175-.2.395-.2.66v4.546zm7.9 0v-6.964h1.6v6.964zm0-8.183v-1.549h1.6v1.549zm3.6 8.183v-6.964h1.6v.997c.1-.18.2-.353.4-.519s.4-.301.7-.404.6-.155 1-.155q.6 0 1.2.256.45.257.9.801.3.546.3 1.408v4.58h-1.6v-4.385c0-.458-.2-.797-.4-1.017-.3-.224-.6-.336-1-.336-.2 0-.5.045-.7.134-.3.086-.4.218-.6.398-.1.175-.2.395-.2.66v4.546zm10.9 2.303q-1.65 0-2.7-.471-.9-.472-.9-1.293c0-.247.1-.454.2-.62s.3-.303.4-.411c.2-.108.3-.191.5-.249.1-.058.2-.101.2-.128q0-.067-.3-.175a1.6 1.6 0 0 1-.3-.296c-.1-.126-.1-.29-.1-.492q0-.35.3-.647c.2-.197.5-.339 1-.424-.5-.211-.8-.496-1-.855-.3-.359-.4-.732-.4-1.118 0-.458.2-.851.4-1.179.3-.328.7-.579 1.1-.754.5-.175 1.1-.263 1.7-.263q.75 0 1.2.155c.3.103.6.242.8.418.1-.036.2-.086.4-.149.2-.067.3-.139.5-.215q.3-.121.6-.229c.2-.076.3-.139.4-.189v1.354l-1.2.216c.1.13.1.271.2.424v.404q0 .606-.3 1.125c-.2.341-.6.615-1 .821-.5.207-1.1.31-1.7.31q-.15 0-.3-.007l-.3-.013c-.3.013-.6.056-.7.128-.2.072-.2.15-.2.236q0 .182.3.242t.9.108l.7.034c.2.013.5.031.8.053q1.2.075 1.8.6.6.519.6 1.347 0 .963-.9 1.583-.75.62-2.7.619m.3-.963c.6 0 1-.081 1.3-.242.3-.162.5-.4.5-.714q0-.364-.3-.593t-.9-.269l-1.8-.108c-.1-.014-.3.022-.5.108-.2.08-.3.195-.4.343-.1.144-.2.303-.2.478q0 .492.6.741c.4.171.9.256 1.7.256m-.3-4.93c.5 0 .8-.108 1.1-.323.2-.22.4-.53.4-.93 0-.413-.2-.734-.4-.963-.3-.233-.6-.35-1.1-.35-.4 0-.8.117-1 .35-.3.234-.4.555-.4.963 0 .387.1.692.4.916.2.225.6.337 1 .337M18573 843.832c-3.1 0-5.6 2.514-5.6 5.613 0 3.098 2.5 5.612 5.6 5.612s5.6-2.514 5.6-5.612-2.5-5.613-5.6-5.613m0 10.103c-2.5 0-4.5-2.01-4.5-4.49s2-4.49 4.5-4.49 4.5 2.009 4.5 4.49c0 2.48-2 4.49-4.5 4.49"
              />
              <path
                fill="#637381"
                d="M18573.3 846.637h-.9v3.367l3 1.768.4-.69-2.5-1.499zM18494.7 972.324v-6.46h-1.6v-.679q.75 0 1.2-.107c.2-.071.4-.179.5-.325s.2-.327.2-.544h.8v8.115zm3.2 0v-.9650000000000001c0-.415 0-.775.2-1.078q.3-.455.6-.791.45-.342.9-.612t.9-.516c.3-.169.6-.343.8-.522q.45-.275.6-.618.3-.348.3-.819c0-.412-.2-.746-.5-1.005a1.7 1.7 0 0 0-1.1-.387c-.6 0-1 .15-1.3.449q-.45.449-.6 1.196h-1q0-.702.3-1.28c.3-.389.6-.7 1-.932s1-.348 1.6-.348c.5 0 1 .098 1.4.292q.6.286.9.808c.3.345.4.747.4 1.207q0 .628-.3 1.078-.15.448-.6.78c-.2.217-.5.411-.8.583q-.45.259-.9.5c-.3.157-.6.324-.8.499q-.45.26-.6.595-.3.337-.3.803v.163h4.3v.92zm6.1.432 2.8-8.547h.8l-2.8 8.547zm7.2-.308q-1.35 0-2.1-1.044c-.5-.7-.8-1.734-.8-3.104 0-.924.2-1.699.4-2.324s.6-1.094 1-1.408c.4-.315 1-.472 1.5-.472q1.35 0 2.1 1.061c.6.703.8 1.746.8 3.126 0 1.373-.2 2.412-.8 3.115q-.75 1.05-2.1 1.05m0-.898c.6 0 1.1-.255 1.4-.764.3-.512.4-1.345.4-2.497 0-1.175-.2-2.021-.5-2.537-.3-.52-.7-.78-1.3-.78-.5 0-1 .262-1.3.786-.3.52-.5 1.363-.5 2.531 0 1.149.2 1.979.5 2.492s.8.769 1.3.769m4.2.774v-.9650000000000001c0-.415 0-.775.2-1.078q.3-.455.6-.791.45-.342.9-.612t.9-.516c.3-.169.6-.343.8-.522q.45-.275.6-.618.3-.348.3-.819c0-.412-.2-.746-.5-1.005q-.45-.387-1.2-.387t-1.2.449c-.4.299-.5.698-.6 1.196h-1q0-.702.3-1.28c.3-.389.6-.7 1-.932s1-.348 1.6-.348c.5 0 1 .098 1.4.292q.6.286.9.808c.2.345.4.747.4 1.207q0 .628-.3 1.078-.15.448-.6.78c-.2.217-.5.411-.8.583q-.45.259-.9.5c-.3.157-.6.324-.8.499q-.45.26-.6.595-.3.337-.3.803v.163h4.3v.92zm6.1.432 2.8-8.547h.8l-2.8 8.547zm4.5-.432v-.9650000000000001c0-.415.1-.775.2-1.078q.3-.455.6-.791.45-.342.9-.612t.9-.516c.3-.169.6-.343.8-.522q.45-.275.6-.618.3-.348.3-.819c0-.412-.2-.746-.5-1.005-.2-.258-.6-.387-1.1-.387-.6 0-1 .15-1.3.449q-.45.449-.6 1.196h-1c0-.468.1-.895.4-1.28q.3-.584.9-.932c.5-.232 1-.348 1.6-.348s1 .098 1.4.292c.4.191.7.46 1 .808q.3.517.3 1.207c0 .419-.1.778-.2 1.078-.2.299-.4.559-.7.78-.2.217-.5.411-.8.583q-.45.259-.9.5c-.3.157-.6.324-.8.499q-.45.26-.6.595-.3.337-.3.803v.163h4.3v.92zm9.4.124q-1.35 0-2.1-1.044c-.5-.7-.8-1.734-.8-3.104 0-.924.1-1.699.4-2.324.2-.624.6-1.094 1-1.408q.6-.472 1.5-.472 1.35 0 2.1 1.061c.5.703.8 1.746.8 3.126 0 1.373-.3 2.412-.8 3.115q-.75 1.05-2.1 1.05m0-.898c.6 0 1-.255 1.3-.764.3-.512.5-1.345.5-2.497 0-1.175-.2-2.021-.5-2.537-.3-.52-.7-.78-1.3-.78s-1 .262-1.3.786c-.3.52-.5 1.363-.5 2.531 0 1.149.2 1.979.5 2.492s.7.769 1.3.769m4.1.774v-.9650000000000001q0-.623.3-1.078.15-.455.6-.791c.3-.228.5-.432.8-.612.3-.179.6-.352 1-.516.3-.169.5-.343.8-.522.2-.184.5-.389.6-.618.2-.232.2-.505.2-.819 0-.412-.1-.746-.4-1.005q-.45-.387-1.2-.387t-1.2.449q-.6.449-.6 1.196h-1q0-.702.3-1.28c.2-.389.6-.7 1-.932s.9-.348 1.6-.348c.5 0 1 .098 1.4.292q.6.286.9.808.3.517.3 1.207c0 .419 0 .778-.2 1.078q-.15.448-.6.78c-.3.217-.5.411-.8.583q-.45.259-.9.5-.45.236-.9.499-.3.26-.6.595c-.1.225-.2.492-.2.803v.163h4.3v.92zm9.7.124c-.5 0-.9-.088-1.4-.264-.4-.176-.7-.421-1.1-.735q-.45-.472-.6-1.084l.9-.376c.1.307.3.58.5.82.2.239.4.426.7.561s.6.202 1 .202c.5 0 1-.166 1.4-.499.3-.337.5-.794.5-1.37q0-.538-.3-.937c-.1-.27-.4-.479-.6-.629a2.1 2.1 0 0 0-1-.224q-.3 0-.6.062c-.2.037-.4.112-.5.224q-.3.168-.6.511c-.1.011-.1.017-.1.017v-.023l-.9-.275.4-4.22h4.8v.898h-4l-.2 2.621q.45-.376.9-.534c.3-.108.7-.162 1.1-.162s.9.101 1.3.303c.4.198.8.494 1 .886.3.39.4.872.4 1.449 0 .561-.1 1.049-.4 1.464-.2.416-.6.739-1 .971-.4.229-1 .343-1.6.343"
              />
              <path
                fill="#F2F2F2"
                d="M19180.3 775.357c0-7.44 6-13.47 13.4-13.47h40.4c7.5 0 13.5 6.03 13.5 13.47 0 7.439-6 13.47-13.5 13.47h-40.4c-7.4 0-13.4-6.031-13.4-13.47"
              />
              <path
                fill="#6B7280"
                d="M19190.7 780.133v-10.551h7v1.525h-5.2v2.955h4.6v1.503h-4.6v3.021l5.3.007v1.54zm13 .146q-.75 0-1.5-.19c-.5-.131-.9-.323-1.3-.576-.4-.258-.7-.577-1-.956-.2-.384-.4-.832-.5-1.343h1.9c.1.355.2.655.4.898q.45.365.9.554.6.19 1.2.19c.4 0 .8-.058 1.1-.175s.6-.29.8-.518q.3-.351.3-.861c0-.384-.1-.684-.4-.898-.2-.218-.6-.391-1.1-.518l-2.1-.488c-.5-.122-1-.3-1.4-.533q-.6-.35-.9-.919-.3-.577-.3-1.409c0-.632.1-1.179.5-1.641.3-.462.8-.817 1.4-1.066.6-.252 1.3-.379 2-.379.9 0 1.6.144 2.2.431.6.282 1 .661 1.3 1.138s.5.999.5 1.568h-1.8c0-.423-.2-.756-.4-.999-.2-.248-.4-.428-.8-.54-.3-.112-.6-.168-1-.168-.7 0-1.2.149-1.6.445-.3.297-.5.645-.5 1.044 0 .374.1.671.4.89.2.219.6.389 1.1.51l2 .46c.7.136 1.2.345 1.6.628.4.282.7.617.8 1.007q.3.576.3 1.276c0 .613-.2 1.156-.5 1.627s-.8.842-1.4 1.109c-.7.268-1.4.402-2.2.402m6.2-.146v-10.551h1.7v10.551zm4.3 0v-10.551h1.1q.45 0 .9.008c.3 0 .6.002.8.007 1.3.024 2.4.246 3.2.664.8.413 1.4 1.004 1.7 1.773q.6 1.145.6 2.765 0 1.693-.6 2.882t-1.8 1.824c-.9.419-1.9.628-3.2.628zm1.8-1.467h.9c.8 0 1.4-.124 2-.372.5-.253 1-.661 1.3-1.226.3-.564.4-1.318.4-2.261 0-.915-.1-1.647-.4-2.197-.3-.549-.7-.946-1.3-1.189-.5-.248-1.2-.372-1.9-.372h-1zm8.5 1.467v-10.551h3.8c.7 0 1.4.132 2 .394.6.258 1.1.64 1.4 1.146.4.506.5 1.128.5 1.868 0 .695-.1 1.291-.4 1.787-.3.497-.8.876-1.3 1.139-.6.262-1.3.394-2 .394h-2.2v3.823zm1.8-5.246h2.2q.9 0 1.5-.555.6-.554.6-1.444c0-.604-.3-1.07-.7-1.401q-.6-.504-1.5-.504h-2.1zm7.6 5.246v-10.551h1.8v9.019h4.8v1.532z"
              />
              <path
                fill="#F2F2F2"
                d="M19108.4 775.357c0-7.44 6.1-13.47 13.5-13.47h40.4c7.4 0 13.5 6.03 13.5 13.47 0 7.439-6.1 13.47-13.5 13.47h-40.4c-7.4 0-13.5-6.031-13.5-13.47"
              />
              <path
                fill="#6B7280"
                d="M19124.5 780.293c-.7 0-1.2-.119-1.8-.357-.5-.239-1-.577-1.3-1.014a2.22 2.22 0 0 1-.6-1.547h1.7q.15.663.6 1.08c.4.272.8.408 1.3.408s1-.138 1.4-.416c.5-.277.8-.712 1-1.306.2-.593.2-1.364.2-2.313q-.15.467-.6.818-.3.35-.9.547c-.3.126-.7.19-1.1.19-.7 0-1.3-.134-1.9-.402-.5-.272-1-.659-1.3-1.16-.3-.506-.4-1.104-.4-1.795 0-.7.1-1.32.4-1.86.4-.54.8-.963 1.4-1.27.6-.306 1.2-.46 2-.46.9 0 1.6.212 2.2.635.7.423 1.1 1.027 1.5 1.81.3.783.5 1.712.5 2.787 0 1.226-.2 2.257-.5 3.094q-.6 1.247-1.5 1.889c-.7.428-1.4.642-2.3.642m.1-5.355c.4 0 .7-.078 1-.234.3-.155.6-.357.8-.605q.3-.372.3-.788 0-.759-.3-1.314c-.1-.374-.4-.663-.7-.868-.3-.209-.6-.314-1.1-.314-.3 0-.7.09-1 .27s-.5.431-.7.752c-.1.316-.2.683-.2 1.102 0 .622.2 1.111.5 1.466.4.355.8.533 1.4.533m7.2 5.195q0-.68.3-1.693c.2-.681.4-1.43.8-2.247.3-.822.6-1.671 1.1-2.547.5-.875 1-1.736 1.6-2.582h-5.7v-1.482h7.6v1.482c-.3.462-.7.997-1 1.605-.4.603-.7 1.243-1 1.919a8.9 8.9 0 0 0-.9 2.021q-.45 1.007-.6 1.919-.3.912-.3 1.605zm11 .153c-.9 0-1.6-.124-2.2-.372a4.05 4.05 0 0 1-1.5-1.065c-.3-.458-.5-.995-.5-1.613q0-.605.3-1.16c.2-.37.5-.681.8-.934.3-.258.6-.421 1-.489q-.75-.306-1.2-.875c-.3-.384-.4-.856-.4-1.416 0-.627.1-1.157.5-1.59.3-.438.7-.769 1.3-.993.5-.228 1.2-.343 1.9-.343q1.05 0 1.8.343c.6.224 1 .555 1.4.993.3.433.5.963.5 1.59 0 .56-.2 1.032-.5 1.416-.3.379-.7.671-1.1.875q.45.102.9.489c.3.253.6.564.8.934q.3.555.3 1.16c0 .618-.2 1.155-.5 1.613q-.45.685-1.5 1.065-.9.372-2.1.372m0-1.372c.7 0 1.2-.155 1.6-.467q.6-.467.6-1.247 0-.519-.3-.912c-.1-.268-.4-.477-.7-.628q-.6-.226-1.2-.226-.75 0-1.2.226c-.4.151-.6.36-.8.628q-.3.393-.3.912 0 .78.6 1.247c.4.312 1 .467 1.7.467m0-4.968c.5 0 1-.141 1.3-.424q.6-.43.6-1.196 0-.759-.6-1.204c-.3-.297-.8-.445-1.3-.445-.6 0-1 .148-1.4.445s-.5.698-.5 1.204c0 .511.1.909.5 1.196.4.283.8.424 1.4.424m5.6 6.187v-1.438q0-.809.3-1.393c.2-.394.5-.737.8-1.029.4-.292.7-.55 1.1-.773q.6-.343 1.2-.642c.4-.205.8-.414 1.1-.628.3-.219.6-.462.8-.729q.3-.402.3-.956c0-.472-.2-.856-.5-1.153-.3-.302-.8-.452-1.4-.452q-.9 0-1.5.518c-.3.345-.6.831-.6 1.459h-1.8c0-.642.2-1.226.5-1.751.3-.526.7-.944 1.3-1.255.6-.316 1.3-.475 2.2-.475.8 0 1.4.132 1.9.394.6.258 1 .621 1.3 1.088.3.462.5 1.002.5 1.619q0 .81-.3 1.387c-.2.384-.5.717-.8.999-.3.278-.7.523-1.1.737s-.7.416-1.1.606c-.4.185-.8.379-1.1.583-.3.2-.6.429-.8.686q-.3.387-.3.927v.153h5.5v1.518zm13 .153c-.8 0-1.6-.124-2.2-.372-.6-.253-1.1-.608-1.4-1.065-.4-.458-.5-.995-.5-1.613q0-.605.3-1.16c.2-.37.4-.681.7-.934.4-.258.7-.421 1-.489-.4-.204-.8-.496-1.1-.875-.3-.384-.5-.856-.5-1.416 0-.627.2-1.157.5-1.59.3-.438.8-.769 1.3-.993.6-.228 1.2-.343 1.9-.343s1.3.115 1.9.343c.5.224 1 .555 1.3.993.3.433.5.963.5 1.59 0 .56-.2 1.032-.5 1.416-.3.379-.6.671-1.1.875.3.068.7.231 1 .489.3.253.5.564.8.934q.3.555.3 1.16 0 .926-.6 1.613c-.3.457-.8.812-1.4 1.065-.6.248-1.4.372-2.2.372m0-1.372c.7 0 1.3-.155 1.7-.467q.6-.467.6-1.247 0-.519-.3-.912c-.2-.268-.5-.477-.8-.628q-.45-.226-1.2-.226c-.5 0-.8.075-1.2.226-.3.151-.6.36-.8.628-.2.262-.2.566-.2.912q0 .78.6 1.247c.4.312.9.467 1.6.467m0-4.968c.6 0 1-.141 1.4-.424.3-.287.5-.685.5-1.196 0-.506-.2-.907-.5-1.204-.4-.297-.8-.445-1.4-.445-.5 0-1 .148-1.4.445-.3.297-.5.698-.5 1.204 0 .511.2.909.5 1.196.4.283.9.424 1.4.424"
              />
            </g>
          </g>
          <g clipPath="url(#PulseLogicFig_svg__m)">
            <rect
              width={844.12}
              height={143.68}
              x={18425.9}
              y={564.328}
              fill="#F8F9FA"
              rx={8.98}
            />
            <rect
              width={221.133}
              height={39.288}
              x={18605.5}
              y={621.574}
              fill="#FFA726"
              rx={11.225}
            />
            <rect
              width={221.133}
              height={39.288}
              x={18972.6}
              y={621.574}
              fill="#B5BDC6"
              rx={11.225}
            />
            <path
              fill="#fff"
              d="M19061.9 639.13h1.2q.6 0 .9-.191.45-.2.6-.553c.1-.24.2-.519.2-.836 0-.287-.1-.54-.2-.76-.1-.225-.3-.399-.5-.522-.2-.128-.5-.192-.8-.192s-.6.054-.8.162q-.3.16-.6.452c-.1.195-.2.43-.2.706h-2.2c0-.614.2-1.148.5-1.603s.8-.811 1.3-1.067c.6-.256 1.2-.384 1.9-.384s1.4.123 2 .369c.5.24 1 .596 1.3 1.066s.5 1.054.5 1.75q0 .529-.3 1.028c-.1.327-.4.624-.7.89-.3.261-.6.471-1.1.629-.4.154-.9.23-1.4.23h-1.6zm0 1.681v-1.143h1.6c.6 0 1.1.069 1.6.207.4.138.8.337 1.1.598.3.256.6.56.7.913q.3.522.3 1.159 0 .782-.3 1.397-.3.605-.9 1.028c-.3.281-.8.496-1.2.644-.5.144-1 .215-1.6.215-.5 0-.9-.064-1.4-.192-.4-.133-.9-.33-1.2-.59q-.6-.4-.9-.998-.3-.606-.3-1.435h2.2c0 .287.1.542.2.767.2.226.3.402.6.53s.5.192.9.192q.45 0 .9-.192c.2-.133.4-.317.5-.553.2-.24.2-.519.2-.836 0-.409 0-.737-.2-.982q-.15-.376-.6-.553c-.3-.117-.6-.176-1-.176zm14.3-1.704v1.934q0 1.259-.3 2.172c-.1.603-.4 1.099-.7 1.488q-.6.576-1.2.852c-.5.184-1 .276-1.6.276q-.6 0-1.2-.169c-.4-.117-.8-.299-1.1-.544s-.5-.555-.8-.929a4.8 4.8 0 0 1-.5-1.35c-.1-.522-.2-1.121-.2-1.796v-1.934q0-1.258.3-2.156c.2-.603.5-1.097.8-1.481q.45-.575 1.2-.844c.4-.184 1-.276 1.5-.276s.9.059 1.3.176c.4.113.7.289 1 .53.3.24.6.55.8.928.2.374.4.821.5 1.343.1.517.2 1.11.2 1.78m-2.2 2.226v-2.525c0-.404 0-.757-.1-1.059 0-.302-.1-.557-.2-.767q-.15-.322-.3-.522c-.1-.133-.3-.23-.4-.291q-.3-.093-.6-.093c-.2 0-.5.049-.6.146-.2.097-.4.253-.5.468q-.3.315-.3.844c-.1.348-.1.773-.1 1.274v3.591c.1.307.1.571.2.791q.15.322.3.529c.2.133.3.23.5.292s.3.092.5.092c.3 0 .5-.049.7-.146.2-.102.3-.261.5-.476q.15-.33.3-.859c.1-.353.1-.783.1-1.289m9.9-2.241v6.584h-2.2v-8.303h2.1zm-.3 2.141h-.6c0-.578.1-1.11.2-1.596q.3-.737.6-1.274c.3-.363.6-.644 1.1-.844.4-.199.8-.299 1.4-.299.3 0 .7.056 1 .169.3.107.5.278.8.514.2.23.4.532.5.905.1.368.2.811.2 1.328v5.54h-2.2v-5.295c0-.378-.1-.67-.2-.875s-.2-.347-.4-.429-.4-.123-.7-.123-.5.059-.8.176c-.2.118-.3.282-.5.492q-.15.307-.3.721c-.1.276-.1.573-.1.89m5-.253-.8.099c0-.542 0-1.046.2-1.511q.15-.699.6-1.228c.2-.353.6-.627 1-.821.4-.199.8-.299 1.4-.299.4 0 .7.059 1 .176q.6.169.9.545c.2.246.4.568.5.967.2.399.2.887.2 1.465v5.303h-2.2v-5.303c0-.383-.1-.675-.2-.874-.1-.205-.2-.346-.4-.422q-.3-.123-.6-.123c-.3 0-.5.054-.7.161-.2.102-.4.246-.5.43a.85.85 0 0 0-.3.644c-.1.241-.1.504-.1.791m9.1-3.607v8.303h-2.3v-8.303zm-2.4-2.164q0-.483.3-.798.45-.314.9-.314.6 0 .9.314c.3.21.4.476.4.798s-.1.589-.4.798q-.3.315-.9.315-.45 0-.9-.315-.3-.313-.3-.798m6.3 3.937v6.53h-2.2v-8.303h2.1zm-.3 2.087h-.6q0-.92.3-1.658.15-.744.6-1.266c.3-.353.7-.621 1.1-.805.4-.19.8-.284 1.3-.284.4 0 .7.056 1.1.169.3.112.6.291.8.537.2.245.4.57.5.974s.2.898.2 1.481v5.295h-2.2v-5.303c0-.368-.1-.654-.2-.859s-.2-.348-.4-.43c-.2-.087-.5-.13-.7-.13-.3 0-.6.059-.8.176q-.3.177-.6.492-.15.307-.3.721c0 .276-.1.573-.1.89"
            />
            <rect
              width={221.133}
              height={39.288}
              x={18384.4}
              y={621.574}
              fill="#16A34A"
              rx={11.225}
            />
            <path
              fill="#fff"
              d="M18470.2 643.949v1.727h-7.6v-1.474l3.6-3.875c.3-.404.6-.759.8-1.066.2-.312.4-.591.5-.837.1-.25.1-.488.1-.713 0-.338 0-.627-.1-.867-.2-.246-.3-.435-.5-.568-.3-.133-.5-.2-.8-.2q-.6 0-.9.246c-.3.164-.4.391-.6.683-.1.291-.2.621-.2.99h-2.2c0-.665.2-1.274.5-1.826.3-.558.8-1.001 1.3-1.328q.9-.499 2.1-.499c.8 0 1.4.128 2 .384q.75.376 1.2 1.09c.3.47.4 1.033.4 1.688 0 .368 0 .729-.1 1.082-.2.347-.3.695-.5 1.043-.3.343-.5.691-.8 1.044s-.7.718-1.1 1.097l-1.9 2.179zm3.6-10.059v11.786h-2.2V633.89zm-.3 7.343h-.6c0-.578.1-1.11.2-1.596.2-.491.4-.916.7-1.274.2-.363.6-.644 1-.844s.8-.299 1.3-.299c.4 0 .7.059 1.1.176.3.113.6.297.8.553q.45.375.6.99c.1.409.2.905.2 1.488v5.249h-2.2v-5.264c0-.368-.1-.657-.2-.867-.1-.215-.2-.366-.4-.453-.2-.092-.5-.138-.8-.138s-.6.059-.8.176c-.2.118-.4.282-.5.492q-.15.307-.3.721c-.1.276-.1.573-.1.89m16.2-6.753v11.196h-2.2v-8.648l-2.7.844v-1.742l4.6-1.65zm11.1 4.627v1.934c0 .839 0 1.563-.2 2.172-.2.603-.5 1.099-.8 1.488q-.45.576-1.2.852c-.4.184-1 .276-1.5.276s-.9-.056-1.3-.169c-.4-.117-.7-.299-1-.544s-.6-.555-.8-.929c-.3-.378-.4-.829-.5-1.35-.2-.522-.2-1.121-.2-1.796v-1.934q0-1.258.3-2.156c.1-.603.4-1.097.7-1.481q.6-.575 1.2-.844c.5-.184 1-.276 1.6-.276q.6 0 1.2.176c.4.113.8.289 1.1.53.3.24.5.55.8.928.2.374.3.821.5 1.343.1.517.1 1.11.1 1.78m-2.2 2.226v-3.5839999999999996c-.1-.302-.1-.557-.2-.767-.1-.215-.2-.389-.4-.522a.72.72 0 0 0-.4-.291c-.2-.062-.3-.093-.5-.093-.3 0-.5.049-.7.146s-.4.253-.5.468q-.15.315-.3.844c-.1.348-.1.773-.1 1.274v2.525c0 .404 0 .759.1 1.066 0 .307.1.571.2.791q.15.322.3.529c.1.133.3.23.4.292q.3.092.6.092t.6-.146c.2-.102.4-.261.5-.476q.3-.33.3-.859c.1-.353.1-.783.1-1.289m6-2.241v6.584h-2.2v-8.303h2.1zm-.3 2.141h-.6c0-.578.1-1.11.2-1.596.2-.491.4-.916.7-1.274.2-.363.6-.644 1-.844s.9-.299 1.4-.299c.4 0 .7.056 1 .169.3.107.6.278.8.514.2.23.4.532.5.905.1.368.2.811.2 1.328v5.54h-2.2v-5.295c0-.378-.1-.67-.2-.875s-.2-.347-.4-.429-.4-.123-.7-.123-.5.059-.7.176q-.3.177-.6.492-.15.307-.3.721c0 .276-.1.573-.1.89m5-.253-.8.099c0-.542.1-1.046.2-1.511q.15-.699.6-1.228c.3-.353.6-.627 1-.821.4-.199.9-.299 1.4-.299.4 0 .7.059 1.1.176.3.113.6.294.8.545.2.246.4.568.5.967.2.399.2.887.2 1.465v5.303h-2.2v-5.303c0-.383 0-.675-.1-.874-.1-.205-.3-.346-.5-.422-.1-.082-.4-.123-.6-.123-.3 0-.5.054-.7.161-.2.102-.4.246-.5.43q-.15.276-.3.644c-.1.241-.1.504-.1.791m9.1-3.607v8.303h-2.2v-8.303zm-2.4-2.164c0-.322.1-.588.4-.798q.3-.314.9-.314.45 0 .9.314.3.315.3.798 0 .485-.3.798-.45.315-.9.315-.6 0-.9-.315c-.3-.209-.4-.475-.4-.798m6.4 3.937v6.53h-2.2v-8.303h2zm-.3 2.087h-.6c0-.614 0-1.166.2-1.658.2-.496.4-.918.7-1.266.2-.353.6-.621 1-.805.4-.19.8-.284 1.3-.284.4 0 .8.056 1.1.169.3.112.6.291.8.537.2.245.4.57.5.974.2.404.2.898.2 1.481v5.295h-2.2v-5.303c0-.368 0-.654-.1-.859s-.3-.348-.5-.43c-.2-.087-.4-.13-.7-.13s-.6.059-.8.176c-.2.118-.4.282-.5.492q-.3.307-.3.721c-.1.276-.1.573-.1.89M18694.9 639.13h1.1c.4 0 .7-.064 1-.191.2-.133.4-.318.5-.553.2-.24.2-.519.2-.836 0-.287 0-.54-.2-.76-.1-.225-.2-.399-.5-.522-.2-.128-.5-.192-.8-.192s-.5.054-.8.162c-.2.107-.4.258-.5.452-.1.195-.2.43-.2.706h-2.2c0-.614.1-1.148.5-1.603.3-.456.7-.811 1.3-1.067.5-.256 1.2-.384 1.8-.384.8 0 1.5.123 2 .369.6.24 1 .596 1.3 1.066.4.471.5 1.054.5 1.75 0 .353-.1.695-.2 1.028-.2.327-.4.624-.7.89-.3.261-.7.471-1.1.629q-.75.23-1.5.23h-1.5zm0 1.681v-1.143h1.5c.6 0 1.1.069 1.6.207q.75.207 1.2.598c.3.256.5.56.7.913.1.348.2.734.2 1.159q0 .782-.3 1.397c-.2.404-.5.746-.8 1.028-.4.281-.8.496-1.3.644-.5.144-1 .215-1.6.215-.4 0-.9-.064-1.4-.192q-.6-.2-1.2-.59-.45-.4-.9-.998-.3-.606-.3-1.435h2.2q0 .43.3.767c.1.226.3.402.5.53q.45.192.9.192t.9-.192c.3-.133.4-.317.6-.553.1-.24.2-.519.2-.836 0-.409-.1-.737-.2-.982-.2-.251-.4-.435-.7-.553-.2-.117-.6-.176-1-.176zm14.4 3.138v1.727h-7.7v-1.474l3.6-3.875q.6-.606.9-1.066c.2-.312.4-.591.5-.837 0-.25.1-.488.1-.713 0-.338-.1-.627-.2-.867-.1-.246-.2-.435-.5-.568-.2-.133-.5-.2-.8-.2s-.6.082-.8.246q-.45.245-.6.683c-.1.291-.2.621-.2.99h-2.2c0-.665.2-1.274.5-1.826.3-.558.7-1.001 1.3-1.328q.9-.499 2.1-.499c.8 0 1.4.128 2 .384q.75.376 1.2 1.09c.3.47.4 1.033.4 1.688 0 .368-.1.729-.2 1.082-.1.347-.3.695-.5 1.043-.2.343-.5.691-.8 1.044s-.6.718-1 1.097l-1.9 2.179zm7.6-4.857v6.584h-2.3v-8.303h2.1zm-.3 2.141h-.7q0-.867.3-1.596.15-.737.6-1.274c.2-.363.6-.644 1-.844s.9-.299 1.4-.299c.4 0 .7.056 1 .169.3.107.6.278.8.514.2.23.4.532.5.905.1.368.2.811.2 1.328v5.54h-2.2v-5.295c0-.378-.1-.67-.2-.875s-.2-.347-.4-.429-.4-.123-.7-.123c-.2 0-.5.059-.7.176-.2.118-.4.282-.5.492q-.3.307-.3.721c-.1.276-.1.573-.1.89m4.9-.253-.8.099c0-.542.1-1.046.2-1.511q.15-.699.6-1.228c.3-.353.6-.627 1-.821.4-.199.9-.299 1.4-.299.4 0 .8.059 1.1.176.3.113.6.294.8.545.3.246.4.568.6.967.1.399.2.887.2 1.465v5.303h-2.3v-5.303c0-.383 0-.675-.1-.874-.1-.205-.3-.346-.4-.422-.2-.082-.4-.123-.7-.123s-.5.054-.7.161c-.2.102-.4.246-.5.43q-.15.276-.3.644c-.1.241-.1.504-.1.791m9.1-3.607v8.303h-2.2v-8.303zm-2.4-2.164c0-.322.2-.588.4-.798q.3-.314.9-.314t.9.314q.3.315.3.798 0 .485-.3.798-.3.315-.9.315t-.9-.315c-.2-.209-.4-.475-.4-.798m6.4 3.937v6.53h-2.2v-8.303h2.1zm-.3 2.087h-.6c0-.614 0-1.166.2-1.658.2-.496.4-.918.7-1.266.3-.353.6-.621 1-.805.4-.19.8-.284 1.3-.284.4 0 .8.056 1.1.169.3.112.6.291.8.537.3.245.4.57.6.974.1.404.2.898.2 1.481v5.295h-2.3v-5.303c0-.368 0-.654-.1-.859s-.3-.348-.5-.43c-.2-.087-.4-.13-.7-.13s-.6.059-.8.176c-.2.118-.4.282-.5.492-.1.204-.3.445-.3.721-.1.276-.1.573-.1.89"
            />
            <path
              stroke="#B5BDC6"
              strokeWidth={2.245}
              d="M18665 613.719v66.227M18447.3 669.844v10.102M18891.8 669.844v10.102M19194.9 669.844v10.102"
            />
            <path
              fill="#B5BDC6"
              d="M18651.6 687.415v6.53h-2.2v-8.302h2.1zm-.3 2.087h-.6c0-.613.1-1.166.2-1.657.2-.496.4-.918.7-1.266.3-.353.6-.622 1-.806.4-.189.9-.284 1.3-.284s.8.057 1.1.169.6.292.8.537q.45.369.6.975c.1.404.2.898.2 1.481v5.294h-2.3v-5.302c0-.368 0-.655-.1-.859-.1-.205-.3-.348-.5-.43-.2-.087-.4-.131-.7-.131s-.5.059-.8.177c-.2.118-.3.281-.5.491q-.15.307-.3.721c-.1.277-.1.573-.1.89m6.6.376v-.161q0-.913.3-1.68c.1-.517.4-.964.7-1.343q.6-.568 1.2-.882c.5-.215 1.1-.323 1.7-.323.7 0 1.2.108 1.7.323q.75.314 1.2.882c.4.379.6.826.8 1.343q.3.767.3 1.68v.161q0 .906-.3 1.681c-.2.511-.4.959-.8 1.343q-.45.567-1.2.882c-.5.21-1 .315-1.7.315-.6 0-1.2-.105-1.6-.315-.5-.21-.9-.504-1.3-.882-.3-.384-.6-.832-.7-1.343q-.3-.775-.3-1.681m2.2-.161v.161c0 .348 0 .673.1.975q.15.453.3.798c.1.225.3.402.5.529.3.128.5.192.8.192s.6-.064.8-.192q.3-.191.6-.529c.1-.23.2-.496.2-.798.1-.302.1-.627.1-.975v-.161c0-.337 0-.654-.1-.951q0-.453-.3-.798c-.1-.236-.3-.42-.5-.553s-.5-.199-.8-.199-.6.066-.8.199-.4.317-.5.553q-.15.345-.3.798c-.1.297-.1.614-.1.951m9.4 2.08 1.7-6.154h1.4l-.4 2.417-1.8 5.885h-1.1zm-.9-6.154 1.3 6.146.1 2.156h-1.4l-2.1-8.302zm5.6 6.046 1.2-6.046h2.2l-2.2 8.302h-1.3zm-1.4-6.046 1.7 6.108.3 2.194h-1.2l-1.7-5.877-.5-2.425zM18438.4 688.282v1.735h-4.4v-1.735zm7.1-5.532v11.195h-2.2v-8.648l-2.7.845V684.4l4.7-1.65zm5.9-.591v11.786h-2.2v-11.786zm-.3 7.343h-.6c0-.578.1-1.11.2-1.596q.3-.736.6-1.273c.3-.364.7-.645 1-.844.4-.2.9-.3 1.3-.3s.8.059 1.1.177q.6.168.9.552.3.376.6.99c.1.409.2.906.2 1.489v5.248h-2.3v-5.264c0-.368 0-.657-.1-.867-.1-.215-.3-.365-.5-.452-.2-.092-.4-.139-.7-.139s-.6.059-.8.177-.4.281-.5.491q-.3.307-.3.721c-.1.277-.1.573-.1.89M19194.4 692.219v1.726h-7.7v-1.473l3.6-3.875q.6-.606.9-1.067c.2-.312.4-.59.5-.836 0-.251.1-.489.1-.714 0-.337-.1-.626-.2-.867-.1-.245-.3-.435-.5-.568s-.5-.199-.8-.199-.6.082-.8.246q-.45.245-.6.682c-.1.292-.2.622-.2.99h-2.2c0-.665.2-1.273.5-1.826.3-.558.7-1 1.3-1.327q.9-.5 2.1-.499c.8 0 1.4.128 2 .383q.75.376 1.2 1.09c.3.471.4 1.033.4 1.688 0 .369-.1.729-.2 1.082-.1.348-.3.696-.5 1.044-.2.342-.5.69-.8 1.043s-.6.719-1 1.098l-1.9 2.179zm3.6-10.06v11.786h-2.2v-11.786zm-.3 7.343h-.6c0-.578.1-1.11.2-1.596q.3-.736.6-1.273c.3-.364.6-.645 1-.844.4-.2.9-.3 1.3-.3s.8.059 1.1.177q.6.168.9.552.3.376.6.99c.1.409.2.906.2 1.489v5.248h-2.3v-5.264c0-.368 0-.657-.1-.867-.1-.215-.3-.365-.5-.452-.2-.092-.4-.139-.7-.139s-.6.059-.8.177-.4.281-.5.491q-.3.307-.3.721c-.1.277-.1.573-.1.89M18890.2 682.75v11.195h-2.3v-8.648l-2.6.845V684.4l4.6-1.65zm5.8-.591v11.786h-2.2v-11.786zm-.3 7.343h-.6q0-.867.3-1.596.15-.736.6-1.273c.3-.364.6-.645 1-.844.4-.2.8-.3 1.3-.3.4 0 .7.059 1.1.177.3.112.6.296.8.552q.45.376.6.99c.1.409.2.906.2 1.489v5.248h-2.2v-5.264c0-.368-.1-.657-.2-.867-.1-.215-.2-.365-.4-.452-.2-.092-.5-.139-.7-.139-.4 0-.6.059-.9.177-.2.118-.4.281-.5.491q-.15.307-.3.721c0 .277-.1.573-.1.89M19270.1 670.906l-12.5-5.551v11.101z"
            />
            <path
              stroke="#B5BDC6"
              strokeWidth={3.368}
              d="M18424.8 670.969h834"
            />
            <path
              fill="#212B36"
              d="M18456.6 597.797v-12.985h2.6v12.985zm5.2 0v-9.285h2.5v2.2c.1-.473.4-.886.6-1.24.3-.359.6-.637 1-.835.4-.203.9-.305 1.3-.305q.15 0 .3.018c.1.006.1.018.1.036v2.496c0-.024-.1-.039-.2-.045 0-.006-.1-.012-.1-.018-.6-.041-1-.027-1.4.045q-.45.108-.9.368c-.2.174-.4.387-.5.638-.1.252-.1.533-.1.844v5.083zm7.4 0v-9.285h2.5v2.2c.1-.473.4-.886.6-1.24.3-.359.6-.637 1-.835.4-.203.9-.305 1.3-.305q.15 0 .3.018c.1.006.1.018.1.036v2.496c0-.024-.1-.039-.2-.045 0-.006-.1-.012-.1-.018-.6-.041-1-.027-1.4.045q-.45.108-.9.368c-.2.174-.3.387-.5.638-.1.252-.1.533-.1.844v5.083zm7.4 0v-9.285h2.5v9.285zm0-10.614v-2.362h2.5v2.362zm9 13.685c-1.6 0-2.9-.209-3.8-.629-.8-.419-1.3-.969-1.3-1.652q0-.476.3-.799t.6-.512q.3-.197.6-.296c.2-.072.3-.12.4-.144-.1-.054-.3-.132-.5-.233-.1-.108-.3-.252-.5-.432-.1-.185-.2-.425-.2-.718 0-.329.2-.634.5-.916.3-.281.8-.476 1.4-.584-.6-.287-1.1-.676-1.4-1.167s-.5-.994-.5-1.509q0-.915.6-1.571c.4-.437.9-.769 1.6-.997s1.4-.341 2.2-.341c.7 0 1.2.069 1.6.206.4.132.8.306 1.1.521q.3-.08.6-.206c.2-.09.5-.186.7-.288.3-.107.5-.212.8-.314.3-.108.5-.204.7-.287v2.029l-1.6.261c0 .161.1.335.1.52 0 .186.1.339.1.458 0 .539-.2 1.042-.5 1.509s-.8.844-1.4 1.132-1.4.431-2.3.431c-.2 0-.3-.003-.5-.009s-.3-.015-.5-.027c-.3.018-.6.063-.7.134s-.2.156-.2.252c0 .143.1.239.4.287q.45.063 1.2.117c.2.012.5.027.8.045q.6.027 1.2.072c1.1.077 2 .359 2.5.844q.9.718.9 1.814c0 .868-.5 1.583-1.3 2.146-.8.569-2 .853-3.7.853m.4-1.464c.8 0 1.3-.09 1.6-.269s.5-.437.5-.772c0-.282-.2-.509-.4-.683-.3-.179-.6-.284-1.1-.314l-2.1-.144c-.3-.012-.5.03-.7.126s-.4.227-.5.395-.2.347-.2.539c0 .389.3.673.7.853.5.179 1.2.269 2.2.269m-.5-6.528q.75 0 1.2-.404c.3-.276.5-.647.5-1.114 0-.485-.2-.874-.5-1.167q-.45-.44-1.2-.44t-1.2.44c-.3.293-.4.682-.4 1.167 0 .461.1.829.4 1.105q.45.413 1.2.413m9.6 5.1c-.6 0-1.1-.11-1.6-.332-.5-.221-.9-.542-1.1-.961-.3-.425-.5-.94-.5-1.544q0-1.527 1.2-2.317 1.05-.8 3.6-.826l1.2-.018v-.557c0-.425-.2-.751-.4-.979q-.45-.35-1.2-.341c-.4.006-.7.096-1.1.269-.3.174-.5.476-.7.907h-2.2q.15-1.005.6-1.652.6-.655 1.5-.97c.6-.215 1.3-.323 2-.323 1 0 1.8.12 2.3.359.6.234 1 .572 1.3 1.015.2.437.4.958.4 1.562v6.529h-2.2l-.2-1.599q-.6 1.006-1.2 1.392c-.5.258-1.1.386-1.7.386m.9-1.724c.2 0 .4-.042.7-.125q.3-.135.6-.351c.1-.149.3-.317.4-.503.1-.185.2-.377.2-.574v-1.374l-1 .018q-.6.01-1.2.161-.6.144-.9.476c-.3.222-.4.521-.4.898 0 .431.2.77.5 1.015.3.24.6.359 1.1.359m10.2 1.644c-.9 0-1.5-.105-1.9-.315-.5-.209-.8-.503-1-.88-.1-.377-.2-.814-.2-1.311v-5.056h-1.5v-1.822h1.6l.6-2.802h1.9v2.793h2.1v1.831h-2.1v4.948c0 .228 0 .399.1.512q.15.162.3.216c.1.03.3.045.4.045h1.3v1.616q-.15.081-.6.153c-.2.048-.6.072-1 .072m3.5-.099v-9.285h2.5v9.285zm-.1-10.614v-2.362h2.6v2.362zm8.9 10.793q-1.35 0-2.4-.583c-.7-.389-1.2-.94-1.6-1.653a6.5 6.5 0 0 1-.5-2.532c0-.976.2-1.829.5-2.559.4-.731.9-1.299 1.6-1.706q1.05-.611 2.4-.611t2.4.602c.6.395 1.2.957 1.5 1.688q.6 1.095.6 2.586 0 1.4-.6 2.479-.45 1.068-1.5 1.679-1.05.61-2.4.61m0-1.948c.4 0 .8-.135 1.1-.404q.45-.405.6-1.06c.1-.443.2-.925.2-1.446 0-.491-.1-.955-.2-1.392q-.15-.655-.6-1.059c-.2-.27-.6-.404-1.1-.404s-.9.128-1.1.386c-.3.251-.5.595-.7 1.032-.1.432-.2.91-.2 1.437 0 .485.1.952.2 1.401q.15.664.6 1.087t1.2.422m6.3 1.769v-9.285h2.5v1.311q.3-.341.6-.656.3-.323.9-.53.45-.206 1.2-.206c.6 0 1.1.11 1.6.332q.75.332 1.2 1.051c.3.473.5 1.092.5 1.859v6.124h-2.6v-5.801c0-.503-.2-.88-.5-1.132a1.72 1.72 0 0 0-1.1-.377c-.3 0-.6.051-.8.153-.3.102-.5.254-.7.458-.1.203-.2.455-.2.754v5.945zm18.7.099c-.9 0-1.5-.105-1.9-.315-.5-.209-.8-.503-1-.88-.1-.377-.2-.814-.2-1.311v-5.056h-1.5v-1.822h1.6l.6-2.802h1.9v2.793h2.1v1.831h-2.1v4.948c0 .228 0 .399.1.512q0 .162.3.216c.1.03.2.045.4.045h1.3v1.616q-.15.081-.6.153c-.2.048-.6.072-1 .072m3.5-.099v-9.285h2.5v9.285zm-.1-10.614v-2.362h2.6v2.362zm4.9 10.614v-9.285h2.5v1.311q.45-.611 1.2-1.051.6-.44 1.8-.44.45 0 .9.171c.4.113.7.281 1 .502.3.216.5.488.7.818q.45-.638 1.2-1.06c.4-.287 1-.431 1.6-.431.3 0 .7.057 1 .171.4.113.7.299 1 .556s.6.602.7 1.033q.3.637.3 1.581v6.124h-2.6v-5.801c0-.371-.1-.668-.2-.889a1.9 1.9 0 0 0-.6-.485c-.2-.102-.4-.153-.7-.153-.2 0-.5.048-.7.144q-.3.135-.6.44t-.3.799v5.945h-2.6v-6.035c0-.281-.1-.518-.2-.709-.2-.192-.3-.335-.6-.431a1.3 1.3 0 0 0-.6-.153c-.3 0-.5.051-.8.153q-.3.144-.6.458c-.1.203-.2.461-.2.772v5.945zm20.3.179q-1.35 0-2.4-.574c-.7-.389-1.3-.937-1.6-1.644q-.6-1.059-.6-2.496c0-.928.1-1.763.5-2.505q.6-1.123 1.5-1.77c.7-.437 1.5-.655 2.5-.655q1.35 0 2.4.602c.6.395 1.1.948 1.4 1.661.3.706.5 1.524.5 2.451v.71h-6.2c0 .473 0 .886.2 1.239.2.347.4.617.7.808.3.186.6.279 1.1.279.4 0 .8-.096 1.1-.288.4-.191.6-.506.7-.943h2.4c-.1.659-.4 1.222-.8 1.689q-.6.7-1.5 1.068c-.6.246-1.2.368-1.9.368m-2-5.783h3.8q0-.556-.3-1.023-.15-.467-.6-.737c-.3-.179-.6-.269-1-.269s-.8.099-1.1.296c-.2.192-.5.443-.6.755-.2.311-.2.637-.2.978m11.1 5.766c-.7 0-1.3-.081-1.7-.243q-.6-.243-.9-.638c-.1-.269-.3-.565-.3-.889-.1-.329-.1-.661-.1-.996v-10.74h2.6v10.416c0 .342 0 .62.2.836.1.209.4.338.8.386l.5.027v1.616q-.3.09-.6.153c-.2.048-.4.072-.5.072m2.8-.162v-9.285h2.6v9.285zm0-10.614v-2.362h2.6v2.362zm4.9 10.614v-9.285h2.5v1.311q.3-.341.6-.656.3-.323.9-.53.45-.206 1.2-.206c.6 0 1.1.11 1.6.332q.75.332 1.2 1.051c.3.473.5 1.092.5 1.859v6.124h-2.6v-5.801c0-.503-.2-.88-.5-1.132a1.72 1.72 0 0 0-1.1-.377c-.3 0-.5.051-.8.153s-.5.254-.7.458c-.1.203-.2.455-.2.754v5.945zm14.9.179c-.9 0-1.8-.191-2.5-.574-.7-.389-1.2-.937-1.6-1.644q-.6-1.059-.6-2.496 0-1.392.6-2.505.45-1.123 1.5-1.77 1.05-.655 2.4-.655 1.5 0 2.4.602c.7.395 1.1.948 1.5 1.661.3.706.5 1.524.5 2.451v.71h-6.3q0 .71.3 1.239.15.521.6.808c.3.186.7.279 1.1.279q.75 0 1.2-.288c.3-.191.6-.506.7-.943h2.4c-.2.659-.4 1.222-.8 1.689-.5.467-1 .823-1.6 1.068q-.9.369-1.8.368m-2.1-5.783h3.8c0-.371-.1-.712-.2-1.023q-.15-.467-.6-.737c-.3-.179-.7-.269-1.1-.269s-.7.099-1 .296c-.3.192-.5.443-.7.755-.1.311-.2.637-.2.978"
            />
            <path
              fill="#637381"
              d="M19213.6 605.293c-1.1 0-1.9-.418-2.6-1.253q-.9-1.26-.9-3.724c0-1.109.1-2.039.4-2.789q.45-1.125 1.2-1.69c.6-.377 1.2-.566 1.9-.566 1 0 1.9.424 2.5 1.273q.9 1.267.9 3.751 0 2.472-.9 3.738c-.6.84-1.5 1.26-2.5 1.26m0-1.078c.7 0 1.2-.305 1.6-.916.3-.615.5-1.614.5-2.997q0-2.115-.6-3.044-.45-.936-1.5-.936c-.7 0-1.2.314-1.6.943q-.6.936-.6 3.037 0 2.067.6 2.99c.3.616.9.923 1.6.923m8.4.93v-6.964h1.2v1.01c.2-.306.5-.573.8-.802s.8-.343 1.3-.343c.3 0 .5.042.8.128.2.085.5.213.7.384.2.17.4.379.5.626q.3-.512.9-.822.6-.316 1.2-.316c.3 0 .5.038.8.114.3.072.5.202.7.391.3.184.4.442.6.774.1.328.2.75.2 1.267v4.553h-1.2v-4.432q0-.633-.3-.977a1 1 0 0 0-.5-.491c-.2-.095-.4-.142-.7-.142-.2 0-.4.043-.7.128q-.3.129-.6.431c-.2.202-.2.478-.2.829v4.654h-1.3v-4.796c0-.274-.1-.503-.2-.687s-.3-.323-.5-.417c-.3-.095-.5-.142-.7-.142s-.5.047-.7.142q-.45.14-.6.451-.3.303-.3.795v4.654zm11.7 0v-6.964h1.2v6.964zm0-8.439v-1.294h1.2v1.294zm3.4 8.439v-6.964h1.2v1.01c.1-.193.2-.375.4-.546.2-.17.5-.307.8-.411.2-.103.6-.154.9-.154.5 0 .9.087 1.3.262q.45.262.9.822.3.552.3 1.428v4.553h-1.3v-4.432c0-.543-.1-.945-.4-1.206-.3-.265-.6-.397-1.1-.397q-.45 0-.9.155-.45.148-.6.458-.3.303-.3.768v4.654z"
            />
            <path
              fill="#16A34A"
              d="M19234.2 578.963c-.8-3.872-4.2-6.779-8.3-6.779-3.2 0-6 1.84-7.4 4.534-3.4.36-6.1 3.222-6.1 6.691 0 3.715 3.1 6.735 6.8 6.735h14.6c3.1 0 5.6-2.515 5.6-5.613 0-2.963-2.3-5.365-5.2-5.568m-.4 8.936h-14.6c-2.5 0-4.5-2.01-4.5-4.49s2-4.49 4.5-4.49h.8c.7-2.593 3.1-4.49 5.9-4.49 3.4 0 6.2 2.761 6.2 6.173v.562h1.7c1.8 0 3.3 1.504 3.3 3.367s-1.5 3.368-3.3 3.368"
            />
          </g>
          <rect
            width={842.997}
            height={427.673}
            x={18425.4}
            y={1050.93}
            fill="#F8F9FA"
            stroke="#DCE0E4"
            strokeWidth={1.123}
            rx={8.419}
          />
          <path
            fill="#212B36"
            d="M18434 1037.43q-1.2 0-2.4-.3c-.8-.2-1.5-.51-2.1-.91s-1.2-.91-1.6-1.52c-.4-.6-.6-1.31-.7-2.13h3.3c.2.5.4.91.7 1.25.3.33.7.59 1.2.77q.75.27 1.8.27c.5 0 1-.07 1.4-.22q.75-.225 1.2-.69c.3-.31.4-.69.4-1.15 0-.56-.2-.97-.6-1.25s-1-.51-1.7-.67l-3-.67c-.9-.18-1.6-.45-2.3-.83-.6-.38-1.1-.87-1.4-1.48-.4-.61-.5-1.36-.5-2.23 0-1.01.2-1.88.8-2.62.5-.73 1.3-1.29 2.3-1.68.9-.4 2-.6 3.2-.6 1.4 0 2.5.22 3.4.67 1 .43 1.7 1.02 2.2 1.77.5.74.7 1.57.7 2.48h-3.2q-.15-.84-.6-1.35c-.2-.34-.6-.59-1.1-.74-.4-.15-.9-.23-1.5-.23-1 0-1.7.19-2.1.59-.5.4-.7.86-.7 1.38 0 .5.2.9.5 1.2.4.3.9.53 1.7.69l2.8.6c1 .21 1.9.53 2.5.97.7.43 1.1.96 1.4 1.58s.5 1.32.5 2.09c0 .98-.3 1.84-.8 2.59-.6.74-1.4 1.32-2.3 1.74-1 .42-2.2.63-3.4.63m13.9 0c-1 0-2-.24-2.9-.72-.8-.48-1.5-1.16-2-2.05-.4-.9-.7-1.97-.7-3.21 0-1.2.3-2.25.7-3.17.5-.91 1.1-1.62 2-2.13.8-.52 1.8-.77 2.9-.77 1 0 1.8.19 2.5.59.8.4 1.3.93 1.7 1.61.4.67.7 1.42.7 2.25h-2.7c-.1-.3-.2-.61-.3-.91-.2-.3-.4-.55-.7-.75s-.7-.3-1.1-.3c-.8 0-1.4.29-1.9.88s-.7 1.48-.7 2.68c0 1.13.2 2.02.7 2.69.4.66 1.1.99 1.9.99.5 0 .8-.11 1.1-.33.3-.21.6-.47.7-.77.2-.31.3-.59.3-.86h2.7c-.1.81-.3 1.53-.7 2.18s-1 1.16-1.7 1.54c-.7.37-1.5.56-2.5.56m7.2-.22v-16.68h3.2v6.74c.2-.27.5-.53.8-.79.2-.27.6-.5 1-.68s1-.27 1.6-.27c.7 0 1.4.15 2 .44s1.1.7 1.5 1.25c.3.54.5 1.21.5 1.99v8h-3.3v-7.51c0-.53-.1-.93-.5-1.2-.4-.29-.9-.43-1.4-.43-.4 0-.7.06-1 .19-.4.13-.6.32-.8.58q-.3.39-.3.96v7.41zm18.6.22q-1.65 0-3-.72c-.9-.48-1.6-1.17-2-2.05-.5-.88-.8-1.92-.8-3.12 0-1.16.2-2.21.7-3.13.4-.94 1.1-1.68 1.9-2.21.9-.55 1.9-.82 3.1-.82 1.1 0 2.1.25 2.9.75.8.49 1.4 1.18 1.9 2.07.4.89.6 1.91.6 3.07v.89h-7.8c0 .59.1 1.1.3 1.54s.4.78.8 1.02c.4.23.8.34 1.4.34.5 0 1-.12 1.4-.36q.6-.36.9-1.17h3c-.2.82-.5 1.52-1 2.11-.6.58-1.2 1.02-1.9 1.33-.8.31-1.6.46-2.4.46m-2.5-7.23h4.7c0-.46-.1-.89-.3-1.28-.1-.39-.4-.69-.7-.92-.4-.22-.8-.33-1.4-.33-.5 0-.9.12-1.2.37-.4.24-.7.55-.9.94-.1.39-.2.8-.2 1.22m14.5 7.23c-1.5 0-2.7-.53-3.6-1.6-.9-1.08-1.3-2.58-1.3-4.49 0-1.22.2-2.27.5-3.16.4-.89.9-1.58 1.6-2.06.7-.5 1.5-.74 2.5-.74.4 0 .8.04 1.2.14.3.09.7.22 1 .38.3.17.5.36.7.58q.45.315.6.69v-6.64h3.3v16.68h-2.4l-.4-2.38c-.1.32-.2.63-.4.94s-.4.59-.7.84-.7.45-1.1.6-.9.22-1.5.22m.7-2.36c.9 0 1.5-.28 1.9-.86s.6-1.55.6-2.92c0-.79-.1-1.45-.3-1.97-.2-.53-.4-.92-.8-1.17-.3-.26-.8-.39-1.3-.39q-1.05 0-1.8.81c-.5.54-.7 1.45-.7 2.72 0 1.3.2 2.25.6 2.86.5.62 1.1.92 1.8.92m12.9 2.36c-.6 0-1.1-.08-1.6-.25-.5-.16-1-.4-1.4-.73-.5-.32-.8-.71-1.1-1.18-.2-.48-.4-1.02-.4-1.64v-8.03h3.3v7.61c0 .54.2.98.6 1.33q.45.51 1.5.51c.6 0 1.2-.16 1.5-.49q.6-.51.6-1.41v-7.55h3.2v11.61h-2.4l-.4-2.3c-.1.68-.4 1.2-.8 1.57-.3.36-.8.6-1.2.74-.5.14-1 .21-1.4.21m12.8-.02c-.8 0-1.5-.1-2-.3-.5-.21-.9-.47-1.1-.8-.3-.34-.4-.71-.5-1.11-.1-.41-.1-.83-.1-1.25v-13.42h3.2v13.02c0 .42.1.77.3 1.04.2.26.5.42 1 .48l.6.04v2.02c-.2.07-.5.14-.7.19-.2.06-.5.09-.7.09m8.3.02q-1.65 0-3-.72c-.9-.48-1.5-1.17-2-2.05s-.8-1.92-.8-3.12c0-1.16.3-2.21.7-3.13.5-.94 1.1-1.68 1.9-2.21.9-.55 1.9-.82 3.1-.82q1.8 0 3 .75 1.2.735 1.8 2.07c.4.89.6 1.91.6 3.07v.89h-7.8c0 .59.1 1.1.3 1.54s.5.78.8 1.02c.4.23.8.34 1.4.34.5 0 1-.12 1.4-.36q.75-.36.9-1.17h3c-.2.82-.5 1.52-1 2.11-.5.58-1.2 1.02-1.9 1.33-.8.31-1.5.46-2.4.46m-2.5-7.23h4.7c0-.46-.1-.89-.2-1.28-.2-.39-.5-.69-.8-.92-.4-.22-.8-.33-1.3-.33s-1 .12-1.3.37c-.4.24-.6.55-.8.94s-.3.8-.3 1.22m15.6 7.01v-16.23h3.2v16.23zm6.5 0v-11.61h3.1v2.75c.2-.59.5-1.11.8-1.55.3-.45.8-.8 1.2-1.04.5-.26 1.1-.38 1.7-.38.1 0 .2 0 .3.02.1.01.2.02.2.04v3.12c-.1-.03-.2-.04-.2-.05-.1-.01-.2-.02-.3-.02-.6-.06-1.2-.04-1.6.05-.5.09-.9.24-1.2.46-.2.22-.4.48-.6.8-.1.31-.2.66-.2 1.05v6.36zm9.2 0v-11.61h3.2v2.75c.2-.59.4-1.11.7-1.55.4-.45.8-.8 1.3-1.04.5-.26 1-.38 1.6-.38.1 0 .2 0 .3.02.1.01.2.02.2.04v3.12c0-.03-.1-.04-.2-.05l-.2-.02c-.7-.06-1.2-.04-1.7.05s-.8.24-1.1.46-.5.48-.6.8c-.1.31-.2.66-.2 1.05v6.36zm9.3 0v-11.61h3.1v11.61zm0-13.27v-2.95h3.1v2.95zm11.2 17.11c-2 0-3.6-.27-4.7-.79-1-.52-1.6-1.21-1.6-2.07q0-.585.3-.99c.2-.27.5-.49.8-.64.2-.17.5-.29.7-.37.3-.09.4-.15.5-.18-.1-.07-.3-.17-.5-.3-.3-.13-.5-.31-.7-.53-.1-.24-.2-.54-.2-.9 0-.41.2-.8.5-1.15.4-.35 1-.59 1.8-.73-.7-.36-1.3-.84-1.7-1.46-.4-.61-.6-1.24-.6-1.88 0-.77.2-1.42.7-1.97.5-.54 1.1-.96 2-1.24.8-.29 1.7-.43 2.8-.43.8 0 1.4.09 1.9.26.6.16 1 .38 1.5.65.1-.07.4-.15.6-.26.3-.11.6-.23 1-.36l.9-.39c.4-.13.6-.25.9-.36v2.54l-2 .32c0 .2.1.42.1.65.1.24.1.43.1.58 0 .67-.2 1.3-.6 1.88-.4.59-1 1.06-1.7 1.42-.8.36-1.8.54-2.9.54-.2 0-.4-.01-.6-.02q-.3 0-.6-.03c-.4.02-.7.08-.9.17s-.2.19-.2.31c0 .18.1.3.5.36q.45.075 1.5.15l1 .05c.4.03.9.06 1.4.09 1.4.1 2.5.45 3.2 1.06.7.6 1 1.35 1 2.27 0 1.08-.5 1.98-1.5 2.68-1 .71-2.6 1.07-4.7 1.07m.6-1.83c.9 0 1.5-.12 1.9-.34s.6-.55.6-.97c0-.35-.1-.63-.4-.85s-.8-.35-1.4-.39l-2.6-.18c-.4-.02-.7.04-.9.16-.3.12-.5.28-.6.49-.2.21-.3.43-.3.67 0 .49.3.85.9 1.07s1.5.34 2.8.34m-.6-8.16c.6 0 1.1-.17 1.4-.51.4-.34.6-.81.6-1.39 0-.61-.2-1.09-.6-1.46-.3-.37-.8-.55-1.4-.55-.7 0-1.2.18-1.5.55-.4.37-.6.85-.6 1.46 0 .57.2 1.04.5 1.38.4.34.9.52 1.6.52m11.9 6.37c-.7 0-1.4-.14-2-.41-.6-.28-1.1-.68-1.4-1.2-.4-.54-.5-1.18-.5-1.94 0-1.27.5-2.23 1.4-2.89 1-.67 2.5-1.01 4.5-1.03l1.5-.03v-.69c0-.53-.2-.94-.5-1.23q-.45-.435-1.5-.42c-.4 0-.9.12-1.3.33q-.6.33-.9 1.14h-2.7c0-.84.3-1.53.7-2.07s1.1-.95 1.8-1.21c.8-.27 1.6-.4 2.6-.4 1.2 0 2.1.15 2.9.44.7.3 1.2.72 1.5 1.27s.5 1.2.5 1.96v8.16h-2.7l-.3-2q-.6 1.26-1.5 1.74t-2.1.48m1.1-2.15c.3 0 .6-.06.9-.16.2-.11.5-.26.7-.44.2-.19.4-.4.5-.63q.3-.345.3-.72v-1.71l-1.2.02c-.6.01-1.1.07-1.5.2q-.75.18-1.2.6c-.3.27-.4.65-.4 1.12 0 .54.2.96.5 1.27.4.3.9.45 1.4.45m12.8 2.05q-1.65 0-2.4-.39c-.6-.26-1-.63-1.2-1.1s-.3-1.02-.3-1.64v-6.32h-1.9v-2.28h2l.8-3.5h2.4v3.49h2.6v2.29h-2.6v6.18c0 .29 0 .5.1.64q.15.21.3.27.3.06.6.06h1.6v2.02c-.2.07-.4.13-.7.19s-.8.09-1.3.09m4.3-.12v-11.61h3.2v11.61zm0-13.27v-2.95h3.2v2.95zm11 13.49c-1.1 0-2.1-.24-2.9-.73-.9-.48-1.5-1.17-2-2.06-.4-.89-.7-1.95-.7-3.17s.3-2.29.7-3.2c.5-.91 1.1-1.62 2-2.13.8-.51 1.8-.76 2.9-.76q1.8 0 3 .75c.9.49 1.5 1.2 2 2.11.4.91.6 1.99.6 3.23 0 1.17-.2 2.2-.6 3.1-.5.89-1.1 1.59-1.9 2.1-.9.51-1.9.76-3.1.76m0-2.43c.6 0 1.1-.17 1.4-.51.4-.34.6-.78.8-1.32.2-.56.2-1.16.2-1.81 0-.61 0-1.19-.2-1.74-.1-.55-.4-.99-.7-1.33-.4-.33-.8-.5-1.5-.5-.5 0-1 .16-1.4.48-.3.32-.6.75-.7 1.29q-.3.81-.3 1.8c0 .6.1 1.19.2 1.75.2.55.4 1.01.8 1.36.3.35.8.53 1.4.53m7.9 2.21v-11.61h3.2v1.64c.2-.29.4-.56.7-.82.3-.27.7-.49 1.1-.66s1-.26 1.6-.26c.7 0 1.3.14 2 .41q.9.42 1.5 1.32c.3.59.5 1.36.5 2.32v7.66h-3.2v-7.25c0-.63-.2-1.1-.6-1.42-.4-.31-.8-.47-1.4-.47-.3 0-.7.06-1 .19s-.6.32-.8.57c-.2.26-.3.57-.3.95v7.43zM18438.8 1082.72v-12.99h3.2l3.4 9.93 3.4-9.93h3.1v12.99h-2.2v-10.18l-3.4 10.18h-1.8l-3.4-10.12v10.12zm18.6.18c-.6 0-1.1-.11-1.6-.32-.5-.23-.9-.54-1.1-.95-.3-.41-.4-.91-.4-1.5 0-1.02.4-1.79 1.1-2.31.7-.53 1.9-.8 3.5-.82l1.4-.04v-.63c0-.49-.1-.87-.4-1.15s-.8-.41-1.4-.41c-.4.01-.8.12-1.2.32-.4.21-.6.55-.7 1.04h-1.9c0-.64.2-1.17.5-1.59.4-.43.8-.75 1.4-.96.6-.22 1.3-.33 2-.33.9 0 1.6.12 2.2.35.5.24 1 .58 1.2 1.02.3.44.4.97.4 1.59v6.51h-1.8l-.2-1.67c-.3.7-.8 1.18-1.3 1.45s-1.1.4-1.7.4m.7-1.48c.3 0 .5-.05.8-.15s.5-.23.7-.4.4-.37.5-.58.2-.42.2-.65v-1.47l-1.1.02q-.9.015-1.5.18c-.4.12-.8.3-1 .55s-.3.57-.3.99c0 .47.1.84.5 1.11.3.26.7.4 1.2.4m10.1 1.48c-.6 0-1.2-.1-1.8-.31s-1.1-.53-1.5-.98c-.4-.44-.6-1.01-.7-1.71h1.9c.1.34.2.62.4.83.3.22.5.38.8.48s.6.14.9.14c.6 0 1-.09 1.4-.28.3-.2.5-.49.5-.89 0-.3-.1-.53-.3-.7-.2-.18-.5-.31-.9-.4l-1.8-.4c-.8-.18-1.4-.46-1.9-.86-.5-.41-.7-.97-.7-1.7 0-.55.1-1.04.4-1.47.3-.44.7-.77 1.3-1.02.5-.25 1.2-.38 2-.38 1.1 0 2 .25 2.6.73.7.48 1 1.17 1 2.06h-1.8c-.1-.4-.3-.71-.6-.94-.3-.22-.7-.34-1.2-.34s-.9.1-1.3.3c-.3.2-.5.5-.5.91 0 .28.2.5.4.66.3.16.6.3 1.1.41l1.7.41q.75.18 1.2.48c.3.21.5.43.7.68.2.24.3.48.4.74 0 .25.1.49.1.7 0 .6-.2 1.11-.5 1.54-.3.42-.7.74-1.3.97-.6.22-1.2.34-2 .34m9.4-.11c-.8 0-1.3-.1-1.7-.29s-.7-.47-.9-.83c-.1-.36-.2-.79-.2-1.29v-5.4h-1.5v-1.55h1.6l.5-2.75h1.6v2.74h2v1.56h-2v5.32c0 .28 0 .48.1.61 0 .13.1.21.3.26.1.03.3.05.5.05h1.2v1.38c-.1.05-.3.09-.6.13q-.3.06-.9.06m7.4.11q-1.35 0-2.4-.57c-.7-.38-1.2-.93-1.6-1.63-.4-.71-.6-1.55-.6-2.53 0-.95.2-1.79.5-2.53.4-.74.9-1.32 1.5-1.75.7-.42 1.5-.64 2.4-.64s1.7.2 2.3.59c.7.39 1.1.93 1.5 1.63.3.7.4 1.51.4 2.44v.67h-6.4c0 .53.1.99.3 1.4.1.41.4.73.7.96.4.23.8.34 1.3.34s1-.11 1.3-.34c.4-.23.7-.59.8-1.06h2c-.1.65-.4 1.2-.8 1.64-.4.45-.9.79-1.4 1.03-.6.23-1.2.35-1.8.35m-2.4-5.68h4.4c0-.45-.1-.85-.3-1.21-.1-.36-.4-.65-.7-.86-.3-.22-.7-.32-1.2-.32s-.9.11-1.2.35c-.3.23-.6.53-.7.9q-.3.555-.3 1.14m8.5 5.5v-9.29h2.1v2.01c.2-.46.4-.85.7-1.17.2-.33.6-.58.9-.76.4-.17.8-.26 1.3-.26.1 0 .2.01.3.02s.2.03.2.06v2.1c-.1-.03-.1-.05-.2-.07-.2-.01-.2-.01-.3-.01-.5-.04-.9-.02-1.2.05-.4.07-.6.19-.9.37-.2.17-.4.38-.5.64s-.2.56-.2.91v5.4zm11.3 0v-1.11l6.8-10.02h-6.5v-1.86h9.6v1.06l-6.9 10.05h6.8v1.88zm15.6.18c-.9 0-1.7-.19-2.3-.57-.7-.38-1.2-.93-1.6-1.64-.3-.71-.5-1.57-.5-2.57 0-.97.2-1.82.5-2.55q.6-1.095 1.5-1.71c.7-.4 1.5-.61 2.4-.61s1.6.2 2.3.59c.6.39 1.2.94 1.5 1.67.4.72.5 1.59.5 2.61 0 .94-.1 1.77-.5 2.49-.3.71-.8 1.27-1.4 1.68-.7.4-1.5.61-2.4.61m0-1.66q.75 0 1.2-.42c.4-.27.6-.65.8-1.13.1-.48.2-1.02.2-1.63 0-.57-.1-1.09-.2-1.57-.2-.48-.4-.87-.7-1.15-.3-.3-.8-.44-1.3-.44s-.9.13-1.3.4c-.3.26-.6.64-.7 1.11q-.3.72-.3 1.65c0 .56.1 1.08.3 1.57.1.48.3.87.7 1.17.3.29.7.44 1.3.44m6.3 1.48v-9.29h2.2v1.33q.15-.36.6-.69.3-.33.9-.54c.4-.14.8-.2 1.3-.2s1.1.11 1.6.34c.5.22.9.58 1.2 1.07.3.48.4 1.11.4 1.87v6.11h-2.2v-5.85c0-.61-.1-1.06-.5-1.35q-.45-.45-1.2-.45c-.4 0-.7.06-1 .18-.3.11-.6.29-.8.53-.2.23-.3.52-.3.88v6.06zm14.7.18q-1.35 0-2.4-.57c-.7-.38-1.2-.93-1.6-1.63-.4-.71-.5-1.55-.5-2.53 0-.95.1-1.79.5-2.53.3-.74.8-1.32 1.5-1.75.6-.42 1.4-.64 2.3-.64 1 0 1.7.2 2.4.59.6.39 1 .93 1.4 1.63.3.7.5 1.51.5 2.44v.67h-6.5c0 .53.1.99.3 1.4s.4.73.8.96c.3.23.7.34 1.2.34s1-.11 1.4-.34c.3-.23.6-.59.7-1.06h2c-.1.65-.3 1.2-.8 1.64-.4.45-.8.79-1.4 1.03-.6.23-1.2.35-1.8.35m-2.4-5.68h4.4c0-.45-.1-.85-.3-1.21-.1-.36-.3-.65-.7-.86-.3-.22-.7-.32-1.2-.32-.4 0-.8.11-1.2.35-.3.23-.6.53-.7.9q-.3.555-.3 1.14m12.1 5.68c-.7 0-1.3-.1-1.9-.31s-1-.53-1.4-.98c-.4-.44-.7-1.01-.8-1.71h2c0 .34.2.62.4.83.2.22.5.38.7.48.3.1.6.14 1 .14.5 0 1-.09 1.3-.28.3-.2.5-.49.5-.89 0-.3-.1-.53-.3-.7-.2-.18-.5-.31-.9-.4l-1.7-.4c-.8-.18-1.5-.46-1.9-.86-.5-.41-.8-.97-.8-1.7 0-.55.2-1.04.5-1.47.2-.44.7-.77 1.2-1.02.6-.25 1.3-.38 2.1-.38 1 0 1.9.25 2.6.73.6.48 1 1.17 1 2.06h-1.9c0-.4-.2-.71-.5-.94-.4-.22-.8-.34-1.3-.34q-.75 0-1.2.3c-.3.2-.5.5-.5.91 0 .28.1.5.4.66.2.16.6.3 1.1.41l1.7.41c.4.12.8.28 1.1.48.3.21.6.43.8.68.1.24.2.48.3.74.1.25.1.49.1.7 0 .6-.1 1.11-.4 1.54-.4.42-.8.74-1.3.97-.6.22-1.3.34-2 .34"
          />
          <g filter="url(#PulseLogicFig_svg__n)">
            <g clipPath="url(#PulseLogicFig_svg__o)">
              <path
                fill="#8B8B8B"
                d="M19239.1 1029.05c0-6.2 5-11.23 11.2-11.23h2.4c6.2 0 11.3 5.03 11.3 11.23 0 6.19-5.1 11.22-11.3 11.22h-2.4c-6.2 0-11.2-5.03-11.2-11.22"
              />
              <path
                fill="#fff"
                d="M19249.3 1036.7v-10.45h2.8v10.45zm0-11.94v-2.66h2.9v2.66z"
              />
            </g>
          </g>
        </g>
        <path
          stroke="#434647"
          strokeWidth={1.768}
          d="M18399.9 543.884h896.232v537.032H18399.9z"
        />
      </g>
    </g>
    <path
      fill="#3F4142"
      d="M15328 3475.5h-20c.7 101.5 6.7 206.03 47.9 302.02 58.2 158.44 250.8 173.44 391.2 169.48h1985.7c538.8 43.1 942.7-450.11 1029.2-941.42 114.9-494.73 119.3-1005.61 125.2-1509.85.7-101.22.8-202.25.8-303.73h-20c0 101.46-.1 202.44-.8 303.6-5.8 503.8-10.4 1014.08-124.6 1505.28-87.9 488.98-479.3 967.1-1009.8 926.12h-1985.7c-142.8 3.45-318.7-10.54-373-157.6-39.1-90.78-45.5-193.73-46.1-293.9"
    />
    <path
      fill="#424546"
      d="M15616 4248c-55.2 0-100-44.77-100-100s44.8-100 100-100v200m0-100v-100h14014.5v200H15616z"
    />
    <path
      fill="#5BB3E5"
      d="M15616 4218c-38.7 0-70-31.34-70-70s31.3-70 70-70v140m0-70v-70h14025.5v140H15616z"
    />
    <path stroke="#424546" strokeWidth={200} d="M17046 3021h-649" />
    <path stroke="#5BB3E5" strokeWidth={140} d="M17046 3021h-650" />
    <g filter="url(#PulseLogicFig_svg__p)">
      <path
        fill="#49A75D"
        d="M16768 2951c0 19.33-101.2 58-120.5 58-184.5-22.5 47.5-32.5 47.5-40.5 0-19.33 18.7-52.5 38-52.5s35 15.67 35 35"
      />
    </g>
    <path
      stroke="#424546"
      strokeWidth={100}
      d="M15500 3343h111c60 0 120 60 120 120v615"
    />
    <path
      stroke="#5BB3E5"
      strokeWidth={70}
      d="M15458 3343h153c60 0 120 60 120 120v615"
    />
    <path
      stroke="#424546"
      strokeWidth={100}
      d="M16964 1401h-111c-60 0-120 60-120 120v615"
    />
    <path
      stroke="#49A75D"
      strokeWidth={70}
      d="M16964 1401h-111c-60 0-120 60-120 120v615"
    />
    <path
      stroke="#424546"
      strokeWidth={100}
      d="M16768 2041c266.7.98 278 1.03 278 1.03"
    />
    <path stroke="#49A75D" strokeWidth={70} d="m16768 2041 278 1.03" />
    <path stroke="#424546" strokeWidth={100} d="M16733 2952v-816" />
    <path stroke="#49A75D" strokeWidth={70} d="M16733 2952v-816" />
    <path stroke="#424546" strokeWidth={100} d="M16964 1401.02h82" />
    <path stroke="#49A75D" strokeWidth={70} d="M16964 1401.02h82" />
    <path
      stroke="#424546"
      strokeWidth={100}
      d="M15150 3343h-111c-60 0-120 60-120 120v52"
    />
    <path
      stroke="#5BB3E5"
      strokeWidth={70}
      d="M15192 3343h-153c-60 0-120 60-120 120v52"
    />
    <path
      stroke="#424546"
      strokeWidth={100}
      d="M14688 3627h111c60 0 120-60 120-120v-52"
    />
    <path
      stroke="#5BB3E5"
      strokeWidth={70}
      d="M14688 3627h111c60 0 120-60 120-120v-52"
    />
    <path
      fill="#8C8E8E"
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15071 3279h484v129h-484z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      d="M15486 3380v28h69v-28zM15071 3380v28h69v-28z"
    />
    <path
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15071 3279h484v129h-484z"
    />
    <path
      fill="#8C8E8E"
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15247 3088h132v21h-132z"
    />
    <path fill="#595959" fillOpacity={0.2} d="M15346 3088v21h33v-21z" />
    <path
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15247 3088h132v21h-132z"
    />
    <path
      fill="#8C8E8E"
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15297 3109h32v54h-32z"
    />
    <path fill="#595959" fillOpacity={0.2} d="M15318 3109v54h11v-54z" />
    <path
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15297 3109h32v54h-32z"
    />
    <path
      fill="#8C8E8E"
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15399.8 3163c0 101 88.2 101 88.2 101v148.5l-67.5 64.5H15207l-69-64.5V3264s82.8 0 82.8-101z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      d="m15176 3449 30 28h214l68.5-66.5-3.5-143.5-28.5-8.5-23.5-14-25-33.5-9.5-46h-39.5s8 53.42 26.5 79.5 56.5 50.5 56.5 50.5v99l-69 55z"
    />
    <path
      stroke="#424546"
      strokeLinejoin="round"
      strokeWidth={10}
      d="M15399.8 3163c0 101 88.2 101 88.2 101v148.5l-67.5 64.5H15207l-69-64.5V3264s82.8 0 82.8-101z"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M19111.8 1192c0 1426.03 34.9 2713 658.7 2713H29645"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M19034.8 1192c0 1428.79 57.6 2745 681.4 2745h9926.3"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M18957.8 1192c0 1425.99 73.7 2778 697.5 2778h9987.2"
    />
    <path
      stroke="#424546"
      strokeWidth={200}
      d="M16398.6 3021.02c-120 0-240 120-240 240"
    />
    <path
      stroke="#5BB3E5"
      strokeWidth={140}
      d="M16398.6 3021.02c-120 0-240 120-240 240"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17305.5 2607.12h-185.4v836.55h185.4z"
    />
    <path
      fill="gray"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.259}
      d="M17569.4 2755.83h604.8v-101.88l-36.2-29.78-521 1.51-47.6 28.27z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17502.6 2734.09h-197.1v556.53h197.1zM18438.1 2734.95H18241v556.54h197.1z"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.854}
      d="M17281.8 2607.13V2533h-138v74.13zM17120 2902h-74v247h74z"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M18241 2755.83h-738.4v514.79h738.4z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.187}
      d="m17502.6 2796.69 738.4-6.95M17502.6 2844.87l738.4-6.96M17502.6 2893.05l738.4-6.96M17502.6 2941.22l738.4-6.95M17502.6 2989.39l738.4-6.95M17502.6 3037.57l738.4-6.96M17502.6 3085.75l738.4-6.96M17502.6 3133.92l738.4-6.96M17502.6 3182.1l738.4-6.96M17502.6 3230.27l738.4-6.95"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      d="M17120.4 3379.32v63.98h185.1v-63.98zM17310 3227v64h188v-64zM18247.1 3227.52v63.98h185v-63.98z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17305.5 2607.12h-185.4v836.55h185.4zM17502.6 2734.09h-197.1v556.53h197.1zM18438.1 2734.95H18241v556.54h197.1z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M18120 2755.83h54.2v-98.87l-37.2-32.79h-53l39 38.82z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.259}
      d="M17569.4 2755.83h604.8v-101.88l-36.2-29.78-521 1.51-47.6 28.27z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17199.3 1155.79h-109.5V1650h109.5z"
    />
    <path
      fill="gray"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.259}
      d="M17355.3 1243.64h357.5v-60.19l-21.4-17.59-307.9.89-28.2 16.7z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17315.9 1230.8h-116.6v328.78h116.6zM17868.8 1231.31h-116.5v328.78h116.5z"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.854}
      d="M17185.3 1155.79V1112h-81.5v43.79zM17090 1353h-44v100h44z"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M17752.3 1243.64h-436.4v304.13h436.4z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.187}
      d="m17315.9 1267.78 436.4-4.11M17315.9 1296.24l436.4-4.11M17315.9 1324.7l436.4-4.11M17315.9 1353.16l436.4-4.11M17315.9 1381.63l436.4-4.11M17315.9 1410.09l436.4-4.11M17315.9 1438.55l436.4-4.11M17315.9 1467.01l436.4-4.11M17315.9 1495.47l436.4-4.11M17315.9 1523.93l436.4-4.11"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      d="M17090 1611.98v37.8h109.4v-37.8zM17199 1522v38h113v-38zM17755.9 1522.3v37.8h109.4v-37.8z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17199.3 1155.79h-109.5V1650h109.5zM17315.9 1230.8h-116.6v328.78h116.6zM17868.8 1231.31h-116.5v328.78h116.5z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M17680.8 1243.64h32v-58.41l-22-19.37h-31.3l23.1 22.93z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.259}
      d="M17355.3 1243.64h357.5v-60.19l-21.4-17.59-307.9.89-28.2 16.7z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17199.3 1794.79h-109.5V2289h109.5z"
    />
    <path
      fill="gray"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.259}
      d="M17355.3 1882.64h357.5v-60.19l-21.4-17.59-307.9.89-28.2 16.7z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17315.9 1869.8h-116.6v328.78h116.6zM17868.8 1870.31h-116.5v328.78h116.5z"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.854}
      d="M17185.3 1794.79V1751h-81.5v43.79zM17090 1992h-44v100h44z"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M17752.3 1882.64h-436.4v304.13h436.4z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.187}
      d="m17315.9 1906.78 436.4-4.11M17315.9 1935.24l436.4-4.11M17315.9 1963.7l436.4-4.11M17315.9 1992.16l436.4-4.11M17315.9 2020.63l436.4-4.11M17315.9 2049.09l436.4-4.11M17315.9 2077.55l436.4-4.11M17315.9 2106.01l436.4-4.11M17315.9 2134.47l436.4-4.11M17315.9 2162.93l436.4-4.11"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      d="M17090 2250.98v37.8h109.4v-37.8zM17202 2161v38h114v-38zM17755.9 2161.3v37.8h109.4v-37.8z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.496}
      d="M17199.3 1794.79h-109.5V2289h109.5zM17315.9 1869.8h-116.6v328.78h116.6zM17868.8 1870.31h-116.5v328.78h116.5z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M17680.8 1882.64h32v-58.41l-22-19.37h-31.3l23.1 22.93z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.259}
      d="M17355.3 1882.64h357.5v-60.19l-21.4-17.59-307.9.89-28.2 16.7z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M17872 1406c248.2 0 616-77.91 616-216M17872 2053c279.7 0 694-310.92 694-862M18441 3055c81.8 0 203-671.62 203-1862"
    />
    <path fill="#3F4142" d="M12583 3291h-40v60h40z" />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeWidth={10}
      d="M12514 3499.42v-58.421h98v58.421z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M12584 3495.71h28v-49.76h-28z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={10}
      d="M12514 3499.42v-58.421h98v58.421z"
    />
    <rect
      width={89}
      height={120}
      x={12503}
      y={3445}
      fill="#257676"
      stroke="#3F4142"
      strokeWidth={10}
      rx={15}
      transform="rotate(-90 12503 3445)"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M12596 3443h25v-85h-25z"
      clipRule="evenodd"
    />
    <rect
      width={89}
      height={120}
      x={12503}
      y={3445}
      stroke="#3F4142"
      strokeWidth={10}
      rx={15}
      transform="rotate(-90 12503 3445)"
    />
    <mask id="PulseLogicFig_svg__q" fill="#fff">
      <path d="M12626 3563h98v126h-322v-126h98v-77h126z" />
    </mask>
    <path fill="#EDEAE0" d="M12626 3563h98v126h-322v-126h98v-77h126z" />
    <path
      fill="#3F4142"
      d="M12626 3563h-10v10h10zm98 0h10v-10h-10zm0 126v10h10v-10zm-322 0h-10v10h10zm0-126v-10h-10v10zm98 0v10h10v-10zm0-77v-10h-10v10zm126 0h10v-10h-10zm0 77v10h98v-20h-98zm98 0h-10v126h20v-126zm0 126v-10h-322v20h322zm-322 0h10v-126h-20v126zm0-126v10h98v-20h-98zm98 0h10v-77h-20v77zm0-77v10h126v-20h-126zm126 0h-10v77h20v-77z"
      mask="url(#PulseLogicFig_svg__q)"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m12596 3596 25-27.5V3491h-25zM12409 3683.31l311 1.69v-20h-311z"
      clipRule="evenodd"
    />
    <mask id="PulseLogicFig_svg__r" fill="#fff">
      <path d="M12626 3563h98v126h-322v-126h98v-77h126z" />
    </mask>
    <path
      fill="#3F4142"
      d="M12626 3563h-10v10h10zm98 0h10v-10h-10zm0 126v10h10v-10zm-322 0h-10v10h10zm0-126v-10h-10v10zm98 0v10h10v-10zm0-77v-10h-10v10zm126 0h10v-10h-10zm0 77v10h98v-20h-98zm98 0h-10v126h20v-126zm0 126v-10h-322v20h322zm-322 0h10v-126h-20v126zm0-126v10h98v-20h-98zm98 0h10v-77h-20v77zm0-77v10h126v-20h-126zm126 0h-10v77h20v-77z"
      mask="url(#PulseLogicFig_svg__r)"
    />
    <path stroke="#424546" strokeWidth={200} d="M16159 3260.01V4061" />
    <path stroke="#5BB3E5" strokeWidth={140} d="M16159 3260.01V4079" />
    <circle cx={15313} cy={3300} r={337.5} stroke="red" opacity={0} id="a1"/>
    <circle cx={17768} cy={3023} r={700.5} stroke="red" opacity={0} id="a2"/>
    <circle cx={17464} cy={2035} r={337.5} stroke="red" opacity={0} id="a3"/>
    <circle cx={17464} cy={1376} r={337.5} stroke="red" opacity={0} id="a4"/>
    <circle cx={18863} cy={874} r={595.5} stroke="red" opacity={0} id="a5"/>
    <circle cx={13379} cy={5295} r={249.5} stroke="red" opacity={0} id="a6"/>
    <circle cx={13116} cy={4725} r={249.5} stroke="red" opacity={0} id="a7"/>
    <circle cx={12860} cy={4153} r={249.5} stroke="red" opacity={0} id="a8"/>
    <circle cx={13855} cy={4132} r={249.5} stroke="red" opacity={0} id="a9"/>
    <circle cx={12565} cy={3549} r={244.5} stroke="red" opacity={0} id="a10"/>
    <circle cx={13356} cy={2542} r={599.5} stroke="red" opacity={0} id="a11"/>
    <circle cx={14394} cy={1655} r={599.5} stroke="red" opacity={0} id="a12"/>
    <defs>
      <filter
        id="PulseLogicFig_svg__c"
        width={1019.23}
        height={662.276}
        x={18338.4}
        y={492.487}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius={7.858}
          result="effect1_dropShadow_3961_1353"
        />
        <feOffset dy={12.348} />
        <feGaussianBlur stdDeviation={8.419} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={3.368}
          result="effect2_dropShadow_3961_1353"
        />
        <feOffset dy={26.94} />
        <feGaussianBlur stdDeviation={21.328} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.14 0" />
        <feBlend
          in2="effect1_dropShadow_3961_1353"
          result="effect2_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={8.98}
          result="effect3_dropShadow_3961_1353"
        />
        <feOffset dy={10.102} />
        <feGaussianBlur stdDeviation={25.817} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
        <feBlend
          in2="effect2_dropShadow_3961_1353"
          result="effect3_dropShadow_3961_1353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_3961_1353"
          result="shape"
        />
      </filter>
      <filter
        id="PulseLogicFig_svg__e"
        width={850.855}
        height={261.544}
        x={18422.6}
        y={731.579}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius={1.123}
          result="effect1_dropShadow_3961_1353"
        />
        <feOffset dy={2.245} />
        <feGaussianBlur stdDeviation={0.561} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.123} />
        <feGaussianBlur stdDeviation={0.561} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.14 0" />
        <feBlend
          in2="effect1_dropShadow_3961_1353"
          result="effect2_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.123} />
        <feGaussianBlur stdDeviation={1.684} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
        <feBlend
          in2="effect2_dropShadow_3961_1353"
          result="effect3_dropShadow_3961_1353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_3961_1353"
          result="shape"
        />
      </filter>
      <filter
        id="PulseLogicFig_svg__h"
        width={18.394}
        height={68.472}
        x={18601}
        y={894.342}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={2.245} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3961_1353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_3961_1353"
          result="shape"
        />
      </filter>
      <filter
        id="PulseLogicFig_svg__i"
        width={109.006}
        height={51.635}
        x={19142}
        y={824.744}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius={2.245}
          result="effect1_dropShadow_3961_1353"
        />
        <feOffset dy={3.368} />
        <feGaussianBlur stdDeviation={0.561} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2.245} />
        <feGaussianBlur stdDeviation={1.123} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.14 0" />
        <feBlend
          in2="effect1_dropShadow_3961_1353"
          result="effect2_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.123} />
        <feGaussianBlur stdDeviation={2.806} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
        <feBlend
          in2="effect2_dropShadow_3961_1353"
          result="effect3_dropShadow_3961_1353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_3961_1353"
          result="shape"
        />
      </filter>
      <filter
        id="PulseLogicFig_svg__j"
        width={149.292}
        height={51.635}
        x={18995}
        y={824.744}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius={2.245}
          result="effect1_dropShadow_3961_1353"
        />
        <feOffset dy={3.368} />
        <feGaussianBlur stdDeviation={0.561} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2.245} />
        <feGaussianBlur stdDeviation={1.123} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.14 0" />
        <feBlend
          in2="effect1_dropShadow_3961_1353"
          result="effect2_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.123} />
        <feGaussianBlur stdDeviation={2.806} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
        <feBlend
          in2="effect2_dropShadow_3961_1353"
          result="effect3_dropShadow_3961_1353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_3961_1353"
          result="shape"
        />
      </filter>
      <filter
        id="PulseLogicFig_svg__k"
        width={120.107}
        height={51.635}
        x={18876.1}
        y={824.744}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius={2.245}
          result="effect1_dropShadow_3961_1353"
        />
        <feOffset dy={3.368} />
        <feGaussianBlur stdDeviation={0.561} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2.245} />
        <feGaussianBlur stdDeviation={1.123} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.14 0" />
        <feBlend
          in2="effect1_dropShadow_3961_1353"
          result="effect2_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.123} />
        <feGaussianBlur stdDeviation={2.806} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
        <feBlend
          in2="effect2_dropShadow_3961_1353"
          result="effect3_dropShadow_3961_1353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_3961_1353"
          result="shape"
        />
      </filter>
      <filter
        id="PulseLogicFig_svg__n"
        width={31.635}
        height={29.184}
        x={19235.7}
        y={1015.58}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius={1.123}
          result="effect1_dropShadow_3961_1353"
        />
        <feOffset dy={2.245} />
        <feGaussianBlur stdDeviation={0.561} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.123} />
        <feGaussianBlur stdDeviation={0.561} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.14 0" />
        <feBlend
          in2="effect1_dropShadow_3961_1353"
          result="effect2_dropShadow_3961_1353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.123} />
        <feGaussianBlur stdDeviation={1.684} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
        <feBlend
          in2="effect2_dropShadow_3961_1353"
          result="effect3_dropShadow_3961_1353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_3961_1353"
          result="shape"
        />
      </filter>
      <filter
        id="PulseLogicFig_svg__p"
        width={311.771}
        height={213}
        x={16516.2}
        y={2856}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_3961_1353"
          stdDeviation={30}
        />
      </filter>
      <clipPath id="PulseLogicFig_svg__b">
        <path fill="#fff" d="M18322 484h1052v780h-1052z" />
      </clipPath>
      <clipPath id="PulseLogicFig_svg__d">
        <path fill="#fff" d="M18399 543h898v538.8h-898z" />
      </clipPath>
      <clipPath id="PulseLogicFig_svg__f">
        <path
          fill="#fff"
          d="M18425.9 742.804c0-4.959 4.1-8.98 9-8.98h826.2c4.9 0 9 4.021 9 8.98v236.848c0 4.959-4.1 8.98-9 8.98h-826.2c-4.9 0-9-4.021-9-8.98z"
        />
      </clipPath>
      <clipPath id="PulseLogicFig_svg__l">
        <path fill="#fff" d="M18474.2 838.5h70.078v21.889h-70.078z" />
      </clipPath>
      <clipPath id="PulseLogicFig_svg__m">
        <rect
          width={844.12}
          height={143.68}
          x={18425.9}
          y={564.328}
          fill="#fff"
          rx={8.98}
        />
      </clipPath>
      <clipPath id="PulseLogicFig_svg__o">
        <path
          fill="#fff"
          d="M19239.1 1029.05c0-6.2 5-11.23 11.2-11.23h2.4c6.2 0 11.3 5.03 11.3 11.23 0 6.19-5.1 11.22-11.3 11.22h-2.4c-6.2 0-11.2-5.03-11.2-11.22"
        />
      </clipPath>
      <pattern
        id="PulseLogicFig_svg__a"
        width={1}
        height={1}
        patternTransform="matrix(111 0 0 3578 16398 160)"
        patternUnits="userSpaceOnUse"
        preserveAspectRatio="none"
        viewBox="0 0 111 3578"
      >
        <path fill="#D9D9D9" stroke="#8C8E8E" d="M.5.5h110v3577H.5z" />
      </pattern>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgPulseLogicFig);
export default ForwardRef;

